import React, { useMemo, useState, useEffect, useRef, useCallback } from "react";
import {
  DndContext,
  closestCenter,
  useSensor,
  useSensors,
  PointerSensor,
  DragOverlay,
  useDroppable,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import moment from 'moment';
import axios from "axios";
import {
  Card,
  Input,
  Select,
  Typography,
  Form as AntForm,
  Checkbox,
  Upload,
  message,
  Radio,Progress,
  Tooltip,
  Button,
  Space,
  Table,
  Avatar,
  Row,
  Col,
  Divider,
  Steps,
  Collapse,
  Badge,
  Modal,
  Tag,
  Tree,
  Spin,
  Alert,
  Tabs,
  Transfer,
  List,
  Popconfirm,
  Empty,
  Descriptions,
  Form, Popover,
  TimePicker 
} from "antd";
import {
  PlusOutlined,
  FontSizeOutlined,
  NumberOutlined,
  CheckSquareOutlined,
  CalendarOutlined,
  DeleteOutlined,
  UploadOutlined,
  AlignLeftOutlined,
  BorderOutlined,
  ColumnWidthOutlined,
  EyeOutlined,
  BarChartOutlined, ReloadOutlined,  
  TableOutlined,
  FileImageOutlined,
  CopyOutlined,
  SaveOutlined,
  CloseOutlined,
  MenuOutlined,
 FunctionOutlined,
  FolderOutlined,
  DatabaseOutlined,
  DragOutlined,
  ApiOutlined,
  SwapOutlined,
  ClockCircleOutlined,
  SafetyOutlined,
  GlobalOutlined,
  CalculatorOutlined,
  FormOutlined,
  CopyFilled,
  CheckCircleOutlined,
  LineChartOutlined,
  PieChartOutlined,
  AreaChartOutlined,
  ReconciliationOutlined,
  FieldTimeOutlined,
  FileOutlined,
  FilePdfOutlined,
  FileWordOutlined,
  FileExcelOutlined,
  FileTextOutlined,
  InboxOutlined,
  LockOutlined,
  KeyOutlined,
  FontColorsOutlined,
  BgColorsOutlined,
  CodeOutlined,
  ControlOutlined,
  AuditOutlined,
   SearchOutlined,
  FilterOutlined,
  CheckOutlined,
  CloseCircleOutlined,
  HistoryOutlined,
  ApartmentOutlined,
  BankOutlined,
  HomeOutlined,
  BuildOutlined,
  StarOutlined,
  TrophyOutlined,
  CrownOutlined,
  ExperimentOutlined,
  ShopOutlined,
  MedicineBoxOutlined,
  RocketOutlined,
  ThunderboltOutlined,
  EditOutlined,
  TagOutlined,
  SlidersOutlined,
  ArrowUpOutlined, MessageOutlined,           // 👈 ADD THIS
  EyeInvisibleOutlined,  
  ArrowDownOutlined,DownOutlined,
  ImportOutlined,InfoCircleOutlined,ShareAltOutlined
} from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import { useTranslation } from '../hooks/useTranslation';
import MultiLevelFormulaFieldEditor from "../components/MultiLevelFormulaFieldEditor"
// Import the extracted FormAccessControl component
import FormAccessControl from './FormAccessControl';
// Import TableSearchModal
// import { TableSearchModal } from './FieldTypesPalette';

const { Title, Text } = Typography;
const { Option } = Select;
const { Panel } = Collapse;
const { TreeNode } = Tree;
const { Dragger } = Upload;
const { TextArea } = Input;
const { TabPane } = Tabs;

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_BASE = `${API_BASE_URL}/api`;

// ==================== UNITS API FUNCTIONS ====================

const unitAPI = {
  // Get all units
  getUnits: async (params = {}) => {
    // Mock data for development
    const mockUnits = [
      { id: 1, unit_name: 'Kilogram', unit_value: '1', unit_symbol: 'kg', unit_category: 'weight', is_active: true },
      { id: 2, unit_name: 'Gram', unit_value: '0.001', unit_symbol: 'g', unit_category: 'weight', is_active: true },
      { id: 3, unit_name: 'Meter', unit_value: '1', unit_symbol: 'm', unit_category: 'length', is_active: true },
      { id: 4, unit_name: 'Centimeter', unit_value: '0.01', unit_symbol: 'cm', unit_category: 'length', is_active: true },
      { id: 5, unit_name: 'Liter', unit_value: '1', unit_symbol: 'L', unit_category: 'volume', is_active: true },
      { id: 6, unit_name: 'Milliliter', unit_value: '0.001', unit_symbol: 'mL', unit_category: 'volume', is_active: true },
      { id: 7, unit_name: 'Thousand', unit_value: '1000', unit_symbol: 'K', unit_category: 'number_system', is_active: true },
      { id: 8, unit_name: 'Lakh', unit_value: '100000', unit_symbol: 'L', unit_category: 'number_system', is_active: true },
      { id: 9, unit_name: 'Crore', unit_value: '10000000', unit_symbol: 'Cr', unit_category: 'number_system', is_active: true },
      { id: 10, unit_name: 'Foot', unit_value: '0.3048', unit_symbol: 'ft', unit_category: 'length', is_active: true },
      { id: 11, unit_name: 'Inch', unit_value: '0.0254', unit_symbol: 'in', unit_category: 'length', is_active: true },
      { id: 12, unit_name: 'Pound', unit_value: '0.453592', unit_symbol: 'lb', unit_category: 'weight', is_active: true },
    ];

    // Filter based on params
    let filteredUnits = [...mockUnits];
    
    if (params.category && params.category !== 'all') {
      filteredUnits = filteredUnits.filter(u => u.unit_category === params.category);
    }
    
    if (params.active_only) {
      filteredUnits = filteredUnits.filter(u => u.is_active);
    }
    
    return { success: true, data: filteredUnits };
  },

  // Get unit categories
  getUnitCategories: async () => {
    const categories = ['weight', 'length', 'volume', 'area', 'time', 'speed', 'temperature', 'digital', 'currency', 'number_system', 'percentage'];
    return { success: true, data: categories };
  },

  // Create new unit
  createUnit: async (unitData) => {
    console.log('Creating unit:', unitData);
    // Mock successful creation
    return { 
      success: true, 
      data: { 
        id: Math.floor(Math.random() * 1000) + 10,
        ...unitData 
      } 
    };
  },

  // Update unit
  updateUnit: async (id, unitData) => {
    console.log('Updating unit:', id, unitData);
    return { success: true, data: { id, ...unitData } };
  },

  // Delete unit
  deleteUnit: async (id) => {
    console.log('Deleting unit:', id);
    return { success: true };
  },

  // Get units by category
  getUnitsByCategory: async (category) => {
    const mockUnits = [
      { id: 1, unit_name: 'Kilogram', unit_value: '1', unit_symbol: 'kg', unit_category: 'weight', is_active: true },
      { id: 2, unit_name: 'Gram', unit_value: '0.001', unit_symbol: 'g', unit_category: 'weight', is_active: true },
    ].filter(u => u.unit_category === category);
    
    return { success: true, data: mockUnits };
  },

  // Convert value between units
  convertUnit: async (value, fromUnitId, toUnitId) => {
    // Mock conversion
    return { 
      success: true, 
      data: {
        input: { value, unit: { id: fromUnitId } },
        output: { value: value * 1, unit: { id: toUnitId } }
      }
    };
  }
};

// ==================== UNITS API SERVICE ====================
const unitsApi = {
  // Fetch all units from database
  fetchUnits: async (category = null, activeOnly = true) => {
    try {
      let url = `${API_BASE}/forms/units`;
      const params = new URLSearchParams();
      if (category) params.append('category', category);
      if (activeOnly) params.append('active_only', 'true');
      if (params.toString()) url += '?' + params.toString();
      
      const response = await axios.get(url);
      return response.data?.data || [];
    } catch (error) {
      console.error('Error fetching units:', error);
      message.error('Failed to load units from database');
      return [];
    }
  },

  // Fetch unit categories
  fetchCategories: async () => {
    try {
      const response = await axios.get(`${API_BASE}/forms/units/categories`);
      return response.data?.data || [];
    } catch (error) {
      console.error('Error fetching categories:', error);
      return [];
    }
  },

  // Create new unit
  createUnit: async (unitData) => {
    try {
      const response = await axios.post(`${API_BASE}/forms/units`, unitData);
      if (response.data?.success) {
        // message.success('Unit created successfully');
        return response.data?.data;
      }
      return null;
    } catch (error) {
      console.error('Error creating unit:', error);
      message.error(error.response?.data?.error || 'Failed to create unit');
      throw error;
    }
  },

  // Update unit
  updateUnit: async (unitId, unitData) => {
    try {
      const response = await axios.put(`${API_BASE}/forms/units/${unitId}`, unitData);
      if (response.data?.success) {
        // message.success('Unit updated successfully');
        return response.data?.data;
      }
      return null;
    } catch (error) {
      console.error('Error updating unit:', error);
      message.error(error.response?.data?.error || 'Failed to update unit');
      throw error;
    }
  },

  // Delete unit
  deleteUnit: async (unitId) => {
    try {
      const response = await axios.delete(`${API_BASE}/forms/units/${unitId}`);
      if (response.data?.success) {
        // message.success('Unit deleted successfully');
        return true;
      }
      return false;
    } catch (error) {
      console.error('Error deleting unit:', error);
      message.error(error.response?.data?.error || 'Failed to delete unit');
      throw error;
    }
  },

  // Get units by category
  getUnitsByCategory: async (category) => {
    try {
      const response = await axios.get(`${API_BASE}/forms/units/categories/${category}`);
      return response.data?.data || [];
    } catch (error) {
      console.error('Error fetching units by category:', error);
      return [];
    }
  },

  // Convert value between units
  convertUnit: async (value, fromUnitId, toUnitId) => {
    try {
      const response = await axios.post(`${API_BASE}/forms/units/convert`, {
        value,
        from_unit_id: fromUnitId,
        to_unit_id: toUnitId
      });
      return response.data?.data;
    } catch (error) {
      console.error('Error converting unit:', error);
      message.error(error.response?.data?.error || 'Failed to convert unit');
      return null;
    }
  }
};

// FORM LANGUAGE MODES
const FORM_LANGUAGE_MODES = [
  { value: "bilingual", label: " (Marathi + English) / द्विभाषिक (मराठी + इंग्रजी)", icon: <GlobalOutlined />, description: "Users can fill in either language / वापरकर्ते कोणत्याही भाषेत भरू शकतात" },
  { value: "marathi_only", label: "Marathi Only / फक्त मराठी", icon: <FontSizeOutlined />, description: "Form will be displayed only in Marathi / फॉर्म फक्त मराठीत भरू शकतात" },
  { value: "english_only", label: "English Only / फक्त इंग्रजी", icon: <FontSizeOutlined />, description: "Form will be displayed only in English / फॉर्म फक्त इंग्रजीत भरू शकतात" },
];

// ULB Class options with icons and colors
const ULB_CLASSES = [
  { value: "A", label: "A Class (Nagar Nigam)", icon: <CrownOutlined />, color: "#722ed1", description: "Major cities / मोठी शहरे" },
  { value: "B", label: "B Class (Municipal Council)", icon: <TrophyOutlined />, color: "#52c41a", description: "Medium cities / मध्यम शहरे" },
  { value: "C", label: "C Class (Municipal Council)", icon: <StarOutlined />, color: "#fa8c16", description: "Small cities / लहान शहरे" },
  { value: "NP", label: "NP (Nagar Panchayat)", icon: <BankOutlined />, color: "#1890ff", description: "Town panchayats / नगर पंचायत" },
  { value: "CT", label: "CT (Census Town)", icon: <HomeOutlined />, color: "#eb2f96", description: "Census towns / जनगणना शहरे" },
  { value: "all", label: "All Classes / सर्व वर्ग", icon: <ApartmentOutlined />, color: "#13c2c2", description: "All ULBs regardless of class / सर्व वर्गातील ULB" },
];

// Comparison operators
const COMPARISON_OPERATORS = [
  { value: "equals", label: "Equals (=)", symbol: "=" },
  { value: "not_equals", label: "Not Equals (≠)", symbol: "≠" },
  { value: "greater_than", label: "Greater Than (>)", symbol: ">" },
  { value: "less_than", label: "Less Than (<)", symbol: "<" },
  { value: "greater_than_equal", label: "Greater Than or Equal (≥)", symbol: "≥" },
  { value: "less_than_equal", label: "Less Than or Equal (≤)", symbol: "≤" },
];
// Comparison operators for dates
// Comparison operators for dates
const DATE_COMPARISON_OPERATORS = [
  { value: "equals", label: "Equals (=)", symbol: "=" },
  { value: "not_equals", label: "Not Equals (≠)", symbol: "≠" },
  { value: "before", label: "Before (<)", symbol: "<" },
  { value: "after", label: "After (>)", symbol: ">" },
  { value: "on_or_before", label: "On or Before (≤)", symbol: "≤" },
  { value: "on_or_after", label: "On or After (≥)", symbol: "≥" },
  { value: "between", label: "Between", symbol: "between" },
  { value: "current_date", label: "Current Date (Today)", symbol: "📅" }, // ✅ ADD THIS
];
// Arithmetic operators for subfields - UPDATED with PERCENTAGE
const ARITHMETIC_OPERATORS = [
  { value: "add", label: "Addition (+)", symbol: "+" },
  { value: "subtract", label: "Subtraction (-)", symbol: "-" },
  { value: "multiply", label: "Multiplication (×)", symbol: "×" },
  { value: "divide", label: "Division (÷)", symbol: "÷" },
  { value: "modulus", label: "Modulus (%)", symbol: "%" },
  { value: "average", label: "Average", symbol: "avg" },
  { value: "percentage", label: "Percentage (%)", symbol: "%" },
];

// File type icons mapping
const FILE_TYPE_ICONS = {
  '.pdf': <FilePdfOutlined style={{ color: '#ff4d4f' }} />,
  '.doc': <FileWordOutlined style={{ color: '#1890ff' }} />,
  '.docx': <FileWordOutlined style={{ color: '#1890ff' }} />,
  '.xls': <FileExcelOutlined style={{ color: '#52c41a' }} />,
  '.xlsx': <FileExcelOutlined style={{ color: '#52c41a' }} />,
  '.txt': <FileTextOutlined style={{ color: '#fa8c16' }} />,
  '.jpg': <FileImageOutlined style={{ color: '#722ed1' }} />,
  '.jpeg': <FileImageOutlined style={{ color: '#722ed1' }} />,
  '.png': <FileImageOutlined style={{ color: '#722ed1' }} />,
  '.gif': <FileImageOutlined style={{ color: '#eb2f96' }} />,
  '.bmp': <FileImageOutlined style={{ color: '#13c2c2' }} />,
  'default': <FileOutlined />
};

// Frequency options
const FREQUENCY_OPTIONS = [
  { value: "daily", label: "Daily / दैनिक", icon: <ClockCircleOutlined />, requiresTime: true },
  { value: "weekly", label: "Weekly / साप्ताहिक", icon: <CalendarOutlined />, requiresDay: true, requiresTime: true },
  { value: "monthly", label: "Monthly / मासिक", icon: <CalendarOutlined />, requiresDate: true, requiresTime: true },
  { value: "quarterly", label: "Quarterly / त्रैमासिक", icon: <ReconciliationOutlined />, requiresEveryNMonths: true, n: 3, requiresTime: true },
  { value: "half_yearly", label: "Half-Yearly / सहामाही", icon: <ReconciliationOutlined />, requiresEveryNMonths: true, n: 6, requiresTime: true },
  { value: "yearly", label: "Yearly / वार्षिक", icon: <FieldTimeOutlined />, requiresDate: true, requiresMonth: true, requiresTime: true },
  // { value: "custom", label: "Custom / सानुकूल", icon: <FieldTimeOutlined /> },
];
// Weekdays for weekly schedule
const WEEKDAYS = [
  { value: "monday", label: "Monday / सोमवार", short: "Mon", shortMr: "सोम" },
  { value: "tuesday", label: "Tuesday / मंगळवार", short: "Tue", shortMr: "मंगळ" },
  { value: "wednesday", label: "Wednesday / बुधवार", short: "Wed", shortMr: "बुध" },
  { value: "thursday", label: "Thursday / गुरुवार", short: "Thu", shortMr: "गुरु" },
  { value: "friday", label: "Friday / शुक्रवार", short: "Fri", shortMr: "शुक्र" },
  { value: "saturday", label: "Saturday / शनिवार", short: "Sat", shortMr: "शनि" },
  { value: "sunday", label: "Sunday / रविवार", short: "Sun", shortMr: "रवि" },
];

// Months for yearly schedule
const MONTHS = [
  { value: 1, label: "January / जानेवारी" },
  { value: 2, label: "February / फेब्रुवारी" },
  { value: 3, label: "March / मार्च" },
  { value: 4, label: "April / एप्रिल" },
  { value: 5, label: "May / मे" },
  { value: 6, label: "June / जून" },
  { value: 7, label: "July / जुलै" },
  { value: 8, label: "August / ऑगस्ट" },
  { value: 9, label: "September / सप्टेंबर" },
  { value: 10, label: "October / ऑक्टोबर" },
  { value: 11, label: "November / नोव्हेंबर" },
  { value: 12, label: "December / डिसेंबर" },
];

// Field types palette
const FIELD_TYPES = [
  { type: "text", label: "Text", icon: <FontSizeOutlined /> },
  { type: "number", label: "Number", icon: <NumberOutlined /> },
  { type: "date", label: "Date", icon: <CalendarOutlined /> },
  { type: "checkbox", label: "Checkbox", icon: <CheckSquareOutlined /> },
  { type: "radio", label: "Radio", icon: <BorderOutlined /> },
  { type: "heading", label: "Heading", icon: <FontSizeOutlined /> },
  { type: "paragraph", label: "Paragraph", icon: <AlignLeftOutlined /> },
  { type: "file", label: "File Upload", icon: <UploadOutlined /> },
  { type: "row", label: "2 Columns", icon: <ColumnWidthOutlined /> },
  { type: "comparison", label: "Comparison", icon: <SwapOutlined /> },
  { type: "arithmetic", label: "Arithmetic", icon: <CalculatorOutlined /> },
    { type: "formula", label: "Formula", icon: <FunctionOutlined /> },  // ✅ ADD THIS

];

// Validation pattern options - EXTENDED
const VALIDATION_PATTERNS = [
  { value: "none", label: "No Pattern / कोणताही नमुना नाही", icon: <FontSizeOutlined /> },
  { value: "letters_only", label: "Only Letters (A-Z, a-z) / फक्त अक्षरे", icon: <FontSizeOutlined /> },
  { value: "letters_spaces", label: "Letters + Spaces / अक्षरे + स्पेस", icon: <FontSizeOutlined /> },
  { value: "alphanumeric", label: "Alphanumeric (A-Z, a-z, 0-9) / अक्षरांकी", icon: <KeyOutlined /> },
  { value: "alphanumeric_spaces", label: "Alphanumeric + Spaces / अक्षरांकी + स्पेस", icon: <KeyOutlined /> },
  { value: "numbers_only", label: "Only Numbers / फक्त संख्या", icon: <NumberOutlined /> },
  { value: "email", label: "Email Format / ईमेल स्वरूप", icon: <GlobalOutlined /> },
  // { value: "phone", label: "Phone Number / फोन नंबर", icon: <GlobalOutlined /> },
  // { value: "url", label: "URL / यूआरएल", icon: <GlobalOutlined /> },
  // { value: "ip_address", label: "IP Address / आयपी पत्ता", icon: <GlobalOutlined /> },
  // { value: "credit_card", label: "Credit Card / क्रेडिट कार्ड", icon: <KeyOutlined /> },
  // { value: "custom", label: "Custom Regex / सानुकूल रेगेक्स", icon: <CodeOutlined /> },
];

// Date format options
const DATE_FORMATS = [
  { value: "YYYY-MM-DD", label: "YYYY-MM-DD (2024-01-31)" },
  { value: "DD/MM/YYYY", label: "DD/MM/YYYY (31/01/2024)" },
  { value: "MM/DD/YYYY", label: "MM/DD/YYYY (01/31/2024)" },
  { value: "DD-MM-YYYY", label: "DD-MM-YYYY (31-01-2024)" },
  { value: "MM-DD-YYYY", label: "MM-DD-YYYY (01-31-2024)" },
  { value: "YYYY/MM/DD", label: "YYYY/MM/DD (2024/01/31)" },
  { value: "DD MMM YYYY", label: "DD MMM YYYY (31 Jan 2024)" },
  { value: "MMM DD, YYYY", label: "MMM DD, YYYY (Jan 31, 2024)" },
  { value: "DD MMMM YYYY", label: "DD MMMM YYYY (31 January 2024)" },
  { value: "MMMM DD, YYYY", label: "MMMM DD, YYYY (January 31, 2024)" },
];

// Font options - Simplified to Marathi and English only
const FONT_OPTIONS = [
  { value: "default", label: "Default / डीफॉल्ट", font: "inherit" },
  { value: "english", label: "English / इंग्रजी", font: "'Arial', 'Helvetica', sans-serif" },
  { value: "marathi", label: "Marathi / मराठी", font: "'Noto Sans Devanagari', 'Nirmala UI', sans-serif" },
];

// Language script options - Simplified to Marathi and English only
const LANGUAGE_SCRIPTS = [
  { value: "any", label: "Any / कोणतेही" },
  { value: "english_only", label: "English Only / फक्त इंग्रजी" },
  { value: "marathi_only", label: "Marathi Only / फक्त मराठी" },
  { value: "english_marathi", label: "English + Marathi / इंग्रजी + मराठी" },
];

// Allowed character sets
const ALLOWED_CHARACTERS = [
  { value: "any", label: "Any / कोणतेही" },
  // { value: "letters_only", label: "Letters Only / फक्त अक्षरे" },
  { value: "numbers_only", label: "Numbers Only / फक्त संख्या" },
  { value: "alphanumeric", label: "Alphanumeric / अक्षरांकी" },
  // { value: "custom", label: "Custom / सानुकूल" },
];

// Unit options for number fields - Simple Thousand, Lakh, Crore
const UNIT_OPTIONS = [
  { value: 'none', label: 'No Unit', labelMr: 'युनिट नाही', symbol: '' },
  { value: 'thousand', label: 'Thousand', labelMr: 'हजार', symbol: 'K' },
  { value: 'lakh', label: 'Lakh', labelMr: 'लाख', symbol: 'L' },
  { value: 'crore', label: 'Crore', labelMr: 'कोटी', symbol: 'Cr' },
];

const uid = () => `field_${Date.now()}_${Math.random().toString(36).substr(2, 6)}`;
const ComparisonModal = ({ visible, onClose, formFields, language }) => {
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          {language === 'english' ? 'Close' : 'बंद करा'}
        </Button>
      ]}
      width={600}
      title={
        <Space>
          <SwapOutlined style={{ color: '#fa8c16' }} />
          {language === 'english' ? 'Comparison Feature' : 'तुलना वैशिष्ट्य'}
        </Space>
      }
      centered
    >
      <div style={{ padding: '20px 0' }}>
        <p>
          {language === 'english' 
            ? 'Comparison functionality is being developed. Please check back later.'
            : 'तुलना कार्यक्षमता विकसित केली जात आहे. कृपया नंतर परत तपासा.'}
        </p>
      </div>
    </Modal>
  );
};
// ==================== UNIT MANAGER COMPONENT ====================
// 🟢 Unit Manager Component with maskStyle fix
const UnitManager = ({ language = 'english', onUnitSelect, visible, onClose }) => {
  const [units, setUnits] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [editingUnit, setEditingUnit] = useState(null);
  const [form] = Form.useForm();
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [searchText, setSearchText] = useState('');
  const [showActiveOnly, setShowActiveOnly] = useState(false);

  // Load units on mount
  useEffect(() => {
    if (visible) {
      loadUnits();
      loadCategories();
    }
  }, [visible, selectedCategory, showActiveOnly]);

  // Load units with filters
  const loadUnits = async () => {
    try {
      setLoading(true);
      const params = {
        category: selectedCategory,
        active_only: showActiveOnly
      };
      const response = await unitAPI.getUnits(params);
      if (response.success) {
        setUnits(response.data);
      }
    } catch (error) {
      message.error(language === 'english' 
        ? 'Failed to load units' 
        : 'युनिट लोड करण्यात अयशस्वी');
    } finally {
      setLoading(false);
    }
  };

  // Load categories
  const loadCategories = async () => {
    try {
      const response = await unitAPI.getUnitCategories();
      if (response.success) {
        setCategories(['all', ...response.data]);
      }
    } catch (error) {
      console.error('Failed to load categories:', error);
    }
  };

  // Handle create/update unit
  const handleSubmit = async (values) => {
    try {
      if (editingUnit) {
        const response = await unitAPI.updateUnit(editingUnit.id, values);
        if (response.success) {
          // message.success(language === 'english' 
          //   ? 'Unit updated successfully' 
          //   : 'युनिट यशस्वीरित्या अद्यतनित केले');
        }
      } else {
        const response = await unitAPI.createUnit(values);
        if (response.success) {
          // message.success(language === 'english' 
          //   ? 'Unit created successfully' 
          //   : 'युनिट यशस्वीरित्या तयार केले');
        }
      }
      setModalVisible(false);
      form.resetFields();
      setEditingUnit(null);
      loadUnits();
    } catch (error) {
      message.error(language === 'english' 
        ? 'Failed to save unit' 
        : 'युनिट जतन करण्यात अयशस्वी');
    }
  };

  // Handle delete unit
  const handleDelete = async (id) => {
    try {
      const response = await unitAPI.deleteUnit(id);
      if (response.success) {
        // message.success(language === 'english' 
        //   ? 'Unit deleted successfully' 
        //   : 'युनिट यशस्वीरित्या हटवले');
        loadUnits();
      }
    } catch (error) {
      message.error(language === 'english' 
        ? 'Failed to delete unit' 
        : 'युनिट हटवण्यात अयशस्वी');
    }
  };

  // Filter units based on search
  const filteredUnits = units.filter(unit => {
    if (searchText) {
      return unit.unit_name.toLowerCase().includes(searchText.toLowerCase()) ||
             unit.unit_symbol?.toLowerCase().includes(searchText.toLowerCase());
    }
    return true;
  });

  // Columns for table
  const columns = [
    {
      title: language === 'english' ? 'Unit Name' : 'युनिट नाव',
      dataIndex: 'unit_name',
      key: 'unit_name',
      render: (text, record) => (
        <Space>
          <CalculatorOutlined style={{ color: '#1890ff' }} />
          <Text strong>{text}</Text>
          {record.unit_symbol && (
            <Tag color="blue">{record.unit_symbol}</Tag>
          )}
        </Space>
      ),
    },
    {
      title: language === 'english' ? 'Value' : 'मूल्य',
      dataIndex: 'unit_value',
      key: 'unit_value',
      render: (text) => <Text code>{text}</Text>,
    },
    {
      title: language === 'english' ? 'Category' : 'श्रेणी',
      dataIndex: 'unit_category',
      key: 'unit_category',
      render: (text) => text ? <Tag color="purple">{text}</Tag> : '-',
    },
    {
      title: language === 'english' ? 'Status' : 'स्थिती',
      dataIndex: 'is_active',
      key: 'is_active',
      render: (active) => active ? (
        <Tag color="green" icon={<CheckCircleOutlined />}>Active</Tag>
      ) : (
        <Tag color="red" icon={<CloseCircleOutlined />}>Inactive</Tag>
      ),
    },
    {
      title: language === 'english' ? 'Actions' : 'क्रिया',
      key: 'actions',
      render: (_, record) => (
        <Space>
          <Tooltip title={language === 'english' ? 'Select' : 'निवडा'}>
            <Button 
              type="primary" 
              size="small" 
              icon={<CheckOutlined />}
              onClick={() => {
                if (onUnitSelect) {
                  onUnitSelect(record);
                }
                onClose();
              }}
            />
          </Tooltip>
          <Tooltip title={language === 'english' ? 'Edit' : 'संपादित करा'}>
            <Button 
              size="small" 
              icon={<EditOutlined />}
              onClick={() => {
                setEditingUnit(record);
                form.setFieldsValue({
                  unit_name: record.unit_name,
                  unit_value: record.unit_value,
                  unit_symbol: record.unit_symbol,
                  unit_category: record.unit_category,
                  is_active: record.is_active
                });
                setModalVisible(true);
              }}
            />
          </Tooltip>
          <Popconfirm
            title={language === 'english' 
              ? 'Are you sure you want to delete this unit?' 
              : 'तुम्हाला हे युनिट हटवायचे आहे का?'}
            onConfirm={() => handleDelete(record.id)}
            okText={language === 'english' ? 'Yes' : 'होय'}
            cancelText={language === 'english' ? 'No' : 'नाही'}
          >
            <Tooltip title={language === 'english' ? 'Delete' : 'हटवा'}>
              <Button size="small" danger icon={<DeleteOutlined />} />
            </Tooltip>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      width={900}
      footer={null}
      title={
        <Space>
          <CalculatorOutlined style={{ color: '#1890ff' }} />
          {language === 'english' ? 'Unit Manager' : 'युनिट व्यवस्थापक'}
        </Space>
      }
      maskClosable={true}
      centered
      destroyOnClose={true}
      styles={{ mask: { backdropFilter: 'none' } }}
    >
      <div style={{ padding: '20px 0' }}>
        {/* Filters */}
        <Row gutter={16} style={{ marginBottom: 16 }}>
          <Col span={8}>
            <Select
              style={{ width: '100%' }}
              value={selectedCategory}
              onChange={setSelectedCategory}
              placeholder={language === 'english' ? 'Select Category' : 'श्रेणी निवडा'}
            >
              <Option value="all">
                {language === 'english' ? 'All Categories' : 'सर्व श्रेणी'}
              </Option>
              {categories.filter(c => c !== 'all').map(cat => (
                <Option key={cat} value={cat}>{cat}</Option>
              ))}
            </Select>
          </Col>
          <Col span={8}>
            <Input
              placeholder={language === 'english' ? 'Search units...' : 'युनिट शोधा...'}
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              allowClear
            />
          </Col>
          <Col span={4}>
            <Checkbox
              checked={showActiveOnly}
              onChange={(e) => setShowActiveOnly(e.target.checked)}
            >
              {language === 'english' ? 'Active only' : 'फक्त सक्रिय'}
            </Checkbox>
          </Col>
          <Col span={4} style={{ textAlign: 'right' }}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => {
                setEditingUnit(null);
                form.resetFields();
                setModalVisible(true);
              }}
            >
              {language === 'english' ? 'New Unit' : 'नवीन युनिट'}
            </Button>
          </Col>
        </Row>

        {/* Units Table */}
        <Table
          dataSource={filteredUnits}
          columns={columns}
          rowKey="id"
          loading={loading}
          pagination={{ pageSize: 10 }}
          size="small"
        />
      </div>

      {/* Create/Edit Unit Modal */}
      <Modal
        open={modalVisible}
        onCancel={() => {
          setModalVisible(false);
          setEditingUnit(null);
          form.resetFields();
        }}
        title={editingUnit 
          ? (language === 'english' ? 'Edit Unit' : 'युनिट संपादित करा')
          : (language === 'english' ? 'Create New Unit' : 'नवीन युनिट तयार करा')
        }
        footer={null}
        maskClosable={true}
        centered
        destroyOnClose={true}
        styles={{ mask: { backdropFilter: 'none' } }}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={{ is_active: true }}
        >
          <Form.Item
            name="unit_name"
            label={language === 'english' ? 'Unit Name' : 'युनिट नाव'}
            rules={[{ required: true, message: language === 'english' ? 'Please enter unit name' : 'कृपया युनिट नाव प्रविष्ट करा' }]}
          >
            <Input placeholder="e.g., Kilogram, Meter, Liter" />
          </Form.Item>

          <Form.Item
            name="unit_value"
            label={language === 'english' ? 'Unit Value' : 'युनिट मूल्य'}
            rules={[{ required: true, message: language === 'english' ? 'Please enter unit value' : 'कृपया युनिट मूल्य प्रविष्ट करा' }]}
            extra={language === 'english' 
              ? 'Base unit value (e.g., 1 for Kilogram, 0.001 for Gram)'
              : 'मूळ युनिट मूल्य (उदा., किलोग्रॅमसाठी १, ग्रॅमसाठी ०.००१)'}
          >
            <Input placeholder="1, 0.001, 1000" />
          </Form.Item>

          <Form.Item
            name="unit_symbol"
            label={language === 'english' ? 'Unit Symbol' : 'युनिट चिन्ह'}
          >
            <Input placeholder="kg, m, L" />
          </Form.Item>

          <Form.Item
            name="unit_category"
            label={language === 'english' ? 'Category' : 'श्रेणी'}
          >
            <Select
              placeholder={language === 'english' ? 'Select category' : 'श्रेणी निवडा'}
              allowClear
              showSearch
            >
              <Option value="weight">Weight / वजन</Option>
              <Option value="length">Length / लांबी</Option>
              <Option value="volume">Volume / घनफळ</Option>
              <Option value="area">Area / क्षेत्रफळ</Option>
              <Option value="time">Time / वेळ</Option>
              <Option value="speed">Speed / वेग</Option>
              <Option value="temperature">Temperature / तापमान</Option>
              <Option value="digital">Digital / डिजिटल</Option>
              <Option value="currency">Currency / चलन</Option>
              <Option value="number_system">Number System / संख्या प्रणाली</Option>
              <Option value="percentage">Percentage / टक्केवारी</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="is_active"
            valuePropName="checked"
          >
            <Checkbox>
              {language === 'english' ? 'Active' : 'सक्रिय'}
            </Checkbox>
          </Form.Item>

          <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
            <Space>
              <Button onClick={() => {
                setModalVisible(false);
                setEditingUnit(null);
                form.resetFields();
              }}>
                {language === 'english' ? 'Cancel' : 'रद्द करा'}
              </Button>
              <Button type="primary" htmlType="submit">
                {editingUnit 
                  ? (language === 'english' ? 'Update' : 'अद्यतनित करा')
                  : (language === 'english' ? 'Create' : 'तयार करा')
                }
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </Modal>
  );
};

// ==================== DYNAMIC UNIT MANAGEMENT MODAL ====================
const UnitManagementModal = ({ visible, onClose, onUnitSelect, selectedUnit, language, fieldId }) => {
  const [units, setUnits] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [loading, setLoading] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [newUnit, setNewUnit] = useState({
    unit_name: '',
    unit_value: '1',
    unit_symbol: '',
    unit_category: '',
    is_active: true
  });
  const [editingUnit, setEditingUnit] = useState(null);
  const [filteredUnits, setFilteredUnits] = useState([]);
  const [searchText, setSearchText] = useState('');

  // Load units on mount
  useEffect(() => {
    if (visible) {
      loadUnits();
      loadCategories();
    }
  }, [visible]);

  const loadUnits = async () => {
    setLoading(true);
    try {
      const data = await unitsApi.fetchUnits(selectedCategory === 'all' ? null : selectedCategory);
      setUnits(data);
      setFilteredUnits(data);
    } finally {
      setLoading(false);
    }
  };

  const loadCategories = async () => {
    const cats = await unitsApi.fetchCategories();
    setCategories(['all', ...cats]);
  };

  // Filter when category changes
  useEffect(() => {
    if (selectedCategory === 'all') {
      setFilteredUnits(units);
    } else {
      setFilteredUnits(units.filter(u => u.unit_category === selectedCategory));
    }
  }, [selectedCategory, units]);

  // Search filter
  useEffect(() => {
    if (!searchText) {
      if (selectedCategory === 'all') {
        setFilteredUnits(units);
      } else {
        setFilteredUnits(units.filter(u => u.unit_category === selectedCategory));
      }
    } else {
      const searchLower = searchText.toLowerCase();
      const filtered = units.filter(u => 
        (u.unit_name && u.unit_name.toLowerCase().includes(searchLower)) ||
        (u.unit_symbol && u.unit_symbol.toLowerCase().includes(searchLower)) ||
        (u.unit_category && u.unit_category.toLowerCase().includes(searchLower))
      );
      setFilteredUnits(filtered);
    }
  }, [searchText, units, selectedCategory]);

  const handleCreateUnit = async () => {
    if (!newUnit.unit_name || !newUnit.unit_value) {
      message.warning(language === 'english' 
        ? 'Unit name and value are required' 
        : 'युनिटचे नाव आणि मूल्य आवश्यक आहे');
      return;
    }

    try {
      const created = await unitsApi.createUnit(newUnit);
      if (created) {
        setShowCreateModal(false);
        setNewUnit({
          unit_name: '',
          unit_value: '1',
          unit_symbol: '',
          unit_category: '',
          is_active: true
        });
        loadUnits();
        loadCategories();
      }
    } catch (error) {
      console.error('Create unit error:', error);
    }
  };

  const handleUpdateUnit = async () => {
    if (!editingUnit) return;
    
    if (!editingUnit.unit_name || !editingUnit.unit_value) {
      message.warning(language === 'english' 
        ? 'Unit name and value are required' 
        : 'युनिटचे नाव आणि मूल्य आवश्यक आहे');
      return;
    }

    try {
      const updated = await unitsApi.updateUnit(editingUnit.id, editingUnit);
      if (updated) {
        setEditingUnit(null);
        loadUnits();
        loadCategories();
      }
    } catch (error) {
      console.error('Update unit error:', error);
    }
  };

  const handleDeleteUnit = async (unitId) => {
    try {
      await unitsApi.deleteUnit(unitId);
      loadUnits();
      loadCategories();
    } catch (error) {
      console.error('Delete unit error:', error);
    }
  };

  const handleSelectUnit = (unit) => {
    if (onUnitSelect) {
      onUnitSelect(unit);
    }
    onClose();
  };

  return (
    <>
      <Modal
        open={visible}
        onCancel={onClose}
        footer={null}
        width={800}
        title={
          <Space>
            <SlidersOutlined style={{ color: '#722ed1' }} />
            {language === 'english' ? 'Unit Management' : 'युनिट व्यवस्थापन'}
          </Space>
        }
        maskClosable={false}
        centered
      >
        <div style={{ padding: '20px 0' }}>
          {/* Toolbar */}
          <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
            <Col span={8}>
              <Input
                placeholder={language === 'english' ? 'Search units...' : 'युनिट शोधा...'}
                prefix={<FilterOutlined />}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                allowClear
              />
            </Col>
            <Col span={6}>
              <Select
                style={{ width: '100%' }}
                value={selectedCategory}
                onChange={setSelectedCategory}
                placeholder={language === 'english' ? 'Filter by category' : 'श्रेणीनुसार फिल्टर'}
              >
                {categories.map(cat => (
                  <Option key={cat} value={cat}>
                    {cat === 'all' 
                      ? (language === 'english' ? 'All Categories' : 'सर्व श्रेणी') 
                      : cat}
                  </Option>
                ))}
              </Select>
            </Col>
            <Col span={10} style={{ textAlign: 'right' }}>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => setShowCreateModal(true)}
              >
                {language === 'english' ? 'New Unit' : 'नवीन युनिट'}
              </Button>
            </Col>
          </Row>

          {/* Units List */}
          <div style={{ 
            maxHeight: '400px', 
            overflowY: 'auto',
            border: '1px solid #f0f0f0',
            borderRadius: '8px',
            padding: '12px'
          }}>
            {loading ? (
              <div style={{ textAlign: 'center', padding: '40px' }}>
                <Spin />
              </div>
            ) : filteredUnits.length === 0 ? (
              <Empty 
                description={language === 'english' 
                  ? 'No units found. Create a new unit to get started.' 
                  : 'कोणतेही युनिट सापडले नाही. सुरू करण्यासाठी नवीन युनिट तयार करा.'}
              />
            ) : (
              <List
                itemLayout="horizontal"
                dataSource={filteredUnits}
                renderItem={unit => (
                  <List.Item
                    actions={[
                      <Button 
                        type="link" 
                        size="small" 
                        icon={<EditOutlined />}
                        onClick={() => setEditingUnit(unit)}
                      />,
                      <Popconfirm
                        title={language === 'english' ? 'Delete this unit?' : 'हे युनिट हटवायचे?'}
                        onConfirm={() => handleDeleteUnit(unit.id)}
                        okText={language === 'english' ? 'Yes' : 'होय'}
                        cancelText={language === 'english' ? 'No' : 'नाही'}
                      >
                        <Button type="link" size="small" icon={<DeleteOutlined />} danger />
                      </Popconfirm>,
                      <Button 
                        type="primary" 
                        size="small"
                        onClick={() => handleSelectUnit(unit)}
                      >
                        {language === 'english' ? 'Select' : 'निवडा'}
                      </Button>
                    ]}
                  >
                    <List.Item.Meta
                      avatar={<TagOutlined style={{ fontSize: 24, color: '#722ed1' }} />}
                      title={
                        <Space>
                          <Text strong>{unit.unit_name}</Text>
                          {unit.unit_symbol && (
                            <Tag color="blue">{unit.unit_symbol}</Tag>
                          )}
                          {unit.unit_category && (
                            <Tag color="green">{unit.unit_category}</Tag>
                          )}
                          {!unit.is_active && (
                            <Tag color="red">Inactive</Tag>
                          )}
                        </Space>
                      }
                      description={
                        <Space direction="vertical" size={0}>
                          <Text type="secondary">Value: {unit.unit_value}</Text>
                          {unit.id === selectedUnit?.id && (
                            <Text type="success">✓ Currently selected</Text>
                          )}
                        </Space>
                      }
                    />
                  </List.Item>
                )}
              />
            )}
          </div>
        </div>
      </Modal>

      {/* Create/Edit Unit Modal */}
      <Modal
        open={showCreateModal || !!editingUnit}
        onCancel={() => {
          setShowCreateModal(false);
          setEditingUnit(null);
          setNewUnit({
            unit_name: '',
            unit_value: '1',
            unit_symbol: '',
            unit_category: '',
            is_active: true
          });
        }}
        footer={null}
        title={
          <Space>
            {editingUnit ? <EditOutlined /> : <PlusOutlined />}
            {editingUnit 
              ? (language === 'english' ? 'Edit Unit' : 'युनिट संपादित करा')
              : (language === 'english' ? 'Create New Unit' : 'नवीन युनिट तयार करा')
            }
          </Space>
        }
      >
        <div style={{ padding: '20px 0' }}>
          <Form layout="vertical">
            <Form.Item 
              label={language === 'english' ? 'Unit Name *' : 'युनिटचे नाव *'}
              required
            >
              <Input
                value={editingUnit ? editingUnit.unit_name : newUnit.unit_name}
                onChange={(e) => {
                  if (editingUnit) {
                    setEditingUnit({ ...editingUnit, unit_name: e.target.value });
                  } else {
                    setNewUnit({ ...newUnit, unit_name: e.target.value });
                  }
                }}
                placeholder={language === 'english' ? 'e.g., Kilogram' : 'उदा., किलोग्रॅम'}
              />
            </Form.Item>

            <Form.Item 
              label={language === 'english' ? 'Unit Value *' : 'युनिट मूल्य *'}
              required
              extra={language === 'english' 
                ? 'Base conversion factor (e.g., 1000 for Kilogram to Gram)' 
                : 'मूलभूत रूपांतरण घटक (उदा., किलोग्रॅम ते ग्रॅमसाठी 1000)'}
            >
              <Input
                value={editingUnit ? editingUnit.unit_value : newUnit.unit_value}
                onChange={(e) => {
                  if (editingUnit) {
                    setEditingUnit({ ...editingUnit, unit_value: e.target.value });
                  } else {
                    setNewUnit({ ...newUnit, unit_value: e.target.value });
                  }
                }}
                placeholder="1"
              />
            </Form.Item>

            <Form.Item 
              label={language === 'english' ? 'Unit Symbol' : 'युनिट चिन्ह'}
            >
              <Input
                value={editingUnit ? editingUnit.unit_symbol : newUnit.unit_symbol}
                onChange={(e) => {
                  if (editingUnit) {
                    setEditingUnit({ ...editingUnit, unit_symbol: e.target.value });
                  } else {
                    setNewUnit({ ...newUnit, unit_symbol: e.target.value });
                  }
                }}
                placeholder={language === 'english' ? 'e.g., kg' : 'उदा., किग्रॅ'}
              />
            </Form.Item>

            <Form.Item 
              label={language === 'english' ? 'Category' : 'श्रेणी'}
            >
              <Input
                value={editingUnit ? editingUnit.unit_category : newUnit.unit_category}
                onChange={(e) => {
                  if (editingUnit) {
                    setEditingUnit({ ...editingUnit, unit_category: e.target.value });
                  } else {
                    setNewUnit({ ...newUnit, unit_category: e.target.value });
                  }
                }}
                placeholder={language === 'english' ? 'e.g., Weight' : 'उदा., वजन'}
              />
            </Form.Item>

            {editingUnit && (
              <Form.Item 
                label={language === 'english' ? 'Status' : 'स्थिती'}
              >
                <Radio.Group
                  value={editingUnit.is_active}
                  onChange={(e) => setEditingUnit({ ...editingUnit, is_active: e.target.value })}
                >
                  <Radio value={true}>Active</Radio>
                  <Radio value={false}>Inactive</Radio>
                </Radio.Group>
              </Form.Item>
            )}

            <Form.Item>
              <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
                <Button onClick={() => {
                  setShowCreateModal(false);
                  setEditingUnit(null);
                }}>
                  {language === 'english' ? 'Cancel' : 'रद्द करा'}
                </Button>
                <Button 
                  type="primary" 
                  onClick={editingUnit ? handleUpdateUnit : handleCreateUnit}
                >
                  {editingUnit 
                    ? (language === 'english' ? 'Update' : 'अद्यतनित करा')
                    : (language === 'english' ? 'Create' : 'तयार करा')
                  }
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </>
  );
};

const createField = (type, existingColumn = null, parentId = null, colName = null) => {
  const id = uid();

  console.log(`🔧 Creating field of type: ${type} with parentId: ${parentId}`);

  // ==================== DROPDOWN FIELD ====================
  if (type === "dropdown") {
    const defaultEnOptions = ["Sample Option 1", "Sample Option 2", "Sample Option 3"];
    const defaultMrOptions = ["नमुना पर्याय १", "नमुना पर्याय २", "नमुना पर्याय ३"];
    
    console.log("✅ Creating dropdown field with options:", defaultEnOptions);
    
    return {
      id: id,
      type: "dropdown",
      // English fields
      enLabel: "Dropdown Field",
      enPlaceholder: "Select an option...",
      enRequired: false,
      enOptions: [...defaultEnOptions],
      enHelpText: "",
      // Marathi fields
      mrLabel: "ड्रॉपडाउन फील्ड",
      mrPlaceholder: "पर्याय निवडा...",
      mrRequired: false,
      mrOptions: [...defaultMrOptions],
      mrHelpText: "",
      // Backward compatibility
      label: "Dropdown Field",
      placeholder: "Select an option...",
      required: false,
      options: [...defaultEnOptions],
      helpText: "",
      // Dropdown specific
      isDropdown: true,
      allowSearch: false,
      allowMultiSelect: false,
      // Position and hierarchy
      position: 0,
      parentId: parentId || null,
      colName: colName || null,
      // Validation
      validation: {
        exactLength: null,
        patternType: "none",
        customPattern: "",
        patternErrorMessage: "",
        allowedCharacters: "any",
        disallowedCharacters: "",
        allowSpaces: true,
        allowLeadingSpaces: false,
        allowTrailingSpaces: false,
        allowMultipleSpaces: true,
        trimInput: true,
        caseSensitive: true,
        uppercase: false,
        lowercase: false,
        languageScript: "any",
        fontFamily: "default",
        dateFormat: "YYYY-MM-DD",
        timeFormat: "HH:mm",
        dateTimeFormat: "YYYY-MM-DD HH:mm",
        allowZero: true,
        allowDecimals: false,
        decimalPlaces: null,
        allowNegative: false,
        validationFunction: null,
        validationMessage: "",
        isEmail: false,
        isPhone: false,
        isUrl: false,
        isIPAddress: false,
        isCreditCard: false,
        regexPattern: "",
        regexFlags: "g",
        customErrorMessage: "",
        detectLanguage: false,
        allowedLanguages: [],
      },
    };
  }

  // ==================== TEXT FIELD ====================
  if (type === "text") {
    return {
      id: id,
      type: "text",
      enLabel: "Text Field",
      mrLabel: "मजकूर फील्ड",
      enPlaceholder: "Enter text...",
      mrPlaceholder: "मजकूर प्रविष्ट करा...",
      enRequired: false,
      mrRequired: false,
      required: false,
      enHelpText: "",
      mrHelpText: "",
      label: "Text Field",
      placeholder: "Enter text...",
      position: 0,
      parentId: parentId || null,
      colName: colName || null,
      validation: {
        exactLength: null,
        patternType: "none",
        customPattern: "",
        patternErrorMessage: "",
        allowedCharacters: "any",
        disallowedCharacters: "",
        allowSpaces: true,
        allowLeadingSpaces: false,
        allowTrailingSpaces: false,
        allowMultipleSpaces: true,
        trimInput: true,
        caseSensitive: true,
        uppercase: false,
        lowercase: false,
        languageScript: "any",
        fontFamily: "default",
        dateFormat: "YYYY-MM-DD",
        timeFormat: "HH:mm",
        dateTimeFormat: "YYYY-MM-DD HH:mm",
        allowZero: true,
        allowDecimals: false,
        decimalPlaces: null,
        allowNegative: false,
        validationFunction: null,
        validationMessage: "",
        isEmail: false,
        isPhone: false,
        isUrl: false,
        isIPAddress: false,
        isCreditCard: false,
        regexPattern: "",
        regexFlags: "g",
        customErrorMessage: "",
        detectLanguage: false,
        allowedLanguages: [],
      },
    };
  }

  // ==================== NUMBER FIELD ====================
  if (type === "number") {
    return {
      id: id,
      type: "number",
      enLabel: "Number Field",
      mrLabel: "संख्या फील्ड",
      enPlaceholder: "Enter number...",
      mrPlaceholder: "संख्या प्रविष्ट करा...",
      enRequired: false,
      mrRequired: false,
      required: false,
      enHelpText: "",
      mrHelpText: "",
      label: "Number Field",
      placeholder: "Enter number...",
      hasUnit: false,
      selectedUnit: null,
      position: 0,
      parentId: parentId || null,
      colName: colName || null,
      defaultValue: null,        // ✅ ADD THIS
      importedExistingValue: null,
      validation: {
        exactLength: null,
        patternType: "none",
        customPattern: "",
        patternErrorMessage: "",
        allowedCharacters: "any",
        disallowedCharacters: "",
        allowSpaces: true,
        allowLeadingSpaces: false,
        allowTrailingSpaces: false,
        allowMultipleSpaces: true,
        trimInput: true,
        caseSensitive: true,
        uppercase: false,
        lowercase: false,
        languageScript: "any",
        fontFamily: "default",
        dateFormat: "YYYY-MM-DD",
        timeFormat: "HH:mm",
        dateTimeFormat: "YYYY-MM-DD HH:mm",
        allowZero: true,
        allowDecimals: false,
        decimalPlaces: null,
        allowNegative: false,
        validationFunction: null,
        validationMessage: "",
        isEmail: false,
        isPhone: false,
        isUrl: false,
        isIPAddress: false,
        isCreditCard: false,
        regexPattern: "",
        regexFlags: "g",
        customErrorMessage: "",
        detectLanguage: false,
        allowedLanguages: [],
      },
      reportConfig: {
        enabled: false,
        operator: 'add',
        customFormula: null,
        fields: []
      },
    };
  }

  // ==================== DATE FIELD ====================
  // ==================== DATE FIELD ====================
if (type === "date") {
  return {
    id: id,
    type: "date",
    enLabel: "Date Field",
    mrLabel: "तारीख फील्ड",
    enRequired: false,
    mrRequired: false,
    required: false,
    enHelpText: "",
    mrHelpText: "",
    label: "Date Field",
    position: 0,
    parentId: parentId || null,
    colName: colName || null,
    defaultValue: null,        // ✅ ADD THIS
    importedExistingValue: null,
    // ✅ ADD DATE COMPARISON PROPERTIES
    enableDateComparison: false,           // Enable/disable comparison
    comparisonType: "single",              // 'single', 'range', or 'field'
    comparisonOperator: "equals",          // Operator for comparison
    compareWithDate: null,                 // Static date value
    compareWithFieldId: null,              // Another date field ID
    startDate: null,                       // For range - start date
    endDate: null,                         // For range - end date
    customValidationMessage: "",           // Custom error message
    showComparisonResult: true,            // Show validation result
    
    validation: {
      exactLength: null,
      patternType: "none",
      customPattern: "",
      patternErrorMessage: "",
      allowedCharacters: "any",
      disallowedCharacters: "",
      allowSpaces: true,
      allowLeadingSpaces: false,
      allowTrailingSpaces: false,
      allowMultipleSpaces: true,
      trimInput: true,
      caseSensitive: true,
      uppercase: false,
      lowercase: false,
      languageScript: "any",
      fontFamily: "default",
      dateFormat: "YYYY-MM-DD",
      timeFormat: "HH:mm",
      dateTimeFormat: "YYYY-MM-DD HH:mm",
      allowZero: true,
      allowDecimals: false,
      decimalPlaces: null,
      allowNegative: false,
      validationFunction: null,
      validationMessage: "",
      isEmail: false,
      isPhone: false,
      isUrl: false,
      isIPAddress: false,
      isCreditCard: false,
      regexPattern: "",
      regexFlags: "g",
      customErrorMessage: "",
      detectLanguage: false,
      allowedLanguages: [],
      // ✅ ADD DATE VALIDATION
      minDate: null,
      maxDate: null,
      futureDates: false,
      pastDates: false,
      todayOnly: false,
    },
  };
}

  // ==================== CHECKBOX FIELD ====================
  if (type === "checkbox") {
    return {
      id: id,
      type: "checkbox",
      enLabel: "Checkbox Field",
      mrLabel: "चेकबॉक्स फील्ड",
      enOptions: ["Option 1", "Option 2", "Option 3"],
      mrOptions: ["पर्याय १", "पर्याय २", "पर्याय ३"],
      options: ["Option 1", "Option 2", "Option 3"],
      enRequired: false,
      mrRequired: false,
      required: false,
      enHelpText: "",
      mrHelpText: "",
      label: "Checkbox Field",
      isCheckboxGroup: true,
      position: 0,
      parentId: parentId || null,
      colName: colName || null,
      defaultValue: null,        // ✅ ADD THIS
      importedExistingValue: null,
      validation: {
        exactLength: null,
        patternType: "none",
        customPattern: "",
        patternErrorMessage: "",
        allowedCharacters: "any",
        disallowedCharacters: "",
        allowSpaces: true,
        allowLeadingSpaces: false,
        allowTrailingSpaces: false,
        allowMultipleSpaces: true,
        trimInput: true,
        caseSensitive: true,
        uppercase: false,
        lowercase: false,
        languageScript: "any",
        fontFamily: "default",
        dateFormat: "YYYY-MM-DD",
        timeFormat: "HH:mm",
        dateTimeFormat: "YYYY-MM-DD HH:mm",
        allowZero: true,
        allowDecimals: false,
        decimalPlaces: null,
        allowNegative: false,
        validationFunction: null,
        validationMessage: "",
        isEmail: false,
        isPhone: false,
        isUrl: false,
        isIPAddress: false,
        isCreditCard: false,
        regexPattern: "",
        regexFlags: "g",
        customErrorMessage: "",
        detectLanguage: false,
        allowedLanguages: [],
      },
    };
  }

  // ==================== RADIO FIELD ====================
  if (type === "radio") {
    return {
      id: id,
      type: "radio",
      enLabel: "Radio Field",
      mrLabel: "रेडिओ फील्ड",
      enOptions: ["Option 1", "Option 2", "Option 3"],
      mrOptions: ["पर्याय १", "पर्याय २", "पर्याय ३"],
      options: ["Option 1", "Option 2", "Option 3"],
      enRequired: false,
      mrRequired: false,
      required: false,
      enHelpText: "",
      mrHelpText: "",
      label: "Radio Field",
      isRadioGroup: true,
      position: 0,
      parentId: parentId || null,
      colName: colName || null,
      defaultValue: null,        // ✅ ADD THIS
    importedExistingValue: null,
      validation: {
        exactLength: null,
        patternType: "none",
        customPattern: "",
        patternErrorMessage: "",
        allowedCharacters: "any",
        disallowedCharacters: "",
        allowSpaces: true,
        allowLeadingSpaces: false,
        allowTrailingSpaces: false,
        allowMultipleSpaces: true,
        trimInput: true,
        caseSensitive: true,
        uppercase: false,
        lowercase: false,
        languageScript: "any",
        fontFamily: "default",
        dateFormat: "YYYY-MM-DD",
        timeFormat: "HH:mm",
        dateTimeFormat: "YYYY-MM-DD HH:mm",
        allowZero: true,
        allowDecimals: false,
        decimalPlaces: null,
        allowNegative: false,
        validationFunction: null,
        validationMessage: "",
        isEmail: false,
        isPhone: false,
        isUrl: false,
        isIPAddress: false,
        isCreditCard: false,
        regexPattern: "",
        regexFlags: "g",
        customErrorMessage: "",
        detectLanguage: false,
        allowedLanguages: [],
      },
    };
  }

  // ==================== HEADING FIELD ====================
  if (type === "heading") {
    return {
      id: id,
      type: "heading",
      enLabel: "Heading",
      mrLabel: "शीर्षक",
      headingLevel: parentId ? 2 : 1,
      enHelpText: "",
      mrHelpText: "",
      label: "Heading",
      headingChildren: [],
      position: 0,
      parentId: parentId || null,
      colName: colName || null,
    };
  }

  // ==================== PARAGRAPH FIELD ====================
  if (type === "paragraph") {
    return {
      id: id,
      type: "paragraph",
      enLabel: "Paragraph",
      mrLabel: "परिच्छेद",
      enHelpText: "",
      mrHelpText: "",
      label: "Paragraph",
      position: 0,
      parentId: parentId || null,
      colName: colName || null,
    };
  }

  // ==================== FILE UPLOAD FIELD ====================
  if (type === "file") {
    return {
      id: id,
      type: "file",
      enLabel: "File Upload",
      mrLabel: "फाइल अपलोड",
      enRequired: false,
      mrRequired: false,
      required: false,
      enHelpText: "",
      mrHelpText: "",
      label: "File Upload",
      acceptedFileTypes: ".jpg,.jpeg,.png,.gif,.bmp,.pdf,.doc,.docx,.xls,.xlsx,.txt",
      maxFileSize: 5,
      maxFileCount: 1,
      fileList: [],
      position: 0,
      parentId: parentId || null,
      colName: colName || null,
    };
  }

  // ==================== ROW FIELD (2 COLUMNS) ====================
  if (type === "row") {
    return {
      id: id,
      type: "row",
      enLabel: "2 Columns",
      mrLabel: "२ स्तंभ",
      label: "2 Columns",
      children: { left: [], right: [] },
      position: 0,
      parentId: parentId || null,
      colName: colName || null,
    };
  }

  // ==================== COMPARISON FIELD ====================
  // In createField function - COMPARISON FIELD section
if (type === "comparison") {
  return {
    id: id,
    type: "comparison",
    enLabel: "Comparison Field",
    mrLabel: "तुलना फील्ड",
    enHelpText: "",
    mrHelpText: "",
    label: "Comparison Field",
    isComparisonGroup: true,
    comparisonOperator: "equals",
    customValidationMessage: "",
    mainField: {
      id: uid(),
      type: "number",
      enLabel: "Main Value",
      mrLabel: "मुख्य मूल्य",
      enPlaceholder: "Enter main value",
      mrPlaceholder: "मुख्य मूल्य प्रविष्ट करा",
      enRequired: false,
      mrRequired: false,
      required: false,
      // ✅ UNIT PROPERTIES
      hasUnit: false,
      selectedUnit: null,
      selectedUnitObject: null,
      units: {
        enabled: false,
        selectedUnit: null,
        selectedUnitId: null,
        selectedUnitValue: null,
        selectedUnitSymbol: null,
        selectedUnitLabel: null,
        unitCategory: null
      },
      // ✅ ADD VALIDATION FOR MAIN FIELD
      validation: {
        exactLength: null,
        decimalPlaces: null,
        allowDecimals: false,
        allowNegative: false,
        allowZero: true,
        integerOnly: false,
        patternType: "none",
        customPattern: "",
        patternErrorMessage: "",
        allowedCharacters: "any",
        disallowedCharacters: "",
        allowSpaces: true,
        allowLeadingSpaces: false,
        allowTrailingSpaces: false,
        allowMultipleSpaces: true,
        trimInput: true,
        caseSensitive: true,
        uppercase: false,
        lowercase: false,
        languageScript: "any",
        fontFamily: "default",
        dateFormat: "YYYY-MM-DD",
        timeFormat: "HH:mm",
        dateTimeFormat: "YYYY-MM-DD HH:mm",
        validationFunction: null,
        validationMessage: "",
        isEmail: false,
        isPhone: false,
        isUrl: false,
        isIPAddress: false,
        isCreditCard: false,
        regexPattern: "",
        regexFlags: "g",
        customErrorMessage: "",
        detectLanguage: false,
        allowedLanguages: []
      }
    },
    subFields: [{
      id: uid(),
      type: "number",
      arithmeticOperator: "add",
      enLabel: "Sub Value 1",
      mrLabel: "उप-मूल्य १",
      enPlaceholder: "Enter value",
      mrPlaceholder: "मूल्य प्रविष्ट करा",
      enRequired: false,
      mrRequired: false,
      required: false,
      // ✅ UNIT PROPERTIES
      hasUnit: false,
      selectedUnit: null,
      selectedUnitObject: null,
      units: {
        enabled: false,
        selectedUnit: null,
        selectedUnitId: null,
        selectedUnitValue: null,
        selectedUnitSymbol: null,
        selectedUnitLabel: null,
        unitCategory: null
      },
      // ✅ ADD VALIDATION FOR SUB FIELD
      validation: {
        exactLength: null,
        decimalPlaces: null,
        allowDecimals: false,
        allowNegative: false,
        allowZero: true,
        integerOnly: false,
        patternType: "none",
        customPattern: "",
        patternErrorMessage: "",
        allowedCharacters: "any",
        disallowedCharacters: "",
        allowSpaces: true,
        allowLeadingSpaces: false,
        allowTrailingSpaces: false,
        allowMultipleSpaces: true,
        trimInput: true,
        caseSensitive: true,
        uppercase: false,
        lowercase: false,
        languageScript: "any",
        fontFamily: "default",
        dateFormat: "YYYY-MM-DD",
        timeFormat: "HH:mm",
        dateTimeFormat: "YYYY-MM-DD HH:mm",
        validationFunction: null,
        validationMessage: "",
        isEmail: false,
        isPhone: false,
        isUrl: false,
        isIPAddress: false,
        isCreditCard: false,
        regexPattern: "",
        regexFlags: "g",
        customErrorMessage: "",
        detectLanguage: false,
        allowedLanguages: []
      }
    }],
    position: 0,
    parentId: parentId || null,
    colName: colName || null,
  };
}

  // ==================== ARITHMETIC FIELD ====================
if (type === "arithmetic") {
  return {
    id: id,
    type: "arithmetic",
    enLabel: "Arithmetic Field",
    mrLabel: "अंकगणित फील्ड",
    enHelpText: "",
    mrHelpText: "",
    label: "Arithmetic Field",
    isArithmeticGroup: true,
    arithmeticOperator: "add",
    arithmeticFields: [
      {
        id: uid(),
        type: "number",
        enLabel: "Value 1",
        mrLabel: "मूल्य १",
        enPlaceholder: "Enter value",
        mrPlaceholder: "मूल्य प्रविष्ट करा",
        enRequired: false,
        mrRequired: false,
        required: false,
        hasUnit: false,
        selectedUnit: null,
        selectedUnitObject: null,
        units: { enabled: false },
        // :white_check_mark: ADD VALIDATION
        validation: {
          exactLength: null,
          decimalPlaces: null,
          allowDecimals: false,
          allowNegative: false,
          allowZero: true,
          integerOnly: false,
          patternType: "none",
          customPattern: "",
          patternErrorMessage: "",
          allowedCharacters: "any",
          disallowedCharacters: "",
          allowSpaces: true,
          allowLeadingSpaces: false,
          allowTrailingSpaces: false,
          allowMultipleSpaces: true,
          trimInput: true,
          caseSensitive: true,
          uppercase: false,
          lowercase: false,
          languageScript: "any",
          fontFamily: "default",
          dateFormat: "YYYY-MM-DD",
          timeFormat: "HH:mm",
          dateTimeFormat: "YYYY-MM-DD HH:mm",
          validationFunction: null,
          validationMessage: "",
          isEmail: false,
          isPhone: false,
          isUrl: false,
          isIPAddress: false,
          isCreditCard: false,
          regexPattern: "",
          regexFlags: "g",
          customErrorMessage: "",
          detectLanguage: false,
          allowedLanguages: []
        }
      },
      {
        id: uid(),
        type: "number",
        enLabel: "Value 2",
        mrLabel: "मूल्य २",
        enPlaceholder: "Enter value",
        mrPlaceholder: "मूल्य प्रविष्ट करा",
        enRequired: false,
        mrRequired: false,
        required: false,
        hasUnit: false,
        selectedUnit: null,
        selectedUnitObject: null,
        units: { enabled: false },
        // :white_check_mark: ADD VALIDATION
        validation: {
          exactLength: null,
          decimalPlaces: null,
          allowDecimals: false,
          allowNegative: false,
          allowZero: true,
          integerOnly: false,
          patternType: "none",
          customPattern: "",
          patternErrorMessage: "",
          allowedCharacters: "any",
          disallowedCharacters: "",
          allowSpaces: true,
          allowLeadingSpaces: false,
          allowTrailingSpaces: false,
          allowMultipleSpaces: true,
          trimInput: true,
          caseSensitive: true,
          uppercase: false,
          lowercase: false,
          languageScript: "any",
          fontFamily: "default",
          dateFormat: "YYYY-MM-DD",
          timeFormat: "HH:mm",
          dateTimeFormat: "YYYY-MM-DD HH:mm",
          validationFunction: null,
          validationMessage: "",
          isEmail: false,
          isPhone: false,
          isUrl: false,
          isIPAddress: false,
          isCreditCard: false,
          regexPattern: "",
          regexFlags: "g",
          customErrorMessage: "",
          detectLanguage: false,
          allowedLanguages: []
        }
      }
    ],
    showResultBox: true,
    resultField: {
      id: uid(),
      type: "number",
      enLabel: "Result",
      mrLabel: "परिणाम",
      enPlaceholder: "Result",
      mrPlaceholder: "परिणाम",
      enRequired: false,
      mrRequired: false,
      required: false,
      hasUnit: false,
      selectedUnit: null,
      selectedUnitObject: null,
      units: { enabled: false },
      // :white_check_mark: ADD VALIDATION FOR RESULT FIELD
      validation: {
        exactLength: null,
        decimalPlaces: null,
        allowDecimals: false,
        allowNegative: false,
        allowZero: true,
        integerOnly: false,
        patternType: "none",
        customPattern: "",
        patternErrorMessage: "",
        allowedCharacters: "any",
        disallowedCharacters: "",
        allowSpaces: true,
        allowLeadingSpaces: false,
        allowTrailingSpaces: false,
        allowMultipleSpaces: true,
        trimInput: true,
        caseSensitive: true,
        uppercase: false,
        lowercase: false,
        languageScript: "any",
        fontFamily: "default",
        dateFormat: "YYYY-MM-DD",
        timeFormat: "HH:mm",
        dateTimeFormat: "YYYY-MM-DD HH:mm",
        validationFunction: null,
        validationMessage: "",
        isEmail: false,
        isPhone: false,
        isUrl: false,
        isIPAddress: false,
        isCreditCard: false,
        regexPattern: "",
        regexFlags: "g",
        customErrorMessage: "",
        detectLanguage: false,
        allowedLanguages: []
      }
    },
    position: 0,
    parentId: parentId || null,
    colName: colName || null,
  };
}

// ==================== FORMULA FIELD ====================
// In FormBuilderContent.jsx, find the FORMULA FIELD section in createField function
// Replace it with this:

// ==================== FORMULA FIELD ====================
if (type === "formula") {
  return {
    id: id,
    type: "formula",
    enLabel: "Formula Field",
    mrLabel: "सूत्र फील्ड",
    enHelpText: "",
    mrHelpText: "",
    label: "Formula Field",
    isFormulaGroup: true,
    // Multi-level formula steps (can be arithmetic or logical)
    formulaSteps: [],
    // Final combine operator for multiple steps
    stepCombineOperator: "add",
    // Show/hide result in form
    showResult: true,
    // Final result label
    finalResultLabel: { en: "Final Result", mr: "अंतिम निकाल" },
    // Final result false message
    finalFalseMessage: "",
    // Position
    position: 0,
    parentId: parentId || null,
    colName: colName || null,
    // Unit properties for the formula result
    hasUnit: false,
    selectedUnit: null,
    selectedUnitObject: null,
    units: {
      enabled: false,
      selectedUnit: null,
      selectedUnitId: null,
      selectedUnitValue: null,
      selectedUnitSymbol: null,
      selectedUnitLabel: null,
      unitCategory: null
    },
    // Help text (bilingual)
    enHelpText: "",
    mrHelpText: "",
    // Required flag
    required: false,
    enRequired: false,
    mrRequired: false,
  };
}


  // ==================== DEFAULT FALLBACK ====================
  return {
    id: id,
    type: type,
    enLabel: `${type} Field`,
    mrLabel: `${type} फील्ड`,
    enRequired: false,
    mrRequired: false,
    required: false,
    enHelpText: "",
    mrHelpText: "",
    label: `${type} Field`,
    position: 0,
    parentId: parentId || null,
    colName: colName || null,
    validation: {
      exactLength: null,
      patternType: "none",
      customPattern: "",
      patternErrorMessage: "",
      allowedCharacters: "any",
      disallowedCharacters: "",
      allowSpaces: true,
      allowLeadingSpaces: false,
      allowTrailingSpaces: false,
      allowMultipleSpaces: true,
      trimInput: true,
      caseSensitive: true,
      uppercase: false,
      lowercase: false,
      languageScript: "any",
      fontFamily: "default",
      dateFormat: "YYYY-MM-DD",
      timeFormat: "HH:mm",
      dateTimeFormat: "YYYY-MM-DD HH:mm",
      allowZero: true,
      allowDecimals: false,
      decimalPlaces: null,
      allowNegative: false,
      validationFunction: null,
      validationMessage: "",
      isEmail: false,
      isPhone: false,
      isUrl: false,
      isIPAddress: false,
      isCreditCard: false,
      regexPattern: "",
      regexFlags: "g",
      customErrorMessage: "",
      detectLanguage: false,
      allowedLanguages: [],
    },
  };
};

// Update node in list
const updateNodeInList = (list, nodeId, updater) =>
  list.map((n) => {
    if (n.id === nodeId) return updater(n);
    if (n.type === "row" && n.children) {
      return {
        ...n,
        children: {
          left: updateNodeInList(n.children.left || [], nodeId, updater),
          right: updateNodeInList(n.children.right || [], nodeId, updater),
        },
      };
    }
    return n;
  });
// Add this COMPARISON MODAL COMPONENT before FormBuilderContent
// const ComparisonModal = ({ visible, onClose, formFields, language }) => {
//   return (
//     <Modal
//       open={visible}
//       onCancel={onClose}
//       footer={[
//         <Button key="close" onClick={onClose}>
//           {language === 'english' ? 'Close' : 'बंद करा'}
//         </Button>
//       ]}
//       width={600}
//       title={
//         <Space>
//           <SwapOutlined style={{ color: '#fa8c16' }} />
//           {language === 'english' ? 'Comparison Feature' : 'तुलना वैशिष्ट्य'}
//         </Space>
//       }
//       centered
//     >
//       <div style={{ padding: '20px 0' }}>
//         <p>
//           {language === 'english' 
//             ? 'Comparison functionality is being developed. Please check back later.'
//             : 'तुलना कार्यक्षमता विकसित केली जात आहे. कृपया नंतर परत तपासा.'}
//         </p>
//       </div>
//     </Modal>
//   );
// };
// Delete node from list
const deleteNodeFromList = (list, nodeId) =>
  list
    .filter((n) => n.id !== nodeId)
    .map((n) => {
      if (n.type === "row" && n.children) {
        return {
          ...n,
          children: {
            left: deleteNodeFromList(n.children.left || [], nodeId),
            right: deleteNodeFromList(n.children.right || [], nodeId),
          },
        };
      }
      return n;
    });

// Get all subfields for a field
const getSubFields = (nodes, parentId) => {
  return nodes.filter(n => n.parentId === parentId);
};

// Helper function for field colors
const getFieldColor = (type) => {
  const colors = {
    radio: "#722ed1",
    checkbox: "#52c41a",
    heading: "#fa8c16",
    paragraph: "#13c2c2",
    comparison: "#fa8c16",
    arithmetic: "#52c41a",
    file: "#1890ff",
    dropdown: "#722ed1",
    default: "#1890ff"
  };
  return colors[type] || colors.default;
};

// Drag Handle Component
const DragHandle = ({ listeners, attributes }) => (
  <button
    {...attributes}
    {...listeners}
    style={{
      padding: "4px",
      background: "none",
      border: "none",
      cursor: "grab",
      color: "#999",
    }}
  >
    <MenuOutlined />
  </button>
);

// Sortable Item Shell
const SortableItemShell = ({ id, children }) => {
  const {
    setNodeRef,
    attributes,
    listeners,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  return (
    <div
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
      }}
    >
      <div style={{ display: "flex", alignItems: "flex-start", gap: "8px" }}>
        <div ref={setActivatorNodeRef} {...attributes} {...listeners}>
          <DragHandle listeners={listeners} attributes={attributes} />
        </div>
        <div style={{ flex: 1 }}>{children}</div>
      </div>
    </div>
  );
};

// Existing Column Item
const ExistingColumnItem = ({ column, onDragStart }) => {
  const isFileType = column.type === 'file';
  
  return (
    <div
      draggable
      onDragStart={(e) => {
        e.dataTransfer.setData("text/plain", JSON.stringify(column));
        onDragStart && onDragStart(column);
      }}
      style={{
        padding: "8px 12px",
        margin: "4px 0",
        background: "#f0f5ff",
        border: "1px solid #adc6ff",
        borderRadius: "4px",
        cursor: "grab",
        display: "flex",
        alignItems: "center",
        gap: "8px",
        userSelect: "none"
      }}
    >
      <DragOutlined style={{ color: "#113F67" }} />
      <div style={{ flex: 1 }}>
        <Text strong style={{ fontSize: "13px" }}>{column.label}</Text>
        <br />
        <Text type="secondary" style={{ fontSize: "11px" }}>
          {column.type} {column.required && "• Required"}
          {isFileType && column.maxFileSize && ` • Max ${column.maxFileSize}MB`}
          {isFileType && column.maxFileCount > 1 && ` • Up to ${column.maxFileCount} files`}
        </Text>
      </div>
    </div>
  );
};

// Droppable Zone
const DroppableZone = ({ id, children, style }) => {
  const { setNodeRef, isOver } = useDroppable({ id });
  return (
    <div
      ref={setNodeRef}
      style={{
        transition: "all 0.2s",
        background: isOver ? "#e6f7ff" : "transparent",
        minHeight: "50px",
        ...style
      }}
    >
      {children}
    </div>
  );
};

// Editable Input component
const EditableInput = ({ value, onChange, placeholder, language, autoTranslate, onTranslate }) => {
  return (
    <Input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      size="small"
      allowClear
    />
  );
};

// ==================== DROPDOWN FIELD EDITOR - COMPLETELY FIXED ====================
const DropdownFieldEditor = ({ field, onUpdate, onDelete, onCopy, language, autoTranslate, translateTyping, translating, disabled }) => {
  const [activeLanguage, setActiveLanguage] = useState(language || 'english');
  const [typingTimeouts, setTypingTimeouts] = useState({});
  const [localEnOptions, setLocalEnOptions] = useState([]);
  const [localMrOptions, setLocalMrOptions] = useState([]);
  const [previewValue, setPreviewValue] = useState(null);

  // Load options from field on mount and when field changes
  useEffect(() => {
    const enOpts = field.enOptions || field.options || [];
    const mrOpts = field.mrOptions || [];
    
    console.log("📋 Loading dropdown options:", { enOpts, mrOpts });
    
    if (enOpts.length === 0) {
      const defaultEn = ["Option 1", "Option 2", "Option 3"];
      const defaultMr = ["पर्याय १", "पर्याय २", "पर्याय ३"];
      setLocalEnOptions(defaultEn);
      setLocalMrOptions(defaultMr);
      
      onUpdate({ 
        ...field, 
        enOptions: defaultEn, 
        options: defaultEn,
        mrOptions: defaultMr 
      });
    } else {
      setLocalEnOptions([...enOpts]);
      setLocalMrOptions([...mrOpts]);
    }
  }, [field.id]);

  const saveOptionsToParent = (newEn, newMr) => {
    onUpdate({ 
      ...field, 
      enOptions: newEn, 
      options: newEn,
      mrOptions: newMr 
    });
  };

  const updateField = (key, value) => {
    if (disabled) return;
    console.log(`  Updating field: ${key} = ${value}`);
    onUpdate({ ...field, [key]: value });
  };

  const handleTranslate = async (text, targetField) => {
    if (!autoTranslate || !text || text.trim() === '') return;
    if (typingTimeouts[targetField]) clearTimeout(typingTimeouts[targetField]);
    const timeout = setTimeout(async () => {
      const translated = await translateTyping(text, 'mr');
      if (translated && translated !== text) {
        if (targetField === 'mrLabel') updateField('mrLabel', translated);
        else if (targetField === 'mrPlaceholder') updateField('mrPlaceholder', translated);
        else if (targetField === 'mrHelpText') updateField('mrHelpText', translated);
      }
    }, 800);
    setTypingTimeouts(prev => ({ ...prev, [targetField]: timeout }));
  };

  const addOption = () => {
    if (disabled) return;
    const newEn = [...localEnOptions, `Option ${localEnOptions.length + 1}`];
    const newMr = [...localMrOptions, `पर्याय ${localMrOptions.length + 1}`];
    setLocalEnOptions(newEn);
    setLocalMrOptions(newMr);
    saveOptionsToParent(newEn, newMr);
  };

  const removeOption = (index) => {
    if (disabled) return;
    if (localEnOptions.length <= 1) {
      message.warning(activeLanguage === 'english' ? "At least one option is required" : "किमान एक पर्याय आवश्यक आहे");
      return;
    }
    const newEn = localEnOptions.filter((_, i) => i !== index);
    const newMr = localMrOptions.filter((_, i) => i !== index);
    setLocalEnOptions(newEn);
    setLocalMrOptions(newMr);
    saveOptionsToParent(newEn, newMr);
  };

  const updateOption = (index, value, lang) => {
    if (disabled) return;
    if (lang === 'english') {
      const newEn = [...localEnOptions];
      newEn[index] = value;
      setLocalEnOptions(newEn);
      saveOptionsToParent(newEn, localMrOptions);
    } else {
      const newMr = [...localMrOptions];
      newMr[index] = value;
      setLocalMrOptions(newMr);
      saveOptionsToParent(localEnOptions, newMr);
    }
  };

  const moveOptionUp = (index) => {
    if (disabled || index === 0) return;
    const newEn = [...localEnOptions];
    const newMr = [...localMrOptions];
    [newEn[index - 1], newEn[index]] = [newEn[index], newEn[index - 1]];
    [newMr[index - 1], newMr[index]] = [newMr[index], newMr[index - 1]];
    setLocalEnOptions(newEn);
    setLocalMrOptions(newMr);
    saveOptionsToParent(newEn, newMr);
  };

  const moveOptionDown = (index) => {
    if (disabled || index === localEnOptions.length - 1) return;
    const newEn = [...localEnOptions];
    const newMr = [...localMrOptions];
    [newEn[index], newEn[index + 1]] = [newEn[index + 1], newEn[index]];
    [newMr[index], newMr[index + 1]] = [newMr[index + 1], newMr[index]];
    setLocalEnOptions(newEn);
    setLocalMrOptions(newMr);
    saveOptionsToParent(newEn, newMr);
  };

  // Create options for Select component
  const getSelectOptions = () => {
    const options = [];
    for (let i = 0; i < localEnOptions.length; i++) {
      options.push({
        label: activeLanguage === 'english' ? localEnOptions[i] : (localMrOptions[i] || localEnOptions[i]),
        value: localEnOptions[i]
      });
    }
    return options;
  };

  useEffect(() => {
    return () => { Object.values(typingTimeouts).forEach(timeout => clearTimeout(timeout)); };
  }, [typingTimeouts]);

  // Debug log
  console.log("DropdownFieldEditor - disabled:", disabled, "field.enRequired:", field.enRequired);

  return (
    <Card size="small" style={{ marginBottom: 12, borderRadius: "8px", border: "2px solid #722ed1", boxShadow: "0 2px 8px rgba(114, 46, 209, 0.1)", opacity: disabled ? 0.7 : 1 }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Badge count="Dropdown" style={{ backgroundColor: "#722ed1" }} />
          <span style={{ fontWeight: 'bold', fontSize: '14px' }}>Dropdown Field</span>
          {autoTranslate && <Tag color="green" icon={<GlobalOutlined />}>Auto ON</Tag>}
          {disabled && <Tag color="orange">Read Only</Tag>}
        </div>
        <Space size={4}>
          <Tooltip title="Copy"><Button type="text" size="small" icon={<CopyOutlined />} onClick={onCopy} disabled={disabled} /></Tooltip>
          <Tooltip title="Delete"><Button type="text" size="small" icon={<DeleteOutlined />} onClick={onDelete} danger disabled={disabled} /></Tooltip>
        </Space>
      </div>

      <div style={{ marginBottom: 12, display: 'flex', justifyContent: 'flex-end' }}>
        <Button.Group size="small">
          <Button type={activeLanguage === 'english' ? 'primary' : 'default'} onClick={() => setActiveLanguage('english')}>English</Button>
          <Button type={activeLanguage === 'marathi' ? 'primary' : 'default'} onClick={() => setActiveLanguage('marathi')}>मराठी</Button>
        </Button.Group>
      </div>

      {/* Field Label */}
      <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
        <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
          <Text type="secondary">Field Label</Text>
        </Col>
        <Col span={16}>
          <Input
            value={activeLanguage === 'english' ? field.enLabel : field.mrLabel}
            onChange={(e) => {
              const value = e.target.value;
              if (activeLanguage === 'english') {
                updateField("enLabel", value);
                handleTranslate(value, "mrLabel");
              } else {
                updateField("mrLabel", value);
              }
            }}
            placeholder="Enter label"
            disabled={disabled}
          />
        </Col>
      </Row>

      {/* Placeholder */}
      <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
        <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
          <Text type="secondary">Placeholder</Text>
        </Col>
        <Col span={16}>
          <Input
            value={activeLanguage === 'english' ? field.enPlaceholder : field.mrPlaceholder}
            onChange={(e) => {
              const value = e.target.value;
              if (activeLanguage === 'english') {
                updateField("enPlaceholder", value);
                updateField("placeholder", value);
                handleTranslate(value, "mrPlaceholder");
              } else {
                updateField("mrPlaceholder", value);
              }
            }}
            placeholder="Enter placeholder"
            disabled={disabled}
          />
        </Col>
      </Row>

      {/* Help Text */}
      {/* <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
        <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
          <Text type="secondary">Help Text</Text>
        </Col>
        <Col span={16}>
          <Input
            value={activeLanguage === 'english' ? field.enHelpText : field.mrHelpText}
            onChange={(e) => {
              const value = e.target.value;
              if (activeLanguage === 'english') {
                updateField("enHelpText", value);
                handleTranslate(value, "mrHelpText");
              } else {
                updateField("mrHelpText", value);
              }
            }}
            placeholder="Enter help text"
            disabled={disabled}
          />
        </Col>
      </Row> */}

      {/* Dropdown Options */}
      <div style={{ marginBottom: 16 }}>
        <Row align="top" gutter={16}>
          <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
            <Text type="secondary">Dropdown Options</Text>
            <Text type="secondary" style={{ fontSize: "11px" }}>({localEnOptions.length} options)</Text>
          </Col>
          <Col span={16}>
            {localEnOptions.map((opt, idx) => (
              <div key={idx} style={{ marginBottom: "10px", display: "flex", alignItems: "center", gap: "8px", background: "#fafafa", padding: "10px 12px", borderRadius: "8px", border: "1px solid #e8e8e8" }}>
                <MenuOutlined style={{ color: "#999", fontSize: "14px", cursor: "grab" }} />
                <Tag color="purple" style={{ minWidth: "45px", textAlign: "center", fontWeight: "bold" }}>{idx + 1}</Tag>
                <Input
                  value={activeLanguage === 'english' ? opt : (localMrOptions[idx] || opt)}
                  onChange={(e) => updateOption(idx, e.target.value, activeLanguage === 'english' ? 'english' : 'marathi')}
                  size="middle"
                  style={{ flex: 1 }}
                  placeholder={`Option ${idx + 1}`}
                  disabled={disabled}
                />
                <Button.Group size="small">
                  <Tooltip title="Move Up">
                    <Button icon={<ArrowUpOutlined />} onClick={() => moveOptionUp(idx)} disabled={idx === 0 || disabled} />
                  </Tooltip>
                  <Tooltip title="Move Down">
                    <Button icon={<ArrowDownOutlined />} onClick={() => moveOptionDown(idx)} disabled={idx === localEnOptions.length - 1 || disabled} />
                  </Tooltip>
                  {localEnOptions.length > 1 && (
                    <Tooltip title="Delete Option">
                      <Button icon={<DeleteOutlined />} onClick={() => removeOption(idx)} danger disabled={disabled} />
                    </Tooltip>
                  )}
                  <Tooltip title="Add New Option">
                    <Button 
                      icon={<PlusOutlined />} 
                      onClick={addOption} 
                      disabled={disabled}
                      style={{ backgroundColor: "#52c41a", color: "white", borderColor: "#52c41a" }}
                    />
                  </Tooltip>
                </Button.Group>
              </div>
            ))}
          </Col>
        </Row>
      </div>

      {/* Advanced Settings */}
      <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
        <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
          <Text type="secondary">Advanced</Text>
        </Col>
        <Col span={16}>
          <Space direction="vertical" style={{ width: "100%" }}>
            <Checkbox 
              checked={field.allowSearch === true} 
              onChange={(e) => {
                console.log("Allow search changed:", e.target.checked);
                updateField("allowSearch", e.target.checked);
              }} 
              disabled={disabled}
            >
              <Space><SearchOutlined />Allow search in dropdown</Space>
            </Checkbox>
            <Checkbox 
              checked={field.allowMultiSelect === true} 
              onChange={(e) => {
                console.log("Allow multi select changed:", e.target.checked);
                updateField("allowMultiSelect", e.target.checked);
                setPreviewValue(null);
              }} 
              disabled={disabled}
            >
              <Space><CheckSquareOutlined />Allow multiple selection</Space>
            </Checkbox>
          </Space>
        </Col>
      </Row>
{/* Validation - Required field */}
{/* Required checkbox */}
<Row align="middle" gutter={16} style={{ marginBottom: 12 }}>
  <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
    <Text type="secondary" style={{ fontSize: '11px' }}>Required</Text>
  </Col>
  <Col span={16}>
    <Space size={16}>
      <Checkbox
        checked={field.enRequired === true}
        onChange={(e) => {
          const checked = e.target.checked;
          console.log("✅ Dropdown required checkbox clicked:", checked);
          
          // Update all required fields
          updateField("enRequired", checked);
  
        }}
        disabled={disabled === true}
      >
        Required
      </Checkbox>
    </Space>
  </Col>
</Row>

      {/* Live Preview */}
      <Row align="middle" gutter={16}>
        <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
          <Text type="secondary">Live Preview</Text>
        </Col>
        <Col span={16}>
          <div style={{ border: "1px solid #d9d9d9", borderRadius: "8px", padding: "16px", background: "#fafafa" }}>
            <div style={{ marginBottom: 8 }}>
              <Text strong>{activeLanguage === 'english' ? field.enLabel : field.mrLabel}</Text>
              {field.enRequired && <span style={{ color: "#ff4d4f", marginLeft: 4 }}>*</span>}
            </div>
            <Select
              placeholder={activeLanguage === 'english' ? (field.enPlaceholder || "Select option...") : (field.mrPlaceholder || "पर्याय निवडा...")}
              style={{ width: "100%" }}
              showSearch={field.allowSearch === true}
              mode={field.allowMultiSelect === true ? "multiple" : undefined}
              onChange={(value) => {
                console.log("Preview selected value:", value);
                setPreviewValue(value);
              }}
              value={previewValue}
              options={getSelectOptions()}
              getPopupContainer={(trigger) => trigger.parentNode}
              dropdownMatchSelectWidth={true}
              allowClear={!field.enRequired}
              filterOption={(input, option) => {
                return (option?.label?.toLowerCase() || '').includes(input.toLowerCase());
              }}
            />
            <div style={{ marginTop: 10, fontSize: "11px", color: "#666" }}>
              <Space split="|">
                <span><EyeOutlined /> {activeLanguage === 'english' ? 'Click to test' : 'चाचणी करा'}</span>
                {field.allowSearch && <span><SearchOutlined /> {activeLanguage === 'english' ? 'Search enabled' : 'शोध सक्षम'}</span>}
                {field.allowMultiSelect && <span><CheckSquareOutlined /> {activeLanguage === 'english' ? 'Multi-select on' : 'बहु-निवड चालू'}</span>}
                {field.enRequired && <span style={{ color: "#ff4d4f" }}>* {activeLanguage === 'english' ? 'Required' : 'आवश्यक'}</span>}
              </Space>
            </div>
          </div>
        </Col>
      </Row>
    </Card>
  );
};

// ==================== TABLE SEARCH MODAL COMPONENT - FIXED SCROLLING ====================
const TableSearchModal = ({ 
  visible, 
  onClose, 
  onImportColumns,
  language = "english",
  existingColumns = []
}) => {
  const [loading, setLoading] = useState(false);
  const [tables, setTables] = useState([]);
  const [selectedTable, setSelectedTable] = useState(null);
  const [tableColumns, setTableColumns] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [importProgress, setImportProgress] = useState(0);
  const [error, setError] = useState(null);
  
  // Fetch all tables on modal open
  useEffect(() => {
    if (visible) {
      fetchTables();
    }
  }, [visible]);
  
  const fetchTables = async () => {
    setLoading(true);
    setError(null);
    try {
      console.log('Fetching tables from:', `${API_BASE_URL}/api/reports/forms`);
      const response = await fetch(`${API_BASE_URL}/api/reports/forms`, {
        headers: {
          'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      
      const data = await response.json();
      console.log('Tables response:', data);
      
      if (data.success && data.forms) {
        setTables(data.forms);
        // message.success(language === 'english' 
        //   ? `Found ${data.forms.length} tables` 
        //   : `${data.forms.length} टेबल्स सापडली`);
      } else {
        setError(data.message || 'Failed to fetch tables');
        message.error(language === 'english' ? "Failed to fetch tables" : "टेबल्स मिळवण्यात अयशस्वी");
      }
    } catch (error) {
      console.error("Error fetching tables:", error);
      setError(error.message);
      message.error(language === 'english' 
        ? `Failed to fetch tables: ${error.message}` 
        : `टेबल्स मिळवण्यात अयशस्वी: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };
  
  const fetchTableColumns = async (formId, tableName, formNameParam) => {
    setLoading(true);
    setError(null);
    try {
      console.log(`Fetching columns for form ${formId} from:`, `${API_BASE_URL}/api/reports/forms/${formId}/structure`);
      const response = await fetch(`${API_BASE_URL}/api/reports/forms/${formId}/structure`, {
        headers: {
          'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      
      const data = await response.json();
      console.log('Columns response:', data);
      
      if (data.success && data.fields) {
        const systemColumns = ['id', 'created_at', 'updated_at', 'submission_id', 'user_id', 'status'];
        const newColumns = data.fields
          .filter(field => !systemColumns.includes(field.id?.toLowerCase()))
          .filter(field => !existingColumns.some(existing => existing.field_id === field.id))
          .map(field => ({
            field_id: field.id,
            column_name: field.id,
            en_label: field.label || field.id,
            mr_label: field.label || field.id,
            field_type: mapDbTypeToFieldType(field.type),
            report_enabled: false,
            report_operator: 'sum',
            validation_rules: null,
            table_name: tableName,
            form_id: formId,
            form_name: formNameParam || null,
          }));
        setTableColumns(newColumns);
        setSelectedColumns([]);
        // message.success(language === 'english' 
        //   ? `Found ${newColumns.length} columns in ${tableName}` 
        //   : `${tableName} मध्ये ${newColumns.length} कॉलम्स सापडले`);
      } else {
        setTableColumns([]);
        message.warning(language === 'english' ? 'No columns found' : 'कॉलम्स सापडले नाहीत');
      }
    } catch (error) {
      console.error("Error fetching table columns:", error);
      setError(error.message);
      message.error(language === 'english' 
        ? `Failed to fetch columns: ${error.message}` 
        : `कॉलम्स मिळवण्यात अयशस्वी: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };
  
  const mapDbTypeToFieldType = (dbType) => {
    const typeMap = {
      'int': 'number',
      'bigint': 'number',
      'decimal': 'number',
      'float': 'number',
      'double': 'number',
      'varchar': 'text',
      'text': 'textarea',
      'longtext': 'textarea',
      'date': 'date',
      'datetime': 'date',
      'timestamp': 'date',
      'tinyint': 'checkbox',
      'boolean': 'checkbox'
    };
    return typeMap[dbType?.toLowerCase()] || 'text';
  };
  
  const handleTableSelect = (form) => {
    setSelectedTable(form);
    fetchTableColumns(form.id, form.tableName || `form_submissions_${form.id}`, form.name);
  };
  
  const handleColumnToggle = (column) => {
    setSelectedColumns(prev => {
      const exists = prev.some(c => c.field_id === column.field_id);
      if (exists) {
        return prev.filter(c => c.field_id !== column.field_id);
      } else {
        return [...prev, column];
      }
    });
  };
  
  const handleSelectAll = () => {
    if (selectedColumns.length === tableColumns.length) {
      setSelectedColumns([]);
    } else {
      setSelectedColumns([...tableColumns]);
    }
  };
  
  const handleImport = async () => {
    if (selectedColumns.length === 0) {
      message.warning(language === 'english' 
        ? "Please select at least one column to import" 
        : "कृपया आयात करण्यासाठी किमान एक कॉलम निवडा");
      return;
    }
    
    setImportProgress(0);
    const total = selectedColumns.length;
    
    for (let i = 0; i < selectedColumns.length; i++) {
      setImportProgress(((i + 1) / total) * 100);
      await new Promise(resolve => setTimeout(resolve, 50));
    }
    
    onImportColumns(selectedColumns);
    // message.success(language === 'english' 
    //   ? `Successfully imported ${selectedColumns.length} columns` 
    //   : `${selectedColumns.length} कॉलम्स यशस्वीरित्या आयात केले`);
    
    setTimeout(() => {
      onClose();
      setSelectedTable(null);
      setTableColumns([]);
      setSelectedColumns([]);
      setImportProgress(0);
      setError(null);
    }, 1000);
  };
  
  const filteredTables = tables.filter(table =>
    (table.name || table.formName || `Form ${table.id}`).toLowerCase().includes(searchTerm.toLowerCase()) ||
    (table.tableName || `form_submissions_${table.id}`).toLowerCase().includes(searchTerm.toLowerCase()) ||
    `Form ${table.id}`.toLowerCase().includes(searchTerm.toLowerCase())
  );
  
  return (
    <Modal
      open={visible}
      onCancel={() => {
        onClose();
        setSelectedTable(null);
        setTableColumns([]);
        setSelectedColumns([]);
        setImportProgress(0);
        setError(null);
      }}
      width={1100}
      title={
        <Space>
          <DatabaseOutlined style={{ color: "#13c684", fontSize: "20px" }} />
          <span style={{ fontSize: 18, fontWeight: 600 }}>
            {language === 'english' ? 'Import Columns from Existing Table' : 'विद्यमान टेबलमधून कॉलम्स आयात करा'}
          </span>
        </Space>
      }
      footer={[
        <Button key="cancel" onClick={() => {
          onClose();
          setSelectedTable(null);
          setTableColumns([]);
          setSelectedColumns([]);
          setError(null);
        }}>
          {language === 'english' ? 'Cancel' : 'रद्द करा'}
        </Button>,
        <Button
          key="import"
          type="primary"
          onClick={handleImport}
          disabled={selectedColumns.length === 0 || loading}
          loading={importProgress > 0 && importProgress < 100}
          style={{ background: "#13c684", border: "none", fontWeight: 500 }}
        >
          {importProgress > 0 && importProgress < 100 
            ? `${Math.round(importProgress)}%`
            : (language === 'english' ? `Import ${selectedColumns.length} Columns` : `${selectedColumns.length} कॉलम्स आयात करा`)}
        </Button>
      ]}
      centered
      destroyOnClose
      maskClosable={false}
      styles={{
        body: { 
          padding: "24px", 
          height: "calc(85vh - 150px)", 
          overflow: "hidden",
          display: "flex",
          flexDirection: "column"
        }
      }}
    >
      {/* Error display */}
      {error && (
        <Alert
          message={language === 'english' ? 'Error' : 'त्रुटी'}
          description={error}
          type="error"
          showIcon
          style={{ marginBottom: 16 }}
          closable
          onClose={() => setError(null)}
        />
      )}
      
      <div style={{ flex: 1, display: "flex", gap: "24px", minHeight: 0, overflow: "hidden" }}>
        {/* Left Panel - Available Tables */}
        <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", height: "100%" }}>
          <div style={{ 
            background: "#fafafa", 
            borderRadius: "12px", 
            border: "1px solid #e8e8e8",
            display: "flex",
            flexDirection: "column",
            height: "100%",
            overflow: "hidden"
          }}>
            {/* Header */}
            <div style={{ 
              padding: "16px", 
              borderBottom: "2px solid #f0f0f0",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexShrink: 0
            }}>
              <Space>
                <TableOutlined style={{ color: "#13c684", fontSize: "16px" }} />
                <span style={{ fontSize: 15, fontWeight: 500 }}>
                  {language === 'english' ? 'Available Tables' : 'उपलब्ध टेबल्स'}
                </span>
                <Badge 
                  count={tables.length} 
                  style={{ backgroundColor: '#13c684', fontSize: 11 }}
                />
              </Space>
              <Button
                size="small"
                icon={<ReloadOutlined />}
                onClick={fetchTables}
                loading={loading && !tables.length}
              >
                {language === 'english' ? 'Refresh' : 'ताजे करा'}
              </Button>
            </div>
            
            {/* Search */}
            <div style={{ padding: "12px 16px", flexShrink: 0 }}>
              <Input
                prefix={<SearchOutlined style={{ color: '#999' }} />}
                placeholder={language === 'english' ? 'Search tables...' : 'टेबल्स शोधा...'}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                allowClear
                size="middle"
              />
            </div>
            
            {/* Scrollable Table List */}
            <div style={{ 
              flex: 1, 
              overflowY: "auto", 
              padding: "0 12px 12px 12px",
              minHeight: 0
            }}>
              {loading && !tables.length ? (
                <div style={{ textAlign: "center", padding: "40px" }}>
                  <Spin tip={language === 'english' ? 'Loading tables...' : 'टेबल्स लोड होत आहेत...'} />
                </div>
              ) : filteredTables.length === 0 ? (
                <Empty 
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={language === 'english' ? 'No tables found' : 'टेबल्स सापडले नाहीत'}
                  style={{ marginTop: "40px" }}
                />
              ) : (
                <div>
                  {filteredTables.map((table) => (
                    <div
                      key={table.id}
                      onClick={() => handleTableSelect(table)}
                      style={{
                        cursor: "pointer",
                        padding: "12px 16px",
                        borderRadius: "10px",
                        marginBottom: "8px",
                        background: selectedTable?.id === table.id ? "#e6f7ff" : "#ffffff",
                        border: selectedTable?.id === table.id ? "1px solid #13c684" : "1px solid #e8e8e8",
                        transition: "all 0.2s ease"
                      }}
                    >
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px" }}>
                        <Space>
                          <TableOutlined style={{ color: selectedTable?.id === table.id ? "#13c684" : "#1890ff" }} />
                          <Text strong style={{ fontSize: 14 }}>
                            {table.name || table.formName || `Form ${table.id}`}
                          </Text>
                          {table.approval_status === 'approved' && (
                            <Tag color="green" style={{ fontSize: 10 }}>✓ Approved</Tag>
                          )}
                        </Space>
                        {selectedTable?.id === table.id && (
                          <CheckCircleOutlined style={{ color: "#13c684" }} />
                        )}
                      </div>
                      <div style={{ display: "flex", gap: "16px", marginBottom: "4px" }}>
                        <Text type="secondary" style={{ fontSize: 11 }}>
                          📊 {table.tableName || `form_submissions_${table.id}`}
                        </Text>
                        <Text type="secondary" style={{ fontSize: 11 }}>
                            {table.submissionCount || 0} records
                        </Text>
                      </div>
                      {table.created_at && (
                        <Text type="secondary" style={{ fontSize: 10 }}>
                          🕒 {new Date(table.created_at).toLocaleDateString()}
                        </Text>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
        
        {/* Right Panel - Table Columns */}
        <div style={{ flex: 1.5, minWidth: 0, display: "flex", flexDirection: "column", height: "100%" }}>
          <div style={{ 
            background: "#fafafa", 
            borderRadius: "12px", 
            border: "1px solid #e8e8e8",
            display: "flex",
            flexDirection: "column",
            height: "100%",
            overflow: "hidden"
          }}>
            {/* Header */}
            <div style={{ 
              padding: "16px", 
              borderBottom: "2px solid #f0f0f0",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexShrink: 0
            }}>
              <Space>
                <DatabaseOutlined style={{ color: "#722ed1", fontSize: "16px" }} />
                <span style={{ fontSize: 15, fontWeight: 500 }}>
                  {language === 'english' ? 'Table Columns' : 'टेबल कॉलम्स'}
                </span>
                {selectedTable && (
                  <Tag color="#13c684" style={{ fontSize: 11 }}>
                    {tableColumns.length} columns
                  </Tag>
                )}
              </Space>
              {selectedTable && tableColumns.length > 0 && (
                <Button
                  size="small"
                  onClick={handleSelectAll}
                  type="link"
                  style={{ color: "#13c684" }}
                >
                  {selectedColumns.length === tableColumns.length 
                    ? (language === 'english' ? 'Deselect All' : 'सर्व अचयनित करा')
                    : (language === 'english' ? 'Select All' : 'सर्व निवडा')}
                </Button>
              )}
            </div>
            
            {/* Scrollable Columns List */}
            <div style={{ 
              flex: 1, 
              overflowY: "auto", 
              padding: "12px",
              minHeight: 0
            }}>
              {!selectedTable ? (
                <div style={{ 
                  display: "flex", 
                  alignItems: "center", 
                  justifyContent: "center", 
                  height: "100%" 
                }}>
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={
                      <span style={{ color: "#999" }}>
                        {language === 'english' 
                          ? 'Select a table from the left panel to view its columns' 
                          : 'स्तंभ पाहण्यासाठी डाव्या पॅनेलमधून टेबल निवडा'}
                      </span>
                    }
                  />
                </div>
              ) : loading && tableColumns.length === 0 ? (
                <div style={{ textAlign: "center", padding: "40px" }}>
                  <Spin tip={language === 'english' ? 'Loading columns...' : 'कॉलम्स लोड होत आहेत...'} />
                </div>
              ) : tableColumns.length === 0 ? (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={language === 'english' ? 'No columns available in this table' : 'या टेबलमध्ये कॉलम्स उपलब्ध नाहीत'}
                  style={{ marginTop: "40px" }}
                />
              ) : (
                <>
                  {selectedColumns.length > 0 && (
                    <Alert
                      message={
                        <Space>
                          <CheckCircleOutlined style={{ color: "#52c41a" }} />
                          <span>
                            {language === 'english'
                              ? `${selectedColumns.length} column(s) selected for import`
                              : `${selectedColumns.length} कॉलम्स आयात करण्यासाठी निवडले`}
                          </span>
                        </Space>
                      }
                      type="info"
                      showIcon={false}
                      style={{ 
                        marginBottom: "16px", 
                        background: "#f6ffed", 
                        borderColor: "#b7eb8f",
                        borderRadius: "8px"
                      }}
                    />
                  )}
                  
                  {tableColumns.map((column) => {
                    const fieldType = FIELD_TYPES.find(f => f.type === column.field_type) || FIELD_TYPES[0];
                    const isSelected = selectedColumns.some(c => c.field_id === column.field_id);
                    
                    return (
                      <div
                        key={column.field_id}
                        onClick={() => handleColumnToggle(column)}
                        style={{
                          cursor: "pointer",
                          padding: "12px 16px",
                          borderRadius: "10px",
                          marginBottom: "8px",
                          background: isSelected ? "#f0fdf4" : "#ffffff",
                          border: isSelected ? "1px solid #13c684" : "1px solid #e8e8e8",
                          transition: "all 0.2s ease"
                        }}
                      >
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                          <div style={{ flex: 1 }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "6px", flexWrap: "wrap" }}>
                              <Checkbox
                                checked={isSelected}
                                onChange={() => handleColumnToggle(column)}
                                onClick={(e) => e.stopPropagation()}
                              />
                              <Text strong style={{ fontSize: 14 }}>
                                {column.en_label}
                              </Text>
                              <Tag color={fieldType.color} style={{ margin: 0, fontSize: 10 }}>
                                <Space size={4}>
                                  {fieldType.icon}
                                  <span>{fieldType.label}</span>
                                </Space>
                              </Tag>
                              {column.report_enabled && (
                                <Tag color="orange" style={{ fontSize: 10 }}>
                                  <BarChartOutlined /> Report
                                </Tag>
                              )}
                            </div>
                            <div style={{ marginLeft: "24px" }}>
                              <Text type="secondary" style={{ fontSize: 11, fontFamily: "monospace" }}>
                                ID: {column.field_id}
                              </Text>
                              {column.table_name && (
                                <Text type="secondary" style={{ fontSize: 11, marginLeft: 12 }}>
                                  📁 {column.table_name}
                                </Text>
                              )}
                            </div>
                          </div>
                          {isSelected && (
                            <CheckCircleOutlined style={{ color: "#52c41a", fontSize: 18 }} />
                          )}
                        </div>
                      </div>
                    );
                  })}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      
      {importProgress > 0 && importProgress < 100 && (
        <div style={{ marginTop: "16px", padding: "8px 0", flexShrink: 0 }}>
          <Progress 
            percent={importProgress} 
            size="small" 
            status="active"
            format={(percent) => `${Math.round(percent)}%`}
            strokeColor="#13c684"
          />
        </div>
      )}
    </Modal>
  );
};
const SimpleUnitCheckbox = ({ field, onUpdate, language }) => {
  const [units, setUnits] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState(field.selectedUnit || null);
  const [addUnitModalVisible, setAddUnitModalVisible] = useState(false);
  const [unitSelectionModalVisible, setUnitSelectionModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  const [tempSelectedUnit, setTempSelectedUnit] = useState(null);

  // Load units from database
  const loadUnits = async () => {
    try {
      setLoading(true);
      console.log("🔍 Fetching units from API...");
      
      const response = await axios.get(`${API_BASE}/forms/units?active_only=true`);
      
      console.log("📦 API Response:", response.data);
      
      if (response.data && response.data.success) {
        if (Array.isArray(response.data.data)) {
          setUnits(response.data.data);
          console.log(`✅ Loaded ${response.data.data.length} units from database`);
        } else {
          console.warn("Response data.data is not an array:", response.data.data);
          setUnits([]);
        }
      } else if (Array.isArray(response.data)) {
        setUnits(response.data);
        console.log(`✅ Loaded ${response.data.length} units from database`);
      } else if (response.data && Array.isArray(response.data.data)) {
        setUnits(response.data.data);
        console.log(`✅ Loaded ${response.data.data.length} units from database`);
      } else {
        console.warn("Unexpected API response format:", response.data);
        setUnits([]);
      }
    } catch (error) {
      console.error('❌ Failed to load units:', error);
      message.error(
        language === "english"
          ? "Failed to load units from database. Please check your connection."
          : "डेटाबेसमधून युनिट लोड करण्यात अयशस्वी. कृपया तुमचे कनेक्शन तपासा."
      );
      setUnits([]);
    } finally {
      setLoading(false);
    }
  };

  // Open unit selection modal
  const openUnitSelectionModal = async () => {
    setTempSelectedUnit(selectedUnit);
    await loadUnits();
    setUnitSelectionModalVisible(true);
  };

  // Handle unit toggle (enable/disable unit selection)
  const handleUnitToggle = (checked) => {
    console.log("🔄 Unit toggle changed to:", checked);
    
    if (checked) {
      openUnitSelectionModal();
    } else {
      const updatedField = {
        ...field,
        hasUnit: false,
        selectedUnit: null,
        selectedUnitObject: null,
        selectedUnits: [],
        units: {
          ...(field.units || {}),
          enabled: false,
          selectedUnit: null,
          selectedUnitId: null,
          selectedUnitValue: null,
          selectedUnitSymbol: null,
          selectedUnitLabel: null,
          unitCategory: null
        }
      };
      setSelectedUnit(null);
      onUpdate(updatedField);
    }
  };

  // ✅ FIXED: Confirm unit selection with complete data
  const handleConfirmUnitSelection = () => {
    if (!tempSelectedUnit) {
      message.warning(
        language === "english"
          ? "Please select a unit"
          : "कृपया एक युनिट निवडा"
      );
      return;
    }
    
    const selectedUnitObj = units.find(u => u.id === tempSelectedUnit);
    
    setSelectedUnit(tempSelectedUnit);
    
    const updatedField = {
      ...field,
      hasUnit: true,
      selectedUnit: tempSelectedUnit,
      selectedUnitObject: selectedUnitObj,
      selectedUnits: [tempSelectedUnit],
      units: {
        ...(field.units || {}),
        enabled: true,
        selectedUnit: selectedUnitObj?.unit_name,
        selectedUnitId: tempSelectedUnit,
        selectedUnitValue: selectedUnitObj?.unit_value,
        selectedUnitSymbol: selectedUnitObj?.unit_symbol,
        selectedUnitLabel: selectedUnitObj?.unit_name,
        unitCategory: selectedUnitObj?.unit_category,
      }
    };
    
    onUpdate(updatedField);
    setUnitSelectionModalVisible(false);
    console.log("✅ Unit saved with complete info:", updatedField.units);
  };

  // Handle unit selection in modal
  const handleUnitSelectInModal = (unitId) => {
    setTempSelectedUnit(unitId);
  };

  // Create new unit
  const handleAddUnit = async (values) => {
    try {
      setSubmitting(true);
      console.log("  Creating new unit:", values);
      
      const response = await axios.post(`${API_BASE}/forms/units`, values);
      
      console.log("📦 Create unit response:", response.data);
      
      if (response.data && response.data.success) {
        await loadUnits();
        
        const newUnitId = response.data.data?.id;
        if (newUnitId) {
          setTempSelectedUnit(newUnitId);
        }

        setAddUnitModalVisible(false);
        form.resetFields();
      } else {
        throw new Error(response.data?.error || 'Failed to create unit');
      }
    } catch (error) {
      console.error('❌ Create unit error:', error);
      message.error(
        language === "english"
          ? error.response?.data?.error || "Failed to create unit"
          : error.response?.data?.error || "युनिट तयार करण्यात अयशस्वी"
      );
    } finally {
      setSubmitting(false);
    }
  };

  // Group units by category for better organization
  const groupedUnits = useMemo(() => {
    const groups = {};
    units.forEach(unit => {
      const category = unit.unit_category || 'Other';
      if (!groups[category]) {
        groups[category] = [];
      }
      groups[category].push(unit);
    });
    return groups;
  }, [units]);

  // Get category label in selected language
  const getCategoryLabel = (category) => {
    const categoryMap = {
      weight: language === "english" ? "Weight" : "वजन",
      length: language === "english" ? "Length" : "लांबी",
      volume: language === "english" ? "Volume" : "घनफळ",
      area: language === "english" ? "Area" : "क्षेत्रफळ",
      time: language === "english" ? "Time" : "वेळ",
      speed: language === "english" ? "Speed" : "वेग",
      temperature: language === "english" ? "Temperature" : "तापमान",
      digital: language === "english" ? "Digital" : "डिजिटल",
      currency: language === "english" ? "Currency" : "चलन",
      number_system: language === "english" ? "Number System" : "संख्या प्रणाली",
      percentage: language === "english" ? "Percentage" : "टक्केवारी"
    };
    return categoryMap[category] || (language === "english" ? category : category);
  };

  return (
    <div
      style={{
        marginTop: 20,
        marginBottom: 30,
        padding: "8px",
        background: "#f9f9f9",
        border: "1px solid #e8e8e8",
        borderRadius: "6px"
      }}
    >
      <Row align="middle" gutter={16}>
        <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
          <Text type="secondary">
            {language === "english" ? "Unit Option" : "युनिट पर्याय"}
          </Text>
        </Col>
        <Col span={16}>
          <Checkbox
            checked={field.hasUnit || false}
            onChange={(e) => handleUnitToggle(e.target.checked)}
          >
            <Space>
              <CalculatorOutlined style={{ color: "#1890ff" }} />
              {language === "english"
                ? "Enable unit selection in form"
                : "फॉर्ममध्ये युनिट निवड सक्षम करा"}
            </Space>
          </Checkbox>

          {field.hasUnit && selectedUnit && (
            <div style={{ marginTop: 12 }}>
              <div style={{ 
                padding: "8px 12px", 
                background: "#e6f7ff", 
                borderRadius: "4px",
                border: "1px solid #91d5ff",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between"
              }}>
                <Space>
                  <CheckCircleOutlined style={{ color: "#52c41a" }} />
                  <Text type="secondary" style={{ fontSize: "12px" }}>
                    {language === "english" ? "Selected unit:" : "निवडलेले युनिट:"}
                  </Text>
                  <Text strong style={{ fontSize: "13px" }}>
                    {units.find(u => u.id === selectedUnit)?.unit_name}
                  </Text>
                  {units.find(u => u.id === selectedUnit)?.unit_symbol && (
                    <Tag color="blue" style={{ margin: 0 }}>
                      {units.find(u => u.id === selectedUnit)?.unit_symbol}
                    </Tag>
                  )}
                  <Text type="secondary" style={{ fontSize: "11px" }}>
                    ({units.find(u => u.id === selectedUnit)?.unit_value})
                  </Text>
                </Space>
                <Button 
                  type="link" 
                  size="small"
                  onClick={openUnitSelectionModal}
                >
                  {language === "english" ? "Change" : "बदला"}
                </Button>
              </div>
            </div>
          )}
        </Col>
      </Row>

      {/* Unit Selection Modal - Radio Button List Format */}
      <Modal
        open={unitSelectionModalVisible}
        onCancel={() => {
          setUnitSelectionModalVisible(false);
          setTempSelectedUnit(selectedUnit);
        }}
        // title={
        //   <Space>
        //     <CalculatorOutlined style={{ color: "#1890ff" }} />
        //     <span>{language === "english" ? "Select Unit" : "युनिट निवडा"}</span>
        //   </Space>
        // }
        footer={[
          <Button key="cancel" onClick={() => {
            setUnitSelectionModalVisible(false);
            setTempSelectedUnit(selectedUnit);
          }}>
            {language === "english" ? "Cancel" : "रद्द करा"}
          </Button>,
          <Button 
            key="confirm" 
            type="primary" 
            onClick={handleConfirmUnitSelection}
            disabled={!tempSelectedUnit}
          >
            {language === "english" ? "Confirm" : "पुष्टी करा"}
          </Button>
        ]}
        width={600}
        centered
        destroyOnClose
      >
        {loading ? (
          <div style={{ textAlign: "center", padding: "40px" }}>
            <Spin size="large" />
            <div style={{ marginTop: 20, color: "#999" }}>
              {language === "english" ? "Loading units..." : "युनिट लोड होत आहे..."}
            </div>
          </div>
        ) : units.length === 0 ? (
          <div style={{ textAlign: "center", padding: "30px" }}>
            <DatabaseOutlined style={{ fontSize: 42, color: "#999", marginBottom: 12 }} />
            <div style={{ fontSize: "14px", color: "#666", marginBottom: 16 }}>
              {language === "english" 
                ? "No units found in database. Create a new unit to get started."
                : "डेटाबेसमध्ये कोणतेही युनिट सापडले नाही. सुरू करण्यासाठी नवीन युनिट तयार करा."}
            </div>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => {
                setUnitSelectionModalVisible(false);
                setAddUnitModalVisible(true);
              }}
            >
              {language === "english" ? "Create New Unit" : "नवीन युनिट तयार करा"}
            </Button>
          </div>
        ) : (
          <div style={{ maxHeight: "350px", overflowY: "auto" }}>
            <Radio.Group 
              value={tempSelectedUnit} 
              onChange={(e) => handleUnitSelectInModal(e.target.value)}
              style={{ width: "100%" }}
            >
              {Object.keys(groupedUnits).map(category => (
                <div key={category} style={{ marginBottom: 20, marginTop: 20 }}>
                  <div style={{ 
                    padding: "8px 12px", 
                    background: "#f0f0f0", 
                    borderRadius: "4px",
                    marginBottom: 8,
                    marginTop: 8,
                    display: "flex",
                    alignItems: "center",
                    gap: "8px"
                  }}>
                    <TagOutlined style={{ color: "#1890ff" }} />
                    <strong>{getCategoryLabel(category)}</strong>
                    <Tag color="blue" style={{ fontSize: "11px" }}>
                      {groupedUnits[category].length}
                    </Tag>
                  </div>
                  <div style={{ paddingLeft: 12 }}>
                    {groupedUnits[category].map(unit => (
                      <div 
                        key={unit.id} 
                        style={{ 
                          padding: "10px 12px",
                          marginBottom: "8px",
                          background: tempSelectedUnit === unit.id ? "#e6f7ff" : "#fafafa",
                          borderRadius: "6px",
                          border: tempSelectedUnit === unit.id ? "1px solid #1890ff" : "1px solid #e8e8e8",
                          transition: "all 0.3s",
                          cursor: "pointer"
                        }}
                        onClick={() => handleUnitSelectInModal(unit.id)}
                      >
                        <Radio value={unit.id} style={{ width: "100%", margin: 0 }}>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                            <div>
                              <div style={{ fontWeight: "bold", fontSize: "14px", marginBottom: "4px" }}>
                                {unit.unit_name}
                              </div>
                              <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                                {unit.unit_symbol && (
                                  <Tag color="blue" style={{ fontSize: "11px", margin: 0 }}>
                                    {unit.unit_symbol}
                                  </Tag>
                                )}
                                {/* <Text type="secondary" style={{ fontSize: "11px" }}>
                                  {language === "english" ? "Value:" : "मूल्य:"} {unit.unit_value}
                                </Text> */}
                              </div>
                            </div>
                            {tempSelectedUnit === unit.id && (
                              <CheckCircleOutlined style={{ color: "#52c41a", fontSize: "18px" }} />
                            )}
                          </div>
                        </Radio>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </Radio.Group>
          </div>
        )}
        
        <Divider style={{ margin: "16px 0" }} />
        
        <Button
          type="dashed"
          icon={<PlusOutlined />}
          block
          onClick={() => {
            setUnitSelectionModalVisible(false);
            setAddUnitModalVisible(true);
          }}
        >
          {language === "english" ? "+ Create New Unit" : "+ नवीन युनिट तयार करा"}
        </Button>
      </Modal>

      {/* Create New Unit Modal */}
      <Modal
        open={addUnitModalVisible}
        onCancel={() => {
          setAddUnitModalVisible(false);
          form.resetFields();
        }}
        title={language === "english" ? "Create New Unit" : "नवीन युनिट तयार करा"}
        footer={null}
        centered
        destroyOnClose={true}
        styles={{ mask: { backdropFilter: 'none' } }}
      >
        <Form form={form} layout="vertical" onFinish={handleAddUnit}>
          <Form.Item
            name="unit_name"
            label={language === "english" ? "Unit Name *" : "युनिटचे नाव *"}
            rules={[{ required: true, message: language === "english" ? "Please enter unit name" : "कृपया युनिटचे नाव प्रविष्ट करा" }]}
          >
            <Input placeholder={language === "english" ? "e.g., Kilogram" : "उदा., किलोग्रॅम"} />
          </Form.Item>

          <Form.Item
            name="unit_value"
            label={language === "english" ? "Unit Value *" : "युनिट मूल्य *"}
            rules={[{ required: true, message: language === "english" ? "Please enter unit value" : "कृपया युनिट मूल्य प्रविष्ट करा" }]}
            extra={language === "english" 
              ? "Base conversion factor (e.g., 1 for Kilogram, 0.001 for Gram)" 
              : "मूलभूत रूपांतरण घटक (उदा., किलोग्रॅमसाठी १, ग्रॅमसाठी ०.००१)"}
          >
            <Input placeholder="1 / 0.001 / 1000" />
          </Form.Item>

          <Form.Item
            name="unit_symbol"
            label={language === "english" ? "Unit Symbol" : "युनिट चिन्ह"}
          >
            <Input placeholder={language === "english" ? "e.g., kg" : "उदा., किग्रॅ"} />
          </Form.Item>

          <Form.Item
            name="unit_category"
            label={language === "english" ? "Category" : "श्रेणी"}
          >
            <Select 
              placeholder={language === "english" ? "Select category" : "श्रेणी निवडा"} 
              allowClear
              getPopupContainer={(trigger) => trigger.parentNode}
            >
              <Option value="weight">Weight / वजन</Option>
              <Option value="length">Length / लांबी</Option>
              <Option value="volume">Volume / घनफळ</Option>
              <Option value="area">Area / क्षेत्रफळ</Option>
              <Option value="time">Time / वेळ</Option>
              <Option value="speed">Speed / वेग</Option>
              <Option value="temperature">Temperature / तापमान</Option>
              <Option value="digital">Digital / डिजिटल</Option>
              <Option value="currency">Currency / चलन</Option>
              <Option value="number_system">Number System / संख्या प्रणाली</Option>
              <Option value="percentage">Percentage / टक्केवारी</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="is_active"
            valuePropName="checked"
            initialValue={true}
          >
            <Checkbox>
              {language === "english" ? "Active" : "सक्रिय"}
            </Checkbox>
          </Form.Item>

          <Form.Item style={{ marginBottom: 0, textAlign: "right" }}>
            <Space>
              <Button
                onClick={() => {
                  setAddUnitModalVisible(false);
                  form.resetFields();
                }}
              >
                {language === "english" ? "Cancel" : "रद्द करा"}
              </Button>
              <Button type="primary" htmlType="submit" loading={submitting}>
                {language === "english" ? "Create" : "तयार करा"}
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

// ✅ COMPREHENSIVE Validation Panel - UPDATED: Removed min/max length and min/max value
const ValidationPanel = ({ field, onUpdate, language }) => {
  const [activeTab, setActiveTab] = useState('basic');

  const updateValidation = (key, value) => {
    console.log(`Updating validation: ${key} =`, value);
    
    const updatedField = { ...field };
    if (!updatedField.validation) {
      updatedField.validation = {};
    }
    updatedField.validation[key] = value;
    onUpdate(updatedField);
  };

  const updateNestedValidation = (parentKey, key, value) => {
    console.log(`Updating nested validation: ${parentKey}.${key} =`, value);
    
    const updatedField = { ...field };
    if (!updatedField.validation) {
      updatedField.validation = {};
    }
    if (!updatedField.validation[parentKey]) {
      updatedField.validation[parentKey] = {};
    }
    updatedField.validation[parentKey][key] = value;
    onUpdate(updatedField);
  };

  // Validation tabs
  const tabs = [
    // { key: 'basic', label: language === 'english' ? 'Basic' : 'मूलभूत', icon: <FontSizeOutlined /> },
    { key: 'length', label: language === 'english' ? 'Length' : 'लांबी', icon: <ColumnWidthOutlined /> },
    { key: 'pattern', label: language === 'english' ? 'Pattern' : 'नमुना', icon: <CodeOutlined /> },
    { key: 'spaces', label: language === 'english' ? 'Spaces' : 'स्पेस', icon: <FontColorsOutlined /> },
    { key: 'case', label: language === 'english' ? 'Case' : 'केस', icon: <FontColorsOutlined /> },
    { key: 'language', label: language === 'english' ? 'Language' : 'भाषा', icon: <GlobalOutlined /> },
    { key: 'numbers', label: language === 'english' ? 'Numbers' : 'संख्या', icon: <NumberOutlined /> },
  ];

  // Filter tabs based on field type
  const getVisibleTabs = () => {
    if (field.type === 'number') {
      return tabs.filter(t => !['pattern', 'case', 'language'].includes(t.key));
    }
    if (field.type === 'date') {
      return tabs.filter(t => !['length', 'pattern', 'spaces', 'case', 'language', 'numbers'].includes(t.key));
    }
    return tabs;
  };

  return (
    <Card
      size="small"
      style={{
        marginTop: 16,
        background: "#fafafa",
        border: "1px solid #d9d9d9",
        borderRadius: "8px"
      }}
      title={
        <Space>
          <LockOutlined style={{ color: "#722ed1" }} />
          <Text strong>
            {language === 'english' ? 'Validation Rules' : 'वैधता नियम'}
          </Text>
        </Space>
      }
      extra={
        <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
          {getVisibleTabs().map(tab => (
            <Button
              key={tab.key}
              type={activeTab === tab.key ? 'primary' : 'text'}
              size="small"
              icon={tab.icon}
              onClick={() => setActiveTab(tab.key)}
              style={{ 
                padding: '4px 8px',
                background: activeTab === tab.key ? '#722ed1' : 'transparent',
                color: activeTab === tab.key ? 'white' : '#666',
                border: activeTab === tab.key ? 'none' : '1px solid #d9d9d9'
              }}
            >
              {tab.label}
            </Button>
          ))}
        </div>
      }
    >
      {/* BASIC TAB */}
      {activeTab === 'basic' && (
        <div>
          

          {/* <Row gutter={16} style={{ marginBottom: 8 }}>
            <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
              <Text type="secondary">{language === 'english' ? 'Help Text' : 'मदत मजकूर'}</Text>
            </Col>
            <Col span={16}>
              <Input.TextArea
                rows={2}
                value={field.enHelpText || ''}
                onChange={(e) => {
                  const updatedField = { ...field };
                  updatedField.enHelpText = e.target.value;
                  onUpdate(updatedField);
                }}
                placeholder={language === 'english' ? 'Enter help text' : 'मदत मजकूर प्रविष्ट करा'}
                size="small"
              />
            </Col>
          </Row> */}
        </div>
      )}

      {/* LENGTH TAB - ONLY EXACT LENGTH */}
      {activeTab === 'length' && (
        <div>
          <Row gutter={16} style={{ marginBottom: 8 }}>
            <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
              <Text type="secondary">{language === 'english' ? 'Exact Length' : 'निश्चित लांबी'}</Text>
            </Col>
            <Col span={16}>
              <Input
                type="number"
                min={1}
                value={field.validation?.exactLength || ''}
                onChange={(e) => {
                  const val = e.target.value ? parseInt(e.target.value) : null;
                  updateValidation("exactLength", val);
                }}
                placeholder="Enter exact length"
                style={{ width: 120 }}
                size="small"
              />
              <Text type="secondary" style={{ marginLeft: 8, fontSize: '12px' }}>
                {language === 'english' ? 'characters' : 'अक्षरे'}
              </Text>
            </Col>
          </Row>

          {/* Info message about exact length */}
          <Row gutter={16} style={{ marginTop: 8 }}>
            <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
              <Text type="secondary"></Text>
            </Col>
            <Col span={16}>
              <Alert
                message={language === 'english' 
                  ? "Field must be exactly this many characters long" 
                  : "फील्ड या अचूक संख्येच्या अक्षरांचे असणे आवश्यक आहे"}
                type="info"
                showIcon
                style={{ fontSize: '12px' }}
              />
            </Col>
          </Row>
        </div>
      )}

      {/* PATTERN TAB */}
      {activeTab === 'pattern' && (
        <div>
          <Row gutter={16} style={{ marginBottom: 16 }}>
            <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
              <Text type="secondary">{language === 'english' ? 'Pattern Type' : 'नमुना प्रकार'}</Text>
            </Col>
            <Col span={16}>
              <Radio.Group
                value={field.validation?.patternType || "none"}
                onChange={(e) => updateValidation("patternType", e.target.value)}
              >
                <Space direction="vertical">
                  <Radio value="none">
                    <Space>
                      <FontSizeOutlined />
                      <Text>No Pattern / कोणताही नमुना नाही</Text>
                    </Space>
                  </Radio>
                  <Radio value="letters_only">
                    <Space>
                      <FontSizeOutlined />
                      <Text>Only Letters (A-Z, a-z) / फक्त अक्षरे</Text>
                    </Space>
                  </Radio>
                  <Radio value="letters_spaces">
                    <Space>
                      <FontSizeOutlined />
                      <Text>Letters + Spaces / अक्षरे + स्पेस</Text>
                    </Space>
                  </Radio>
                  <Radio value="alphanumeric">
                    <Space>
                      <KeyOutlined />
                      <Text>Alphanumeric (A-Z, a-z, 0-9) / अक्षरांकी</Text>
                    </Space>
                  </Radio>
                  <Radio value="alphanumeric_spaces">
                    <Space>
                      <KeyOutlined />
                      <Text>Alphanumeric + Spaces / अक्षरांकी + स्पेस</Text>
                    </Space>
                  </Radio>
                  <Radio value="numbers_only">
                    <Space>
                      <NumberOutlined />
                      <Text>Only Numbers / फक्त संख्या</Text>
                    </Space>
                  </Radio>
                  {/* <Radio value="email">
                    <Space>
                      <GlobalOutlined />
                      <Text>Email Format / ईमेल स्वरूप</Text>
                    </Space>
                  </Radio> */}
                  <Radio value="phone">
                    <Space>
                      <GlobalOutlined />
                      <Text>Phone Number / फोन नंबर</Text>
                    </Space>
                  </Radio>
                  {/* <Radio value="url">
                    <Space>
                      <GlobalOutlined />
                      <Text>URL / यूआरएल</Text>
                    </Space>
                  </Radio> */}
                  {/* <Radio value="ip_address">
                    <Space>
                      <GlobalOutlined />
                      <Text>IP Address / आयपी पत्ता</Text>
                    </Space>
                  </Radio> */}
                  {/* <Radio value="credit_card">
                    <Space>
                      <KeyOutlined />
                      <Text>Credit Card / क्रेडिट कार्ड</Text>
                    </Space>
                  </Radio> */}
                  {/* <Radio value="custom">
                    <Space>
                      <CodeOutlined />
                      <Text>Custom Regex / सानुकूल रेगेक्स</Text>
                    </Space>
                  </Radio> */}
                </Space>
              </Radio.Group>
            </Col>
          </Row>

          {field.validation?.patternType === "custom" && (
            <>
              <Row gutter={16} style={{ marginBottom: 16 }}>
                <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
                  <Text type="secondary">{language === 'english' ? 'Regex Pattern' : 'रेगेक्स नमुना'}</Text>
                </Col>
                <Col span={16}>
                  <Input
                    value={field.validation?.customPattern || ''}
                    onChange={(e) => updateValidation("customPattern", e.target.value)}
                    placeholder="e.g., ^[A-Za-z]+$"
                    size="small"
                  />
                </Col>
              </Row>

              <Row gutter={16} style={{ marginBottom: 16 }}>
                <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
                  <Text type="secondary">{language === 'english' ? 'Regex Flags' : 'रेगेक्स फ्लॅग्स'}</Text>
                </Col>
                <Col span={16}>
                  <Checkbox.Group
                    value={field.validation?.regexFlags ? field.validation.regexFlags.split('') : []}
                    onChange={(values) => updateValidation("regexFlags", values.join(''))}
                  >
                    <Space direction="vertical">
                      <Checkbox value="g">Global (g)</Checkbox>
                      <Checkbox value="i">Case Insensitive (i)</Checkbox>
                      <Checkbox value="m">Multiline (m)</Checkbox>
                      <Checkbox value="s">Dot All (s)</Checkbox>
                      <Checkbox value="u">Unicode (u)</Checkbox>
                    </Space>
                  </Checkbox.Group>
                </Col>
              </Row>
            </>
          )}

          {/* Special format toggles */}
          <Row gutter={16} style={{ marginBottom: 8 }}>
            {/* <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
              <Text type="secondary">{language === 'english' ? 'Special Formats' : 'विशेष स्वरूप'}</Text>
            </Col> */}
            <Col span={16}>
              <Space direction="vertical" size={4}>
                {/* <Checkbox
                  checked={field.validation?.isEmail || false}
                  onChange={(e) => {
                    updateValidation("isEmail", e.target.checked);
                    if (e.target.checked) updateValidation("patternType", "email");
                  }}
                >
                  Email Format / ईमेल स्वरूप
                </Checkbox> */}
                {/* <Checkbox
                  checked={field.validation?.isPhone || false}
                  onChange={(e) => {
                    updateValidation("isPhone", e.target.checked);
                    if (e.target.checked) updateValidation("patternType", "phone");
                  }}
                >
                  Phone Number / फोन नंबर
                </Checkbox> */}
                {/* <Checkbox
                  checked={field.validation?.isUrl || false}
                  onChange={(e) => {
                    updateValidation("isUrl", e.target.checked);
                    if (e.target.checked) updateValidation("patternType", "url");
                  }}
                >
                  URL / यूआरएल
                </Checkbox> */}
                {/* <Checkbox
                  checked={field.validation?.isIPAddress || false}
                  onChange={(e) => {
                    updateValidation("isIPAddress", e.target.checked);
                    if (e.target.checked) updateValidation("patternType", "ip_address");
                  }}
                >
                  IP Address / आयपी पत्ता
                </Checkbox> */}
                {/* <Checkbox
                  checked={field.validation?.isCreditCard || false}
                  onChange={(e) => {
                    updateValidation("isCreditCard", e.target.checked);
                    if (e.target.checked) updateValidation("patternType", "credit_card");
                  }}
                >
                  Credit Card / क्रेडिट कार्ड
                </Checkbox> */}
              </Space>
            </Col>
          </Row>

          {/* Custom error message */}
          {/* <Row gutter={16} style={{ marginBottom: 8 }}>
            <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
              <Text type="secondary">{language === 'english' ? 'Error Message' : 'त्रुटी संदेश'}</Text>
            </Col>
            <Col span={16}>
              <Input
                value={field.validation?.patternErrorMessage || field.validation?.customErrorMessage || ''}
                onChange={(e) => {
                  updateValidation("patternErrorMessage", e.target.value);
                  updateValidation("customErrorMessage", e.target.value);
                }}
                placeholder={language === 'english' ? 'Custom error message' : 'सानुकूल त्रुटी संदेश'}
                size="small"
              />
            </Col>
          </Row> */}
        </div>
      )}

      {/* SPACES TAB */}
      {activeTab === 'spaces' && (
        <div>
          <Row gutter={16} style={{ marginBottom: 8 }}>
            <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
              <Text type="secondary">{language === 'english' ? 'Space Rules' : 'स्पेस नियम'}</Text>
            </Col>
            <Col span={16}>
              <Space direction="vertical" size={4}>
                <Checkbox
  checked={field.validation?.allowSpaces === true}  // Changed from !== false to === true
  onChange={(e) => updateValidation("allowSpaces", e.target.checked)}
>
  {language === 'english' ? 'Allow spaces' : 'स्पेसला परवानगी द्या'}
</Checkbox>
                
                {field.validation?.allowSpaces && (
                  <>
                    <Checkbox
                      checked={field.validation?.allowMultipleSpaces !== false}
                      onChange={(e) => updateValidation("allowMultipleSpaces", e.target.checked)}
                    >
                      {language === 'english' ? 'Allow multiple consecutive spaces' : 'एकापेक्षा जास्त स्पेसला परवानगी द्या'}
                    </Checkbox>
                    
                    <Checkbox
                      checked={!field.validation?.allowLeadingSpaces}
                      onChange={(e) => updateValidation("allowLeadingSpaces", !e.target.checked)}
                    >
                      {language === 'english' ? 'No leading spaces' : 'सुरुवातीला स्पेस नको'}
                    </Checkbox>
                    
                    <Checkbox
                      checked={!field.validation?.allowTrailingSpaces}
                      onChange={(e) => updateValidation("allowTrailingSpaces", !e.target.checked)}
                    >
                      {language === 'english' ? 'No trailing spaces' : 'शेवटी स्पेस नको'}
                    </Checkbox>
                  </>
                )}
                
                <Checkbox
                  checked={field.validation?.trimInput !== false}
                  onChange={(e) => updateValidation("trimInput", e.target.checked)}
                >
                  {language === 'english' ? 'Automatically trim spaces' : 'आपोआप स्पेस काढा'}
                </Checkbox>
                
                <Checkbox
                  checked={field.validation?.collapseSpaces || false}
                  onChange={(e) => updateValidation("collapseSpaces", e.target.checked)}
                >
                  {language === 'english' ? 'Collapse multiple spaces to single' : 'एकापेक्षा जास्त स्पेस एकत्र करा'}
                </Checkbox>
              </Space>
            </Col>
          </Row>

          <Row gutter={16} style={{ marginBottom: 8 }}>
            <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
              <Text type="secondary">{language === 'english' ? 'Allowed Characters' : 'अनुमत अक्षरे'}</Text>
            </Col>
            <Col span={16}>
              <Radio.Group
                style={{ marginBottom: 8 }}
                value={field.validation?.allowedCharacters || "any"}
                onChange={(e) => updateValidation("allowedCharacters", e.target.value)}
              >
                <Space direction="vertical">
                  <Radio value="any">Any / कोणतेही</Radio>
                  <Radio value="letters_only">Letters Only / फक्त अक्षरे</Radio>
                  <Radio value="numbers_only">Numbers Only / फक्त संख्या</Radio>
                  <Radio value="alphanumeric">Alphanumeric / अक्षरांकी</Radio>
                  {/* <Radio value="custom">Custom / सानुकूल</Radio> */}
                </Space>
              </Radio.Group>
              
              {field.validation?.allowedCharacters === "custom" && (
                <Input
                  value={field.validation?.customAllowedChars || ''}
                  onChange={(e) => updateValidation("customAllowedChars", e.target.value)}
                  placeholder="e.g., ABCabc123!@#"
                  size="small"
                  style={{ marginTop: 8 }}
                />
              )}
            </Col>
          </Row>

          {/* <Row gutter={16} style={{ marginBottom: 8 }}>
            <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
              <Text type="secondary">{language === 'english' ? 'Disallowed Characters' : 'निषिद्ध अक्षरे'}</Text>
            </Col>
            <Col span={16}>
              <Input
                value={field.validation?.disallowedCharacters || ''}
                onChange={(e) => updateValidation("disallowedCharacters", e.target.value)}
                placeholder="e.g., @#$%"
                size="small"
              />
            </Col>
          </Row> */}
        </div>
      )}

      {/* CASE TAB */}
      {activeTab === 'case' && (
        <div>
          <Row gutter={16} style={{ marginBottom: 16 }}>
            <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
              <Text type="secondary">{language === 'english' ? 'Case Sensitivity' : 'केस संवेदनशीलता'}</Text>
            </Col>
            <Col span={16}>
              <Radio.Group
                value={field.validation?.caseSensitive ? "sensitive" : "insensitive"}
                onChange={(e) => updateValidation("caseSensitive", e.target.value === "sensitive")}
                size="small"
                buttonStyle="solid"
              >
                <Radio.Button value="sensitive">
                  {language === 'english' ? 'Case Sensitive' : 'केस संवेदनशील'}
                </Radio.Button>
                <Radio.Button value="insensitive">
                  {language === 'english' ? 'Case Insensitive' : 'केस असंवेदनशील'}
                </Radio.Button>
              </Radio.Group>
            </Col>
          </Row>

          <Row gutter={16} style={{ marginBottom: 16 }}>
            <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
              <Text type="secondary">{language === 'english' ? 'Force Case' : 'केस फोर्स करा'}</Text>
            </Col>
            <Col span={16}>
              <Space direction="vertical" size={4}>
                <Checkbox
                  checked={field.validation?.uppercase || false}
                  onChange={(e) => {
                    updateValidation("uppercase", e.target.checked);
                    if (e.target.checked) updateValidation("lowercase", false);
                  }}
                >
                  {language === 'english' ? 'Force UPPERCASE' : 'मोठी अक्षरे'}
                </Checkbox>
                <Checkbox
                  checked={field.validation?.lowercase || false}
                  onChange={(e) => {
                    updateValidation("lowercase", e.target.checked);
                    if (e.target.checked) updateValidation("uppercase", false);
                  }}
                >
                  {language === 'english' ? 'Force lowercase' : 'लहान अक्षरे'}
                </Checkbox>
                <Checkbox
                  checked={field.validation?.capitalize || false}
                  onChange={(e) => {
                    updateValidation("capitalize", e.target.checked);
                    if (e.target.checked) {
                      updateValidation("uppercase", false);
                      updateValidation("lowercase", false);
                    }
                  }}
                >
                  {language === 'english' ? 'Capitalize first letter' : 'पहिले अक्षर मोठे'}
                </Checkbox>
                <Checkbox
                  checked={field.validation?.titleCase || false}
                  onChange={(e) => {
                    updateValidation("titleCase", e.target.checked);
                    if (e.target.checked) {
                      updateValidation("uppercase", false);
                      updateValidation("lowercase", false);
                      updateValidation("capitalize", false);
                    }
                  }}
                >
                  {language === 'english' ? 'Title Case (Each Word)' : 'टायटल केस (प्रत्येक शब्द)'}
                </Checkbox>
              </Space>
            </Col>
          </Row>

          {(field.validation?.uppercase || field.validation?.lowercase || field.validation?.capitalize || field.validation?.titleCase) && (
            <Row gutter={16} style={{ marginBottom: 8 }}>
              <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
                <Text type="secondary">{language === 'english' ? 'Preview' : 'पूर्वावलोकन'}</Text>
              </Col>
              <Col span={16}>
                <div style={{
                  padding: '8px 12px',
                  background: '#f6ffed',
                  border: '1px solid #b7eb8f',
                  borderRadius: '4px',
                  fontSize: '13px'
                }}>
                  <Space>
                    <FieldTimeOutlined style={{ color: '#52c41a' }} />
                    <Text>
                      {language === 'english' 
                        ? `Input will be converted to: ${
                            field.validation?.uppercase ? 'UPPERCASE' :
                            field.validation?.lowercase ? 'lowercase' :
                            field.validation?.capitalize ? 'Capitalized' :
                            field.validation?.titleCase ? 'Title Case' : ''
                          }`
                        : `इनपुट रूपांतरित होईल: ${
                            field.validation?.uppercase ? 'मोठी अक्षरे' :
                            field.validation?.lowercase ? 'लहान अक्षरे' :
                            field.validation?.capitalize ? 'पहिले अक्षर मोठे' :
                            field.validation?.titleCase ? 'टायटल केस' : ''
                          }`}
                    </Text>
                  </Space>
                </div>
              </Col>
            </Row>
          )}
        </div>
      )}

      {/* LANGUAGE TAB */}
      {activeTab === 'language' && (
        <div>
          <Row gutter={16} style={{ marginBottom: 16 }}>
            <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
              <Text type="secondary">{language === 'english' ? 'Language Script' : 'लिपी'}</Text>
            </Col>
            <Col span={16}>
              <Radio.Group
                value={field.validation?.languageScript || "any"}
                onChange={(e) => updateValidation("languageScript", e.target.value)}
              >
                <Space direction="vertical">
                  {LANGUAGE_SCRIPTS.map(script => (
                    <Radio key={script.value} value={script.value}>{script.label}</Radio>
                  ))}
                </Space>
              </Radio.Group>
            </Col>
          </Row>
          
          <Row gutter={16} style={{ marginBottom: 16 }}>
            <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
              <Text type="secondary">{language === 'english' ? 'Font Family' : 'फॉन्ट'}</Text>
            </Col>
            <Col span={16}>
              <Radio.Group
                value={field.validation?.fontFamily || "default"}
                onChange={(e) => updateValidation("fontFamily", e.target.value)}
              >
                <Space direction="vertical">
                  {FONT_OPTIONS.map(font => (
                    <Radio key={font.value} value={font.value}>
                      <span style={{ fontFamily: font.font }}>{font.label}</span>
                    </Radio>
                  ))}
                </Space>
              </Radio.Group>
            </Col>
          </Row>

          {/* <Row gutter={16} style={{ marginBottom: 8 }}>
            <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
              <Text type="secondary">{language === 'english' ? 'Language Detection' : 'भाषा शोधा'}</Text>
            </Col>
            <Col span={16}>
              <Checkbox
                checked={field.validation?.detectLanguage || false}
                onChange={(e) => updateValidation("detectLanguage", e.target.checked)}
              >
                {language === 'english' ? 'Automatically detect language' : 'आपोआप भाषा शोधा'}
              </Checkbox>
            </Col>
          </Row> */}
        </div>
      )}
         
      {/* NUMBERS TAB - UPDATED: Default settings for number fields */}
      {activeTab === 'numbers' && field.type === 'number' && (
        <div>
          <Row gutter={16} style={{ marginBottom: 16 }}>
            <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
              <Text type="secondary">{language === 'english' ? 'Decimal Places' : 'दशांश स्थळे'}</Text>
            </Col>
            <Col span={16}>
              <Input
                type="number"
                min={0}
                max={10}
                value={field.validation?.decimalPlaces || ''}
                onChange={(e) => {
                  const val = e.target.value ? parseInt(e.target.value) : null;
                  updateValidation("decimalPlaces", val);
                  updateValidation("allowDecimals", val ? true : false);
                }}
                placeholder="No restriction"
                size="small"
                style={{ width: 120 }}
              />
              <Text type="secondary" style={{ marginLeft: 8, fontSize: '12px' }}>
                {language === 'english' ? 'digits after decimal' : 'दशांशानंतरचे अंक'}
              </Text>
            </Col>
          </Row>

          <Row gutter={16} style={{ marginBottom: 8 }}>
            <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
              <Text type="secondary">{language === 'english' ? 'Number Options' : 'संख्या पर्याय'}</Text>
            </Col>
            <Col span={16}>
              <Space direction="vertical" size={4}>
                <Checkbox
                  checked={field.validation?.allowZero !== false}
                  onChange={(e) => updateValidation("allowZero", e.target.checked)}
                >
                  {language === 'english' ? 'Allow zero' : 'शून्याला परवानगी द्या'}
                </Checkbox>
                <Checkbox
                  checked={field.validation?.allowDecimals || false}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    updateValidation("allowDecimals", checked);
                    if (!checked) {
                      updateValidation("decimalPlaces", null);
                    }
                  }}
                >
                  {language === 'english' ? 'Allow decimals' : 'दशांशांना परवानगी द्या'}
                </Checkbox>
                <Checkbox
                  checked={field.validation?.allowNegative || false}
                  onChange={(e) => updateValidation("allowNegative", e.target.checked)}
                >
                  {language === 'english' ? 'Allow negative numbers' : 'ऋण संख्यांना परवानगी द्या'}
                </Checkbox>
                <Checkbox
                  checked={field.validation?.integerOnly || false}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    updateValidation("integerOnly", checked);
                    if (checked) {
                      updateValidation("allowDecimals", false);
                      updateValidation("decimalPlaces", 0);
                    }
                  }}
                >
                  {language === 'english' ? 'Integer only (no decimals)' : 'फक्त पूर्णांक (दशांश नको)'}
                </Checkbox>
              </Space>
            </Col>
          </Row>

          {/* Info about default settings */}
          <Row gutter={16} style={{ marginTop: 8 }}>
            <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
              <Text type="secondary"></Text>
            </Col>
            <Col span={16}>
              <Alert
                message={language === 'english' 
                  ? "Default: Zero allowed, no decimals, no negatives" 
                  : "डीफॉल्ट: शून्य अनुमत, दशांश नाही, ऋण नाही"}
                type="info"
                showIcon
                style={{ fontSize: '12px' }}
              />
            </Col>
          </Row>
        </div>
      )}

      {/* DATE TAB */}
      {activeTab === 'basic' && field.type === 'date' && (
        <div>
          {/* <Row gutter={16} style={{ marginBottom: 16 }}>
            <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
              <Text type="secondary">{language === 'english' ? 'Date Format' : 'तारीख स्वरूप'}</Text>
            </Col>
            <Col span={16}>
              <Radio.Group
                value={field.validation?.dateFormat || "YYYY-MM-DD"}
                onChange={(e) => updateValidation("dateFormat", e.target.value)}
              >
                <Space direction="vertical">
                  {DATE_FORMATS.map(format => (
                    <Radio key={format.value} value={format.value}>{format.label}</Radio>
                  ))}
                </Space>
              </Radio.Group>
            </Col>
          </Row> */}

          <Row gutter={16} style={{ marginBottom: 16 }}>
            <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
              <Text type="secondary">{language === 'english' ? 'Date Range' : 'तारीख मर्यादा'}</Text>
            </Col>
            <Col span={16}>
              <Space direction="vertical" size={8} style={{ width: "100%" }}>
                <Input
                  type="date"
                  value={field.validation?.minDate || ''}
                  onChange={(e) => updateValidation("minDate", e.target.value)}
                  placeholder="Min Date"
                  size="small"
                  style={{ width: '100%' }}
                />
                <Input
                  type="date"
                  value={field.validation?.maxDate || ''}
                  onChange={(e) => updateValidation("maxDate", e.target.value)}
                  placeholder="Max Date"
                  size="small"
                  style={{ width: '100%' }}
                />
              </Space>
            </Col>
          </Row>

          <Row gutter={16} style={{ marginBottom: 8 }}>
            <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
              <Text type="secondary">{language === 'english' ? 'Date Options' : 'तारीख पर्याय'}</Text>
            </Col>
            <Col span={16}>
              <Space direction="vertical" size={4}>
                <Checkbox
                  checked={field.validation?.futureDates || false}
                  onChange={(e) => updateValidation("futureDates", e.target.checked)}
                >
                  {language === 'english' ? 'Allow future dates only' : 'फक्त भविष्यातील तारखा'}
                </Checkbox>
                <Checkbox
                  checked={field.validation?.pastDates || false}
                  onChange={(e) => updateValidation("pastDates", e.target.checked)}
                >
                  {language === 'english' ? 'Allow past dates only' : 'फक्त भूतकाळातील तारखा'}
                </Checkbox>
                <Checkbox
                  checked={field.validation?.todayOnly || false}
                  onChange={(e) => updateValidation("todayOnly", e.target.checked)}
                >
                  {language === 'english' ? 'Allow today only' : 'फक्त आजची तारीख'}
                </Checkbox>
              </Space>
            </Col>
          </Row>
        </div>
      )}

     

      {/* Summary of all active validations - UPDATED: Removed min/max display */}
      <Divider style={{ margin: '16px 0 8px 0' }} />
      
      
    </Card>
  );
};
// ==================== DATE COMPARISON HELPER FUNCTIONS ====================
const compareDates = (date1, date2, operator) => {
  if (!date1 || !date2) return false;
  
  const d1 = new Date(date1);
  const d2 = new Date(date2);
  
  if (isNaN(d1.getTime()) || isNaN(d2.getTime())) return false;
  
  // Reset time to midnight for accurate date comparison
  d1.setHours(0, 0, 0, 0);
  d2.setHours(0, 0, 0, 0);
  
  switch (operator) {
    case "equals":
      return d1.getTime() === d2.getTime();
    case "not_equals":
      return d1.getTime() !== d2.getTime();
    case "before":
      return d1.getTime() < d2.getTime();
    case "after":
      return d1.getTime() > d2.getTime();
    case "on_or_before":
      return d1.getTime() <= d2.getTime();
    case "on_or_after":
      return d1.getTime() >= d2.getTime();
    default:
      return false;
  }
};

const isDateInRange = (date, startDate, endDate) => {
  if (!date) return false;
  const d = new Date(date);
  const start = startDate ? new Date(startDate) : null;
  const end = endDate ? new Date(endDate) : null;
  
  d.setHours(0, 0, 0, 0);
  if (start) start.setHours(0, 0, 0, 0);
  if (end) end.setHours(0, 0, 0, 0);
  
  let valid = true;
  if (start && d < start) valid = false;
  if (end && d > end) valid = false;
  
  return valid;
};
// File Upload Field Editor Component
const FileUploadFieldEditor = ({ field, onUpdate, onDelete, onCopy, language, autoTranslate, translateTyping, translating, disabled }) => {
  const [activeLanguage, setActiveLanguage] = useState(language || 'english');
  const [typingTimeouts, setTypingTimeouts] = useState({});
  const [fileList, setFileList] = useState(field.fileList || []);

  const updateField = (key, value) => {
    if (disabled) return;
    onUpdate({ ...field, [key]: value });
  };

  // Cleanup timeouts on unmount
  useEffect(() => {
    return () => {
      Object.values(typingTimeouts).forEach(timeout => {
        clearTimeout(timeout);
      });
    };
  }, [typingTimeouts]);

  // Simple translate function
  const handleTranslate = async (text, targetField) => {
    if (!autoTranslate || !text || text.trim() === '') return;

    if (typingTimeouts[targetField]) {
      clearTimeout(typingTimeouts[targetField]);
    }

    const timeout = setTimeout(async () => {
      const translated = await translateTyping(text, 'mr');
      if (translated && translated !== text) {
        if (targetField === 'mrLabel') {
          updateField('mrLabel', translated);
        } else if (targetField === 'mrHelpText') {
          updateField('mrHelpText', translated);
        }
      }
    }, 800);

    setTypingTimeouts(prev => ({
      ...prev,
      [targetField]: timeout
    }));
  };

  // Upload configuration
  const uploadProps = {
    name: 'file',
    multiple: field.maxFileCount > 1,
    action: `${API_BASE}/upload`,
    fileList,
    onChange(info) {
      if (disabled) return;
      let newFileList = [...info.fileList];
      
      // Limit to maxFileCount
      newFileList = newFileList.slice(-(field.maxFileCount || 1));
      
      // Check file size
      newFileList = newFileList.filter(file => {
        if (file.size && field.maxFileSize) {
          const isLessThanMax = file.size / 1024 / 1024 < field.maxFileSize;
          if (!isLessThanMax) {
            message.error(`${file.name} is larger than ${field.maxFileSize}MB`);
          }
          return isLessThanMax;
        }
        return true;
      });
      
      setFileList(newFileList);
      updateField('fileList', newFileList);
    },
    beforeUpload: (file) => {
      if (disabled) return false;
      // Check file type
      if (field.acceptedFileTypes) {
        const acceptedTypes = field.acceptedFileTypes.split(',').map(type => type.trim().toLowerCase());
        const fileExt = '.' + file.name.split('.').pop().toLowerCase();
        
        if (!acceptedTypes.includes(fileExt) && !acceptedTypes.includes('*/*')) {
          message.error(`${file.name} is not an accepted file type. Accepted: ${field.acceptedFileTypes}`);
          return Upload.LIST_IGNORE;
        }
      }
      return true;
    },
    onRemove: (file) => {
      if (disabled) return;
      const newFileList = fileList.filter(item => item.uid !== file.uid);
      setFileList(newFileList);
      updateField('fileList', newFileList);
    }
  };

  // Custom request to handle actual upload
  const customRequest = async ({ file, onSuccess, onError, onProgress }) => {
    if (disabled) return;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('fieldId', field.id);
    formData.append('type', field.type);

    try {
      const response = await axios.post(`${API_BASE}/upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          onProgress({ percent });
        }
      });

      if (response.data.success) {
        onSuccess(response.data, file);
        // message.success(`${file.name} uploaded successfully`);
      } else {
        onError(new Error(response.data.message || 'Upload failed'));
      }
    } catch (error) {
      onError(error);
      message.error(`${file.name} upload failed`);
    }
  };

  // Get file type icon
  const getFileIcon = (fileName) => {
    const ext = '.' + fileName.split('.').pop().toLowerCase();
    return FILE_TYPE_ICONS[ext] || FILE_TYPE_ICONS['default'];
  };

  return (
    <Card
      size="small"
      style={{
        marginBottom: 12,
        borderRadius: "8px",
        border: "2px solid #1890ff",
        boxShadow: "0 2px 8px rgba(24, 144, 255, 0.1)",
        borderLeft: field.fromExisting ? "4px solid #113F67" : undefined,
        opacity: disabled ? 0.7 : 1
      }}
      title={
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Badge count="File Upload" style={{ backgroundColor: "#1890ff" }} />
            <span style={{ fontWeight: 'bold', fontSize: '14px' }}>
              File Upload Field
            </span>
            {autoTranslate && (
              <Tag color="green" icon={<GlobalOutlined />}>Auto ON</Tag>
            )}
           // In FieldEditor component, inside the Card title section
{field.fromExisting && field.sourceFormName && (
  <Tooltip title={`From Form: ${field.sourceFormName}`}>
    <Tag color="blue" icon={<DatabaseOutlined />}>
      📋 {field.sourceFormName.length > 25 ? `${field.sourceFormName.substring(0, 25)}...` : field.sourceFormName}
    </Tag>
  </Tooltip>
)}
            {disabled && (
              <Tag color="orange">Read Only</Tag>
            )}
          </div>
          <Space size={4}>
            <Tooltip title="Copy">
              <Button type="text" size="small" icon={<CopyOutlined />} onClick={onCopy} disabled={disabled} />
            </Tooltip>
            <Tooltip title="Delete">
              <Button type="text" size="small" icon={<DeleteOutlined />} onClick={onDelete} danger disabled={disabled} />
            </Tooltip>
          </Space>
        </div>
      }
    >
      {/* Language Toggle */}
      <div style={{ marginBottom: 12, display: 'flex', justifyContent: 'flex-end' }}>
        <Button.Group size="small">
          <Button
            type={activeLanguage === 'english' ? 'primary' : 'default'}
            onClick={() => setActiveLanguage('english')}
            icon={<GlobalOutlined />}
            disabled={disabled}
          >
            English
          </Button>
          <Button
            type={activeLanguage === 'marathi' ? 'primary' : 'default'}
            onClick={() => setActiveLanguage('marathi')}
            disabled={disabled}
          >
            मराठी
          </Button>
        </Button.Group>
      </div>

      {/* Field Label */}
      <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
        <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
          <Text type="secondary" style={{ fontSize: '12px' }}>Field Label</Text>
        </Col>
        <Col span={16}>
          <div style={{ display: 'flex', gap: '8px' }}>
            <Tag color="blue" style={{ height: "32px", lineHeight: "30px" }}>EN</Tag>
            <Input
              value={activeLanguage === 'english' ? field.enLabel : field.mrLabel}
              onChange={(e) => {
                const value = e.target.value;
                if (activeLanguage === 'english') {
                  updateField("enLabel", value);
                  handleTranslate(value, "mrLabel");
                } else {
                  updateField("mrLabel", value);
                }
              }}
              placeholder={activeLanguage === 'english' ? "Enter English label" : "मराठी लेबल प्रविष्ट करा"}
              size="middle"
              allowClear
              style={{ width: "100%" }}
              disabled={disabled}
            />
          </div>
        </Col>
      </Row>

      {/* Help Text */}
      {/* <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
        <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
          <Text type="secondary" style={{ fontSize: '12px' }}>Help Text</Text>
        </Col>
        <Col span={16}>
          <div style={{ display: 'flex', gap: '8px' }}>
            <Tag color="blue" style={{ height: "32px", lineHeight: "30px" }}>EN</Tag>
            <Input
              value={activeLanguage === 'english' ? field.enHelpText : field.mrHelpText}
              onChange={(e) => {
                const value = e.target.value;
                if (activeLanguage === 'english') {
                  updateField("enHelpText", value);
                  handleTranslate(value, "mrHelpText");
                } else {
                  updateField("mrHelpText", value);
                }
              }}
              placeholder={activeLanguage === 'english' ? "Enter help text" : "मदत मजकूर प्रविष्ट करा"}
              size="middle"
              allowClear
              style={{ width: "100%" }}
              disabled={disabled}
            />
          </div>
        </Col>
      </Row> */}

      {/* Accepted File Types */}
      <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
        <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
          <Text type="secondary" style={{ fontSize: '12px' }}>Accepted File Types</Text>
        </Col>
        <Col span={16}>
          <Input
            value={field.acceptedFileTypes || ".jpg,.jpeg,.png,.gif,.bmp,.pdf,.doc,.docx,.xls,.xlsx,.txt"}
            onChange={(e) => updateField("acceptedFileTypes", e.target.value)}
            placeholder="e.g., .jpg,.jpeg,.png,.pdf,.doc"
            size="middle"
            allowClear
            disabled={disabled}
          />
          <Text type="secondary" style={{ fontSize: '11px', marginTop: 4, display: 'block' }}>
            Comma separated file extensions (images + documents)
          </Text>
        </Col>
      </Row>

      {/* Max File Size */}
      <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
        <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
          <Text type="secondary" style={{ fontSize: '12px' }}>Max File Size (MB)</Text>
        </Col>
        <Col span={16}>
          <Input
            type="number"
            min={1}
            max={100}
            value={field.maxFileSize || 5}
            onChange={(e) => updateField("maxFileSize", parseInt(e.target.value) || 5)}
            size="middle"
            style={{ width: "100px" }}
            disabled={disabled}
          />
          <Text type="secondary" style={{ marginLeft: 8, fontSize: '11px' }}>
            MB (1-100)
          </Text>
        </Col>
      </Row>

      {/* Max File Count */}
      <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
        <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
          <Text type="secondary" style={{ fontSize: '12px' }}>Max Files</Text>
        </Col>
        <Col span={16}>
          <Input
            type="number"
            min={1}
            max={20}
            value={field.maxFileCount || 1}
            onChange={(e) => updateField("maxFileCount", parseInt(e.target.value) || 1)}
            size="middle"
            style={{ width: "80px" }}
            disabled={disabled}
          />
          <Text type="secondary" style={{ marginLeft: 8, fontSize: '11px' }}>
            files (1-20)
          </Text>
        </Col>
      </Row>

      {/* Required checkbox */}
      <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
        <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
          <Text type="secondary" style={{ fontSize: '12px' }}>Validation</Text>
        </Col>
        <Col span={16}>
          <Checkbox
            checked={field.enRequired}
            onChange={(e) => {
              const checked = e.target.checked;
              updateField("enRequired", checked);
              updateField("required", checked);
            }}
            disabled={disabled}
          >
            {activeLanguage === 'english' ? 'Required' : 'आवश्यक'}
          </Checkbox>
        </Col>
      </Row>

      {/* File Upload Area */}
      <Row align="middle" gutter={16}>
        <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
          <Text type="secondary" style={{ fontSize: '12px' }}>Upload Area</Text>
        </Col>
        <Col span={16}>
          <Dragger
            {...uploadProps}
            customRequest={customRequest}
            style={{ 
              background: '#fafafa',
              border: '2px dashed #d9d9d9',
              borderRadius: '8px',
              padding: '20px'
            }}
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined style={{ fontSize: 48, color: "#1890ff" }} />
            </p>
            <p className="ant-upload-text">
              {activeLanguage === 'english' 
                ? `Click or drag file to this area to upload`
                : `फाइल अपलोड करण्यासाठी क्लिक करा किंवा ड्रॅग करा`}
            </p>
            <p className="ant-upload-hint">
              {activeLanguage === 'english' 
                ? 'Support for images (JPG, PNG, GIF) and documents (PDF, DOC, XLS)'
                : 'प्रतिमा (JPG, PNG, GIF) आणि दस्तऐवज (PDF, DOC, XLS) साठी सपोर्ट'}
            </p>
          </Dragger>

          {/* File List Preview */}
          {fileList.length > 0 && (
            <div style={{ marginTop: 16 }}>
              <Divider style={{ margin: '12px 0' }} />
              <Text strong style={{ fontSize: '12px', display: 'block', marginBottom: 8 }}>
                {activeLanguage === 'english' ? 'Uploaded Files:' : 'अपलोड केलेल्या फाइल्स:'}
              </Text>
              {fileList.map(file => (
                <div key={file.uid} style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '8px',
                  padding: '8px 12px',
                  background: '#fff',
                  border: '1px solid #f0f0f0',
                  borderRadius: '6px',
                  marginBottom: 4
                }}>
                  {getFileIcon(file.name)}
                  <Text style={{ fontSize: '13px', flex: 1 }}>{file.name}</Text>
                  <Text type="secondary" style={{ fontSize: '11px' }}>
                    {(file.size / 1024).toFixed(1)} KB
                  </Text>
                  {file.status === 'done' && (
                    <Tag color="green" style={{ fontSize: '10px' }}>Uploaded</Tag>
                  )}
                  {file.status === 'uploading' && (
                    <Tag color="blue" style={{ fontSize: '10px' }}>Uploading...</Tag>
                  )}
                  {file.status === 'error' && (
                    <Tag color="red" style={{ fontSize: '10px' }}>Failed</Tag>
                  )}
                </div>
              ))}
            </div>
          )}

          {/* File Type Summary */}
          <div style={{ marginTop: 12 }}>
            <Space wrap size={[4, 4]}>
              {(field.acceptedFileTypes || ".jpg,.jpeg,.png,.gif,.bmp,.pdf,.doc,.docx,.xls,.xlsx,.txt")
                .split(',').map((type, idx) => (
                <Tag key={idx} color="blue" style={{ fontSize: '11px' }}>
                  {FILE_TYPE_ICONS[type.trim()] || <FileOutlined />} {type.trim()}
                </Tag>
              ))}
              <Tag color="green">{field.maxFileSize || 5} MB Max</Tag>
              {field.maxFileCount > 1 && (
                <Tag color="orange">Max {field.maxFileCount} files</Tag>
              )}
            </Space>
          </div>
        </Col>
      </Row>
    </Card>
  );
};

// Comparison Field Editor Component
// Comparison Field Editor Component - FIXED: Global operator blank by default
const ComparisonFieldEditor = ({ field, onUpdate, onDelete, onCopy, language, autoTranslate, translateTyping, translating, disabled }) => {
  const [activeLanguage, setActiveLanguage] = useState(language || 'english');
  const [globalOperator, setGlobalOperator] = useState(null);
  const [typingTimeouts, setTypingTimeouts] = useState({});

  const updateField = (key, value) => {
    if (disabled) return;
    onUpdate({ ...field, [key]: value });
  };

  const updateMainField = (key, value) => {
    if (disabled) return;
    updateField("mainField", {
      ...field.mainField,
      [key]: value
    });
  };

  // ✅ Update entire main field object (for unit and validation changes)
  const updateMainFieldComplete = (updatedMainField) => {
    if (disabled) return;
    updateField("mainField", updatedMainField);
  };

  const updateSubField = (index, key, value) => {
    if (disabled) return;
    const newSubFields = [...field.subFields];
    newSubFields[index] = {
      ...newSubFields[index],
      [key]: value
    };
    updateField("subFields", newSubFields);
  };

  // ✅ Update entire sub field object (for unit and validation changes)
  const updateSubFieldComplete = (index, updatedSubField) => {
    if (disabled) return;
    const newSubFields = [...field.subFields];
    newSubFields[index] = updatedSubField;
    updateField("subFields", newSubFields);
  };

  const addSubField = () => {
    if (disabled) return;
    const newSubFields = [...field.subFields, {
      id: uid(),
      type: "number",
      arithmeticOperator: globalOperator || "add",
      enLabel: `Sub Value ${field.subFields.length + 1}`,
      enPlaceholder: "Enter value",
      enRequired: false,
      enHelpText: "",
      mrLabel: `उप-मूल्य ${field.subFields.length + 1}`,
      mrPlaceholder: "मूल्य प्रविष्ट करा",
      mrRequired: false,
      mrHelpText: "",
      label: `Sub Value ${field.subFields.length + 1}`,
      placeholder: "Enter value",
      required: false,
      helpText: "",
      hasUnit: false,
      selectedUnit: null,
      selectedUnitObject: null,
      units: {
        enabled: false,
        selectedUnit: null,
        selectedUnitId: null,
        selectedUnitValue: null,
        selectedUnitSymbol: null,
        selectedUnitLabel: null,
        unitCategory: null
      },
      // ✅ ADD VALIDATION FOR NEW SUB FIELD
      validation: {
        exactLength: null,
        decimalPlaces: null,
        allowDecimals: false,
        allowNegative: false,
        allowZero: true,
        integerOnly: false,
        patternType: "none",
        customPattern: "",
        patternErrorMessage: "",
        allowedCharacters: "any",
        disallowedCharacters: "",
        allowSpaces: true,
        allowLeadingSpaces: false,
        allowTrailingSpaces: false,
        allowMultipleSpaces: true,
        trimInput: true,
        caseSensitive: true,
        uppercase: false,
        lowercase: false,
        languageScript: "any",
        fontFamily: "default",
        dateFormat: "YYYY-MM-DD",
        timeFormat: "HH:mm",
        dateTimeFormat: "YYYY-MM-DD HH:mm",
        validationFunction: null,
        validationMessage: "",
        isEmail: false,
        isPhone: false,
        isUrl: false,
        isIPAddress: false,
        isCreditCard: false,
        regexPattern: "",
        regexFlags: "g",
        customErrorMessage: "",
        detectLanguage: false,
        allowedLanguages: []
      }
    }];
    updateField("subFields", newSubFields);
  };

  const removeSubField = (index) => {
    if (disabled) return;
    const newSubFields = field.subFields.filter((_, i) => i !== index);
    updateField("subFields", newSubFields);
  };

  const applyGlobalOperator = (operator) => {
    if (disabled) return;
    setGlobalOperator(operator);
    if (operator) {
      const newSubFields = field.subFields.map(subField => ({
        ...subField,
        arithmeticOperator: operator
      }));
      updateField("subFields", newSubFields);
    }
  };

  const getOperatorSymbol = (operator) => {
    const op = ARITHMETIC_OPERATORS.find(o => o.value === operator);
    return op ? op.symbol : '+';
  };

  const getEquationString = () => {
    if (!field.subFields || field.subFields.length === 0) return "";

    let equation = "";
    field.subFields.forEach((sf, idx) => {
      if (idx === 0) {
        equation += `[${activeLanguage === 'english' ? (sf.enLabel || sf.label) : (sf.mrLabel || sf.label)}]`;
      } else {
        const operator = sf.arithmeticOperator || "add";
        const symbol = getOperatorSymbol(operator);
        equation += ` ${symbol} [${activeLanguage === 'english' ? (sf.enLabel || sf.label) : (sf.mrLabel || sf.label)}]`;
      }
    });
    return equation;
  };

  // Cleanup timeouts on unmount
  useEffect(() => {
    return () => {
      Object.values(typingTimeouts).forEach(timeout => {
        clearTimeout(timeout);
      });
    };
  }, [typingTimeouts]);

  // Simple translate function
  const handleTranslate = async (text, targetField) => {
    if (!autoTranslate || !text || text.trim() === '') return;

    if (typingTimeouts[targetField]) {
      clearTimeout(typingTimeouts[targetField]);
    }

    const timeout = setTimeout(async () => {
      const translated = await translateTyping(text, 'mr');
      if (translated && translated !== text) {
        if (targetField === 'mrLabel') {
          updateField('mrLabel', translated);
        } else if (targetField === 'mrPlaceholder') {
          updateField('mrPlaceholder', translated);
        } else if (targetField === 'mrHelpText') {
          updateField('mrHelpText', translated);
        } else if (targetField.startsWith('mainField.')) {
          const key = targetField.split('.')[1];
          updateMainField(key, translated);
        } else if (targetField.startsWith('subField.')) {
          const parts = targetField.split('.');
          const index = parseInt(parts[1]);
          const key = parts[2];
          updateSubField(index, key, translated);
        }
      }
    }, 800);

    setTypingTimeouts(prev => ({
      ...prev,
      [targetField]: timeout
    }));
  };

  // ✅ Helper function to get unit display text
  const getUnitDisplay = (subField) => {
    if (subField.hasUnit && subField.selectedUnitObject) {
      return subField.selectedUnitObject.unit_symbol || subField.selectedUnitObject.unit_name;
    }
    if (subField.units?.enabled && subField.units.selectedUnitSymbol) {
      return subField.units.selectedUnitSymbol;
    }
    return null;
  };

  return (
    <Card
      size="small"
      style={{
        marginBottom: 12,
        borderRadius: "8px",
        border: "2px solid #fa8c16",
        boxShadow: "0 2px 8px rgba(250, 140, 22, 0.1)",
        borderLeft: field.fromExisting ? "4px solid #113F67" : undefined,
        opacity: disabled ? 0.7 : 1
      }}
      title={
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Badge count="Comparison" style={{ backgroundColor: "#fa8c16" }} />
            <span style={{ fontWeight: 'bold', fontSize: '14px' }}>Comparison Field</span>
            {autoTranslate && (
              <Tag color="green" icon={<GlobalOutlined />}>Auto ON</Tag>
            )}
            {field.fromExisting && (
              <Tag color="blue">From: {field.sourceColumn}</Tag>
            )}
            {disabled && (
              <Tag color="orange">Read Only</Tag>
            )}
          </div>
          <Space size={4}>
            <Tooltip title="Copy">
              <Button type="text" size="small" icon={<CopyOutlined />} onClick={onCopy} disabled={disabled} />
            </Tooltip>
            <Tooltip title="Delete">
              <Button type="text" size="small" icon={<DeleteOutlined />} onClick={onDelete} danger disabled={disabled} />
            </Tooltip>
          </Space>
        </div>
      }
    >
      {/* Language Toggle */}
      <div style={{ marginBottom: 12, display: 'flex', justifyContent: 'flex-end' }}>
        <Button.Group size="small">
          <Button
            type={activeLanguage === 'english' ? 'primary' : 'default'}
            onClick={() => setActiveLanguage('english')}
            icon={<GlobalOutlined />}
            disabled={disabled}
          >
            English
          </Button>
          <Button
            type={activeLanguage === 'marathi' ? 'primary' : 'default'}
            onClick={() => setActiveLanguage('marathi')}
            disabled={disabled}
          >
            मराठी
          </Button>
        </Button.Group>
      </div>

      {/* Field Label */}
      <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
        <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
          <Text type="secondary" style={{ fontSize: '12px' }}>Field Label</Text>
        </Col>
        <Col span={16}>
          <div style={{ display: 'flex', gap: '8px' }}>
            <Tag color="blue" style={{ height: "32px", lineHeight: "30px" }}>EN</Tag>
            <Input
              value={activeLanguage === 'english' ? field.enLabel : field.mrLabel}
              onChange={(e) => {
                const value = e.target.value;
                if (activeLanguage === 'english') {
                  updateField("enLabel", value);
                  handleTranslate(value, "mrLabel");
                } else {
                  updateField("mrLabel", value);
                }
              }}
              placeholder={activeLanguage === 'english' ? "Enter English label" : "मराठी लेबल प्रविष्ट करा"}
              size="middle"
              allowClear
              style={{ width: "100%" }}
              disabled={disabled}
            />
          </div>
        </Col>
      </Row>

      {/* Comparison Operator */}
      <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
        <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
          <Text type="secondary" style={{ fontSize: "12px" }}>Operator</Text>
        </Col>
        <Col span={16}>
          <Select
            style={{ width: "100%" }}
            value={field.comparisonOperator || "equals"}
            onChange={(value) => updateField("comparisonOperator", value)}
            getPopupContainer={(trigger) => trigger.parentNode}
            disabled={disabled}
          >
            {COMPARISON_OPERATORS.map(op => (
              <Option key={op.value} value={op.value}>{op.label}</Option>
            ))}
          </Select>
        </Col>
      </Row>

      {/* ==================== MAIN FIELD SECTION WITH UNIT AND VALIDATION ==================== */}
      <div style={{
        marginBottom: 16,
        padding: 16,
        background: "#f0f5ff",
        borderRadius: "6px",
        border: "1px solid #adc6ff"
      }}>
        <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
          <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
            <Text strong style={{ fontSize: "13px" }}>Main Field</Text>
          </Col>
          <Col span={16}>
            <NumberOutlined style={{ color: "#1890ff", marginRight: 8 }} />
          </Col>
        </Row>

        {/* Main Field Label */}
        <Row align="middle" gutter={16} style={{ marginBottom: 12 }}>
          <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
            <Text type="secondary" style={{ fontSize: '11px' }}>Label</Text>
          </Col>
          <Col span={16}>
            <div style={{ display: 'flex', gap: '8px' }}>
              <Tag color="blue" style={{ height: "28px", lineHeight: "26px" }}>EN</Tag>
              <Input
                value={field.mainField?.enLabel}
                onChange={(e) => {
                  const value = e.target.value;
                  updateMainField("enLabel", value);
                  handleTranslate(value, "mainField.mrLabel");
                }}
                placeholder="English label"
                size="small"
                allowClear
                style={{ flex: 1 }}
                disabled={disabled}
              />
            </div>
          </Col>
        </Row>

        {/* Placeholder */}
        <Row align="middle" gutter={16} style={{ marginBottom: 12 }}>
          <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
            <Text type="secondary" style={{ fontSize: '11px' }}>Placeholder</Text>
          </Col>
          <Col span={16}>
            <div style={{ display: 'flex', gap: '8px' }}>
              <Tag color="blue" style={{ height: "28px", lineHeight: "26px" }}>EN</Tag>
              <Input
                value={field.mainField?.enPlaceholder}
                onChange={(e) => {
                  const value = e.target.value;
                  updateMainField("enPlaceholder", value);
                  handleTranslate(value, "mainField.mrPlaceholder");
                }}
                placeholder="Placeholder"
                size="small"
                allowClear
                style={{ flex: 1 }}
                disabled={disabled}
              />
            </div>
          </Col>
        </Row>

        {/* Required checkbox */}
        <Row align="middle" gutter={16} style={{ marginBottom: 12 }}>
          <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
            <Text type="secondary" style={{ fontSize: '11px' }}>Required</Text>
          </Col>
          <Col span={16}>
            <Space size={16}>
              <Checkbox
                checked={field.mainField?.enRequired}
                onChange={(e) => {
                  updateMainField("enRequired", e.target.checked);
                  
                }}
                disabled={disabled}
              >
              Required
              </Checkbox>
              
            </Space>
          </Col>
        </Row>

        {/* Unit Option for Main Field */}
        <Row align="middle" gutter={16} style={{ marginTop: 12 }}>
          <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
            <Text type="secondary" style={{ fontSize: '11px' }}>Unit</Text>
          </Col>
          <Col span={16}>
            <SimpleUnitCheckbox
              field={field.mainField || {
                hasUnit: false,
                selectedUnit: null,
                selectedUnitObject: null,
                units: { enabled: false }
              }}
              onUpdate={(updatedMainField) => {
                updateMainFieldComplete(updatedMainField);
              }}
              language={language}
            />
          </Col>
        </Row>

        {/* ✅ NEW: VALIDATION PANEL FOR MAIN FIELD */}
        <Divider style={{ margin: '12px 0 8px 0' }} />
        <Row align="middle" gutter={16}>
          <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
            <Text type="secondary" style={{ fontSize: '11px' }}>Validation Rules</Text>
          </Col>
          <Col span={16}>
            <ValidationPanel
              field={field.mainField}
              onUpdate={(updatedMainField) => {
                updateMainFieldComplete(updatedMainField);
              }}
              language={activeLanguage}
            />
          </Col>
        </Row>
      </div>

      {/* Global Arithmetic Operator */}
      <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
        <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
          <Text type="secondary" style={{ fontSize: "12px" }}>Global Operator</Text>
        </Col>
        <Col span={16}>
          <Select
            style={{ width: "100%" }}
            value={globalOperator}
            onChange={applyGlobalOperator}
            placeholder={language === 'english' ? "Select operator (optional)" : "ऑपरेटर निवडा (पर्यायी)"}
            getPopupContainer={(trigger) => trigger.parentNode}
            disabled={disabled}
            allowClear
          >
            {ARITHMETIC_OPERATORS.map(op => (
              <Option key={op.value} value={op.value}>{op.label}</Option>
            ))}
          </Select>
          <Text type="secondary" style={{ fontSize: '11px', marginTop: 4, display: 'block' }}>
            {language === 'english' 
              ? "Select an operator to apply to all existing sub-fields (optional)" 
              : "सर्व विद्यमान उप-फील्डवर लागू करण्यासाठी ऑपरेटर निवडा (पर्यायी)"}
          </Text>
        </Col>
      </Row>

      {/* Custom Validation Message */}
      <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
        <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
          <Text type="secondary" style={{ fontSize: "12px" }}>
            {activeLanguage === 'english' ? 'Validation Message' : 'मान्यता संदेश'}
          </Text>
        </Col>
        <Col span={16}>
          <Input
            value={field.customValidationMessage || ''}
            onChange={(e) => {
              updateField("customValidationMessage", e.target.value);
            }}
            placeholder={language === 'english' 
              ? "Custom message when validation fails" 
              : "मान्यता अयशस्वी झाल्यास सानुकूल संदेश"}
          />
          <Text type="secondary" style={{ fontSize: '11px', marginTop: 4, display: 'block' }}>
            {activeLanguage === 'english' 
              ? "This message will be shown when validation fails" 
              : "हा संदेश मान्यता अयशस्वी झाल्यावर दर्शविला जाईल"}
          </Text>
        </Col>
      </Row>

{/* Required checkbox for Comparison Field - Single checkbox for EN/MR */}


      {/* ==================== SUB FIELDS SECTION WITH UNIT AND VALIDATION ==================== */}
      <div style={{ marginBottom: 16 }}>
        <Row align="middle" gutter={16} style={{ marginBottom: 12 }}>
          <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
            <Text type="secondary" style={{ fontSize: "12px" }}>Sub Fields</Text>
          </Col>
          <Col span={16}>
            <Button
              type="dashed"
              size="small"
              icon={<PlusOutlined />}
              onClick={addSubField}
              block
              disabled={disabled}
            >
              {activeLanguage === 'english' ? 'Add Sub Field' : 'उप-फील्ड जोडा'}
            </Button>
          </Col>
        </Row>

        {/* Equation Preview */}
        {field.subFields.length > 0 && (
          <Row align="middle" gutter={16} style={{ marginBottom: 12 }}>
            <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
              <Text type="secondary" style={{ fontSize: '11px' }}>Equation</Text>
            </Col>
            <Col span={16}>
              <div style={{
                padding: "6px 10px",
                background: "#f6ffed",
                border: "1px solid #b7eb8f",
                borderRadius: "4px",
                fontFamily: "monospace",
                fontSize: "12px"
              }}>
                <Space>
                  <CalculatorOutlined style={{ color: "#52c41a" }} />
                  <Text>{getEquationString()}</Text>
                </Space>
              </div>
            </Col>
          </Row>
        )}

        {field.subFields.map((subField, index) => (
          <Card
            key={subField.id}
            size="small"
            style={{
              marginBottom: 12,
              background: "#fafafa",
              border: "1px solid #e8e8e8",
              marginLeft: "33.33%",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: 12 }}>
              <NumberOutlined style={{ color: "#52c41a" }} />
              <Text strong style={{ fontSize: "13px" }}>
                {activeLanguage === 'english' ? 'Sub Field' : 'उप-फील्ड'} {index + 1}
              </Text>
              {field.subFields.length > 1 && (
                <Button
                  type="text"
                  size="small"
                  icon={<DeleteOutlined />}
                  onClick={() => removeSubField(index)}
                  danger
                  style={{ marginLeft: 'auto' }}
                  disabled={disabled}
                />
              )}
            </div>

            {/* Sub Field Label */}
            <Row align="middle" gutter={16} style={{ marginBottom: 12 }}>
              <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
                <Text type="secondary" style={{ fontSize: '11px' }}>Label</Text>
              </Col>
              <Col span={16}>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <Tag color="blue" style={{ height: "28px", lineHeight: "26px" }}>EN</Tag>
                  <Input
                    value={activeLanguage === 'english' ? subField.enLabel : subField.mrLabel}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (activeLanguage === 'english') {
                        updateSubField(index, "enLabel", value);
                        handleTranslate(value, `subField.${index}.mrLabel`);
                      } else {
                        updateSubField(index, "mrLabel", value);
                      }
                    }}
                    placeholder="Label"
                    size="small"
                    allowClear
                    style={{ flex: 1 }}
                    disabled={disabled}
                  />
                </div>
              </Col>
            </Row>

            {/* Operator */}
            <Row align="middle" gutter={16} style={{ marginBottom: 12 }}>
              <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
                <Text type="secondary" style={{ fontSize: '11px' }}>Operator</Text>
              </Col>
              <Col span={16}>
                <Select
                  style={{ width: "100px" }}
                  size="small"
                  value={subField.arithmeticOperator || "add"}
                  onChange={(value) => updateSubField(index, "arithmeticOperator", value)}
                  getPopupContainer={(trigger) => trigger.parentNode}
                  disabled={disabled}
                >
                  {ARITHMETIC_OPERATORS.map(op => (
                    <Option key={op.value} value={op.value}>{op.symbol} - {op.label}</Option>
                  ))}
                </Select>
              </Col>
            </Row>

            {/* Placeholder */}
            <Row align="middle" gutter={16} style={{ marginBottom: 12 }}>
              <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
                <Text type="secondary" style={{ fontSize: '11px' }}>Placeholder</Text>
              </Col>
              <Col span={16}>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <Tag color="blue" style={{ height: "28px", lineHeight: "26px" }}>EN</Tag>
                  <Input
                    value={activeLanguage === 'english' ? subField.enPlaceholder : subField.mrPlaceholder}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (activeLanguage === 'english') {
                        updateSubField(index, "enPlaceholder", value);
                        handleTranslate(value, `subField.${index}.mrPlaceholder`);
                      } else {
                        updateSubField(index, "mrPlaceholder", value);
                      }
                    }}
                    placeholder="Placeholder"
                    size="small"
                    allowClear
                    style={{ flex: 1 }}
                    disabled={disabled}
                  />
                </div>
              </Col>
            </Row>

            {/* Required checkboxes */}
            <Row align="middle" gutter={16} style={{ marginBottom: 12 }}>
              <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
                <Text type="secondary" style={{ fontSize: '11px' }}>Required</Text>
              </Col>
              <Col span={16}>
                <Space size={16}>
                  <Checkbox
                    checked={subField.enRequired}
                    onChange={(e) => {
                      updateSubField(index, "enRequired", e.target.checked);
                    
                    }}
                    disabled={disabled}
                  >
                    Required
                 </Checkbox>
                </Space>
              </Col>
            </Row>

            {/* Unit Option for Sub Field */}
            <Row align="middle" gutter={16} style={{ marginTop: 12 }}>
              <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
                <Text type="secondary" style={{ fontSize: '11px' }}>Unit</Text>
              </Col>
              <Col span={16}>
                <SimpleUnitCheckbox
                  field={subField}
                  onUpdate={(updatedSubField) => {
                    updateSubFieldComplete(index, updatedSubField);
                  }}
                  language={language}
                />
              </Col>
            </Row>

            {/* Show selected unit badge if unit is selected */}
            {getUnitDisplay(subField) && (
              <Row align="middle" gutter={16} style={{ marginTop: 8 }}>
                <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
                  <Text type="secondary" style={{ fontSize: '11px' }}>Selected Unit</Text>
                </Col>
                <Col span={16}>
                  <Tag color="green" icon={<CheckCircleOutlined />}>
                    {getUnitDisplay(subField)}
                  </Tag>
                </Col>
              </Row>
            )}

            {/* ✅ VALIDATION PANEL FOR SUB FIELD */}
            <Divider style={{ margin: '12px 0 8px 0' }} />
            <Row align="middle" gutter={16}>
              <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
                <Text type="secondary" style={{ fontSize: '11px' }}>Validation Rules</Text>
              </Col>
              <Col span={16}>
                <ValidationPanel
                  field={subField}
                  onUpdate={(updatedSubField) => {
                    updateSubFieldComplete(index, updatedSubField);
                  }}
                  language={activeLanguage}
                />
              </Col>
            </Row>
          </Card>
        ))}
      </div>
    </Card>
  );
};

const ArithmeticFieldEditor = ({ field, onUpdate, onDelete, onCopy, language, autoTranslate, translateTyping, translating, disabled = false }) => {
  const [activeLanguage, setActiveLanguage] = useState(language || 'english');
  const [typingTimeouts, setTypingTimeouts] = useState({});
  const [localOperator, setLocalOperator] = useState(field.arithmeticOperator || "add");

  const updateField = (key, value) => {
    if (disabled) return;
    onUpdate({ ...field, [key]: value });
  };

  const updateArithmeticField = (index, key, value) => {
    if (disabled) return;
    const newFields = [...(field.arithmeticFields || [])];
    newFields[index] = {
      ...newFields[index],
      [key]: value
    };
    updateField("arithmeticFields", newFields);
  };

  // Direct update for required checkbox (bypasses disabled check)
  const directUpdateRequired = (index, checked) => {
    console.log(`🚀 Direct update required checkbox for field ${index}:`, checked);
    const newFields = [...(field.arithmeticFields || [])];
    newFields[index] = {
      ...newFields[index],
      enRequired: checked,
      required: checked
    };
    onUpdate({ ...field, arithmeticFields: newFields });
  };

  const updateArithmeticFieldComplete = (index, updatedField) => {
    if (disabled) return;
    const newFields = [...(field.arithmeticFields || [])];
    newFields[index] = updatedField;
    updateField("arithmeticFields", newFields);
  };

  const updateResultField = (key, value) => {
    if (disabled) return;
    updateField("resultField", {
      ...field.resultField,
      [key]: value
    });
  };

  const directUpdateResultRequired = (checked) => {
    console.log(`🚀 Direct update result field required:`, checked);
    onUpdate({
      ...field,
      resultField: {
        ...field.resultField,
        enRequired: checked,
        mrRequired: checked
      }
    });
  };

  const updateResultFieldComplete = (updatedResultField) => {
    if (disabled) return;
    updateField("resultField", updatedResultField);
  };

  const addArithmeticField = () => {
    if (disabled) return;
    const newFields = [...(field.arithmeticFields || []), {
      id: uid(),
      type: "number",
      enLabel: `Value ${(field.arithmeticFields?.length || 0) + 1}`,
      enPlaceholder: "Enter value",
      enRequired: false,
      mrLabel: `मूल्य ${(field.arithmeticFields?.length || 0) + 1}`,
      mrPlaceholder: "मूल्य प्रविष्ट करा",
      mrRequired: false,
      label: `Value ${(field.arithmeticFields?.length || 0) + 1}`,
      placeholder: "Enter value",
      required: false,
      hasUnit: false,
      selectedUnit: null,
      selectedUnitObject: null,
      units: {
        enabled: false,
        selectedUnit: null,
        selectedUnitId: null,
        selectedUnitValue: null,
        selectedUnitSymbol: null,
        selectedUnitLabel: null,
        unitCategory: null
      },
      validation: {
        exactLength: null,
        decimalPlaces: null,
        allowDecimals: false,
        allowNegative: false,
        allowZero: true,
        integerOnly: false,
        patternType: "none",
        customPattern: "",
        patternErrorMessage: "",
        allowedCharacters: "any",
        disallowedCharacters: "",
        allowSpaces: true,
        allowLeadingSpaces: false,
        allowTrailingSpaces: false,
        allowMultipleSpaces: true,
        trimInput: true,
        caseSensitive: true,
        uppercase: false,
        lowercase: false,
        languageScript: "any",
        fontFamily: "default",
        dateFormat: "YYYY-MM-DD",
        timeFormat: "HH:mm",
        dateTimeFormat: "YYYY-MM-DD HH:mm",
        validationFunction: null,
        validationMessage: "",
        isEmail: false,
        isPhone: false,
        isUrl: false,
        isIPAddress: false,
        isCreditCard: false,
        regexPattern: "",
        regexFlags: "g",
        customErrorMessage: "",
        detectLanguage: false,
        allowedLanguages: []
      }
    }];
    updateField("arithmeticFields", newFields);
  };

  const removeArithmeticField = (index) => {
    if (disabled) return;
    const newFields = field.arithmeticFields.filter((_, i) => i !== index);
    updateField("arithmeticFields", newFields);
  };

  useEffect(() => {
    return () => {
      Object.values(typingTimeouts).forEach(timeout => clearTimeout(timeout));
    };
  }, [typingTimeouts]);

  useEffect(() => {
    setLocalOperator(field.arithmeticOperator || "add");
  }, [field.arithmeticOperator]);

  const handleTranslate = async (text, targetField) => {
    if (!autoTranslate || !text || text.trim() === '') return;
    if (typingTimeouts[targetField]) clearTimeout(typingTimeouts[targetField]);
    const timeout = setTimeout(async () => {
      const translated = await translateTyping(text, 'mr');
      if (translated && translated !== text) {
        if (targetField === 'mrLabel') {
          updateField('mrLabel', translated);
        } else if (targetField === 'mrHelpText') {
          updateField('mrHelpText', translated);
        } else if (targetField.startsWith('arithmeticField.')) {
          const parts = targetField.split('.');
          const index = parseInt(parts[1]);
          const key = parts[2];
          updateArithmeticField(index, key, translated);
        } else if (targetField.startsWith('resultField.')) {
          const key = targetField.split('.')[1];
          updateResultField(key, translated);
        }
      }
    }, 800);
    setTypingTimeouts(prev => ({ ...prev, [targetField]: timeout }));
  };

  const getUnitDisplay = (arithmeticField) => {
    if (!arithmeticField) return null;
    if (arithmeticField.hasUnit && arithmeticField.selectedUnitObject) {
      return arithmeticField.selectedUnitObject.unit_symbol || arithmeticField.selectedUnitObject.unit_name;
    }
    if (arithmeticField.units?.enabled && arithmeticField.units.selectedUnitSymbol) {
      return arithmeticField.units.selectedUnitSymbol;
    }
    return null;
  };

  return (
    <Card
      size="small"
      style={{
        marginBottom: 12,
        borderRadius: "8px",
        border: "2px solid #52c41a",
        boxShadow: "0 2px 8px rgba(82, 196, 26, 0.1)",
        borderLeft: field.fromExisting ? "4px solid #113F67" : undefined,
        opacity: disabled ? 0.7 : 1
      }}
      title={
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Badge count="Arithmetic" style={{ backgroundColor: "#52c41a" }} />
            <span style={{ fontWeight: 'bold', fontSize: '14px' }}>Arithmetic Field</span>
            {autoTranslate && <Tag color="green" icon={<GlobalOutlined />}>Auto ON</Tag>}
            {field.fromExisting && <Tag color="blue">From: {field.sourceColumn}</Tag>}
            {disabled && <Tag color="orange">Read Only</Tag>}
          </div>
          <Space size={4}>
            <Tooltip title="Copy"><Button type="text" size="small" icon={<CopyOutlined />} onClick={onCopy} disabled={disabled} /></Tooltip>
            <Tooltip title="Delete"><Button type="text" size="small" icon={<DeleteOutlined />} onClick={onDelete} danger disabled={disabled} /></Tooltip>
          </Space>
        </div>
      }
    >
      {/* Language Toggle */}
      <div style={{ marginBottom: 12, display: 'flex', justifyContent: 'flex-end' }}>
        <Button.Group size="small">
          <Button type={activeLanguage === 'english' ? 'primary' : 'default'} onClick={() => setActiveLanguage('english')} disabled={disabled}>English</Button>
          <Button type={activeLanguage === 'marathi' ? 'primary' : 'default'} onClick={() => setActiveLanguage('marathi')} disabled={disabled}>मराठी</Button>
        </Button.Group>
      </div>

      {/* Field Label */}
      <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
        <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
          <Text type="secondary" style={{ fontSize: '12px' }}>Field Label</Text>
        </Col>
        <Col span={16}>
          <div style={{ display: 'flex', gap: '8px' }}>
            <Tag color="blue" style={{ height: "32px", lineHeight: "30px" }}>EN</Tag>
            <Input
              value={activeLanguage === 'english' ? field.enLabel : field.mrLabel}
              onChange={(e) => {
                const value = e.target.value;
                if (activeLanguage === 'english') {
                  updateField("enLabel", value);
                  handleTranslate(value, "mrLabel");
                } else {
                  updateField("mrLabel", value);
                }
              }}
              placeholder={activeLanguage === 'english' ? "Enter English label" : "मराठी लेबल प्रविष्ट करा"}
              size="middle"
              allowClear
              style={{ width: "100%" }}
              disabled={disabled}
            />
          </div>
        </Col>
      </Row>

      {/* Arithmetic Operator Selection */}
      <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
        <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
          <Text type="secondary" style={{ fontSize: '12px' }}>Operator</Text>
        </Col>
        <Col span={16}>
          <Radio.Group
            value={localOperator}
            onChange={(e) => {
              setLocalOperator(e.target.value);
              updateField("arithmeticOperator", e.target.value);
            }}
            optionType="button"
            buttonStyle="solid"
            size="middle"
            disabled={disabled}
          >
            <Radio.Button value="add">+</Radio.Button>
            <Radio.Button value="subtract">-</Radio.Button>
            <Radio.Button value="multiply">×</Radio.Button>
            <Radio.Button value="divide">÷</Radio.Button>
            <Radio.Button value="average">avg</Radio.Button>
            <Radio.Button value="percentage">%</Radio.Button>
          </Radio.Group>
        </Col>
      </Row>

      {/* Number Fields */}
      <div style={{ marginBottom: 16 }}>
        <Row align="middle" gutter={16} style={{ marginBottom: 12 }}>
          <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
            <Text type="secondary" style={{ fontSize: '12px' }}>Number Fields</Text>
          </Col>
          <Col span={16}>
            <Button type="dashed" size="small" icon={<PlusOutlined />} onClick={addArithmeticField} block disabled={disabled}>
              {activeLanguage === 'english' ? 'Add Number Field' : 'संख्या फील्ड जोडा'}
            </Button>
          </Col>
        </Row>

        {field.arithmeticFields?.map((afield, index) => (
          <Card
            key={afield.id}
            size="small"
            style={{
              marginBottom: 12,
              background: "#fafafa",
              border: "1px solid #e8e8e8",
              marginLeft: "33.33%",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: 12 }}>
              <NumberOutlined style={{ color: "#52c41a" }} />
              <Text strong style={{ fontSize: "13px" }}>
                {activeLanguage === 'english' ? 'Value' : 'मूल्य'} {index + 1}
                {localOperator === "percentage" && index === 0 && " (Percentage)"}
                {localOperator === "percentage" && index === 1 && " (Base Value)"}
              </Text>
              {field.arithmeticFields.length > 1 && (
                <Button type="text" size="small" icon={<DeleteOutlined />} onClick={() => removeArithmeticField(index)} danger style={{ marginLeft: 'auto' }} disabled={disabled} />
              )}
            </div>

            {/* Field Label */}
            <Row align="middle" gutter={16} style={{ marginBottom: 12 }}>
              <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
                <Text type="secondary" style={{ fontSize: '11px' }}>Label</Text>
              </Col>
              <Col span={16}>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <Tag color="blue" style={{ height: "28px", lineHeight: "26px" }}>EN</Tag>
                  <Input
                    value={activeLanguage === 'english' ? afield.enLabel : afield.mrLabel}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (activeLanguage === 'english') {
                        updateArithmeticField(index, "enLabel", value);
                        handleTranslate(value, `arithmeticField.${index}.mrLabel`);
                      } else {
                        updateArithmeticField(index, "mrLabel", value);
                      }
                    }}
                    placeholder="Label"
                    size="small"
                    allowClear
                    style={{ flex: 1 }}
                    disabled={disabled}
                  />
                </div>
              </Col>
            </Row>

            {/* Placeholder */}
            <Row align="middle" gutter={16} style={{ marginBottom: 12 }}>
              <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
                <Text type="secondary" style={{ fontSize: '11px' }}>Placeholder</Text>
              </Col>
              <Col span={16}>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <Tag color="blue" style={{ height: "28px", lineHeight: "26px" }}>EN</Tag>
                  <Input
                    value={activeLanguage === 'english' ? afield.enPlaceholder : afield.mrPlaceholder}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (activeLanguage === 'english') {
                        updateArithmeticField(index, "enPlaceholder", value);
                        handleTranslate(value, `arithmeticField.${index}.mrPlaceholder`);
                      } else {
                        updateArithmeticField(index, "mrPlaceholder", value);
                      }
                    }}
                    placeholder="Placeholder"
                    size="small"
                    allowClear
                    style={{ flex: 1 }}
                    disabled={disabled}
                  />
                </div>
              </Col>
            </Row>

            {/* ✅ FIXED: Required checkbox - SIMPLIFIED like Text field */}
            <Row align="middle" gutter={16} style={{ marginBottom: 12 }}>
              <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
                <Text type="secondary" style={{ fontSize: '11px' }}>Required</Text>
              </Col>
              <Col span={16}>
                <Checkbox
                  checked={afield.enRequired === true}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    console.log(`✅ Arithmetic field ${index + 1} required checkbox clicked:`, checked);
                    directUpdateRequired(index, checked);
                  }}
                  // Force enable - ignore disabled prop
                  disabled={false}
                >
                  Required
                </Checkbox>
              </Col>
            </Row>

            {/* Unit Option */}
            <Row align="middle" gutter={16} style={{ marginTop: 12 }}>
              <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
                <Text type="secondary" style={{ fontSize: '11px' }}>Unit</Text>
              </Col>
              <Col span={16}>
                <SimpleUnitCheckbox
                  field={afield}
                  onUpdate={(updatedField) => updateArithmeticFieldComplete(index, updatedField)}
                  language={activeLanguage}
                />
              </Col>
            </Row>

            {getUnitDisplay(afield) && (
              <Row align="middle" gutter={16} style={{ marginTop: 8 }}>
                <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
                  <Text type="secondary" style={{ fontSize: '11px' }}>Selected Unit</Text>
                </Col>
                <Col span={16}>
                  <Tag color="green" icon={<CheckCircleOutlined />}>{getUnitDisplay(afield)}</Tag>
                </Col>
              </Row>
            )}

            {/* Validation Panel */}
            <Divider style={{ margin: '12px 0 8px 0' }} />
            <Row align="middle" gutter={16}>
              <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
                <Text type="secondary" style={{ fontSize: '11px' }}>Validation Rules</Text>
              </Col>
              <Col span={16}>
                <ValidationPanel
                  field={afield}
                  onUpdate={(updatedField) => updateArithmeticFieldComplete(index, updatedField)}
                  language={activeLanguage}
                />
              </Col>
            </Row>
          </Card>
        ))}
      </div>

      {/* Result Field Configuration */}
      <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
        <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
          <Text type="secondary" style={{ fontSize: '12px' }}>Result Field</Text>
        </Col>
        <Col span={16}>
          <Card size="small" style={{ background: "#f9f9f9" }}>
            <Row align="middle" gutter={16} style={{ marginBottom: 8 }}>
              <Col span={8}><Text type="secondary" style={{ fontSize: '11px' }}>Label (EN)</Text></Col>
              <Col span={16}>
                <Input size="small" value={field.resultField?.enLabel || "Result"} onChange={(e) => updateResultField("enLabel", e.target.value)} placeholder="Result label" disabled={disabled} />
              </Col>
            </Row>
            <Row align="middle" gutter={16} style={{ marginBottom: 8 }}>
              <Col span={8}><Text type="secondary" style={{ fontSize: '11px' }}>Label (MR)</Text></Col>
              <Col span={16}>
                <Input size="small" value={field.resultField?.mrLabel || "परिणाम"} onChange={(e) => updateResultField("mrLabel", e.target.value)} placeholder="परिणाम" disabled={disabled} />
              </Col>
            </Row>

            {/* ✅ FIXED: Result field required checkbox - SIMPLIFIED */}
            <Row align="middle" gutter={16} style={{ marginBottom: 8 }}>
              <Col span={8}><Text type="secondary" style={{ fontSize: '11px' }}>Required</Text></Col>
              <Col span={16}>
                <Checkbox
                  checked={field.resultField?.enRequired === true}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    console.log("✅ Result field required checkbox clicked:", checked);
                    directUpdateResultRequired(checked);
                  }}
                  disabled={false}
                >
                  Make result field required
                </Checkbox>
              </Col>
            </Row>

            {/* Unit Option for Result Field */}
            <Divider style={{ margin: '12px 0 8px 0' }} />
            <Row align="middle" gutter={16}>
              <Col span={8}><Text type="secondary" style={{ fontSize: '11px' }}>Unit</Text></Col>
              <Col span={16}>
                <SimpleUnitCheckbox
                  field={field.resultField || { hasUnit: false, selectedUnit: null, selectedUnitObject: null, units: { enabled: false } }}
                  onUpdate={(updatedResultField) => updateResultFieldComplete(updatedResultField)}
                  language={activeLanguage}
                />
              </Col>
            </Row>

            {/* Validation Panel for Result Field */}
            {(field.resultField?.validation || field.resultField) && (
              <>
                <Divider style={{ margin: '12px 0 8px 0' }} />
                <Row align="middle" gutter={16}>
                  <Col span={8}><Text type="secondary" style={{ fontSize: '11px' }}>Validation Rules</Text></Col>
                  <Col span={16}>
                    <ValidationPanel
                      field={field.resultField || { validation: {} }}
                      onUpdate={(updatedResultField) => updateResultFieldComplete(updatedResultField)}
                      language={activeLanguage}
                    />
                  </Col>
                </Row>
              </>
            )}
          </Card>
        </Col>
      </Row>

      {/* Result Box Preview */}
      <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
        <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
          <Text type="secondary" style={{ fontSize: '12px' }}>Result Preview</Text>
        </Col>
        <Col span={16}>
          <div style={{ padding: "12px", background: "#f6ffed", border: "2px solid #b7eb8f", borderRadius: "8px", textAlign: "center" }}>
            <Space direction="vertical" size={4} style={{ width: '100%' }}>
              <Text strong style={{ fontSize: "12px", color: "#389e0d" }}>
                {activeLanguage === 'english' ? (field.resultField?.enLabel || "Result") : (field.resultField?.mrLabel || "परिणाम")}
              </Text>
              <div style={{ fontSize: "16px", fontWeight: "bold", color: "#389e0d" }}>
                0.00
                {getUnitDisplay(field.resultField) && (
                  <span style={{ fontSize: "12px", marginLeft: 4, color: "#666" }}>({getUnitDisplay(field.resultField)})</span>
                )}
              </div>
            </Space>
          </div>
        </Col>
      </Row>

      {localOperator === "percentage" && (
        <Alert
          message={activeLanguage === 'english' 
            ? "Percentage Calculation: First value is percentage, second value is base" 
            : "टक्केवारी गणना: पहिले मूल्य टक्केवारी आहे, दुसरे मूल्य आधार मूल्य आहे"}
          type="info"
          showIcon
          style={{ marginTop: 8 }}
        />
      )}
    </Card>
  );
};

const SimpleAccessReport = ({ fields, reportConfig, onReportConfigChange, onFieldReportConfigChange, language }) => {
  // State
  const [selectedFields, setSelectedFields] = useState(reportConfig?.selectedFields || []);
  const [operations, setOperations] = useState(reportConfig?.operations || {});
  const [importantFields, setImportantFields] = useState(reportConfig?.importantFields || []);
  const [reportName, setReportName] = useState(reportConfig?.reportName || '');
  const [reportDescription, setReportDescription] = useState(reportConfig?.reportDescription || '');
  const [expandedSections, setExpandedSections] = useState({});
  
  // State for operation modal/expanded rows
  const [activeOperationField, setActiveOperationField] = useState(null);
  const [tempOperation, setTempOperation] = useState(null);
  
  // State for column import modal
  const [tableSearchVisible, setTableSearchVisible] = useState(false);
  const [selectedFieldForImport, setSelectedFieldForImport] = useState(null);
  const [importedColumnsMap, setImportedColumnsMap] = useState(reportConfig?.importedColumnsMap || {});

  // Operators list
  const operators = useMemo(() => [
    { value: 'sum', label: 'Sum', labelMr: 'बेरीज', symbol: '∑', color: '#52c41a' },
    { value: 'count', label: 'Count', labelMr: 'गणना', symbol: '#', color: '#1890ff' },
    { value: 'average', label: 'Average', labelMr: 'सरासरी', symbol: 'avg', color: '#722ed1' },
    { value: 'min', label: 'Min', labelMr: 'किमान', symbol: 'Min', color: '#fa8c16' },
    { value: 'max', label: 'Max', labelMr: 'कमाल', symbol: 'Max', color: '#eb2f96' },
    { value: 'percentage', label: '%', labelMr: 'टक्केवारी', symbol: '%', color: '#13c2c2' },
  ], []);


    const getUnitDisplayInfo = (field) => {
    if (!field) return null;
    if (field.selectedUnitObject) {
      return { 
        symbol: field.selectedUnitObject.unit_symbol, 
        name: field.selectedUnitObject.unit_name, 
        value: field.selectedUnitObject.unit_value 
      };
    }
    if (field.units?.enabled && field.units.selectedUnitSymbol) {
      return { 
        symbol: field.units.selectedUnitSymbol, 
        name: field.units.selectedUnitLabel, 
        value: field.units.selectedUnitValue 
      };
    }
    if (field.hasUnit && field.selectedUnit) {
      if (typeof field.selectedUnit === 'object') {
        return { 
          symbol: field.selectedUnit.unit_symbol, 
          name: field.selectedUnit.unit_name, 
          value: field.selectedUnit.unit_value 
        };
      }
    }
    return null;
  };

  // ✅ COMPLETELY FIXED: Function to recursively collect ALL fields with their children
  const collectAllFieldsWithChildren = useCallback((fieldList, parentId = null, level = 0) => {
    const result = [];
    
    for (const field of fieldList) {
      // Skip system internal fields
      if (field.type === 'system_report') continue;
      
      // Add current field
      result.push({
        ...field,
        level,
        parentId
      });
      
      // ==================== 1. HEADING FIELDS ====================
      if (field.type === 'heading') {
        // Get all child fields under this heading (fields with parentId = this field id)
        const childFields = fields.filter(f => f.parentId === field.id);
        if (childFields.length > 0) {
          result.push(...collectAllFieldsWithChildren(childFields, field.id, level + 1));
        }
      }
      
      // ==================== 2. RADIO FIELDS ====================
      if (field.type === 'radio') {
        // Get options for display
        const options = field.enOptions || field.options || [];
        
        // Add each radio option as a parent row
        options.forEach((option, idx) => {
          result.push({
            id: `${field.id}_opt_${idx}`,
            originalId: field.id,
            type: 'radio_option',
            enLabel: `${field.enLabel || field.label} → ${option}`,
            mrLabel: `${field.mrLabel || field.label} → ${option}`,
            isSubField: true,
            parentId: field.id,
            level: level + 1,
            originalField: field,
            optionValue: option
          });
        });
        
        // Get child fields for radio (subfields that appear when option is selected)
        const radioChildFields = fields.filter(f => f.parentId === field.id);
        if (radioChildFields.length > 0) {
          result.push(...collectAllFieldsWithChildren(radioChildFields, field.id, level + 1));
        }
      }
      
      // ==================== 3. CHECKBOX FIELDS ====================
      if (field.type === 'checkbox') {
        // Get options for display
        const options = field.enOptions || field.options || [];
        
        // Add each checkbox option as a parent row
        options.forEach((option, idx) => {
          result.push({
            id: `${field.id}_opt_${idx}`,
            originalId: field.id,
            type: 'checkbox_option',
            enLabel: `${field.enLabel || field.label} → ${option}`,
            mrLabel: `${field.mrLabel || field.label} → ${option}`,
            isSubField: true,
            parentId: field.id,
            level: level + 1,
            originalField: field,
            optionValue: option
          });
        });
        
        // Get child fields for checkbox
        const checkboxChildFields = fields.filter(f => f.parentId === field.id);
        if (checkboxChildFields.length > 0) {
          result.push(...collectAllFieldsWithChildren(checkboxChildFields, field.id, level + 1));
        }
      }
      
      // ==================== 4. DROPDOWN FIELDS ====================
      if (field.type === 'dropdown') {
        // Get options for display
        const options = field.enOptions || field.options || [];
        
        // Add each dropdown option as a parent row
        options.forEach((option, idx) => {
          result.push({
            id: `${field.id}_opt_${idx}`,
            originalId: field.id,
            type: 'dropdown_option',
            enLabel: `${field.enLabel || field.label} → ${option}`,
            mrLabel: `${field.mrLabel || field.label} → ${option}`,
            isSubField: true,
            parentId: field.id,
            level: level + 1,
            originalField: field,
            optionValue: option
          });
        });
        
        // Get child fields for dropdown (if any)
        const dropdownChildFields = fields.filter(f => f.parentId === field.id);
        if (dropdownChildFields.length > 0) {
          result.push(...collectAllFieldsWithChildren(dropdownChildFields, field.id, level + 1));
        }
      }
      
      // ==================== 5. DATE FIELDS ====================
      if (field.type === 'date') {
        // Date fields can have subfields (like date range subfields)
        const dateChildFields = fields.filter(f => f.parentId === field.id);
        if (dateChildFields.length > 0) {
          result.push(...collectAllFieldsWithChildren(dateChildFields, field.id, level + 1));
        }
      }
      
      // ==================== 6. COMPARISON FIELD subfields ====================
      if (field.type === 'comparison' && field.subFields && field.subFields.length > 0) {
        // Add main field as a sub-entry
        if (field.mainField) {
          result.push({
            id: `${field.id}_main`,
            originalId: field.id,
            type: 'comparison_main',
            enLabel: `${field.enLabel || field.label} (Main)`,
            mrLabel: `${field.mrLabel || field.label} (मुख्य)`,
            isSubField: true,
            parentId: field.id,
            level: level + 1,
            originalField: field
          });
        }
        
        // Add each subfield
        field.subFields.forEach((subField, idx) => {
          result.push({
            id: subField.id,
            originalId: field.id,
            type: subField.type || 'number',
            enLabel: `${field.enLabel || field.label} - ${subField.enLabel || `Value ${idx + 1}`}`,
            mrLabel: `${field.mrLabel || field.label} - ${subField.mrLabel || `मूल्य ${idx + 1}`}`,
            isSubField: true,
            parentId: field.id,
            level: level + 1,
            arithmeticOperator: subField.arithmeticOperator,
            originalField: field
          });
        });
      }
      
      // ==================== 7. ARITHMETIC FIELD subfields ====================
      if (field.type === 'arithmetic' && field.arithmeticFields && field.arithmeticFields.length > 0) {
        // Add each arithmetic input field
        field.arithmeticFields.forEach((afield, idx) => {
          const isPercentage = field.arithmeticOperator === 'percentage';
          const suffix = isPercentage 
            ? (idx === 0 ? ' (Percentage %)' : idx === 1 ? ' (Base Value)' : ` (Value ${idx + 1})`)
            : ` (Value ${idx + 1})`;
          
          result.push({
            id: afield.id,
            originalId: field.id,
            type: afield.type || 'number',
            enLabel: `${field.enLabel || field.label}${suffix}`,
            mrLabel: `${field.mrLabel || field.label}${suffix === ' (Percentage %)' ? ' (टक्केवारी %)' : suffix === ' (Base Value)' ? ' (मूळ मूल्य)' : ` (मूल्य ${idx + 1})`}`,
            isSubField: true,
            parentId: field.id,
            level: level + 1,
            arithmeticOperator: field.arithmeticOperator,
            originalField: field
          });
        });
        
        // Add result field
        if (field.resultField) {
          result.push({
            id: `${field.id}_result`,
            originalId: field.id,
            type: 'arithmetic_result',
            enLabel: `${field.enLabel || field.label} (Result)`,
            mrLabel: `${field.mrLabel || field.label} (परिणाम)`,
            isSubField: true,
            parentId: field.id,
            level: level + 1,
            originalField: field
          });
        }
      }
      
 if (field.type === 'formula' && field.formulaSteps && field.formulaSteps.length > 0) {
      
      // Add Final Result (top level)
      result.push({
        id: `${field.id}_final_result`,
        originalId: field.id,
        type: 'formula_final_result',
        enLabel: `${field.enLabel || field.label} [FINAL RESULT]`,
        mrLabel: `${field.mrLabel || field.label} [अंतिम निकाल]`,
        isSubField: true,
        parentId: field.id,
        level: level + 1,
        originalField: field,
        isFormulaParent: true,
        stepCombineOp: field.stepCombineOperator || 'add' 
      });
      
      // Process each step
      field.formulaSteps.forEach((step, stepIdx) => {
        const stepId = `${field.id}_step_${stepIdx}`;
        
        // Add STEP container (parent node)
        result.push({
          id: stepId,
          originalId: field.id,
          type: 'formula_step_parent',
          enLabel: `📌 ${step.name || `Step ${stepIdx + 1}`}`,
          mrLabel: `📌 ${step.name || `पायरी ${stepIdx + 1}`}`,
          isSubField: true,
          isStepParent: true,
          parentId: `${field.id}_final_result`,
          level: level + 2,
          originalField: field,
          stepId: step.id,
          stepName: step.name,
          stepCombineOp: step.combineOperator || 'add',
          hasChildren: (step.arithmeticFields && step.arithmeticFields.length > 0)
        });
        
        // Add each arithmetic field INSIDE the step as separate rows
        if (step.arithmeticFields && step.arithmeticFields.length > 0) {
          step.arithmeticFields.forEach((afield, idx) => {
            // Get unit info for display
            const unitInfo = getUnitDisplayInfo(afield);
            const unitSymbol = unitInfo?.symbol || '';
            
            result.push({
              id: afield.id,
              originalId: field.id,
              type: afield.type || 'number',
              enLabel: `${afield.enLabel || `Value ${idx + 1}`} ${unitSymbol ? `(${unitSymbol})` : ''}`,
              mrLabel: `${afield.mrLabel || `मूल्य ${idx + 1}`} ${unitSymbol ? `(${unitSymbol})` : ''}`,
              isSubField: true,
              isFormulaField: true,
              parentId: stepId,
              level: level + 3,
              originalField: field,
              stepId: step.id,
              stepName: step.name,
              arithmeticOperator: step.combineOperator, 
              fieldObject: afield,
              unitInfo: unitInfo
            });
          });
        }
      });
    }

      // ==================== 8. ROW field children ====================
      if (field.type === 'row' && field.children) {
        const leftChildren = field.children.left || [];
        const rightChildren = field.children.right || [];
        const allChildren = [...leftChildren, ...rightChildren];
        if (allChildren.length > 0) {
          result.push(...collectAllFieldsWithChildren(allChildren, field.id, level + 1));
        }
      }
      
      // ==================== 9. General children array ====================
      if (field.children && Array.isArray(field.children) && field.children.length > 0) {
        // Only process if not already processed for specific types
        if (field.type !== 'radio' && field.type !== 'checkbox' && field.type !== 'heading' && field.type !== 'dropdown') {
          result.push(...collectAllFieldsWithChildren(field.children, field.id, level + 1));
        }
      }
    }
    
    return result;
  }, [fields]);

  // Get all fields including children
  const allFieldsWithChildren = useMemo(() => {
    const mainFields = fields.filter(f => !f.parentId);
    return collectAllFieldsWithChildren(mainFields);
  }, [fields, collectAllFieldsWithChildren]);

  // Create parent-child mapping for expansion
// Create parent-child mapping for expansion - Update this useMemo
const parentChildMap = useMemo(() => {
  const map = {};
  allFieldsWithChildren.forEach(field => {
    if (field.parentId) {
      if (!map[field.parentId]) {
        map[field.parentId] = [];
      }
      map[field.parentId].push(field);
    }
  });
  return map;
}, [allFieldsWithChildren]);

  // Flatten fields for table view with proper expansion
  const flattenFields = useMemo(() => {
    const flatList = [];
    
    const flatten = (fieldList, level = 0) => {
      fieldList.forEach((field) => {
        // Skip if this is a subfield and its parent is not expanded
        const parentId = field.parentId;
        if (parentId && !expandedSections[parentId] && (field.isSubField || field.type === 'radio_option' || field.type === 'checkbox_option' || field.type === 'dropdown_option')) {
          return;
        }
        
        const isSelected = selectedFields.includes(field.id);
        const isImportant = importantFields.includes(field.id);
        const currentOp = operations[field.id]?.operator;
        const hasChildren = parentChildMap[field.id] && parentChildMap[field.id].length > 0;
        const importedColumn = importedColumnsMap[field.id];
        const isComparisonMain = field.type === 'comparison_main';
        const isArithmeticResult = field.type === 'arithmetic_result';
        const isRadioOption = field.type === 'radio_option';
        const isCheckboxOption = field.type === 'checkbox_option';
        const isDropdownOption = field.type === 'dropdown_option';
        const isFormulaStep = field.type === 'formula_step';
        const isFormulaResult = field.type === 'formula_result';
        const isStepParent = field.type === 'formula_step_parent';
        const isFormulaField = field.type === 'number' && field.isFormulaField === true;

        flatList.push({
          ...field,
          level,
          srNo: flatList.length + 1,
          isSelected,
          isImportant,
          currentOp,
          hasChildren,
          isExpanded: expandedSections[field.id] || false,
          isOperationActive: activeOperationField === field.id,
          importedColumn,
          isComparisonMain,
          isArithmeticResult,
          isRadioOption,
          isCheckboxOption,
          isDropdownOption,
          isFormulaStep,      
          isFormulaResult,
          isStepParent,      // ✅ ADD THIS
          isFormulaField   
        });
        
        if (hasChildren && expandedSections[field.id]) {
          flatten(parentChildMap[field.id], level + 1);
        }
      });
    };
    
    flatten(allFieldsWithChildren.filter(f => !f.parentId));
    return flatList;
  }, [allFieldsWithChildren, selectedFields, importantFields, operations, expandedSections, parentChildMap, activeOperationField, importedColumnsMap]);

  // Handle column import
  const handleImportColumns = (columns) => {
    if (!selectedFieldForImport) return;
    
    const column = columns[0];
    if (!column) return;
    
    const newImportedColumn = {
      table_id: column.table_id,
      table_name: column.table_name,
      column_name: column.column_name,
      column_label: column.en_label || column.column_name,
      column_type: column.field_type,
      imported_at: new Date().toISOString()
    };

    const updatedImportedColumnsMap = {
      ...importedColumnsMap,
      [selectedFieldForImport.id]: newImportedColumn
    };

    setImportedColumnsMap(updatedImportedColumnsMap);
    
    if (onReportConfigChange) {
      onReportConfigChange({
        reportName,
        reportDescription,
        selectedFields,
        operations,
        importantFields,
        importedColumnsMap: updatedImportedColumnsMap
      });
    }
    
    if (onFieldReportConfigChange) {
      onFieldReportConfigChange(selectedFieldForImport.id, {
        enabled: selectedFields.includes(selectedFieldForImport.id),
        operator: operations[selectedFieldForImport.id]?.operator || null,
        fields: [],
        customFormula: null,
        important: importantFields.includes(selectedFieldForImport.id),
        linkedTableName: column.table_name,
        linkedColumnName: column.column_name,
        linkedColumnLabel: column.en_label || column.column_name,
        linkedColumnType: column.field_type,
        linkedAt: new Date().toISOString()
      });
    }
  };

  // Remove imported column
  const removeImportedColumn = (fieldId) => {
    const updatedImportedColumnsMap = { ...importedColumnsMap };
    delete updatedImportedColumnsMap[fieldId];
    setImportedColumnsMap(updatedImportedColumnsMap);
    
    if (onFieldReportConfigChange) {
      onFieldReportConfigChange(fieldId, {
        enabled: selectedFields.includes(fieldId),
        operator: operations[fieldId]?.operator || null,
        fields: [],
        customFormula: null,
        important: importantFields.includes(fieldId),
        linkedTableName: null,
        linkedColumnName: null,
        linkedColumnLabel: null,
        linkedColumnType: null,
        linkedAt: null
      });
    }
    
    if (onReportConfigChange) {
      onReportConfigChange({
        reportName,
        reportDescription,
        selectedFields,
        operations,
        importantFields,
        importedColumnsMap: updatedImportedColumnsMap
      });
    }
  };

  // Handle click outside - close operation panel
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (activeOperationField) {
        const operationCell = document.querySelector(`.operation-cell-${activeOperationField}`);
        if (operationCell && !operationCell.contains(e.target)) {
          if (tempOperation) {
            handleOperatorChange(activeOperationField, tempOperation);
          }
          setActiveOperationField(null);
          setTempOperation(null);
        }
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [activeOperationField, tempOperation]);

  // Handle important checkbox toggle
  const handleImportantToggle = (fieldId, checked) => {
    let newImportant = [...importantFields];
    
    if (checked) {
      if (!newImportant.includes(fieldId)) {
        newImportant.push(fieldId);
      }
    } else {
      newImportant = newImportant.filter(id => id !== fieldId);
    }
    
    setImportantFields(newImportant);
    
    onReportConfigChange({
      reportName,
      reportDescription,
      selectedFields,
      operations,
      importantFields: newImportant,
      importedColumnsMap
    });
    
    if (onFieldReportConfigChange) {
      const field = allFieldsWithChildren.find(f => f.id === fieldId);
      onFieldReportConfigChange(fieldId, {
        enabled: selectedFields.includes(fieldId),
        operator: operations[fieldId]?.operator || null,
        fields: [],
        customFormula: null,
        important: checked,
        linkedTableName: importedColumnsMap[fieldId]?.table_name,
        linkedColumnName: importedColumnsMap[fieldId]?.column_name,
        linkedColumnLabel: importedColumnsMap[fieldId]?.column_label,
        linkedColumnType: importedColumnsMap[fieldId]?.column_type,
        linkedAt: importedColumnsMap[fieldId]?.imported_at
      });
    }
  };

  // Handle operator change
  const handleOperatorChange = (fieldId, operatorValue) => {
    const newOps = {
      ...operations,
      [fieldId]: { operator: operatorValue }
    };

    let newSelected = [...selectedFields];
    if (operatorValue && !newSelected.includes(fieldId)) {
      newSelected.push(fieldId);
    }

    setOperations(newOps);
    setSelectedFields(newSelected);
    
    onReportConfigChange({
      reportName,
      reportDescription,
      selectedFields: newSelected,
      operations: newOps,
      importantFields,
      importedColumnsMap
    });
    
    if (onFieldReportConfigChange) {
      const field = allFieldsWithChildren.find(f => f.id === fieldId);
      onFieldReportConfigChange(fieldId, {
        enabled: !!operatorValue,
        operator: operatorValue || null,
        fields: [],
        customFormula: null,
        important: importantFields.includes(fieldId),
        linkedTableName: importedColumnsMap[fieldId]?.table_name,
        linkedColumnName: importedColumnsMap[fieldId]?.column_name,
        linkedColumnLabel: importedColumnsMap[fieldId]?.column_label,
        linkedColumnType: importedColumnsMap[fieldId]?.column_type,
        linkedAt: importedColumnsMap[fieldId]?.imported_at
      });
    }
    
    setActiveOperationField(null);
    setTempOperation(null);
  };

  // Clear operator
  const handleClearOperator = (fieldId) => {
    const newOps = { ...operations };
    delete newOps[fieldId];
    
    const newSelected = selectedFields.filter(id => id !== fieldId);
    
    setOperations(newOps);
    setSelectedFields(newSelected);
    
    onReportConfigChange({
      reportName,
      reportDescription,
      selectedFields: newSelected,
      operations: newOps,
      importantFields,
      importedColumnsMap
    });
    
    if (onFieldReportConfigChange) {
      onFieldReportConfigChange(fieldId, {
        enabled: false,
        operator: null,
        fields: [],
        customFormula: null,
        important: importantFields.includes(fieldId),
        linkedTableName: importedColumnsMap[fieldId]?.table_name,
        linkedColumnName: importedColumnsMap[fieldId]?.column_name,
        linkedColumnLabel: importedColumnsMap[fieldId]?.column_label,
        linkedColumnType: importedColumnsMap[fieldId]?.column_type,
        linkedAt: importedColumnsMap[fieldId]?.imported_at
      });
    }
    
    setActiveOperationField(null);
    setTempOperation(null);
  };

  // Toggle operation panel
  const toggleOperationPanel = (fieldId) => {
    if (activeOperationField === fieldId) {
      if (tempOperation) {
        handleOperatorChange(fieldId, tempOperation);
      }
      setActiveOperationField(null);
      setTempOperation(null);
    } else {
      setActiveOperationField(fieldId);
      setTempOperation(operations[fieldId]?.operator || null);
    }
  };

  // Handle temporary operator selection
  const handleTempOperatorSelect = (operatorValue) => {
    setTempOperation(operatorValue);
  };

  // Toggle section expansion
  const toggleSection = (fieldId) => {
    setExpandedSections(prev => ({
      ...prev,
      [fieldId]: !prev[fieldId]
    }));
  };

  // Open column import modal for a field
  const openColumnImportModal = (field) => {
    setSelectedFieldForImport(field);
    setTableSearchVisible(true);
  };

const getFieldIcon = (type, isSubField = false, isComparisonMain = false, isArithmeticResult = false, isRadioOption = false, isCheckboxOption = false, isDropdownOption = false, isFormulaField = false, isStepParent = false) => {
  if (isComparisonMain) return <SwapOutlined style={{ color: '#fa8c16' }} />;
  if (isArithmeticResult) return <CalculatorOutlined style={{ color: '#52c41a' }} />;
  if (isStepParent) return <FolderOutlined style={{ color: '#fa8c16', fontSize: '12px' }} />;
  if (isFormulaField) return <NumberOutlined style={{ color: '#52c41a', fontSize: '12px' }} />;
  if (type === 'formula_final_result') return <FunctionOutlined style={{ color: '#722ed1' }} />;
  if (isRadioOption) return <BorderOutlined style={{ color: '#722ed1', fontSize: '12px' }} />;
  if (isCheckboxOption) return <CheckSquareOutlined style={{ color: '#52c41a', fontSize: '12px' }} />;
  if (isDropdownOption) return <ApiOutlined style={{ color: '#722ed1', fontSize: '12px' }} />;
  
  if (isSubField) {
    return <NumberOutlined style={{ color: '#95a5a6', fontSize: '12px' }} />;
  }
  
  switch(type) {
    case 'text': return <FontSizeOutlined />;
    case 'number': return <NumberOutlined />;
    case 'date': return <CalendarOutlined />;
    case 'checkbox': return <CheckSquareOutlined />;
    case 'radio': return <BorderOutlined />;
    case 'dropdown': return <ApiOutlined />;
    case 'heading': return <FontSizeOutlined />;
    case 'paragraph': return <AlignLeftOutlined />;
    case 'file': return <UploadOutlined />;
    case 'comparison': return <SwapOutlined />;
    case 'arithmetic': return <CalculatorOutlined />;
    case 'formula': return <FunctionOutlined style={{ color: '#722ed1' }} />;
    default: return <FormOutlined />;
  }
};

  // Render operation panel with radio buttons
  const renderOperationPanel = (field) => {
    const currentOp = tempOperation !== null ? tempOperation : (operations[field.id]?.operator || null);
    
    return (
      <div 
        className={`operation-panel operation-cell-${field.id}`}
        onClick={(e) => e.stopPropagation()}
        style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          background: '#ffffff',
          border: '1px solid #d9d9d9',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          padding: '12px',
          zIndex: 1000,
          marginTop: '4px',
          minWidth: '180px'
        }}
      >
        <div style={{ marginBottom: '8px', fontSize: '12px', color: '#666', fontWeight: 500 }}>
          {language === 'english' ? 'Select Operation:' : 'ऑपरेशन निवडा:'}
        </div>
        <Radio.Group 
          value={currentOp}
          onChange={(e) => handleTempOperatorSelect(e.target.value)}
          style={{ width: '100%' }}
        >
          <Space direction="vertical" style={{ width: '100%' }}>
            {operators.map(op => (
              <Radio key={op.value} value={op.value}>
                <Space size={8}>
                  <span style={{ color: op.color, fontWeight: 'bold', width: '24px' }}>{op.symbol}</span>
                  <span>{language === 'english' ? op.label : op.labelMr}</span>
                </Space>
              </Radio>
            ))}
          </Space>
        </Radio.Group>
        <div style={{ 
          marginTop: '12px', 
          paddingTop: '8px', 
          borderTop: '1px solid #f0f0f0',
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '8px'
        }}>
          <Button 
            size="small" 
            onClick={(e) => {
              e.stopPropagation();
              handleClearOperator(field.id);
            }}
          >
            {language === 'english' ? 'Clear' : 'साफ करा'}
          </Button>
          <Button 
            type="primary" 
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              if (tempOperation) {
                handleOperatorChange(field.id, tempOperation);
              }
            }}
            disabled={!tempOperation}
          >
            {language === 'english' ? 'Apply' : 'लागू करा'}
          </Button>
        </div>
      </div>
    );
  };

  // Render add operation button and operation display
  const renderOperationCell = (field) => {
    const hasOperation = !!operations[field.id]?.operator;
    const currentOp = operations[field.id]?.operator;
    const currentOpData = operators.find(op => op.value === currentOp);
    const isActive = activeOperationField === field.id;
    
    return (
      <div style={{ position: 'relative' }}>
        <Checkbox
          checked={hasOperation}
          onChange={(e) => {
            if (e.target.checked) {
              toggleOperationPanel(field.id);
            } else {
              handleClearOperator(field.id);
            }
          }}
          style={{ marginRight: '8px' }}
        >
          {language === 'english' ? 'Add Operation' : 'ऑपरेशन जोडा'}
        </Checkbox>
        
        {hasOperation && currentOpData && (
          <Tag 
            color={currentOpData.color}
            style={{ 
              marginLeft: '8px', 
              cursor: 'pointer',
              fontSize: '11px'
            }}
            onClick={() => toggleOperationPanel(field.id)}
          >
            {currentOpData.symbol} {language === 'english' ? currentOpData.label : currentOpData.labelMr}
          </Tag>
        )}
        
        {isActive && renderOperationPanel(field)}
      </div>
    );
  };

  // Render column import button and mapping info
  const renderColumnImportCell = (field) => {
    const importedColumn = importedColumnsMap[field.id];
    const hasImport = !!importedColumn;
    
    return (
      <div style={{ position: 'relative' }}>
        <Button
          type={hasImport ? "default" : "dashed"}
          size="small"
          icon={<ImportOutlined />}
          onClick={() => openColumnImportModal(field)}
          style={{
            borderColor: hasImport ? "#52c41a" : undefined,
            color: hasImport ? "#52c41a" : undefined
          }}
        >
          {hasImport 
            ? (language === 'english' ? 'Linked' : 'लिंक केले') 
            : (language === 'english' ? 'Link Column' : 'कॉलम लिंक करा')}
        </Button>
        
        {hasImport && (
          <div style={{ marginTop: 4, fontSize: '10px', color: '#666' }}>
            <Tooltip title={`Table: ${importedColumn.table_name}\nColumn: ${importedColumn.column_label}`}>
              <Tag color="blue" style={{ fontSize: '10px', margin: 0 }}>
                {importedColumn.table_name?.substring(0, 20)}... : {importedColumn.column_label}
              </Tag>
            </Tooltip>
            <Button
              type="text"
              size="small"
              icon={<CloseOutlined />}
              onClick={() => removeImportedColumn(field.id)}
              style={{ marginLeft: 4, color: '#ff4d4f' }}
            />
          </div>
        )}
      </div>
    );
  };

  const importantCount = importantFields.length;
  const selectedCount = selectedFields.length;
  const importedCount = Object.keys(importedColumnsMap).length;

  return (
    <div className="excel-report-container">
      {/* Header */}
      <div className="excel-header">
        <div className="excel-title">
          <h3>{language === 'english' ? 'Access Report Configuration' : 'अॅक्सेस रिपोर्ट कॉन्फिगरेशन'}</h3>
          <div className="excel-stats">
            <span className="stat-selected">
              <CheckCircleOutlined /> {selectedCount} Selected
            </span>
            <span className="stat-important">
              <StarOutlined /> {importantCount} Important
            </span>
            {importedCount > 0 && (
              <span className="stat-imported">
                <ImportOutlined /> {importedCount} Linked
              </span>
            )}
          </div>
        </div>
      </div>

      {/* Excel-like Table */}
      <div className="excel-table-wrapper">
        <table className="excel-table">
          <thead>
            <tr>
              <th className="col-expand" style={{ width: '40px' }}></th>
              <th className="col-srno" style={{ width: '50px' }}>Sr No</th>
              <th className="col-field">Field Name</th>
              <th className="col-link" style={{ width: '160px' }}>Link to Column</th>
              <th className="col-important" style={{ width: '80px' }}>Important</th>
              <th className="col-operation" style={{ width: '160px' }}>Operation</th>
            </tr>
          </thead>
          <tbody>
            {flattenFields.length === 0 ? (
              <tr>
                <td colSpan="6" className="empty-row">
                  <Empty 
                    description={language === 'english' ? 'No fields found' : 'कोणतीही फील्ड नाही'} 
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                  />
                </td>
              </tr>
            ) : (
              flattenFields.map((field) => {
                const indentLevel = field.level;
                const hasChildren = field.hasChildren;
                const isExpanded = field.isExpanded;
                const isSubField = field.isSubField === true;
                const isComparisonMain = field.isComparisonMain === true;
                const isArithmeticResult = field.isArithmeticResult === true;
                const isRadioOption = field.isRadioOption === true;
                const isCheckboxOption = field.isCheckboxOption === true;
                const isDropdownOption = field.isDropdownOption === true;
                
                // Calculate padding for subfields
                const subFieldPadding = (isSubField || isRadioOption || isCheckboxOption || isDropdownOption) ? 20 : 0;
                
                return (
                  <tr 
                    key={field.id} 
                    className={`${field.isSelected ? 'row-selected' : ''} ${field.isImportant ? 'row-important' : ''} ${(isSubField || isRadioOption || isCheckboxOption || isDropdownOption) ? 'subfield-row' : ''}`}
                    style={{ backgroundColor: (isSubField || isRadioOption || isCheckboxOption || isDropdownOption) ? '#f9f9f9' : 'transparent' }}
                  >
                    {/* Expand/Collapse Column */}
                    <td className="col-expand">
                      {hasChildren && (
                        <button
                          className="expand-btn"
                          onClick={() => toggleSection(field.id)}
                        >
                          {isExpanded ? '▼' : '▶'}
                        </button>
                      )}
                    </td>
                    
                    {/* SR No Column */}
                    <td className="col-srno">
                      <span style={{ paddingLeft: `${indentLevel * 20 + subFieldPadding}px` }}>{field.srNo}</span>
                    </td>
                    
                    {/* Field Name Column */}
                    <td className="col-field">
                      <div className="field-name-cell" style={{ paddingLeft: `${subFieldPadding}px` }}>
                        <span className="field-icon" style={{ fontSize: (isSubField || isRadioOption || isCheckboxOption || isDropdownOption) ? '12px' : '14px', opacity: (isSubField || isRadioOption || isCheckboxOption || isDropdownOption) ? 0.7 : 1 }}>
                          {getFieldIcon(field.type, isSubField, isComparisonMain, isArithmeticResult, isRadioOption, isCheckboxOption, isDropdownOption)}
                        </span>
                        <span className="field-label" style={{ fontSize: (isSubField || isRadioOption || isCheckboxOption || isDropdownOption) ? '12px' : '13px', color: (isSubField || isRadioOption || isCheckboxOption || isDropdownOption) ? '#666' : '#1e1e1e' }}>
                          {language === 'english' ? (field.enLabel || field.label) : (field.mrLabel || field.label)}
                        </span>
                        <span className="field-type-badge" style={{ fontSize: (isSubField || isRadioOption || isCheckboxOption || isDropdownOption) ? '9px' : '10px' }}>
                          {isComparisonMain ? 'Main Value' : 
                           isArithmeticResult ? 'Result' : 
                           isRadioOption ? 'Radio Option' : 
                           isCheckboxOption ? 'Checkbox Option' : 
                           isDropdownOption ? 'Dropdown Option' : 
                           (field.type === 'comparison_main' ? 'Main Value' : field.type)}
                        </span>
                       {field.arithmeticOperator && (
  <Tag color="orange" style={{ fontSize: '9px', marginLeft: '4px' }}>
    {field.arithmeticOperator === 'add' ? '+' : 
     field.arithmeticOperator === 'subtract' ? '-' : 
     field.arithmeticOperator === 'multiply' ? '×' : 
     field.arithmeticOperator === 'divide' ? '÷' : 
     field.arithmeticOperator === 'average' ? 'avg' : '%'}
  </Tag>
)}
{field.stepCombineOp && !field.arithmeticOperator && (
  <Tag color="purple" style={{ fontSize: '9px', marginLeft: '4px' }}>
    {field.stepCombineOp === 'add' ? '⊕' : 
     field.stepCombineOp === 'subtract' ? '⊖' : 
     field.stepCombineOp === 'multiply' ? '⊗' : 
     field.stepCombineOp === 'divide' ? '⊘' : 
     field.stepCombineOp === 'average' ? 'avg' : field.stepCombineOp}
  </Tag>
)}
                      </div>
                    </td>
                    
                    {/* Link to Column Column */}
                    <td className="col-link">
                      {renderColumnImportCell(field)}
                    </td>
                    
                    {/* Important Checkbox Column */}
                    <td className="col-important">
                      <Checkbox
                        checked={field.isImportant}
                        onChange={(e) => handleImportantToggle(field.id, e.target.checked)}
                      />
                    </td>
                    
                    {/* Operation Column */}
                    <td className="col-operation">
                      {renderOperationCell(field)}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      {/* Footer Summary */}
      {selectedCount > 0 && (
        <div className="excel-footer">
          <div className="footer-summary">
            <CheckCircleOutlined style={{ color: '#52c41a' }} />
            <span>
              {language === 'english' 
                ? `${selectedCount} field(s) selected for report`
                : `${selectedCount} फील्ड रिपोर्टसाठी निवडले`}
            </span>
            {importantCount > 0 && (
              <Tag color="orange" icon={<StarOutlined />}>
                {importantCount} important
              </Tag>
            )}
            {importedCount > 0 && (
              <Tag color="green" icon={<ImportOutlined />}>
                {importedCount} linked to columns
              </Tag>
            )}
          </div>
        </div>
      )}

      {/* Table Search Modal */}
      <TableSearchModal
        visible={tableSearchVisible}
        onClose={() => {
          setTableSearchVisible(false);
          setSelectedFieldForImport(null);
        }}
        onImportColumns={handleImportColumns}
        language={language}
        existingColumns={[]}
      />

      <style>{`
        .excel-report-container {
          background: #ffffff;
          border-radius: 4px;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
        }

        .excel-header {
          padding: 16px 0;
          border-bottom: 1px solid #e0e0e0;
          margin-bottom: 16px;
        }

        .excel-title {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .excel-title h3 {
          margin: 0;
          font-size: 16px;
          font-weight: 500;
          color: #1e1e1e;
        }

        .excel-stats {
          display: flex;
          gap: 16px;
        }

        .stat-selected {
          font-size: 12px;
          color: #1890ff;
          background: #e6f7ff;
          padding: 4px 12px;
          border-radius: 4px;
        }

        .stat-important {
          font-size: 12px;
          color: #fa8c16;
          background: #fff7e6;
          padding: 4px 12px;
          border-radius: 4px;
        }

        .stat-imported {
          font-size: 12px;
          color: #52c41a;
          background: #f6ffed;
          padding: 4px 12px;
          border-radius: 4px;
        }

        .excel-table-wrapper {
          overflow-x: auto;
          border: 1px solid #e0e0e0;
          border-radius: 4px;
        }

        .excel-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 13px;
        }

        .excel-table thead tr {
          background: #f5f5f5;
          border-bottom: 2px solid #e0e0e0;
        }

        .excel-table th {
          padding: 10px 12px;
          text-align: left;
          font-weight: 500;
          color: #4a4a4a;
          font-size: 12px;
          border-right: 1px solid #e0e0e0;
          background: #f5f5f5;
        }

        .excel-table th:last-child {
          border-right: none;
        }

        .excel-table td {
          padding: 10px 12px;
          border-bottom: 1px solid #e8e8e8;
          border-right: 1px solid #e8e8e8;
          vertical-align: middle;
        }

        .excel-table td:last-child {
          border-right: none;
        }

        .excel-table tbody tr:hover {
          background: #fafafa;
        }

        .excel-table tbody tr.row-selected {
          background: #e6f7ff;
        }

        .excel-table tbody tr.row-important {
          background: #fff7e6;
        }
        
        .excel-table tbody tr.subfield-row {
          background: #f9f9f9;
        }
        
        .excel-table tbody tr.subfield-row:hover {
          background: #f5f5f5;
        }

        .col-expand {
          text-align: center;
          padding: 10px 4px !important;
        }

        .col-srno {
          text-align: center;
          color: #8c8c8c;
          font-size: 12px;
        }

        .field-name-cell {
          display: flex;
          align-items: center;
          gap: 8px;
          flex-wrap: wrap;
        }

        .field-icon {
          font-size: 14px;
          color: #8c8c8c;
          width: 20px;
        }

        .field-label {
          font-weight: 400;
          color: #1e1e1e;
        }

        .field-type-badge {
          padding: 2px 6px;
          background: #f0f0f0;
          border-radius: 3px;
          font-size: 10px;
          color: #8c8c8c;
          font-family: monospace;
        }

        .col-important {
          text-align: center;
        }

        .col-important .ant-checkbox-wrapper {
          margin: 0;
        }

        .col-operation, .col-link {
          position: relative;
        }

        .expand-btn {
          background: none;
          border: none;
          cursor: pointer;
          font-size: 12px;
          color: #8c8c8c;
          padding: 0;
          width: 20px;
          height: 20px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-radius: 2px;
        }

        .expand-btn:hover {
          background: #e8e8e8;
          color: #1890ff;
        }

        .empty-row td {
          padding: 40px;
          text-align: center;
        }

        .excel-footer {
          margin-top: 16px;
          padding: 12px 0;
          border-top: 1px solid #e0e0e0;
        }

        .footer-summary {
          display: flex;
          align-items: center;
          gap: 12px;
          font-size: 12px;
          color: #4a4a4a;
          flex-wrap: wrap;
        }

        .operation-panel {
          animation: fadeIn 0.2s ease;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-8px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .excel-table-wrapper::-webkit-scrollbar {
          height: 8px;
          width: 8px;
        }

        .excel-table-wrapper::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 4px;
        }

        .excel-table-wrapper::-webkit-scrollbar-thumb {
          background: #c1c1c1;
          border-radius: 4px;
        }

        .excel-table-wrapper::-webkit-scrollbar-thumb:hover {
          background: #a8a8a8;
        }
      `}</style>
    </div>
  );
};
const ScheduleConfiguration = ({ 
  frequencyType, 
  scheduleConfig, 
  onScheduleChange, 
  language,
  disabled 
}) => {
  // Date formats for dropdown
  const DATE_FORMATS = [
    { value: "YYYY-MM-DD", label: "YYYY-MM-DD (2024-01-31)" },
    { value: "DD-MM-YYYY", label: "DD-MM-YYYY (31-01-2024)" },
    { value: "MM-DD-YYYY", label: "MM-DD-YYYY (01-31-2024)" },
    { value: "DD/MM/YYYY", label: "DD/MM/YYYY (31/01/2024)" },
    { value: "MM/DD/YYYY", label: "MM/DD/YYYY (01/31/2024)" },
  ];

  const MONTHLY_DATE_FORMATS = [
    { value: "YYYY-MM", label: "YYYY-MM " },
    { value: "MM-YYYY", label: "MM-YYYY " },
    { value: "MMM-YYYY", label: "MMM-YYYY " },
    { value: "MMMM-YYYY", label: "MMMM-YYYY " },
  ];

  const YEARLY_FORMATS = [
    { value: "YY", label: "YY " },
    { value: "YYYY", label: "YYYY" },
    {value: "YY-YY", label: "YY-YY" },
    { value: "YYYY-YY", label: "YYYY-YY" },
    { value: "YYYY/YYYY", label: "YYYY/YYYY" },
    { value: "YYYY-YYYY", label: "YYYY-YYYY Financial Year" },
    { value: "FY-YYYY", label: "FY-YYYY " },
  ];

  // Week numbers for monthly schedule
  const WEEK_NUMBERS = [
    { value: 1, label: "1st " },
    { value: 2, label: "2nd " },
    { value: 3, label: "3rd " },
    { value: 4, label: "4th " },
    { value: "last", label: "Last" },
  ];

  // Period options (Last, This, Next)
  const PERIOD_OPTIONS = [
    { value: "last", label: "Last ", example: "example :Last month " },
    { value: "this", label: "This ", example: "example :This month " },
    { value: "next", label: "Next ", example: "example :Next month " },
  ];

  // Days of week
  const WEEKDAYS = [
    { value: "monday", label: "Monday ", short: "Mon" },
    { value: "tuesday", label: "Tuesday ", short: "Tue" },
    { value: "wednesday", label: "Wednesday ", short: "Wed" },
    { value: "thursday", label: "Thursday ", short: "Thu" },
    { value: "friday", label: "Friday ", short: "Fri" },
    { value: "saturday", label: "Saturday ", short: "Sat" },
    { value: "sunday", label: "Sunday ", short: "Sun" },
  ];

  // Months
  const MONTHS = [
    { value: 1, label: "January " },
    { value: 2, label: "February" },
    { value: 3, label: "March" },
    { value: 4, label: "April" },
    { value: 5, label: "May " },
    { value: 6, label: "June " },
    { value: 7, label: "July" },
    { value: 8, label: "August " },
    { value: 9, label: "September " },
    { value: 10, label: "October " },
    { value: 11, label: "November " },
    { value: 12, label: "December " },
  ];

  // ✅ REMOVED local states - Directly use props
  // const [monthlySelectionType, setMonthlySelectionType] = useState(...);
  // const [selectionType, setSelectionType] = useState(...);

  // ✅ Get values directly from scheduleConfig props
  const monthlySelectionType = scheduleConfig?.monthlySelectionType || "date";
  const selectionType = scheduleConfig?.selectionType || "date";

  // Update parent when selection type changes - No local state
  const updateSelectionType = (type) => {
    console.log(`🔄 updateSelectionType called: frequencyType=${frequencyType}, type=${type}`);
    if (frequencyType === 'monthly') {
      onScheduleChange({ ...scheduleConfig, monthlySelectionType: type });
    } else {
      onScheduleChange({ ...scheduleConfig, selectionType: type });
    }
  };

  // Handle time change
  const handleTimeChange = (time) => {
    if (time && time.isValid()) {
      const formattedTime = time.format('HH:mm');
      console.log(`🕐 Time changed to: ${formattedTime}`);
      onScheduleChange({ ...scheduleConfig, time: formattedTime });
    }
  };

  // Get the correct everyNMonths value based on frequency type
  const getEveryNMonths = () => {
    if (frequencyType === 'quarterly') {
      return scheduleConfig?.quarterlyEveryNMonths ?? 3;
    }
    if (frequencyType === 'half_yearly') {
      return scheduleConfig?.halfYearlyEveryNMonths ?? 6;
    }
    return scheduleConfig?.everyNMonths ?? 3;
  };

  // Handle everyNMonths change based on frequency type
  const handleEveryNMonthsChange = (value) => {
    const numValue = parseInt(value) || (frequencyType === 'quarterly' ? 3 : 6);
    if (frequencyType === 'quarterly') {
      onScheduleChange({ ...scheduleConfig, quarterlyEveryNMonths: numValue });
    } else if (frequencyType === 'half_yearly') {
      onScheduleChange({ ...scheduleConfig, halfYearlyEveryNMonths: numValue });
    } else {
      onScheduleChange({ ...scheduleConfig, everyNMonths: numValue });
    }
  };

  const everyNMonths = getEveryNMonths();

  // Safe access to scheduleConfig values
  const timeValue = scheduleConfig?.time || "09:00";
  const selectedWeekday = scheduleConfig?.weekday || "monday";
  const selectedDate = scheduleConfig?.date || 1;
  const selectedMonth = scheduleConfig?.month || 1;
  const selectedWeekNumber = scheduleConfig?.weekNumber || 1;
  const selectedDayOfWeek = scheduleConfig?.dayOfWeek || "monday";
  const dateFormat = scheduleConfig?.dateFormat || "YYYY-MM-DD";
  const monthlyDateFormat = scheduleConfig?.monthlyDateFormat || "YYYY-MM";
  const yearlyFormat = scheduleConfig?.yearlyFormat || "YYYY";
  const period = scheduleConfig?.period || "this";

  // ==================== DAILY SCHEDULE ====================
  if (frequencyType === 'daily') {
    return (
      <div style={{
        marginTop: 16,
        padding: 20,
        background: "#f0f5ff",
        borderRadius: 8,
        border: "1px solid #adc6ff"
      }}>
        <div style={{ marginBottom: 16 }}>
          <Space>
            <FieldTimeOutlined style={{ color: "#1890ff" }} />
            <Text strong>
              {language === 'english' ? 'Daily Schedule Configuration' : 'दैनिक वेळापत्रक कॉन्फिगरेशन'}
            </Text>
          </Space>
        </div>

        {/* Time */}
        <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
          <Col span={6}>
            <Text strong>{language === 'english' ? 'Time:' : 'वेळ:'}</Text>
          </Col>
          <Col span={10}>
            <div style={{ position: 'relative', zIndex: 9999 }}>
              <TimePicker
                value={timeValue ? moment(timeValue, 'HH:mm') : null}
                onChange={handleTimeChange}
                format="HH:mm"
                style={{ width: '100%' }}
                disabled={disabled}
                getPopupContainer={(trigger) => trigger.parentNode}
              />
            </div>
          </Col>
          <Col span={8}>
            <Text type="secondary" style={{ fontSize: 12 }}>
              {language === 'english' ? 'Daily at this time' : 'दररोज या वेळी'}
            </Text>
          </Col>
        </Row>

        {/* Format */}
        <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
          <Col span={6}>
            <Text strong>{language === 'english' ? 'Format:' : 'स्वरूप:'}</Text>
          </Col>
          <Col span={10}>
            <Select
              style={{ width: '100%' }}
              value={dateFormat}
              onChange={(value) => onScheduleChange({ ...scheduleConfig, dateFormat: value })}
              disabled={disabled}
              getPopupContainer={(trigger) => trigger.parentNode}
            >
              {DATE_FORMATS.map(format => (
                <Option key={format.value} value={format.value}>{format.label}</Option>
              ))}
            </Select>
          </Col>
        </Row>

        {/* Period */}
        <Row align="middle" gutter={16}>
          <Col span={6}>
            <Text strong>{language === 'english' ? 'Period:' : 'कालावधी:'}</Text>
          </Col>
          <Col span={10}>
            <Select
              style={{ width: '100%' }}
              value={period}
              onChange={(value) => onScheduleChange({ ...scheduleConfig, period: value })}
              disabled={disabled}
              getPopupContainer={(trigger) => trigger.parentNode}
            >
              {PERIOD_OPTIONS.map(opt => (
                <Option key={opt.value} value={opt.value}>
                  {opt.label}
                  <span style={{ fontSize: 11, color: '#999', marginLeft: 8 }}>
                    ({opt.example})
                  </span>
                </Option>
              ))}
            </Select>
          </Col>
        </Row>

        {/* Preview */}
        <div style={{
          marginTop: 20,
          padding: 12,
          background: "#e6f7ff",
          borderRadius: 6,
          border: "1px solid #91d5ff"
        }}>
          <Space>
            <CheckCircleOutlined style={{ color: "#52c41a" }} />
            <Text strong>{language === 'english' ? 'Schedule Summary:' : 'वेळापत्रक सारांश:'}</Text>
            <Text>
              {language === 'english' 
                ? `Daily at ${timeValue} (${period} period)`
                : `दररोज ${timeValue} वाजता (${period === 'last' ? 'मागील' : period === 'this' ? 'हा' : 'पुढील'} कालावधी)`}
            </Text>
          </Space>
        </div>
      </div>
    );
  }

  // ==================== WEEKLY SCHEDULE ====================
  if (frequencyType === 'weekly') {
    return (
      <div style={{
        marginTop: 16,
        padding: 20,
        background: "#f0f5ff",
        borderRadius: 8,
        border: "1px solid #adc6ff"
      }}>
        <div style={{ marginBottom: 16 }}>
          <Space>
            <FieldTimeOutlined style={{ color: "#1890ff" }} />
            <Text strong>
              {language === 'english' ? 'Weekly Schedule Configuration' : 'साप्ताहिक वेळापत्रक कॉन्फिगरेशन'}
            </Text>
          </Space>
        </div>

        {/* Day of Week */}
        <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
          <Col span={6}>
            <Text strong>{language === 'english' ? 'Day of Week:' : 'आठवड्याचा दिवस:'}</Text>
          </Col>
          <Col span={10}>
            <Select
              style={{ width: '100%' }}
              value={selectedWeekday}
              onChange={(value) => onScheduleChange({ ...scheduleConfig, weekday: value })}
              disabled={disabled}
              getPopupContainer={(trigger) => trigger.parentNode}
            >
              {WEEKDAYS.map(day => (
                <Option key={day.value} value={day.value}>{day.label}</Option>
              ))}
            </Select>
          </Col>
        </Row>

        {/* Time */}
        <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
          <Col span={6}>
            <Text strong>{language === 'english' ? 'Time:' : 'वेळ:'}</Text>
          </Col>
          <Col span={10}>
            <div style={{ position: 'relative', zIndex: 9999 }}>
              <TimePicker
                value={timeValue ? moment(timeValue, 'HH:mm') : null}
                onChange={handleTimeChange}
                format="HH:mm"
                style={{ width: '100%' }}
                disabled={disabled}
                getPopupContainer={(trigger) => trigger.parentNode}
              />
            </div>
          </Col>
        </Row>

        {/* Format */}
        <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
          <Col span={6}>
            <Text strong>{language === 'english' ? 'Format:' : 'स्वरूप:'}</Text>
          </Col>
          <Col span={10}>
            <Select
              style={{ width: '100%' }}
              value={dateFormat}
              onChange={(value) => onScheduleChange({ ...scheduleConfig, dateFormat: value })}
              disabled={disabled}
              getPopupContainer={(trigger) => trigger.parentNode}
            >
              <Option value="day YYYY-MM-DD">Day YYYY-MM-DD (Monday 2024-01-31)</Option>
              <Option value="day DD-MM-YYYY">Day DD-MM-YYYY (Monday 31-01-2024)</Option>
              <Option value="YYYY-MM-DD">YYYY-MM-DD (2024-01-31)</Option>
              <Option value="DD-MM-YYYY">DD-MM-YYYY (31-01-2024)</Option>
              <Option value="MM-DD-YYYY">MM-DD-YYYY (01-31-2024)</Option>
            </Select>
          </Col>
        </Row>

        {/* Period */}
        <Row align="middle" gutter={16}>
          <Col span={6}>
            <Text strong>{language === 'english' ? 'Period:' : 'कालावधी:'}</Text>
          </Col>
          <Col span={10}>
            <Select
              style={{ width: '100%' }}
              value={period}
              onChange={(value) => onScheduleChange({ ...scheduleConfig, period: value })}
              disabled={disabled}
              getPopupContainer={(trigger) => trigger.parentNode}
            >
              {PERIOD_OPTIONS.map(opt => (
                <Option key={opt.value} value={opt.value}>
                  {opt.label}
                  <span style={{ fontSize: 11, color: '#999', marginLeft: 8 }}>
                    ({opt.example})
                  </span>
                </Option>
              ))}
            </Select>
          </Col>
        </Row>

        {/* Preview */}
        <div style={{
          marginTop: 20,
          padding: 12,
          background: "#e6f7ff",
          borderRadius: 6,
          border: "1px solid #91d5ff"
        }}>
          <Space>
            <CheckCircleOutlined style={{ color: "#52c41a" }} />
            <Text strong>{language === 'english' ? 'Schedule Summary:' : 'वेळापत्रक सारांश:'}</Text>
            <Text>
              {language === 'english'
                ? `Every ${WEEKDAYS.find(d => d.value === selectedWeekday)?.label} at ${timeValue} (${period} period)`
                : `दर ${WEEKDAYS.find(d => d.value === selectedWeekday)?.label} ${timeValue} वाजता (${period === 'last' ? 'मागील' : period === 'this' ? 'हा' : 'पुढील'} कालावधी)`}
            </Text>
          </Space>
        </div>
      </div>
    );
  }

  // ==================== MONTHLY SCHEDULE ====================
  if (frequencyType === 'monthly') {
    return (
      <div style={{
        marginTop: 16,
        padding: 20,
        background: "#f0f5ff",
        borderRadius: 8,
        border: "1px solid #adc6ff"
      }}>
        <div style={{ marginBottom: 16 }}>
          <Space>
            <FieldTimeOutlined style={{ color: "#1890ff" }} />
            <Text strong>
              {language === 'english' ? 'Monthly Schedule Configuration' : 'मासिक वेळापत्रक कॉन्फिगरेशन'}
            </Text>
          </Space>
        </div>

        {/* Radio: Select as Date or Day */}
        <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
          <Col span={6}>
            <Text strong>{language === 'english' ? 'Select Type:' : 'निवड प्रकार:'}</Text>
          </Col>
          <Col span={16}>
            <Radio.Group
              value={monthlySelectionType}
              onChange={(e) => updateSelectionType(e.target.value)}
              disabled={disabled}
            >
              <Radio value="date">
                <Space><CalendarOutlined /> {language === 'english' ? 'Select as Date' : 'तारीख म्हणून निवडा'}</Space>
              </Radio>
              <Radio value="day">
                <Space><FieldTimeOutlined /> {language === 'english' ? 'Select as Day' : 'दिवस म्हणून निवडा'}</Space>
              </Radio>
            </Radio.Group>
          </Col>
        </Row>

        {/* If Date selected - Date of the Month */}
        {monthlySelectionType === 'date' && (
          <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
            <Col span={6}>
              <Text strong>{language === 'english' ? 'Date of Month:' : 'महिन्याची तारीख:'}</Text>
            </Col>
            <Col span={10}>
              <Select
                style={{ width: '100%' }}
                value={selectedDate}
                onChange={(value) => onScheduleChange({ ...scheduleConfig, date: value })}
                disabled={disabled}
                getPopupContainer={(trigger) => trigger.parentNode}
              >
                {Array.from({ length: 31 }, (_, i) => i + 1).map(day => (
                  <Option key={day} value={day}>{day}</Option>
                ))}
              </Select>
            </Col>
          </Row>
        )}

        {/* If Day selected - Day of Week + Week Number */}
        {monthlySelectionType === 'day' && (
          <>
            <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
              <Col span={6}>
                <Text strong>{language === 'english' ? 'Day of Week:' : 'आठवड्याचा दिवस:'}</Text>
              </Col>
              <Col span={10}>
                <Select
                  style={{ width: '100%' }}
                  value={selectedDayOfWeek}
                  onChange={(value) => onScheduleChange({ ...scheduleConfig, dayOfWeek: value })}
                  disabled={disabled}
                  getPopupContainer={(trigger) => trigger.parentNode}
                >
                  {WEEKDAYS.map(day => (
                    <Option key={day.value} value={day.value}>{day.label}</Option>
                  ))}
                </Select>
              </Col>
            </Row>

            <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
              <Col span={6}>
                <Text strong>{language === 'english' ? 'Week Number:' : 'आठवडा क्रमांक:'}</Text>
              </Col>
              <Col span={10}>
                <Select
                  style={{ width: '100%' }}
                  value={selectedWeekNumber}
                  onChange={(value) => onScheduleChange({ ...scheduleConfig, weekNumber: value })}
                  disabled={disabled}
                  getPopupContainer={(trigger) => trigger.parentNode}
                >
                  {WEEK_NUMBERS.map(week => (
                    <Option key={week.value} value={week.value}>{week.label}</Option>
                  ))}
                </Select>
              </Col>
            </Row>
          </>
        )}

        {/* Time */}
        <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
          <Col span={6}>
            <Text strong>{language === 'english' ? 'Time:' : 'वेळ:'}</Text>
          </Col>
          <Col span={10}>
            <div style={{ position: 'relative', zIndex: 9999 }}>
              <TimePicker
                value={timeValue ? moment(timeValue, 'HH:mm') : null}
                onChange={handleTimeChange}
                format="HH:mm"
                style={{ width: '100%' }}
                disabled={disabled}
                getPopupContainer={(trigger) => trigger.parentNode}
              />
            </div>
          </Col>
        </Row>

        {/* Format */}
        <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
          <Col span={6}>
            <Text strong>{language === 'english' ? 'Format:' : 'स्वरूप:'}</Text>
          </Col>
          <Col span={10}>
            <Select
              style={{ width: '100%' }}
              value={monthlyDateFormat}
              onChange={(value) => onScheduleChange({ ...scheduleConfig, monthlyDateFormat: value })}
              disabled={disabled}
              getPopupContainer={(trigger) => trigger.parentNode}
            >
              {MONTHLY_DATE_FORMATS.map(format => (
                <Option key={format.value} value={format.value}>{format.label}</Option>
              ))}
            </Select>
          </Col>
        </Row>

        {/* Period */}
        <Row align="middle" gutter={16}>
          <Col span={6}>
            <Text strong>{language === 'english' ? 'Period:' : 'कालावधी:'}</Text>
          </Col>
          <Col span={10}>
            <Select
              style={{ width: '100%' }}
              value={period}
              onChange={(value) => onScheduleChange({ ...scheduleConfig, period: value })}
              disabled={disabled}
              getPopupContainer={(trigger) => trigger.parentNode}
            >
              {PERIOD_OPTIONS.map(opt => (
                <Option key={opt.value} value={opt.value}>
                  {opt.label}
                  <span style={{ fontSize: 11, color: '#999', marginLeft: 8 }}>
                    ({opt.example})
                  </span>
                </Option>
              ))}
            </Select>
          </Col>
        </Row>

        {/* Preview */}
        <div style={{
          marginTop: 20,
          padding: 12,
          background: "#e6f7ff",
          borderRadius: 6,
          border: "1px solid #91d5ff"
        }}>
          <Space>
            <CheckCircleOutlined style={{ color: "#52c41a" }} />
            <Text strong>{language === 'english' ? 'Schedule Summary:' : 'वेळापत्रक सारांश:'}</Text>
            <Text>
              {monthlySelectionType === 'date' 
                ? (language === 'english'
                    ? `Every month on day ${selectedDate} at ${timeValue} (${period} period)`
                    : `दर महिन्याला तारखेला ${selectedDate} ${timeValue} वाजता (${period === 'last' ? 'मागील' : period === 'this' ? 'हा' : 'पुढील'} कालावधी)`)
                : (language === 'english'
                    ? `Every month on the ${WEEK_NUMBERS.find(w => w.value === selectedWeekNumber)?.label} ${WEEKDAYS.find(d => d.value === selectedDayOfWeek)?.label} at ${timeValue} (${period} period)`
                    : `दर महिन्याला ${WEEK_NUMBERS.find(w => w.value === selectedWeekNumber)?.label} ${WEEKDAYS.find(d => d.value === selectedDayOfWeek)?.label} ${timeValue} वाजता (${period === 'last' ? 'मागील' : period === 'this' ? 'हा' : 'पुढील'} कालावधी)`)
              }
            </Text>
          </Space>
        </div>
      </div>
    );
  }

  // ==================== QUARTERLY SCHEDULE ====================
  if (frequencyType === 'quarterly') {
    return (
      <div style={{
        marginTop: 16,
        padding: 20,
        background: "#f0f5ff",
        borderRadius: 8,
        border: "1px solid #adc6ff"
      }}>
        <div style={{ marginBottom: 16 }}>
          <Space>
            <ReconciliationOutlined style={{ color: "#1890ff" }} />
            <Text strong>
              {language === 'english' ? 'Quarterly Schedule Configuration' : 'त्रैमासिक वेळापत्रक कॉन्फिगरेशन'}
            </Text>
          </Space>
        </div>

        {/* Radio: Select as Date or Day */}
        <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
          <Col span={6}>
            <Text strong>{language === 'english' ? 'Select Type:' : 'निवड प्रकार:'}</Text>
          </Col>
          <Col span={16}>
            <Radio.Group
              value={selectionType}
              onChange={(e) => updateSelectionType(e.target.value)}
              disabled={disabled}
            >
              <Radio value="date">
                <Space><CalendarOutlined /> {language === 'english' ? 'Select as Date' : 'तारीख म्हणून निवडा'}</Space>
              </Radio>
              <Radio value="day">
                <Space><FieldTimeOutlined /> {language === 'english' ? 'Select as Day' : 'दिवस म्हणून निवडा'}</Space>
              </Radio>
            </Radio.Group>
          </Col>
        </Row>

        {/* Every N Months */}
        <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
          <Col span={6}>
            <Text strong>{language === 'english' ? 'Every:' : 'प्रत्येक:'}</Text>
          </Col>
          <Col span={10}>
            <Input
              type="number"
              min={1}
              value={everyNMonths}
              onChange={(e) => handleEveryNMonthsChange(e.target.value)}
              disabled={disabled}
              style={{ width: '100%' }}
            />
          </Col>
          <Col span={8}>
            <Text type="secondary" style={{ fontSize: 12 }}>
              {language === 'english' ? 'month(s)' : 'महिने'}
            </Text>
          </Col>
        </Row>

        {/* If Date selected - Date of the Month */}
        {selectionType === 'date' && (
          <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
            <Col span={6}>
              <Text strong>{language === 'english' ? 'Date of Month:' : 'महिन्याची तारीख:'}</Text>
            </Col>
            <Col span={10}>
              <Select
                style={{ width: '100%' }}
                value={selectedDate}
                onChange={(value) => onScheduleChange({ ...scheduleConfig, date: value })}
                disabled={disabled}
                getPopupContainer={(trigger) => trigger.parentNode}
              >
                {Array.from({ length: 31 }, (_, i) => i + 1).map(day => (
                  <Option key={day} value={day}>{day}</Option>
                ))}
              </Select>
            </Col>
          </Row>
        )}

        {/* If Day selected - Day of Week + Week Number */}
        {selectionType === 'day' && (
          <>
            <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
              <Col span={6}>
                <Text strong>{language === 'english' ? 'Day of Week:' : 'आठवड्याचा दिवस:'}</Text>
              </Col>
              <Col span={10}>
                <Select
                  style={{ width: '100%' }}
                  value={selectedDayOfWeek}
                  onChange={(value) => onScheduleChange({ ...scheduleConfig, dayOfWeek: value })}
                  disabled={disabled}
                  getPopupContainer={(trigger) => trigger.parentNode}
                >
                  {WEEKDAYS.map(day => (
                    <Option key={day.value} value={day.value}>{day.label}</Option>
                  ))}
                </Select>
              </Col>
            </Row>

            <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
              <Col span={6}>
                <Text strong>{language === 'english' ? 'Week Number:' : 'आठवडा क्रमांक:'}</Text>
              </Col>
              <Col span={10}>
                <Select
                  style={{ width: '100%' }}
                  value={selectedWeekNumber}
                  onChange={(value) => onScheduleChange({ ...scheduleConfig, weekNumber: value })}
                  disabled={disabled}
                  getPopupContainer={(trigger) => trigger.parentNode}
                >
                  {WEEK_NUMBERS.map(week => (
                    <Option key={week.value} value={week.value}>{week.label}</Option>
                  ))}
                </Select>
              </Col>
            </Row>
          </>
        )}

        {/* Time */}
        <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
          <Col span={6}>
            <Text strong>{language === 'english' ? 'Time:' : 'वेळ:'}</Text>
          </Col>
          <Col span={10}>
            <div style={{ position: 'relative', zIndex: 9999 }}>
              <TimePicker
                value={timeValue ? moment(timeValue, 'HH:mm') : null}
                onChange={handleTimeChange}
                format="HH:mm"
                style={{ width: '100%' }}
                disabled={disabled}
                getPopupContainer={(trigger) => trigger.parentNode}
              />
            </div>
          </Col>
        </Row>

        {/* Format */}
        <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
          <Col span={6}>
            <Text strong>{language === 'english' ? 'Format:' : 'स्वरूप:'}</Text>
          </Col>
          <Col span={10}>
            <Select
              style={{ width: '100%' }}
              value={monthlyDateFormat}
              onChange={(value) => onScheduleChange({ ...scheduleConfig, monthlyDateFormat: value })}
              disabled={disabled}
              getPopupContainer={(trigger) => trigger.parentNode}
            >
              {MONTHLY_DATE_FORMATS.map(format => (
                <Option key={format.value} value={format.value}>{format.label}</Option>
              ))}
            </Select>
          </Col>
        </Row>

        {/* Period */}
        <Row align="middle" gutter={16}>
          <Col span={6}>
            <Text strong>{language === 'english' ? 'Period:' : 'कालावधी:'}</Text>
          </Col>
          <Col span={10}>
            <Select
              style={{ width: '100%' }}
              value={period}
              onChange={(value) => onScheduleChange({ ...scheduleConfig, period: value })}
              disabled={disabled}
              getPopupContainer={(trigger) => trigger.parentNode}
            >
              {PERIOD_OPTIONS.map(opt => (
                <Option key={opt.value} value={opt.value}>
                  {opt.label}
                  <span style={{ fontSize: 11, color: '#999', marginLeft: 8 }}>
                    ({opt.example})
                  </span>
                </Option>
              ))}
            </Select>
          </Col>
        </Row>

        {/* Preview */}
        <div style={{
          marginTop: 20,
          padding: 12,
          background: "#e6f7ff",
          borderRadius: 6,
          border: "1px solid #91d5ff"
        }}>
          <Space>
            <CheckCircleOutlined style={{ color: "#52c41a" }} />
            <Text strong>{language === 'english' ? 'Schedule Summary:' : 'वेळापत्रक सारांश:'}</Text>
            <Text>
              {selectionType === 'date'
                ? (language === 'english'
                    ? `Every ${everyNMonths} months on day ${selectedDate} at ${timeValue} (${period} period)`
                    : `दर ${everyNMonths} महिन्याला तारखेला ${selectedDate} ${timeValue} वाजता (${period === 'last' ? 'मागील' : period === 'this' ? 'हा' : 'पुढील'} कालावधी)`)
                : (language === 'english'
                    ? `Every ${everyNMonths} months on the ${WEEK_NUMBERS.find(w => w.value === selectedWeekNumber)?.label} ${WEEKDAYS.find(d => d.value === selectedDayOfWeek)?.label} at ${timeValue} (${period} period)`
                    : `दर ${everyNMonths} महिन्याला ${WEEK_NUMBERS.find(w => w.value === selectedWeekNumber)?.label} ${WEEKDAYS.find(d => d.value === selectedDayOfWeek)?.label} ${timeValue} वाजता (${period === 'last' ? 'मागील' : period === 'this' ? 'हा' : 'पुढील'} कालावधी)`)
              }
            </Text>
          </Space>
        </div>
      </div>
    );
  }

  // ==================== HALF-YEARLY SCHEDULE ====================
  if (frequencyType === 'half_yearly') {
    return (
      <div style={{
        marginTop: 16,
        padding: 20,
        background: "#f0f5ff",
        borderRadius: 8,
        border: "1px solid #adc6ff"
      }}>
        <div style={{ marginBottom: 16 }}>
          <Space>
            <ReconciliationOutlined style={{ color: "#1890ff" }} />
            <Text strong>
              {language === 'english' ? 'Half-Yearly Schedule Configuration' : 'सहामाही वेळापत्रक कॉन्फिगरेशन'}
            </Text>
          </Space>
        </div>

        {/* Radio: Select as Date or Day */}
        <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
          <Col span={6}>
            <Text strong>{language === 'english' ? 'Select Type:' : 'निवड प्रकार:'}</Text>
          </Col>
          <Col span={16}>
            <Radio.Group
              value={selectionType}
              onChange={(e) => updateSelectionType(e.target.value)}
              disabled={disabled}
            >
              <Radio value="date">
                <Space><CalendarOutlined /> {language === 'english' ? 'Select as Date' : 'तारीख म्हणून निवडा'}</Space>
              </Radio>
              <Radio value="day">
                <Space><FieldTimeOutlined /> {language === 'english' ? 'Select as Day' : 'दिवस म्हणून निवडा'}</Space>
              </Radio>
            </Radio.Group>
          </Col>
        </Row>

        {/* Every N Months */}
        <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
          <Col span={6}>
            <Text strong>{language === 'english' ? 'Every:' : 'प्रत्येक:'}</Text>
          </Col>
          <Col span={10}>
            <Input
              type="number"
              min={1}
              value={everyNMonths}
              onChange={(e) => handleEveryNMonthsChange(e.target.value)}
              disabled={disabled}
              style={{ width: '100%' }}
            />
          </Col>
          <Col span={8}>
            <Text type="secondary" style={{ fontSize: 12 }}>
              {language === 'english' ? 'month(s)' : 'महिने'}
            </Text>
          </Col>
        </Row>

        {/* If Date selected - Date of the Month */}
        {selectionType === 'date' && (
          <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
            <Col span={6}>
              <Text strong>{language === 'english' ? 'Date of Month:' : 'महिन्याची तारीख:'}</Text>
            </Col>
            <Col span={10}>
              <Select
                style={{ width: '100%' }}
                value={selectedDate}
                onChange={(value) => onScheduleChange({ ...scheduleConfig, date: value })}
                disabled={disabled}
                getPopupContainer={(trigger) => trigger.parentNode}
              >
                {Array.from({ length: 31 }, (_, i) => i + 1).map(day => (
                  <Option key={day} value={day}>{day}</Option>
                ))}
              </Select>
            </Col>
          </Row>
        )}

        {/* If Day selected - Day of Week + Week Number */}
        {selectionType === 'day' && (
          <>
            <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
              <Col span={6}>
                <Text strong>{language === 'english' ? 'Day of Week:' : 'आठवड्याचा दिवस:'}</Text>
              </Col>
              <Col span={10}>
                <Select
                  style={{ width: '100%' }}
                  value={selectedDayOfWeek}
                  onChange={(value) => onScheduleChange({ ...scheduleConfig, dayOfWeek: value })}
                  disabled={disabled}
                  getPopupContainer={(trigger) => trigger.parentNode}
                >
                  {WEEKDAYS.map(day => (
                    <Option key={day.value} value={day.value}>{day.label}</Option>
                  ))}
                </Select>
              </Col>
            </Row>

            <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
              <Col span={6}>
                <Text strong>{language === 'english' ? 'Week Number:' : 'आठवडा क्रमांक:'}</Text>
              </Col>
              <Col span={10}>
                <Select
                  style={{ width: '100%' }}
                  value={selectedWeekNumber}
                  onChange={(value) => onScheduleChange({ ...scheduleConfig, weekNumber: value })}
                  disabled={disabled}
                  getPopupContainer={(trigger) => trigger.parentNode}
                >
                  {WEEK_NUMBERS.map(week => (
                    <Option key={week.value} value={week.value}>{week.label}</Option>
                  ))}
                </Select>
              </Col>
            </Row>
          </>
        )}

        {/* Time */}
        <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
          <Col span={6}>
            <Text strong>{language === 'english' ? 'Time:' : 'वेळ:'}</Text>
          </Col>
          <Col span={10}>
            <div style={{ position: 'relative', zIndex: 9999 }}>
              <TimePicker
                value={timeValue ? moment(timeValue, 'HH:mm') : null}
                onChange={handleTimeChange}
                format="HH:mm"
                style={{ width: '100%' }}
                disabled={disabled}
                getPopupContainer={(trigger) => trigger.parentNode}
              />
            </div>
          </Col>
        </Row>

        {/* Format */}
        <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
          <Col span={6}>
            <Text strong>{language === 'english' ? 'Format:' : 'स्वरूप:'}</Text>
          </Col>
          <Col span={10}>
            <Select
              style={{ width: '100%' }}
              value={monthlyDateFormat}
              onChange={(value) => onScheduleChange({ ...scheduleConfig, monthlyDateFormat: value })}
              disabled={disabled}
              getPopupContainer={(trigger) => trigger.parentNode}
            >
              {MONTHLY_DATE_FORMATS.map(format => (
                <Option key={format.value} value={format.value}>{format.label}</Option>
              ))}
            </Select>
          </Col>
        </Row>

        {/* Period */}
        <Row align="middle" gutter={16}>
          <Col span={6}>
            <Text strong>{language === 'english' ? 'Period:' : 'कालावधी:'}</Text>
          </Col>
          <Col span={10}>
            <Select
              style={{ width: '100%' }}
              value={period}
              onChange={(value) => onScheduleChange({ ...scheduleConfig, period: value })}
              disabled={disabled}
              getPopupContainer={(trigger) => trigger.parentNode}
            >
              {PERIOD_OPTIONS.map(opt => (
                <Option key={opt.value} value={opt.value}>
                  {opt.label}
                  <span style={{ fontSize: 11, color: '#999', marginLeft: 8 }}>
                    ({opt.example})
                  </span>
                </Option>
              ))}
            </Select>
          </Col>
        </Row>

        {/* Preview */}
        <div style={{
          marginTop: 20,
          padding: 12,
          background: "#e6f7ff",
          borderRadius: 6,
          border: "1px solid #91d5ff"
        }}>
          <Space>
            <CheckCircleOutlined style={{ color: "#52c41a" }} />
            <Text strong>{language === 'english' ? 'Schedule Summary:' : 'वेळापत्रक सारांश:'}</Text>
            <Text>
              {selectionType === 'date'
                ? (language === 'english'
                    ? `Every ${everyNMonths} months on day ${selectedDate} at ${timeValue} (${period} period)`
                    : `दर ${everyNMonths} महिन्याला तारखेला ${selectedDate} ${timeValue} वाजता (${period === 'last' ? 'मागील' : period === 'this' ? 'हा' : 'पुढील'} कालावधी)`)
                : (language === 'english'
                    ? `Every ${everyNMonths} months on the ${WEEK_NUMBERS.find(w => w.value === selectedWeekNumber)?.label} ${WEEKDAYS.find(d => d.value === selectedDayOfWeek)?.label} at ${timeValue} (${period} period)`
                    : `दर ${everyNMonths} महिन्याला ${WEEK_NUMBERS.find(w => w.value === selectedWeekNumber)?.label} ${WEEKDAYS.find(d => d.value === selectedDayOfWeek)?.label} ${timeValue} वाजता (${period === 'last' ? 'मागील' : period === 'this' ? 'हा' : 'पुढील'} कालावधी)`)
              }
            </Text>
          </Space>
        </div>
      </div>
    );
  }

  // ==================== YEARLY SCHEDULE ====================
  if (frequencyType === 'yearly') {
    return (
      <div style={{
        marginTop: 16,
        padding: 20,
        background: "#f0f5ff",
        borderRadius: 8,
        border: "1px solid #adc6ff"
      }}>
        <div style={{ marginBottom: 16 }}>
          <Space>
            <FieldTimeOutlined style={{ color: "#1890ff" }} />
            <Text strong>
              {language === 'english' ? 'Yearly Schedule Configuration' : 'वार्षिक वेळापत्रक कॉन्फिगरेशन'}
            </Text>
          </Space>
        </div>

        {/* Radio: Select as Date or Day */}
        <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
          <Col span={6}>
            <Text strong>{language === 'english' ? 'Select Type:' : 'निवड प्रकार:'}</Text>
          </Col>
          <Col span={16}>
            <Radio.Group
              value={selectionType}
              onChange={(e) => updateSelectionType(e.target.value)}
              disabled={disabled}
            >
              <Radio value="date">
                <Space><CalendarOutlined /> {language === 'english' ? 'Select as Date' : 'तारीख म्हणून निवडा'}</Space>
              </Radio>
              <Radio value="day">
                <Space><FieldTimeOutlined /> {language === 'english' ? 'Select as Day' : 'दिवस म्हणून निवडा'}</Space>
              </Radio>
            </Radio.Group>
          </Col>
        </Row>

        {/* If Date selected - Date of the Month and Month */}
        {selectionType === 'date' && (
          <>
            <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
              <Col span={6}>
                <Text strong>{language === 'english' ? 'Date of Month:' : 'महिन्याची तारीख:'}</Text>
              </Col>
              <Col span={10}>
                <Select
                  style={{ width: '100%' }}
                  value={selectedDate}
                  onChange={(value) => onScheduleChange({ ...scheduleConfig, date: value })}
                  disabled={disabled}
                  getPopupContainer={(trigger) => trigger.parentNode}
                >
                  {Array.from({ length: 31 }, (_, i) => i + 1).map(day => (
                    <Option key={day} value={day}>{day}</Option>
                  ))}
                </Select>
              </Col>
            </Row>

            <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
              <Col span={6}>
                <Text strong>{language === 'english' ? 'Month:' : 'महिना:'}</Text>
              </Col>
              <Col span={10}>
                <Select
                  style={{ width: '100%' }}
                  value={selectedMonth}
                  onChange={(value) => onScheduleChange({ ...scheduleConfig, month: value })}
                  disabled={disabled}
                  getPopupContainer={(trigger) => trigger.parentNode}
                >
                  {MONTHS.map(month => (
                    <Option key={month.value} value={month.value}>{month.label}</Option>
                  ))}
                </Select>
              </Col>
            </Row>
          </>
        )}

        {/* If Day selected - Day of Week + Week Number + Month */}
        {selectionType === 'day' && (
          <>
            <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
              <Col span={6}>
                <Text strong>{language === 'english' ? 'Day of Week:' : 'आठवड्याचा दिवस:'}</Text>
              </Col>
              <Col span={10}>
                <Select
                  style={{ width: '100%' }}
                  value={selectedDayOfWeek}
                  onChange={(value) => onScheduleChange({ ...scheduleConfig, dayOfWeek: value })}
                  disabled={disabled}
                  getPopupContainer={(trigger) => trigger.parentNode}
                >
                  {WEEKDAYS.map(day => (
                    <Option key={day.value} value={day.value}>{day.label}</Option>
                  ))}
                </Select>
              </Col>
            </Row>

            <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
              <Col span={6}>
                <Text strong>{language === 'english' ? 'Week Number:' : 'आठवडा क्रमांक:'}</Text>
              </Col>
              <Col span={10}>
                <Select
                  style={{ width: '100%' }}
                  value={selectedWeekNumber}
                  onChange={(value) => onScheduleChange({ ...scheduleConfig, weekNumber: value })}
                  disabled={disabled}
                  getPopupContainer={(trigger) => trigger.parentNode}
                >
                  {WEEK_NUMBERS.map(week => (
                    <Option key={week.value} value={week.value}>{week.label}</Option>
                  ))}
                </Select>
              </Col>
            </Row>

            <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
              <Col span={6}>
                <Text strong>{language === 'english' ? 'Month:' : 'महिना:'}</Text>
              </Col>
              <Col span={10}>
                <Select
                  style={{ width: '100%' }}
                  value={selectedMonth}
                  onChange={(value) => onScheduleChange({ ...scheduleConfig, month: value })}
                  disabled={disabled}
                  getPopupContainer={(trigger) => trigger.parentNode}
                >
                  {MONTHS.map(month => (
                    <Option key={month.value} value={month.value}>{month.label}</Option>
                  ))}
                </Select>
              </Col>
            </Row>
          </>
        )}

        {/* Time */}
        <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
          <Col span={6}>
            <Text strong>{language === 'english' ? 'Time:' : 'वेळ:'}</Text>
          </Col>
          <Col span={10}>
            <div style={{ position: 'relative', zIndex: 9999 }}>
              <TimePicker
                value={timeValue ? moment(timeValue, 'HH:mm') : null}
                onChange={handleTimeChange}
                format="HH:mm"
                style={{ width: '100%' }}
                disabled={disabled}
                getPopupContainer={(trigger) => trigger.parentNode}
              />
            </div>
          </Col>
        </Row>

        {/* Format - Year or Financial Year */}
        <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
          <Col span={6}>
            <Text strong>{language === 'english' ? 'Format:' : 'स्वरूप:'}</Text>
          </Col>
          <Col span={10}>
            <Select
              style={{ width: '100%' }}
              value={yearlyFormat}
              onChange={(value) => onScheduleChange({ ...scheduleConfig, yearlyFormat: value })}
              disabled={disabled}
              getPopupContainer={(trigger) => trigger.parentNode}
            >
              {YEARLY_FORMATS.map(format => (
                <Option key={format.value} value={format.value}>{format.label}</Option>
              ))}
            </Select>
          </Col>
        </Row>

        {/* Period */}
        <Row align="middle" gutter={16}>
          <Col span={6}>
            <Text strong>{language === 'english' ? 'Period:' : 'कालावधी:'}</Text>
          </Col>
          <Col span={10}>
            <Select
              style={{ width: '100%' }}
              value={period}
              onChange={(value) => onScheduleChange({ ...scheduleConfig, period: value })}
              disabled={disabled}
              getPopupContainer={(trigger) => trigger.parentNode}
            >
              {PERIOD_OPTIONS.map(opt => (
                <Option key={opt.value} value={opt.value}>
                  {opt.label}
                  <span style={{ fontSize: 11, color: '#999', marginLeft: 8 }}>
                    ({opt.example.replace('month', 'year')})
                  </span>
                </Option>
              ))}
            </Select>
          </Col>
        </Row>

        {/* Preview */}
        <div style={{
          marginTop: 20,
          padding: 12,
          background: "#e6f7ff",
          borderRadius: 6,
          border: "1px solid #91d5ff"
        }}>
          <Space>
            <CheckCircleOutlined style={{ color: "#52c41a" }} />
            <Text strong>{language === 'english' ? 'Schedule Summary:' : 'वेळापत्रक सारांश:'}</Text>
            <Text>
              {selectionType === 'date'
                ? (language === 'english'
                    ? `Every year on ${MONTHS.find(m => m.value === selectedMonth)?.label} ${selectedDate} at ${timeValue} (${period} period)`
                    : `दरवर्षी ${MONTHS.find(m => m.value === selectedMonth)?.label} ${selectedDate} ${timeValue} वाजता (${period === 'last' ? 'मागील' : period === 'this' ? 'हा' : 'पुढील'} कालावधी)`)
                : (language === 'english'
                    ? `Every year on the ${WEEK_NUMBERS.find(w => w.value === selectedWeekNumber)?.label} ${WEEKDAYS.find(d => d.value === selectedDayOfWeek)?.label} of ${MONTHS.find(m => m.value === selectedMonth)?.label} at ${timeValue} (${period} period)`
                    : `दरवर्षी ${MONTHS.find(m => m.value === selectedMonth)?.label} महिन्यातील ${WEEK_NUMBERS.find(w => w.value === selectedWeekNumber)?.label} ${WEEKDAYS.find(d => d.value === selectedDayOfWeek)?.label} ${timeValue} वाजता (${period === 'last' ? 'मागील' : period === 'this' ? 'हा' : 'पुढील'} कालावधी)`)
              }
            </Text>
          </Space>
        </div>
      </div>
    );
  }

  return null;
};


// ==================== DATE FIELD EDITOR WITH COMPARISON ====================
const DateFieldEditor = ({ field, onUpdate, onDelete, onCopy, allFields, language, autoTranslate, translateTyping, translating, disabled }) => {
  const [activeLanguage, setActiveLanguage] = useState(language || 'english');
  const [enableComparison, setEnableComparison] = useState(field.enableDateComparison || false);
  const [comparisonType, setComparisonType] = useState(field.comparisonType || 'single');
  const [comparisonOperator, setComparisonOperator] = useState(field.comparisonOperator || 'equals');
  const [compareWithDate, setCompareWithDate] = useState(field.compareWithDate || null);
  const [compareWithFieldId, setCompareWithFieldId] = useState(field.compareWithFieldId || null);
  const [startDate, setStartDate] = useState(field.startDate || null);
  const [endDate, setEndDate] = useState(field.endDate || null);
  const [customMessage, setCustomMessage] = useState(field.customValidationMessage || '');
  const [typingTimeouts, setTypingTimeouts] = useState({});

  const updateField = (key, value) => {
    if (disabled) return;
    onUpdate({ ...field, [key]: value });
  };

  // Get all other date fields for comparison
  const otherDateFields = useMemo(() => {
    if (!allFields) return [];
    return allFields.filter(f => 
      f.id !== field.id && 
      f.type === 'date' && 
      f.enableDateComparison !== false
    );
  }, [allFields, field.id]);

  const handleTranslate = async (text, targetField) => {
    if (!autoTranslate || !text || text.trim() === '') return;
    if (typingTimeouts[targetField]) clearTimeout(typingTimeouts[targetField]);
    const timeout = setTimeout(async () => {
      const translated = await translateTyping(text, 'mr');
      if (translated && translated !== text) {
        updateField(targetField, translated);
      }
    }, 800);
    setTypingTimeouts(prev => ({ ...prev, [targetField]: timeout }));
  };

  useEffect(() => {
    return () => {
      Object.values(typingTimeouts).forEach(timeout => clearTimeout(timeout));
    };
  }, [typingTimeouts]);

  return (
    <Card>
   
      {/* Date Format */}
      <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
        <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
          <Text type="secondary">Date Format</Text>
        </Col>
        <Col span={16}>
          <Select
            style={{ width: "100%" }}
            value={field.validation?.dateFormat || "YYYY-MM-DD"}
            onChange={(value) => {
              const validation = field.validation || {};
              updateField("validation", { ...validation, dateFormat: value });
            }}
            disabled={disabled}
            getPopupContainer={(trigger) => trigger.parentNode}
          >
            {DATE_FORMATS.map(format => (
              <Option key={format.value} value={format.value}>{format.label}</Option>
            ))}
          </Select>
        </Col>
      </Row>

      {/* Enable Date Comparison Toggle */}
      <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
        <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
          <Text type="secondary">Date Comparison</Text>
        </Col>
        <Col span={16}>
          <Checkbox
            checked={enableComparison}
            onChange={(e) => {
              const checked = e.target.checked;
              setEnableComparison(checked);
              updateField("enableDateComparison", checked);
            }}
            disabled={disabled}
          >
            <Space>
              <SwapOutlined style={{ color: "#fa8c16" }} />
              {activeLanguage === 'english' 
                ? 'Enable date validation/comparison' 
                : 'तारीख तुलना/वैधता सक्षम करा'}
            </Space>
          </Checkbox>
        </Col>
      </Row>

      {/* Comparison Settings - Show only if enabled */}
      {enableComparison && (
        <>
          {/* Comparison Type */}
          <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
            <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
              <Text type="secondary">Comparison Type</Text>
            </Col>
            <Col span={16}>
              <Radio.Group
                value={comparisonType}
                onChange={(e) => {
                  const value = e.target.value;
                  setComparisonType(value);
                  updateField("comparisonType", value);
                }}
                disabled={disabled}
              >
                <Radio.Button value="single">
                  <Space><CalendarOutlined />Single Date</Space>
                </Radio.Button>
                <Radio.Button value="range">
                  <Space><CalendarOutlined />Date Range</Space>
                </Radio.Button>
                <Radio.Button value="field">
                  <Space><SwapOutlined />Compare with Field</Space>
                </Radio.Button>
              </Radio.Group>
            </Col>
          </Row>

          {/* Single Date Comparison */}
         {comparisonType === 'single' && (
  <>
    <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
      <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
        <Text type="secondary">Operator</Text>
      </Col>
      <Col span={16}>
        <Select
          style={{ width: "100%" }}
          value={comparisonOperator}
          onChange={(value) => {
            setComparisonOperator(value);
            updateField("comparisonOperator", value);
            // Reset compareWithDate if switching to current_date
            if (value === 'current_date') {
              setCompareWithDate(null);
              updateField("compareWithDate", null);
            }
          }}
          disabled={disabled}
          getPopupContainer={(trigger) => trigger.parentNode}
        >
          {DATE_COMPARISON_OPERATORS.map(op => (
            <Option key={op.value} value={op.value}>
              {op.label} {op.symbol}
            </Option>
          ))}
        </Select>
      </Col>
    </Row>

    {/* Compare With Date - Only show if NOT current_date */}
    {comparisonOperator !== 'current_date' && (
      <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
        <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
          <Text type="secondary">Compare With Date</Text>
        </Col>
        <Col span={16}>
          <Input
            type="date"
            value={compareWithDate}
            onChange={(e) => {
              const value = e.target.value;
              setCompareWithDate(value);
              updateField("compareWithDate", value);
            }}
            disabled={disabled}
            style={{ width: "100%" }}
          />
          <Text type="secondary" style={{ fontSize: "11px", marginTop: 4, display: "block" }}>
            {activeLanguage === 'english' 
              ? 'Select a fixed date to compare with' 
              : 'तुलना करण्यासाठी एक निश्चित तारीख निवडा'}
          </Text>
        </Col>
      </Row>
    )}

    {/* Show Current Date info when selected */}
    {comparisonOperator === 'current_date' && (
      <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
        <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
          <Text type="secondary"></Text>
        </Col>
        <Col span={16}>
          <Alert
            message={activeLanguage === 'english'
              ? "Comparing with TODAY'S date (current date when form is filled)"
              : "आजच्या तारखेशी तुलना करत आहे (फॉर्म भरतानाची सध्याची तारीख)"}
            type="info"
            showIcon
            style={{ fontSize: "12px" }}
          />
        </Col>
      </Row>
    )}
  </>
)}

          {/* Date Range Comparison */}
          {comparisonType === 'range' && (
            <>
              <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
                <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
                  <Text type="secondary">Start Date</Text>
                </Col>
                <Col span={16}>
                  <Input
                    type="date"
                    value={startDate}
                    onChange={(e) => {
                      const value = e.target.value;
                      setStartDate(value);
                      updateField("startDate", value);
                    }}
                    disabled={disabled}
                    style={{ width: "100%" }}
                  />
                </Col>
              </Row>

              <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
                <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
                  <Text type="secondary">End Date</Text>
                </Col>
                <Col span={16}>
                  <Input
                    type="date"
                    value={endDate}
                    onChange={(e) => {
                      const value = e.target.value;
                      setEndDate(value);
                      updateField("endDate", value);
                    }}
                    disabled={disabled}
                    style={{ width: "100%" }}
                  />
                </Col>
              </Row>

              <Row align="middle" gutter={16}>
                <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
                  <Text type="secondary"></Text>
                </Col>
                <Col span={16}>
                  <Alert
                    message={activeLanguage === 'english'
                      ? "Date will be validated to be within the specified range"
                      : "तारीख निर्दिष्ट श्रेणीमध्ये असेल याची पडताळणी केली जाईल"}
                    type="info"
                    showIcon
                    style={{ fontSize: "12px" }}
                  />
                </Col>
              </Row>
            </>
          )}

          {/* Compare with Another Field */}
          {comparisonType === 'field' && (
            <>
              <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
                <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
                  <Text type="secondary">Operator</Text>
                </Col>
                <Col span={16}>
                  <Select
                    style={{ width: "100%" }}
                    value={comparisonOperator}
                    onChange={(value) => {
                      setComparisonOperator(value);
                      updateField("comparisonOperator", value);
                    }}
                    disabled={disabled}
                    getPopupContainer={(trigger) => trigger.parentNode}
                  >
                    {DATE_COMPARISON_OPERATORS.filter(op => op.value !== 'between').map(op => (
                      <Option key={op.value} value={op.value}>
                        {op.label} {op.symbol}
                      </Option>
                    ))}
                  </Select>
                </Col>
              </Row>

              <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
                <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
                  <Text type="secondary">Compare With Field</Text>
                </Col>
                <Col span={16}>
                  <Select
                    style={{ width: "100%" }}
                    value={compareWithFieldId}
                    onChange={(value) => {
                      setCompareWithFieldId(value);
                      updateField("compareWithFieldId", value);
                    }}
                    placeholder={activeLanguage === 'english' ? "Select a date field" : "तारीख फील्ड निवडा"}
                    disabled={disabled || otherDateFields.length === 0}
                    getPopupContainer={(trigger) => trigger.parentNode}
                    allowClear
                  >
                    {otherDateFields.map(df => (
                      <Option key={df.id} value={df.id}>
                        {activeLanguage === 'english' ? (df.enLabel || df.label) : (df.mrLabel || df.label)}
                      </Option>
                    ))}
                  </Select>
                  {otherDateFields.length === 0 && (
                    <Text type="warning" style={{ fontSize: "11px", marginTop: 4, display: "block" }}>
                      {activeLanguage === 'english'
                        ? "No other date fields available for comparison"
                        : "तुलना करण्यासाठी इतर तारीख फील्ड उपलब्ध नाहीत"}
                    </Text>
                  )}
                </Col>
              </Row>
            </>
          )}

          {/* Custom Validation Message */}
          <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
            <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
              <Text type="secondary">Validation Message</Text>
            </Col>
            <Col span={16}>
              <Input
                value={customMessage}
                onChange={(e) => {
                  const value = e.target.value;
                  setCustomMessage(value);
                  updateField("customValidationMessage", value);
                }}
                placeholder={activeLanguage === 'english'
                  ? "Custom message when validation fails"
                  : "वैधता अयशस्वी झाल्यास सानुकूल संदेश"}
                disabled={disabled}
              />
            </Col>
          </Row>

          {/* Preview of validation logic */}
          <Row align="middle" gutter={16}>
            <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
              <Text type="secondary">Preview</Text>
            </Col>
            <Col span={16}>
              <div style={{
                padding: "12px",
                background: "#f0f5ff",
                borderRadius: "6px",
                border: "1px solid #adc6ff",
                fontSize: "12px"
              }}>
                <Space direction="vertical" size={4}>
                  <Text type="secondary">
                    {activeLanguage === 'english' ? 'Validation Rule:' : 'वैधता नियम:'}
                  </Text>
                  <Text>
                    {comparisonType === 'single' && (
                      <>Selected date must be {DATE_COMPARISON_OPERATORS.find(op => op.value === comparisonOperator)?.label || comparisonOperator} {compareWithDate || '[selected date]'}</>
                    )}
                    {comparisonType === 'range' && (
                      <>Selected date must be between {startDate || '[start]'} and {endDate || '[end]'}</>
                    )}
                    {comparisonType === 'field' && compareWithFieldId && (
                      <>This date must be {DATE_COMPARISON_OPERATORS.find(op => op.value === comparisonOperator)?.label || comparisonOperator} the selected date field</>
                    )}
                    {comparisonType === 'field' && !compareWithFieldId && (
                      <>Select a field to compare with</>
                    )}
                  </Text>
                </Space>
              </div>
            </Col>
          </Row>
        </>
      )}

      {/* Help Text */}
      {/* <Row align="middle" gutter={16} style={{ marginTop: 16 }}>
        <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
          <Text type="secondary">Help Text</Text>
        </Col>
        <Col span={16}>
          <div style={{ display: 'flex', gap: '8px' }}>
            <Tag color="blue">EN</Tag>
            <Input
              value={activeLanguage === 'english' ? field.enHelpText : field.mrHelpText}
              onChange={(e) => {
                const value = e.target.value;
                if (activeLanguage === 'english') {
                  updateField("enHelpText", value);
                  handleTranslate(value, "mrHelpText");
                } else {
                  updateField("mrHelpText", value);
                }
              }}
              placeholder="Enter help text"
              disabled={disabled}
            />
          </div>
        </Col>
      </Row> */}

      
    </Card>
  );
};
const FieldEditor = ({ field, onUpdate, onDelete, onCopy, allFields, onAddSubField, onUpdateSubField, onDeleteSubField, language, autoTranslate, translateTyping, translating, disabled }) => {
  const [showFieldSelector, setShowFieldSelector] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [activeLanguage, setActiveLanguage] = useState(language || 'english');
  const [typingTimeouts, setTypingTimeouts] = useState({});
  const [previewValues, setPreviewValues] = useState({});
  // FieldEditor कंपोनंटच्या सुरुवातीला
const [formulaModalVisible, setFormulaModalVisible] = useState(false);
const [editingFormulaField, setEditingFormulaField] = useState(null);
  // ✅ या variables ची definition करा
  const selectedLanguage = language;
  const printMode = false;

  // ✅ getFieldLabel function
  const getFieldLabel = (field) => {
    if (!field) return '';
    if (selectedLanguage === 'english') {
      return field.enLabel || field.englishLabel || field.label || '';
    } else {
      return field.mrLabel || field.marathiLabel || field.enLabel || field.englishLabel || field.label || '';
    }
  };

  // Cleanup timeouts on unmount
  useEffect(() => {
    return () => {
      Object.values(typingTimeouts).forEach(timeout => {
        clearTimeout(timeout);
      });
    };
  }, [typingTimeouts]);

  // Copy field function
  const copyField = (fieldToCopy) => {
    if (disabled) return;
    
    const newField = {
      ...JSON.parse(JSON.stringify(fieldToCopy)),
      id: uid(),
      enLabel: `${fieldToCopy.enLabel || fieldToCopy.label} (Copy)`,
      mrLabel: `${fieldToCopy.mrLabel || fieldToCopy.label} (Copy)`,
      label: `${fieldToCopy.label || fieldToCopy.enLabel} (Copy)`,
    };

    // जर हे heading असेल तर त्याची children पण कॉपी करा
    if (fieldToCopy.type === "heading") {
      const childFields = allFields.filter(f => f.parentId === fieldToCopy.id);
      const newChildFields = childFields.map(child => ({
        ...child,
        id: uid(),
        parentId: newField.id,
        enLabel: `${child.enLabel || child.label} (Copy)`,
        mrLabel: `${child.mrLabel || child.label} (Copy)`,
        label: `${child.label || child.enLabel} (Copy)`,
      }));
      
      if (onAddSubField) {
        onAddSubField(newField);
        newChildFields.forEach(child => onAddSubField(child));
        // message.success(`Copied heading with ${newChildFields.length} sub-fields`);
      }
    } else if (fieldToCopy.type === "radio" || fieldToCopy.type === "checkbox") {
      const childFields = allFields.filter(f => f.parentId === fieldToCopy.id);
      const newChildFields = childFields.map(child => ({
        ...child,
        id: uid(),
        parentId: newField.id,
        enLabel: `${child.enLabel || child.label} (Copy)`,
        mrLabel: `${child.mrLabel || child.label} (Copy)`,
        label: `${child.label || child.enLabel} (Copy)`,
        colName: child.colName
      }));
      
      if (onAddSubField) {
        onAddSubField(newField);
        newChildFields.forEach(child => onAddSubField(child));
        // message.success(`Copied ${fieldToCopy.type} field with ${newChildFields.length} option fields`);
      }
    } else {
      if (onAddSubField) {
        onAddSubField(newField);
        // message.success(`Copied ${fieldToCopy.type} field`);
      }
    }
  };

  // If it's a file field, use the file upload editor
  if (field.type === "file") {
    return (
      <FileUploadFieldEditor
        field={field}
        onUpdate={onUpdate}
        onDelete={onDelete}
        onCopy={onCopy}
        language={language}
        autoTranslate={autoTranslate}
        translateTyping={translateTyping}
        translating={translating}
        disabled={disabled}
      />
    );
  }

  // If it's a comparison field, use the comparison editor
  if (field.type === "comparison") {
    return (
      <ComparisonFieldEditor
        field={field}
        onUpdate={onUpdate}
        onDelete={onDelete}
        onCopy={onCopy}
        language={language}
        autoTranslate={autoTranslate}
        translateTyping={translateTyping}
        translating={translating}
        disabled={disabled}
      />
    );
  }

  // If it's an arithmetic field, use the arithmetic editor
  if (field.type === "arithmetic") {
    return (
      <ArithmeticFieldEditor
        field={field}
        onUpdate={onUpdate}
        onDelete={onDelete}
        onCopy={onCopy}
        language={language}
        autoTranslate={autoTranslate}
        translateTyping={translateTyping}
        translating={translating}
        disabled={disabled}
      />
    );
  }

  // ✅ If it's a dropdown field, use the dropdown editor
  if (field.type === "dropdown") {
    return (
      <DropdownFieldEditor
        field={field}
        onUpdate={onUpdate}
        onDelete={onDelete}
        onCopy={onCopy}
        language={language}
        autoTranslate={autoTranslate}
        translateTyping={translateTyping}
        translating={translating}
        disabled={disabled}
      />
    );
  }

// In FieldEditor component, add this after the existing if statements
if (field.type === "formula") {
  return (
    <MultiLevelFormulaFieldEditor
      field={field}
      onUpdate={onUpdate}
      onDelete={onDelete}
      onCopy={onCopy}
      allFields={allFields}
      language={language}
      autoTranslate={autoTranslate}
      translateTyping={translateTyping}
      translating={translating}
      disabled={disabled}
      previewMode={printMode || false}  // ✅ हे add करा
    />
  );
}

  const updateField = (key, value) => {
    if (disabled) return;
    
    const updatedField = { ...field, [key]: value };
    
    if (key === 'enOptions') {
      updatedField.options = value;
    }
    
    onUpdate(updatedField);
  };

  const handleRequiredChange = (checked) => {
    if (disabled) return;
    const updatedField = {
      ...field,
      required: checked,
      enRequired: checked,
      mrRequired: checked
    };
    onUpdate(updatedField);
  };

  const handleTranslate = async (text, targetField) => {
    if (!autoTranslate || !text || text.trim() === '') return;

    if (typingTimeouts[targetField]) {
      clearTimeout(typingTimeouts[targetField]);
    }

    const timeout = setTimeout(async () => {
      const translated = await translateTyping(text, 'mr');
      if (translated && translated !== text) {
        if (targetField === 'mrLabel') {
          updateField('mrLabel', translated);
        } else if (targetField === 'mrPlaceholder') {
          updateField('mrPlaceholder', translated);
        } else if (targetField === 'mrHelpText') {
          updateField('mrHelpText', translated);
        } else if (targetField.startsWith('mrOptions.')) {
          const index = parseInt(targetField.split('.')[1]);
          const newOptions = [...(field.mrOptions || [])];
          newOptions[index] = translated;
          updateField('mrOptions', newOptions);
        }
      }
    }, 800);

    setTypingTimeouts(prev => ({
      ...prev,
      [targetField]: timeout
    }));
  };

  const updateOption = (index, value, lang) => {
    if (disabled) return;
    
    if (lang === 'english') {
      const newEnOptions = [...(field.enOptions || [])];
      newEnOptions[index] = value;
      
      const updatedField = { 
        ...field, 
        enOptions: newEnOptions,
        options: newEnOptions 
      };
      
      onUpdate(updatedField);
      handleTranslate(value, `mrOptions.${index}`);
    } else {
      const newMrOptions = [...(field.mrOptions || [])];
      newMrOptions[index] = value;
      updateField("mrOptions", newMrOptions);
    }

    if (field.type === 'radio') {
      updateField("radioOptions", field.enOptions || field.options);
    } else if (field.type === 'checkbox') {
      updateField("checkboxOptions", field.enOptions || field.options);
    }
  };

  const addOption = () => {
    if (disabled) return;
    
    const currentOptions = field.enOptions || field.options || [];
    const newOption = `Option ${currentOptions.length + 1}`;
    
    const newEnOptions = [...currentOptions, newOption];
    const newMrOptions = [...(field.mrOptions || []), newOption];
    
    const updatedField = {
      ...field,
      enOptions: newEnOptions,
      options: newEnOptions,
      mrOptions: newMrOptions
    };
    
    if (field.type === 'radio') {
      updatedField.radioOptions = newEnOptions;
    } else if (field.type === 'checkbox') {
      updatedField.checkboxOptions = newEnOptions;
    }
    
    onUpdate(updatedField);
  };

  const removeOption = (index) => {
    if (disabled) return;
    
    const currentEnOptions = field.enOptions || field.options || [];
    const currentMrOptions = field.mrOptions || [];
    
    const newEnOptions = currentEnOptions.filter((_, i) => i !== index);
    const newMrOptions = currentMrOptions.filter((_, i) => i !== index);
    
    const updatedField = {
      ...field,
      enOptions: newEnOptions,
      options: newEnOptions,
      mrOptions: newMrOptions
    };
    
    if (field.type === 'radio') {
      updatedField.radioOptions = newEnOptions;
    } else if (field.type === 'checkbox') {
      updatedField.checkboxOptions = newEnOptions;
    }
    
    onUpdate(updatedField);
  };

  const addSubFieldToOption = (optionValue, fieldType) => {
    if (disabled) return;
    const newField = createField(fieldType, null, field.id, optionValue);

    newField.enLabel = `${fieldType} field for ${optionValue}`;
    newField.mrLabel = fieldType === "text" ? "मजकूर फील्ड" :
      fieldType === "number" ? "संख्या फील्ड" :
        fieldType === "date" ? "तारीख फील्ड" : 
        fieldType === "file" ? "फाइल फील्ड" : `${fieldType} फील्ड`;

    if (onAddSubField) {
      onAddSubField(newField);
      // message.success(`Added ${fieldType} field for "${optionValue}"`);
    }

    setShowFieldSelector(false);
  };

 const addSubFieldToHeading = (fieldType) => {
  if (disabled) return;
  
  console.log(`➕ Adding ${fieldType} field under heading: ${field.id}`);
  
  const newField = createField(fieldType, null, field.id, null);

  newField.enLabel = `${fieldType} field under ${field.enLabel || 'Heading'}`;
  newField.mrLabel = fieldType === "text" ? "मजकूर फील्ड" :
    fieldType === "number" ? "संख्या फील्ड" :
      fieldType === "date" ? "तारीख फील्ड" :
      fieldType === "checkbox" ? "चेकबॉक्स" :
      fieldType === "radio" ? "रेडिओ" :
      fieldType === "dropdown" ? "ड्रॉपडाउन" :
      fieldType === "file" ? "फाइल फील्ड" : `${fieldType} फील्ड`;

  // ✅ For number fields, ensure unit properties are set
  if (fieldType === "number") {
    newField.hasUnit = false;
    newField.selectedUnit = null;
    newField.selectedUnitObject = null;
    newField.units = {
      enabled: false,
      selectedUnit: null,
      selectedUnitId: null,
      selectedUnitValue: null,
      selectedUnitSymbol: null,
      selectedUnitLabel: null,
      unitCategory: null
    };
  }

  newField.parentId = field.id;

  console.log(`✅ Created field under heading:`, {
    id: newField.id,
    parentId: newField.parentId,
    type: newField.type,
    hasUnit: newField.hasUnit
  });

  if (onAddSubField) {
    onAddSubField(newField);
  }

  setShowFieldSelector(false);
};
 const addSubHeading = () => {
  if (disabled) return;
  
  console.log(`➕ Adding sub-heading under heading: ${field.id}`);
  
  // ✅ CRITICAL FIX: Pass the current heading's ID as parentId
  const newHeading = createField("heading", null, field.id, null);
  
  // Set heading level based on current heading's level
  const currentLevel = field.headingLevel || 1;
  newHeading.headingLevel = currentLevel + 1;
  
  // Set labels
  newHeading.enLabel = `Sub-Heading ${currentLevel + 1}`;
  newHeading.mrLabel = `उप-शीर्षक ${currentLevel + 1}`;
  
  // ✅ CRITICAL FIX: Explicitly set parentId again to be sure
  newHeading.parentId = field.id;
  
  // Initialize headingChildren array
  newHeading.headingChildren = [];
  
  console.log(`✅ Created sub-heading:`, {
    id: newHeading.id,
    parentId: newHeading.parentId,
    headingLevel: newHeading.headingLevel
  });
  
  if (onAddSubField) {
    onAddSubField(newHeading);
    // message.success(`Added sub-heading under "${field.enLabel}"`);
  }
};

  const updateSubField = (subFieldId, updatedData) => {
    if (disabled) return;
    if (onUpdateSubField) {
      onUpdateSubField(subFieldId, updatedData);
    }
  };

  const deleteSubField = (subFieldId) => {
    if (disabled) return;
    if (onDeleteSubField) {
      onDeleteSubField(subFieldId);
    }
  };

  const directChildren = allFields.filter(f => f.parentId === field.id);
  const childHeadings = directChildren.filter(f => f.type === "heading");
  const childFields = directChildren.filter(f => f.type !== "heading");

  const subFieldsByOption = {};
  directChildren.forEach(subField => {
    if (subField.type !== "heading") {
      const option = subField.colName || 'default';
      if (!subFieldsByOption[option]) {
        subFieldsByOption[option] = [];
      }
      subFieldsByOption[option].push(subField);
    }
  });

const renderSubField = (subField) => {
  const getSubFieldUnitDisplay = (sf) => {
    if (!sf) return null;
    if (sf.hasUnit && sf.selectedUnitObject) {
      return sf.selectedUnitObject.unit_symbol || sf.selectedUnitObject.unit_name;
    }
    if (sf.units?.enabled && sf.units.selectedUnitSymbol) {
      return sf.units.selectedUnitSymbol;
    }
    return null;
  };

  // ==================== FORMULA FIELD UNDER HEADING ====================
 if (subField.type === "formula") {
    // ✅ CALL THE EXISTING MultiLevelFormulaFieldEditor COMPONENT
    return (
      <div key={subField.id} style={{ marginLeft: 16 }}>
        <MultiLevelFormulaFieldEditor
          field={subField}
          onUpdate={(updatedField) => {
            updateSubField(subField.id, updatedField);
          }}
          onDelete={() => deleteSubField(subField.id)}
          onCopy={() => copyField(subField)}
          allFields={allFields}
          language={activeLanguage}
          autoTranslate={autoTranslate}
          translateTyping={translateTyping}
          translating={translating}
          disabled={disabled}
          previewMode={false}
        />
      </div>
    );
  }

  // ==================== RADIO FIELD UNDER HEADING ====================
  if (subField.type === "radio") {
    const optionsEn = subField.enOptions || subField.options || [];
    const optionsMr = subField.mrOptions || [];
    
    // Get subfields for each radio option (Option-specific Fields)
    const subFieldsByOption = {};
    allFields.forEach(f => {
      if (f.parentId === subField.id && f.colName) {
        if (!subFieldsByOption[f.colName]) {
          subFieldsByOption[f.colName] = [];
        }
        subFieldsByOption[f.colName].push(f);
      }
    });
    
    return (
      <Card
        key={subField.id}
        size="small"
        style={{
          marginBottom: 12,
          background: "#fafafa",
          border: "2px solid #722ed1",
          borderRadius: "8px",
          marginLeft: 16
        }}
      >
        <div style={{ padding: "12px" }}>
          {/* Header */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
            <Space>
              <BorderOutlined style={{ color: "#722ed1", fontSize: "16px" }} />
              <Text strong style={{ color: "#722ed1" }}>Radio Field Configuration</Text>
              {subField.enRequired && <Tag color="red">Required</Tag>}
            </Space>
            <Space size={4}>
              <Tooltip title="Copy">
                <Button type="text" size="small" icon={<CopyOutlined />} onClick={() => copyField(subField)} disabled={disabled} />
              </Tooltip>
              <Tooltip title="Delete">
                <Button type="text" size="small" icon={<DeleteOutlined />} onClick={() => deleteSubField(subField.id)} danger disabled={disabled} />
              </Tooltip>
            </Space>
          </div>

          {/* Language Toggle */}
          <div style={{ marginBottom: 12, display: 'flex', justifyContent: 'flex-end' }}>
            <Button.Group size="small">
              <Button type={activeLanguage === 'english' ? 'primary' : 'default'} onClick={() => setActiveLanguage('english')} disabled={disabled}>English</Button>
              <Button type={activeLanguage === 'marathi' ? 'primary' : 'default'} onClick={() => setActiveLanguage('marathi')} disabled={disabled}>मराठी</Button>
            </Button.Group>
          </div>

          {/* Field Label */}
          <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
            <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
              <Text type="secondary" style={{ fontSize: "12px" }}>Field Label</Text>
            </Col>
            <Col span={16}>
              <div style={{ display: 'flex', gap: '8px' }}>
                <Tag color="blue" style={{ height: "32px", lineHeight: "30px" }}>EN</Tag>
                <Input
                  value={activeLanguage === 'english' ? subField.enLabel : subField.mrLabel}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (activeLanguage === 'english') {
                      updateSubField(subField.id, { ...subField, enLabel: value });
                      handleTranslate(value, "mrLabel");
                    } else {
                      updateSubField(subField.id, { ...subField, mrLabel: value });
                    }
                  }}
                  placeholder="Enter label"
                  size="small"
                  disabled={disabled}
                />
              </div>
            </Col>
          </Row>

          {/* Radio Options Section */}
          <div style={{ marginBottom: 16 }}>
            <Row align="top" gutter={16}>
              <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
                <Text type="secondary" style={{ fontSize: "12px" }}>Radio Options</Text>
              </Col>
              <Col span={16}>
                {/* Live Preview */}
                <div style={{ 
                  marginBottom: 16, 
                  padding: "12px", 
                  background: "#f0f5ff", 
                  borderRadius: "8px",
                  border: "1px solid #adc6ff"
                }}>
                  <Text type="secondary" style={{ fontSize: "11px", marginBottom: 8, display: "block" }}>
                    <EyeOutlined /> Live Preview:
                  </Text>
                  <Radio.Group 
                    value={previewValues[subField.id]} 
                    onChange={(e) => setPreviewValues({ ...previewValues, [subField.id]: e.target.value })}
                  >
                    <Space direction="vertical">
                      {optionsEn.map((opt, idx) => (
                        <Radio key={idx} value={opt}>
                          {activeLanguage === 'english' ? opt : (optionsMr[idx] || opt)}
                        </Radio>
                      ))}
                    </Space>
                  </Radio.Group>
                </div>

                {/* Options Editor */}
                {optionsEn.map((opt, idx) => (
                  <div key={idx} style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: 8 }}>
                    <Radio disabled checked={false} />
                    <Input
                      value={activeLanguage === 'english' ? opt : (optionsMr[idx] || opt)}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        if (activeLanguage === 'english') {
                          const newOptions = [...optionsEn];
                          newOptions[idx] = newValue;
                          updateSubField(subField.id, { ...subField, enOptions: newOptions, options: newOptions });
                        } else {
                          const newMrOptions = [...optionsMr];
                          newMrOptions[idx] = newValue;
                          updateSubField(subField.id, { ...subField, mrOptions: newMrOptions });
                        }
                      }}
                      size="small"
                      style={{ flex: 1 }}
                      placeholder={`Option ${idx + 1}`}
                      disabled={disabled}
                    />
                    {optionsEn.length > 1 && (
                      <Button
                        type="text"
                        size="small"
                        icon={<DeleteOutlined />}
                        onClick={() => {
                          const newOptions = optionsEn.filter((_, i) => i !== idx);
                          const newMrOptions = optionsMr.filter((_, i) => i !== idx);
                          updateSubField(subField.id, { ...subField, enOptions: newOptions, options: newOptions, mrOptions: newMrOptions });
                        }}
                        danger
                        disabled={disabled}
                      />
                    )}
                  </div>
                ))}
                <Button
                  type="dashed"
                  size="small"
                  icon={<PlusOutlined />}
                  onClick={() => {
                    const newOption = `Option ${optionsEn.length + 1}`;
                    updateSubField(subField.id, {
                      ...subField,
                      enOptions: [...optionsEn, newOption],
                      options: [...optionsEn, newOption],
                      mrOptions: [...optionsMr, newOption]
                    });
                  }}
                  block
                  disabled={disabled}
                  style={{ marginTop: 8 }}
                >
                  Add Option / पर्याय जोडा
                </Button>
              </Col>
            </Row>
          </div>

          {/* Required Checkbox */}
          <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
            <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
              <Text type="secondary" style={{ fontSize: "12px" }}>Validation</Text>
            </Col>
            <Col span={16}>
              <Checkbox
                checked={subField.enRequired}
                onChange={(e) => {
                  updateSubField(subField.id, {
                    ...subField,
                    enRequired: e.target.checked,
                    required: e.target.checked,
                    mrRequired: e.target.checked
                  });
                }}
                disabled={disabled}
              >
                Required field (Field will be mandatory in the form)
              </Checkbox>
            </Col>
          </Row>

          {/* Option-specific Fields Section */}
          {optionsEn.length > 0 && (
            <div style={{ marginTop: 16, marginLeft: 24 }}>
              <Divider orientation="left" style={{ margin: "12px 0" }}>
                <Space>
                  <FolderOutlined style={{ color: "#722ed1" }} />
                  <Text type="secondary">Option-specific Fields</Text>
                </Space>
              </Divider>

              {optionsEn.map((option, optIdx) => {
                const optionSubFields = subFieldsByOption[option] || [];
                
                return (
                  <Card
                    key={optIdx}
                    size="small"
                    style={{
                      marginBottom: 16,
                      background: "#f9f9f9",
                      border: "1px dashed #722ed1",
                      borderRadius: "6px"
                    }}
                    title={
                      <Space>
                        <Radio checked={false} disabled />
                        <Text strong>{option}</Text>
                        <Badge
                          count={optionSubFields.length}
                          style={{ backgroundColor: "#52c41a" }}
                          showZero
                        />
                      </Space>
                    }
                    extra={
                      <Button
                        type="text"
                        size="small"
                        icon={<PlusOutlined />}
                        onClick={() => {
                          setSelectedOption(option);
                          setShowFieldSelector(true);
                        }}
                        disabled={disabled}
                      >
                        Add Field
                      </Button>
                    }
                  >
                    {optionSubFields.length === 0 ? (
                      <div style={{
                        textAlign: "center",
                        padding: "20px",
                        background: "#fafafa",
                        borderRadius: "4px",
                        color: "#999"
                      }}>
                        <Text type="secondary">No fields added for this option</Text>
                        <br />
                        <Button
                          type="link"
                          size="small"
                          onClick={() => addSubFieldToOption(option, "text")}
                          disabled={disabled}
                        >
                          + Add Text Field
                        </Button>
                      </div>
                    ) : (
                      <div style={{ marginLeft: 8 }}>
                        {optionSubFields.map(subField => renderSubField(subField))}
                      </div>
                    )}
                  </Card>
                );
              })}
            </div>
          )}
        </div>
      </Card>
    );
  }

  // ==================== CHECKBOX FIELD UNDER HEADING ====================
  if (subField.type === "checkbox") {
    const optionsEn = subField.enOptions || subField.options || [];
    const optionsMr = subField.mrOptions || [];
    
    // Get subfields for each checkbox option
    const subFieldsByOption = {};
    allFields.forEach(f => {
      if (f.parentId === subField.id && f.colName) {
        if (!subFieldsByOption[f.colName]) {
          subFieldsByOption[f.colName] = [];
        }
        subFieldsByOption[f.colName].push(f);
      }
    });
    
    return (
      <Card
        key={subField.id}
        size="small"
        style={{
          marginBottom: 12,
          background: "#fafafa",
          border: "2px solid #52c41a",
          borderRadius: "8px",
          marginLeft: 16
        }}
      >
        <div style={{ padding: "12px" }}>
          {/* Header */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
            <Space>
              <CheckSquareOutlined style={{ color: "#52c41a", fontSize: "16px" }} />
              <Text strong style={{ color: "#52c41a" }}>Checkbox Field Configuration</Text>
              {subField.enRequired && <Tag color="red">Required</Tag>}
            </Space>
            <Space size={4}>
              <Tooltip title="Copy">
                <Button type="text" size="small" icon={<CopyOutlined />} onClick={() => copyField(subField)} disabled={disabled} />
              </Tooltip>
              <Tooltip title="Delete">
                <Button type="text" size="small" icon={<DeleteOutlined />} onClick={() => deleteSubField(subField.id)} danger disabled={disabled} />
              </Tooltip>
            </Space>
          </div>

          {/* Language Toggle */}
          <div style={{ marginBottom: 12, display: 'flex', justifyContent: 'flex-end' }}>
            <Button.Group size="small">
              <Button type={activeLanguage === 'english' ? 'primary' : 'default'} onClick={() => setActiveLanguage('english')} disabled={disabled}>English</Button>
              <Button type={activeLanguage === 'marathi' ? 'primary' : 'default'} onClick={() => setActiveLanguage('marathi')} disabled={disabled}>मराठी</Button>
            </Button.Group>
          </div>

          {/* Field Label */}
          <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
            <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
              <Text type="secondary" style={{ fontSize: "12px" }}>Field Label</Text>
            </Col>
            <Col span={16}>
              <div style={{ display: 'flex', gap: '8px' }}>
                <Tag color="blue" style={{ height: "32px", lineHeight: "30px" }}>EN</Tag>
                <Input
                  value={activeLanguage === 'english' ? subField.enLabel : subField.mrLabel}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (activeLanguage === 'english') {
                      updateSubField(subField.id, { ...subField, enLabel: value });
                      handleTranslate(value, "mrLabel");
                    } else {
                      updateSubField(subField.id, { ...subField, mrLabel: value });
                    }
                  }}
                  placeholder="Enter label"
                  size="small"
                  disabled={disabled}
                />
              </div>
            </Col>
          </Row>

          {/* Checkbox Options Section */}
          <div style={{ marginBottom: 16 }}>
            <Row align="top" gutter={16}>
              <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
                <Text type="secondary" style={{ fontSize: "12px" }}>Checkbox Options</Text>
              </Col>
              <Col span={16}>
                {/* Live Preview */}
                <div style={{ 
                  marginBottom: 16, 
                  padding: "12px", 
                  background: "#f6ffed", 
                  borderRadius: "8px",
                  border: "1px solid #b7eb8f"
                }}>
                  <Text type="secondary" style={{ fontSize: "11px", marginBottom: 8, display: "block" }}>
                    <EyeOutlined /> Live Preview:
                  </Text>
                  <Checkbox.Group 
                    value={previewValues[subField.id] || []} 
                    onChange={(values) => setPreviewValues({ ...previewValues, [subField.id]: values })}
                  >
                    <Space direction="vertical">
                      {optionsEn.map((opt, idx) => (
                        <Checkbox key={idx} value={opt}>
                          {activeLanguage === 'english' ? opt : (optionsMr[idx] || opt)}
                        </Checkbox>
                      ))}
                    </Space>
                  </Checkbox.Group>
                </div>

                {/* Options Editor */}
                {optionsEn.map((opt, idx) => (
                  <div key={idx} style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: 8 }}>
                    <Checkbox disabled checked={false} />
                    <Input
                      value={activeLanguage === 'english' ? opt : (optionsMr[idx] || opt)}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        if (activeLanguage === 'english') {
                          const newOptions = [...optionsEn];
                          newOptions[idx] = newValue;
                          updateSubField(subField.id, { ...subField, enOptions: newOptions, options: newOptions });
                        } else {
                          const newMrOptions = [...optionsMr];
                          newMrOptions[idx] = newValue;
                          updateSubField(subField.id, { ...subField, mrOptions: newMrOptions });
                        }
                      }}
                      size="small"
                      style={{ flex: 1 }}
                      placeholder={`Option ${idx + 1}`}
                      disabled={disabled}
                    />
                    {optionsEn.length > 1 && (
                      <Button
                        type="text"
                        size="small"
                        icon={<DeleteOutlined />}
                        onClick={() => {
                          const newOptions = optionsEn.filter((_, i) => i !== idx);
                          const newMrOptions = optionsMr.filter((_, i) => i !== idx);
                          updateSubField(subField.id, { ...subField, enOptions: newOptions, options: newOptions, mrOptions: newMrOptions });
                        }}
                        danger
                        disabled={disabled}
                      />
                    )}
                  </div>
                ))}
                <Button
                  type="dashed"
                  size="small"
                  icon={<PlusOutlined />}
                  onClick={() => {
                    const newOption = `Option ${optionsEn.length + 1}`;
                    updateSubField(subField.id, {
                      ...subField,
                      enOptions: [...optionsEn, newOption],
                      options: [...optionsEn, newOption],
                      mrOptions: [...optionsMr, newOption]
                    });
                  }}
                  block
                  disabled={disabled}
                  style={{ marginTop: 8 }}
                >
                  Add Option / पर्याय जोडा
                </Button>
              </Col>
            </Row>
          </div>

          {/* Required Checkbox */}
          <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
            <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
              <Text type="secondary" style={{ fontSize: "12px" }}>Validation</Text>
            </Col>
            <Col span={16}>
              <Checkbox
                checked={subField.enRequired}
                onChange={(e) => {
                  updateSubField(subField.id, {
                    ...subField,
                    enRequired: e.target.checked,
                    required: e.target.checked,
                    mrRequired: e.target.checked
                  });
                }}
                disabled={disabled}
              >
                Required field (Field will be mandatory in the form)
              </Checkbox>
            </Col>
          </Row>

          {/* Option-specific Fields Section */}
          {optionsEn.length > 0 && (
            <div style={{ marginTop: 16, marginLeft: 24 }}>
              <Divider orientation="left" style={{ margin: "12px 0" }}>
                <Space>
                  <FolderOutlined style={{ color: "#52c41a" }} />
                  <Text type="secondary">Option-specific Fields</Text>
                </Space>
              </Divider>

              {optionsEn.map((option, optIdx) => {
                const optionSubFields = subFieldsByOption[option] || [];
                
                return (
                  <Card
                    key={optIdx}
                    size="small"
                    style={{
                      marginBottom: 16,
                      background: "#f9f9f9",
                      border: "1px dashed #52c41a",
                      borderRadius: "6px"
                    }}
                    title={
                      <Space>
                        <Checkbox checked={false} disabled />
                        <Text strong>{option}</Text>
                        <Badge
                          count={optionSubFields.length}
                          style={{ backgroundColor: "#52c41a" }}
                          showZero
                        />
                      </Space>
                    }
                    extra={
                      <Button
                        type="text"
                        size="small"
                        icon={<PlusOutlined />}
                        onClick={() => {
                          setSelectedOption(option);
                          setShowFieldSelector(true);
                        }}
                        disabled={disabled}
                      >
                        Add Field
                      </Button>
                    }
                  >
                    {optionSubFields.length === 0 ? (
                      <div style={{
                        textAlign: "center",
                        padding: "20px",
                        background: "#fafafa",
                        borderRadius: "4px",
                        color: "#999"
                      }}>
                        <Text type="secondary">No fields added for this option</Text>
                        <br />
                        <Button
                          type="link"
                          size="small"
                          onClick={() => addSubFieldToOption(option, "text")}
                          disabled={disabled}
                        >
                          + Add Text Field
                        </Button>
                      </div>
                    ) : (
                      <div style={{ marginLeft: 8 }}>
                        {optionSubFields.map(subField => renderSubField(subField))}
                      </div>
                    )}
                  </Card>
                );
              })}
            </div>
          )}
        </div>
      </Card>
    );
  }

  // ==================== DROPDOWN FIELD UNDER HEADING ====================
  if (subField.type === "dropdown") {
    const optionsEn = subField.enOptions || subField.options || [];
    const optionsMr = subField.mrOptions || [];
    
    return (
      <Card
        key={subField.id}
        size="small"
        style={{
          marginBottom: 12,
          background: "#fafafa",
          border: "2px solid #722ed1",
          borderRadius: "8px",
          marginLeft: 16
        }}
      >
        <div style={{ padding: "12px" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
            <Space>
              <ApiOutlined style={{ color: "#722ed1" }} />
              <Text strong style={{ color: "#722ed1" }}>Dropdown Field</Text>
            </Space>
            <Tooltip title="Delete">
              <Button type="text" size="small" icon={<DeleteOutlined />} onClick={() => deleteSubField(subField.id)} danger disabled={disabled} />
            </Tooltip>
          </div>

          <div style={{ marginBottom: 12 }}>
            <Text type="secondary" style={{ fontSize: "11px" }}>Field Label</Text>
            <Input
              value={activeLanguage === 'english' ? subField.enLabel : subField.mrLabel}
              onChange={(e) => {
                if (activeLanguage === 'english') {
                  updateSubField(subField.id, { ...subField, enLabel: e.target.value });
                } else {
                  updateSubField(subField.id, { ...subField, mrLabel: e.target.value });
                }
              }}
              size="small"
              disabled={disabled}
            />
          </div>

          <div style={{ marginBottom: 16, padding: "12px", background: "#f0f5ff", borderRadius: "8px" }}>
            <Text type="secondary" style={{ fontSize: "11px", marginBottom: 8 }}>Live Preview:</Text>
            <Select
              style={{ width: "100%" }}
              placeholder="Select option..."
              value={previewValues[subField.id]}
              onChange={(val) => setPreviewValues({ ...previewValues, [subField.id]: val })}
              options={optionsEn.map((opt, idx) => ({ 
                label: activeLanguage === 'english' ? opt : (optionsMr[idx] || opt), 
                value: opt 
              }))}
              disabled={disabled}
            />
          </div>

          <div style={{ marginBottom: 12 }}>
            <Text type="secondary" style={{ fontSize: "11px", marginBottom: 8 }}>Options:</Text>
            {optionsEn.map((opt, idx) => (
              <div key={idx} style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: 8 }}>
                <Tag color="purple">{idx + 1}</Tag>
                <Input
                  value={activeLanguage === 'english' ? opt : (optionsMr[idx] || opt)}
                  onChange={(e) => {
                    if (activeLanguage === 'english') {
                      const newOptions = [...optionsEn];
                      newOptions[idx] = e.target.value;
                      updateSubField(subField.id, { ...subField, enOptions: newOptions, options: newOptions });
                    } else {
                      const newMrOptions = [...optionsMr];
                      newMrOptions[idx] = e.target.value;
                      updateSubField(subField.id, { ...subField, mrOptions: newMrOptions });
                    }
                  }}
                  size="small"
                  style={{ flex: 1 }}
                  disabled={disabled}
                />
                {optionsEn.length > 1 && (
                  <Button
                    type="text"
                    size="small"
                    icon={<DeleteOutlined />}
                    onClick={() => {
                      const newOptions = optionsEn.filter((_, i) => i !== idx);
                      const newMrOptions = optionsMr.filter((_, i) => i !== idx);
                      updateSubField(subField.id, { ...subField, enOptions: newOptions, options: newOptions, mrOptions: newMrOptions });
                    }}
                    danger
                    disabled={disabled}
                  />
                )}
              </div>
            ))}
            <Button
              type="dashed"
              size="small"
              icon={<PlusOutlined />}
              onClick={() => {
                const newOption = `Option ${optionsEn.length + 1}`;
                updateSubField(subField.id, {
                  ...subField,
                  enOptions: [...optionsEn, newOption],
                  options: [...optionsEn, newOption],
                  mrOptions: [...optionsMr, newOption]
                });
              }}
              block
              disabled={disabled}
              style={{ marginTop: 8 }}
            >
              Add Option
            </Button>
          </div>

          <Checkbox
            checked={subField.enRequired}
            onChange={(e) => {
              updateSubField(subField.id, { ...subField, enRequired: e.target.checked, required: e.target.checked });
            }}
            disabled={disabled}
          >
            Required
          </Checkbox>
        </div>
      </Card>
    );
  }

  // ==================== TEXT, NUMBER, DATE, FILE FIELDS ====================
  return (
    <Card
      key={subField.id}
      size="small"
      style={{
        marginBottom: 8,
        background: "white",
        border: "1px solid #e8e8e8",
        marginLeft: 16
      }}
    >
      <div style={{ display: "flex", alignItems: "flex-start", gap: "8px" }}>
        <div style={{ marginTop: 8 }}>
          {subField.type === "text" && <FontSizeOutlined style={{ color: "#1890ff" }} />}
          {subField.type === "number" && <NumberOutlined style={{ color: "#52c41a" }} />}
          {subField.type === "date" && <CalendarOutlined style={{ color: "#fa8c16" }} />}
          {subField.type === "file" && <UploadOutlined style={{ color: "#1890ff" }} />}
        </div>

        <div style={{ flex: 1 }}>
          <div style={{ marginBottom: 12 }}>
            <Text type="secondary" style={{ fontSize: '11px', display: 'block', marginBottom: 4 }}>
              Field Label
            </Text>
            <div style={{ display: 'flex', gap: '8px' }}>
              <div style={{ flex: 1 }}>
                <Input
                  value={activeLanguage === 'english' ? subField.enLabel : subField.mrLabel}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (activeLanguage === 'english') {
                      updateSubField(subField.id, {
                        ...subField,
                        enLabel: value
                      });
                      handleTranslate(value, "mrLabel");
                    } else {
                      updateSubField(subField.id, {
                        ...subField,
                        mrLabel: value
                      });
                    }
                  }}
                  placeholder={activeLanguage === 'english' ? "English label" : "मराठी लेबल"}
                  size="small"
                  allowClear
                  disabled={disabled}
                />
              </div>
            </div>
          </div>

          <div style={{ marginBottom: 8 }}>
            <div style={{ display: 'flex', gap: '16px', marginBottom: 8 }}>
              <Checkbox
                checked={subField.enRequired}
                onChange={(e) => {
                  const checked = e.target.checked;
                  updateSubField(subField.id, {
                    ...subField,
                    enRequired: checked,
                    required: checked
                  });
                }}
                disabled={disabled}
              >
                Required (EN)
              </Checkbox>
              <Checkbox
                checked={subField.mrRequired}
                onChange={(e) => {
                  updateSubField(subField.id, {
                    ...subField,
                    mrRequired: e.target.checked
                  });
                }}
                disabled={disabled}
              >
                आवश्यक (MR)
              </Checkbox>
            </div>
          </div>

          {subField.type === "text" && (
            <div style={{ marginBottom: 8 }}>
              <Text type="secondary" style={{ fontSize: '11px', display: 'block', marginBottom: 4 }}>
                Placeholder
              </Text>
              <Input
                placeholder="Placeholder (EN)"
                size="small"
                value={subField.enPlaceholder}
                onChange={(e) => {
                  const value = e.target.value;
                  updateSubField(subField.id, {
                    ...subField,
                    enPlaceholder: value,
                    placeholder: value
                  });
                  handleTranslate(value, 'mrPlaceholder');
                }}
                allowClear
                disabled={disabled}
              />
            </div>
          )}

          {subField.type === "number" && (
            <>
              <Divider style={{ margin: '8px 0' }} />
              <SimpleUnitCheckbox
                field={subField}
                onUpdate={(updatedSubField) => {
                  updateSubField(subField.id, updatedSubField);
                }}
                language={activeLanguage}
              />
              
              {getSubFieldUnitDisplay(subField) && (
                <div style={{ marginTop: 8 }}>
                  <Tag color="green" icon={<CheckCircleOutlined />}>
                    Unit: {getSubFieldUnitDisplay(subField)}
                  </Tag>
                </div>
              )}

              <Divider style={{ margin: '12px 0 8px 0' }} />
              <ValidationPanel
                field={subField}
                onUpdate={(updatedSubField) => {
                  updateSubField(subField.id, updatedSubField);
                }}
                language={activeLanguage}
              />
            </>
          )}
        </div>

        <Tooltip title="Delete">
          <Button
            type="text"
            size="small"
            icon={<DeleteOutlined />}
            onClick={() => deleteSubField(subField.id)}
            danger
            disabled={disabled}
          />
        </Tooltip>
      </div>
    </Card>
  );
};
  
const renderChildHeading = (childHeading) => {
  return (
    <div key={childHeading.id} style={{ marginLeft: 24, marginBottom: 16, marginTop: 8 }}>
      <FieldEditor   
        field={childHeading}
        onUpdate={(updatedField) => {
          console.log('🔄 Updating sub-heading:', updatedField.id, updatedField.enLabel);
          if (onUpdateSubField) {
            onUpdateSubField(updatedField.id, updatedField);
          }
        }}
        onDelete={() => deleteSubField(childHeading.id)}
        onCopy={() => copyField(childHeading)}
        allFields={allFields}
        onAddSubField={onAddSubField}
        onUpdateSubField={onUpdateSubField}
        onDeleteSubField={onDeleteSubField}
        language={language}
        autoTranslate={autoTranslate}
        translateTyping={translateTyping}
        translating={translating}
        disabled={disabled}
      />
    </div>
  );
};

  const renderSubFields = () => {
    if (field.type !== "radio" && field.type !== "checkbox") return null;

    const options = field.enOptions || field.options || [];

    return (
      <div style={{ marginTop: 16, marginLeft: 24 }}>
        <Divider orientation="left" style={{ margin: "12px 0" }}>
          <Space>
            <FolderOutlined style={{ color: field.type === "radio" ? "#722ed1" : "#52c41a" }} />
            <Text type="secondary">
              {field.type === "radio" 
                ? (language === 'english' ? 'Option-specific Fields' : 'पर्याय-विशिष्ट फील्ड')
                : (language === 'english' ? 'Checkbox Option Fields' : 'चेकबॉक्स पर्याय फील्ड')}
            </Text>
          </Space>
        </Divider>

        {options.map((option, optIdx) => {
          const optionSubFields = subFieldsByOption[option] || [];

          return (
            <Card
              key={optIdx}
              size="small"
              style={{
                marginBottom: 16,
                background: "#f9f9f9",
                border: field.type === "radio" ? "1px dashed #722ed1" : "1px dashed #52c41a",
                borderRadius: "6px"
              }}
              title={
                <Space>
                  {field.type === "radio" ? (
                    <Radio checked={false} disabled />
                  ) : (
                    <Checkbox checked={false} disabled />
                  )}
                  <Text strong>{option}</Text>
                  <Badge
                    count={optionSubFields.length}
                    style={{ backgroundColor: "#52c41a" }}
                    showZero
                  />
                </Space>
              }
              extra={
                <Button
                  type="text"
                  size="small"
                  icon={<PlusOutlined />}
                  onClick={() => {
                    setSelectedOption(option);
                    setShowFieldSelector(true);
                  }}
                  disabled={disabled}
                >
                  Add Field
                </Button>
              }
            >
              {optionSubFields.length === 0 ? (
                <div style={{
                  textAlign: "center",
                  padding: "20px",
                  background: "#fafafa",
                  borderRadius: "4px",
                  color: "#999"
                }}>
                  <Text type="secondary">
                    {language === 'english' 
                      ? `No fields added for this option`
                      : `या पर्यायासाठी कोणतीही फील्ड जोडलेली नाही`}
                  </Text>
                  <br />
                  <Button
                    type="link"
                    size="small"
                    onClick={() => addSubFieldToOption(option, "text")}
                    disabled={disabled}
                  >
                    + Add Text Field
                  </Button>
                </div>
              ) : (
                <div style={{ marginLeft: 8 }}>
                  {optionSubFields.map(subField => renderSubField(subField))}
                </div>
              )}
            </Card>
          );
        })}
      </div>
    );
  };
  
// ✅ renderHeading function - दोन्ही headings साठी
const renderHeading = (headingField) => {
  const label = getFieldLabel(headingField);
  const headingLevel = headingField.headingLevel || 1;
  
  if (printMode) {
    return (
      <div key={headingField.id} className="print-field">
        <h3 style={{ margin: '0 0 5px 0', fontSize: headingLevel === 1 ? '24px' : '20px' }}>{label}</h3>
      </div>
    );
  }

  // मुख्य heading (level 1) - EDITABLE
  if (headingLevel === 1) {
    return (
      <div key={headingField.id} style={{ 
        marginBottom: '20px',
        marginTop: headingField.parentId ? '20px' : '30px',
      }}>
        <div style={{
          borderBottom: '3px solid #fa8c16',
          paddingBottom: '12px',
        }}>
          <Input
            value={headingField.enLabel || headingField.label || ''}
            onChange={(e) => {
              const updatedField = { 
                ...headingField, 
                enLabel: e.target.value,
                label: e.target.value 
              };
              onUpdate(updatedField);  // ✅ हे main heading update करते
            }}
            placeholder="Enter main heading..."
            style={{
              fontSize: '24px',
              fontWeight: 600,
              border: 'none',
              padding: 0,
              background: 'transparent',
              color: '#1f1f1f',
              width: '100%'
            }}
            disabled={disabled}
          />
          
          {(headingField.enHelpText || headingField.mrHelpText) && (
            <div style={{ 
              marginTop: '4px',
              fontSize: '13px',
              color: '#666',
              fontStyle: 'italic'
            }}>
              {selectedLanguage === 'english' ? headingField.enHelpText : headingField.mrHelpText}
            </div>
          )}
        </div>
      </div>
    );
  }
  
  // ✅ FIXED: Sub-heading (level 2) - आता EDITABLE होईल
  return (
    <div key={headingField.id} style={{ 
      marginBottom: '20px',
      marginTop: headingField.parentId ? '20px' : '30px',
      marginLeft: '24px' // Indent for sub-heading
    }}>
      <div style={{
        borderBottom: '2px solid #ffd591',
        paddingBottom: '8px',
      }}>
        <div style={{ marginBottom: '4px', fontSize: '12px', color: '#666' }}>
          Sub-Heading:
        </div>
        <Input
          value={headingField.enLabel || headingField.label || ''}
          onChange={(e) => {
            console.log('Updating sub-heading:', headingField.id, e.target.value);
            // ✅ IMPORTANT: हे FieldEditor ला update करण्यासाठी onUpdate वापरा
            const updatedField = { 
              ...headingField, 
              enLabel: e.target.value,
              label: e.target.value 
            };
            
            // ✅ हे onUpdate प्रॉपरद्वारे पाठवा
            onUpdate(updatedField);
          }}
          placeholder="Enter sub-heading..."
          style={{
            fontSize: '20px',
            fontWeight: 500,
            border: '1px solid #d9d9d9',
            borderRadius: '6px',
            padding: '8px 12px',
            background: '#ffffff',
            color: '#2c3e50',
            width: '100%'
          }}
          disabled={disabled}
        />
        
        {(headingField.enHelpText || headingField.mrHelpText) && (
          <div style={{ 
            marginTop: '4px',
            fontSize: '13px',
            color: '#666',
            fontStyle: 'italic'
          }}>
            {selectedLanguage === 'english' ? headingField.enHelpText : headingField.mrHelpText}
          </div>
        )}
      </div>
    </div>
  );
};

  // ✅ renderHeadingChildren function
  const renderHeadingChildren = () => {
    if (field.type !== "heading") return null;

    // ✅ Correctly get children
    const childHeadings = allFields.filter(f => f.parentId === field.id && f.type === "heading");
    const childFields = allFields.filter(f => f.parentId === field.id && f.type !== "heading");

    const hasChildren = childHeadings.length > 0 || childFields.length > 0;

    console.log(`📊 Heading ${field.id} has:`, {
      childHeadings: childHeadings.length,
      childFields: childFields.length
    });

    return (
      <div style={{ marginTop: 16, marginLeft: 24 }}>
        <Divider orientation="left" style={{ margin: "12px 0" }}>
          <Space>
            <FolderOutlined style={{ color: "#fa8c16" }} />
            <Text type="secondary">
              {language === 'english' ? 'Content under this heading' : 'या शीर्षकाखालील सामग्री'}
            </Text>
            <Badge
              count={childHeadings.length + childFields.length}
              style={{ backgroundColor: "#fa8c16" }}
              showZero
            />
          </Space>
        </Divider>

        <Space style={{ marginBottom: 16 }}>
          <Button
            type="primary"
            size="small"
            icon={<PlusOutlined />}
            onClick={() => {
              setShowFieldSelector(true);
            }}
            disabled={disabled}
          >
            {language === 'english' ? 'Add Field' : 'फील्ड जोडा'}
          </Button>
          
          <Button
            type="default"
            size="small"
            icon={<FontSizeOutlined />}
            onClick={addSubHeading}
            disabled={disabled}
            style={{ borderColor: "#fa8c16", color: "#fa8c16" }}
          >
            {language === 'english' ? 'Add Sub-Heading' : 'उप-शीर्षक जोडा'}
          </Button>
        </Space>

        {!hasChildren ? (
          <div style={{
            textAlign: "center",
            padding: "20px",
            background: "#fafafa",
            borderRadius: "4px",
            border: "1px dashed #fa8c16",
            color: "#999"
          }}>
            <Text type="secondary">
              {language === 'english' 
                ? `No content added under this heading`
                : `या शीर्षकाखाली कोणतीही सामग्री जोडलेली नाही`}
            </Text>
          </div>
        ) : (
          <div>
            {childHeadings.map(childHeading => renderChildHeading(childHeading))}
            
            {childFields.length > 0 && (
              <div style={{ marginTop: childHeadings.length > 0 ? 16 : 0 }}>
                {childFields.map(subField => renderSubField(subField))}
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  // ✅ DEBUG
  console.log('FieldEditor rendering field:', field.id, field.type, field.headingLevel, field.enLabel);

  return (
    <>
      <Card
        size="small"
        style={{
          marginBottom: 12,
          borderRadius: "8px",
          border: field.type === "radio" ? "2px solid #722ed1" :
            field.type === "checkbox" ? "2px solid #52c41a" :
            field.type === "dropdown" ? "2px solid #722ed1" :
            field.type === "file" ? "2px solid #1890ff" :
              field.type === "comparison" ? "2px solid #fa8c16" :
                field.type === "arithmetic" ? "2px solid #52c41a" :
                field.type === "heading" ? "2px solid #fa8c16" : "1px solid #f0f0f0",
          boxShadow: field.type === "radio" ? "0 2px 8px rgba(114, 46, 209, 0.1)" :
            field.type === "checkbox" ? "0 2px 8px rgba(82, 196, 26, 0.1)" :
            field.type === "dropdown" ? "0 2px 8px rgba(114, 46, 209, 0.1)" :
            field.type === "file" ? "0 2px 8px rgba(24, 144, 255, 0.1)" :
              field.type === "comparison" ? "0 2px 8px rgba(250, 140, 22, 0.1)" :
                field.type === "arithmetic" ? "0 2px 8px rgba(82, 196, 26, 0.1)" :
                field.type === "heading" ? "0 2px 8px rgba(250, 140, 22, 0.1)" : "none",
          borderLeft: field.fromExisting ? "4px solid #113F67" : undefined,
          opacity: disabled ? 0.7 : 1
        }}
        title={
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <Badge
                count={field.type === "heading" ? `H${field.headingLevel || 1}` : field.type}
                style={{
                  backgroundColor: getFieldColor(field.type)
                }}
              />
              <span style={{ fontWeight: 'bold', fontSize: '14px' }}>
                {field.type === "heading" 
                  ? (field.headingLevel === 1 ? 'Heading' : `Sub-Heading Level ${field.headingLevel}`)
                  : 'Field Configuration'}
              </span>
              {autoTranslate && (
                <Tag color="green" icon={<GlobalOutlined />}>Auto ON</Tag>
              )}
              {field.fromExisting && (
                <Tag color="blue">From: {field.sourceColumn}</Tag>
              )}
              {disabled && (
                <Tag color="orange">Read Only</Tag>
              )}
            </div>
            <Space size={4}>
              <Tooltip title="Copy">
                <Button type="text" size="small" icon={<CopyOutlined />} onClick={() => copyField(field)} disabled={disabled} />
              </Tooltip>
              <Tooltip title="Delete">
                <Button type="text" size="small" icon={<DeleteOutlined />} onClick={onDelete} danger disabled={disabled} />
              </Tooltip>
            </Space>
          </div>
        }
      >
        <div style={{ marginBottom: 12, display: 'flex', justifyContent: 'flex-end' }}>
          <Button.Group size="small">
            <Button
              type={activeLanguage === 'english' ? 'primary' : 'default'}
              onClick={() => setActiveLanguage('english')}
              icon={<GlobalOutlined />}
              disabled={disabled}
            >
              English
            </Button>
            <Button
              type={activeLanguage === 'marathi' ? 'primary' : 'default'}
              onClick={() => setActiveLanguage('marathi')}
              disabled={disabled}
            >
              मराठी
            </Button>
          </Button.Group>
        </div>

        <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
          <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
            <Text type="secondary" style={{ fontSize: '12px' }}>
              {field.type === "heading" ? 'Heading Text' : 'Field Label'}
            </Text>
          </Col>
          <Col span={16}>
            <div style={{ display: 'flex', gap: '8px' }}>
              <Tag color="blue" style={{ height: "32px", lineHeight: "30px" }}>EN</Tag>
              <Input
                value={activeLanguage === 'english' ? field.enLabel : field.mrLabel}
                onChange={(e) => {
                  const value = e.target.value;
                  if (activeLanguage === 'english') {
                    updateField("enLabel", value);
                    handleTranslate(value, "mrLabel");
                  } else {
                    updateField("mrLabel", value);
                  }
                }}
                placeholder={activeLanguage === 'english' ? "Enter English label" : "मराठी लेबल प्रविष्ट करा"}
                size="middle"
                allowClear
                style={{ width: "100%" }}
                disabled={disabled}
              />
            </div>
          </Col>
        </Row>

        {field.type === "heading" && (
          <div style={{ marginBottom: 8, padding: 4, background: '#f0f0f0' }}>
            <Text type="secondary">Debug: {field.enLabel} / {field.mrLabel}</Text>
          </div>
        )}

        {(field.type === "radio" || field.type === "checkbox") && (
          <div style={{ marginBottom: 16 }}>
            <Row align="top" gutter={16}>
              <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
                <Text type="secondary" style={{ fontSize: "12px" }}>
                  {field.type === "radio" ? "Radio Options" : "Checkbox Options"}
                </Text>
              </Col>
              <Col span={16}>
                {(field.enOptions || field.options || []).map((opt, idx) => (
                  <div key={idx} style={{ marginBottom: "8px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      {field.type === "radio" ? (
                        <Radio disabled />
                      ) : (
                        <Checkbox disabled />
                      )}
                      <div style={{ display: 'flex', gap: '12px', flex: 1 }}>
                        <Input
                          value={activeLanguage === 'english' 
                            ? (field.enOptions?.[idx] !== undefined ? field.enOptions[idx] : opt) 
                            : (field.mrOptions?.[idx] !== undefined ? field.mrOptions[idx] : opt)
                          }
                          onChange={(e) => {
                            const newValue = e.target.value;
                            if (activeLanguage === 'english') {
                              const newEnOptions = [...(field.enOptions || field.options || [])];
                              newEnOptions[idx] = newValue;
                              
                              const updatedField = { 
                                ...field, 
                                enOptions: newEnOptions,
                                options: newEnOptions 
                              };
                              
                              onUpdate(updatedField);
                              
                              if (autoTranslate && newValue.trim()) {
                                handleTranslate(newValue, `mrOptions.${idx}`);
                              }
                            } else {
                              const newMrOptions = [...(field.mrOptions || [])];
                              while (newMrOptions.length <= idx) {
                                newMrOptions.push('');
                              }
                              newMrOptions[idx] = newValue;
                              
                              onUpdate({ ...field, mrOptions: newMrOptions });
                            }
                          }}
                          size="middle"
                          style={{ flex: 1 }}
                          placeholder={activeLanguage === 'english' 
                            ? `Option ${idx + 1} (EN)` 
                            : `पर्याय ${idx + 1} (MR)`
                          }
                          prefix={
                            <Tag color={activeLanguage === 'english' ? "blue" : "green"} size="small">
                              {activeLanguage === 'english' ? 'EN' : 'MR'}
                            </Tag>
                          }
                          allowClear
                          disabled={disabled}
                        />
                      </div>
                      {(field.enOptions || field.options || []).length > 1 && (
                        <Button
                          type="text"
                          size="small"
                          icon={<CloseOutlined />}
                          onClick={() => removeOption(idx)}
                          danger
                          disabled={disabled}
                        />
                      )}
                    </div>
                  </div>
                ))}
                <Button 
                  type="dashed" 
                  size="small" 
                  onClick={addOption} 
                  block 
                  icon={<PlusOutlined />} 
                  disabled={disabled}
                >
                  Add Option / पर्याय जोडा
                </Button>
              </Col>
            </Row>
          </div>
        )}

        {(field.type === "radio" || field.type === "checkbox") && renderSubFields()}

        {field.type === "heading" && renderHeadingChildren()}

        {field.type !== "heading" && field.type !== "paragraph" && field.type !== "arithmetic" && field.type !== "file" && field.type !== "dropdown" && (
          <div style={{ marginTop: 8 }}>
            <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
              <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
                <Text type="secondary" style={{ fontSize: '12px' }}>Validation</Text>
              </Col>
              <Col span={16}>
                <Checkbox
                  checked={field.required || field.enRequired || field.mrRequired}
                  onChange={(e) => handleRequiredChange(e.target.checked)}
                  disabled={disabled}
                >
                  {activeLanguage === 'english' ? 'Required' : 'आवश्यक'}
                </Checkbox>
              </Col>
            </Row>
          </div>
        )}

        {field.type === "text" && (
          <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
            <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
              <Text type="secondary" style={{ fontSize: '12px' }}>Placeholder</Text>
            </Col>
            <Col span={16}>
              <div style={{ display: 'flex', gap: '8px' }}>
                <Tag color="blue" style={{ height: "32px", lineHeight: "30px" }}>EN</Tag>
                <Input
                  value={activeLanguage === 'english' ? field.enPlaceholder : field.mrPlaceholder}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (activeLanguage === 'english') {
                      updateField("enPlaceholder", value);
                      updateField("placeholder", value);
                      handleTranslate(value, "mrPlaceholder");
                    } else {
                      updateField("mrPlaceholder", value);
                    }
                  }}
                  placeholder={activeLanguage === 'english' ? "Enter placeholder" : "प्लेसहोल्डर प्रविष्ट करा"}
                  size="middle"
                  allowClear
                  style={{ width: "100%" }}
                  disabled={disabled}
                />
              </div>
            </Col>
          </Row>
        )}

        {field.type === "number" && (
          <>
            <Alert
              message={activeLanguage === 'english' 
                ? "Number validation settings are in the Validation Rules panel" 
                : "संख्या वैधता सेटिंग्ज आता वैधता नियम पॅनेलमध्ये आहेत"}
              type="info"
              showIcon
              style={{ marginBottom: 16 }}
            />
            
            <SimpleUnitCheckbox
              field={field}
              onUpdate={onUpdate}
              language={activeLanguage}
            />

            <Card size="small" style={{ marginTop: 16, background: '#fafafa' }}>
              <Space direction="vertical" style={{ width: '100%' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' ,width: '100%',}}>
                  <BarChartOutlined style={{ color: '#722ed1' }} />
                  <Text strong>Access Report Configuration</Text>
                </div>
                
                <Checkbox
                  checked={field.reportConfig?.enabled || false}
                  onChange={(e) => {
                    const enabled = e.target.checked;
                    onUpdate({
                      ...field,
                      reportConfig: {
                        enabled,
                        operator: field.reportConfig?.operator || 'add',
                        customFormula: field.reportConfig?.customFormula || null,
                        fields: field.reportConfig?.fields || []
                      }
                    });
                  }}
                >
                  {language === 'english' 
                    ? 'Include this field in Access Report' 
                    : 'हे फील्ड अॅक्सेस रिपोर्टमध्ये समाविष्ट करा'}
                </Checkbox>
                
                {field.reportConfig?.enabled && (
                  <>
                    <Divider style={{ margin: '8px 0' }} />
                    
                    <Row gutter={16}>
                      <Col span={8}>
                        <Text type="secondary">Operation:</Text>
                      </Col>
                      <Col span={16}>
                        <Radio.Group
                          value={field.reportConfig.operator || 'add'}
                          onChange={(e) => {
                            onUpdate({
                              ...field,
                              reportConfig: {
                                ...field.reportConfig,
                                operator: e.target.value
                              }
                            });
                          }}
                          buttonStyle="solid"
                          size="small"
                        >
                          <Radio.Button value="add">+ Add</Radio.Button>
                          <Radio.Button value="subtract">- Sub</Radio.Button>
                          <Radio.Button value="multiply">× Mul</Radio.Button>
                          <Radio.Button value="divide">÷ Div</Radio.Button>
                          <Radio.Button value="modulus">% Mod</Radio.Button>
                        </Radio.Group>
                      </Col>
                    </Row>
                    
                    {field.reportConfig.operator === 'custom' && (
                      <Row gutter={16} style={{ marginTop: 8 }}>
                        <Col span={8}>
                          <Text type="secondary">Custom Formula:</Text>
                        </Col>
                        <Col span={16}>
                          <Input
                            value={field.reportConfig.customFormula || ''}
                            onChange={(e) => {
                              onUpdate({
                                ...field,
                                reportConfig: {
                                  ...field.reportConfig,
                                  customFormula: e.target.value
                                }
                              });
                            }}
                            placeholder="e.g., field1 + field2"
                            size="small"
                          />
                        </Col>
                      </Row>
                    )}
                  </>
                )}
              </Space>
            </Card>
          </>
        )}

       {field.type === "date" && (
  <DateFieldEditor
    field={field}
    onUpdate={onUpdate}
    onDelete={onDelete}
    onCopy={onCopy}
    allFields={allFields}
    language={language}
    autoTranslate={autoTranslate}
    translateTyping={translateTyping}
    translating={translating}
    disabled={disabled}
  />
)}

        {(field.type === "text" || field.type === "number" || field.type === "date") && (
          <ValidationPanel
            field={field}
            onUpdate={onUpdate}
            language={activeLanguage}
          />
        )}

        {field.type === "heading" && (childHeadings.length > 0 || childFields.length > 0) && (
          <Row align="middle" gutter={16} style={{ marginTop: 12 }}>
            <Col span={8} style={{ textAlign: "right", paddingRight: 8 }}>
              <Text type="secondary" style={{ fontSize: '12px' }}>Summary</Text>
            </Col>
            <Col span={16}>
              <div style={{
                padding: 8,
                background: "#fff7e6",
                border: "1px solid #ffd591",
                borderRadius: "4px",
                fontSize: "12px"
              }}>
                <Space>
                  <FolderOutlined style={{ color: "#fa8c16" }} />
                  <Text type="secondary">
                    {language === 'english' 
                      ? "Content under this heading:" 
                      : "या शीर्षकाखालील सामग्री:"}
                  </Text>
                </Space>
                <div style={{ marginTop: 4 }}>
                  {childHeadings.length > 0 && (
                    <Tag color="orange" style={{ marginBottom: 4 }}>
                      Sub-Headings: {childHeadings.length}
                    </Tag>
                  )}
                  {childFields.length > 0 && (
                    <Tag color="blue" style={{ marginBottom: 4 }}>
                      Fields: {childFields.length}
                    </Tag>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        )}
      </Card>

      <Modal
        open={showFieldSelector}
        onCancel={() => setShowFieldSelector(false)}
        footer={null}
        width={520}
        title={
          field.type === "radio"
            ? `Add field under "${selectedOption || ''}" / "${selectedOption || ''}" अंतर्गत फील्ड जोडा`
            : field.type === "checkbox"
            ? `Add field for "${selectedOption || ''}" / "${selectedOption || ''}" साठी फील्ड जोडा`
            : field.type === "heading"
            ? `Add field under "${field.enLabel || 'Heading'}" / "${field.mrLabel || 'शीर्षक'}" अंतर्गत फील्ड जोडा`
            : `Add field`
        }
        maskClosable={true}
        centered
        destroyOnClose={true}
        maskStyle={{ backdropFilter: 'none' }}
        bodyStyle={{ padding: "20px" }}
      >
        <div style={{ marginTop: 8 }}>
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: "12px"
          }}>
            {FIELD_TYPES.filter(t => !["row", "graph", "comparison", "arithmetic", "heading"].includes(t.type)).map(type => (
              <div
                key={type.type}
                onClick={() => {
                  if (field.type === "heading") {
                    addSubFieldToHeading(type.type);
                  } else {
                    addSubFieldToOption(selectedOption, type.type);
                  }
                  setShowFieldSelector(false);
                }}
                style={{
                  cursor: "pointer",
                  textAlign: "left",
                  height: "48px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  fontSize: "14px",
                  fontWeight: "normal",
                  border: "1px solid #d9d9d9",
                  borderRadius: "8px",
                  padding: "0 12px",
                  transition: "all 0.2s",
                  background: "#ffffff",
                }}
                className="field-selector-item"
              >
                <span style={{
                  marginRight: "10px",
                  fontSize: "18px",
                  color: type.type === "radio" ? "#722ed1" :
                    type.type === "checkbox" ? "#52c41a" :
                    type.type === "dropdown" ? "#722ed1" :
                      type.type === "file" ? "#1890ff" : "#1890ff"
                }}>
                  {type.icon}
                </span>
                <span>
                  {type.label} / {
                    type.type === "text" ? "मजकूर" :
                      type.type === "number" ? "संख्या" :
                        type.type === "date" ? "तारीख" :
                          type.type === "checkbox" ? "चेकबॉक्स" :
                            type.type === "radio" ? "रेडिओ" :
                              type.type === "dropdown" ? "ड्रॉपडाउन" :
                              type.type === "file" ? "फाइल" : type.label
                  }
                </span>
              </div>
            ))}
          </div>

          <div style={{
            marginTop: "20px",
            padding: "10px",
            background: "#f9f9f9",
            borderRadius: "6px",
            fontSize: "13px",
            color: "#666",
            textAlign: "center",
            border: "1px dashed #d9d9d9"
          }}>
            <Text type="secondary">
              {field.type === "radio"
                ? `Click any field type to add it under "${selectedOption}"`
                : field.type === "checkbox"
                ? `Click any field type to add it for "${selectedOption}" checkbox option`
                : field.type === "heading"
                ? `Click any field type to add it under this heading`
                : `Click any field type to add`}
            </Text>
          </div>
        </div>
      </Modal>
    </>
  );
};
// Row Node Editor
const RowNodeEditor = ({ rowNode, onUpdate, onDelete, onCopy, disabled }) => {
  return (
    <Card
      size="small"
      style={{ marginBottom: 12, background: "#fafafa", borderRadius: "8px", border: "2px dashed #ddd", opacity: disabled ? 0.7 : 1 }}
      title={
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Space>
            <Badge count="2 Columns" style={{ backgroundColor: "#722ed1" }} />
            <Text>{rowNode.label}</Text>
          </Space>
          <Space size={4}>
            <Tooltip title="Copy">
              <Button type="text" size="small" icon={<CopyOutlined />} onClick={onCopy} disabled={disabled} />
            </Tooltip>
            <Tooltip title="Delete">
              <Button type="text" size="small" icon={<DeleteOutlined />} onClick={onDelete} danger disabled={disabled} />
            </Tooltip>
          </Space>
        </div>
      }
    >
      <Row gutter={16}>
        <Col span={12}>
          <DroppableZone id={`ROW:${rowNode.id}:left`}>
            <div style={{
              minHeight: "80px",
              background: "white",
              border: "2px dashed #ddd",
              borderRadius: "4px",
              padding: "8px",
              textAlign: "center"
            }}>
              <Text type="secondary" style={{ fontSize: "12px" }}>
                {rowNode.children?.left?.length || 0} items
              </Text>
            </div>
          </DroppableZone>
        </Col>
        <Col span={12}>
          <DroppableZone id={`ROW:${rowNode.id}:right`}>
            <div style={{
              minHeight: "80px",
              background: "white",
              border: "2px dashed #ddd",
              borderRadius: "4px",
              padding: "8px",
              textAlign: "center"
            }}>
              <Text type="secondary" style={{ fontSize: "12px" }}>
                {rowNode.children?.right?.length || 0} items
              </Text>
            </div>
          </DroppableZone>
        </Col>
      </Row>
    </Card>
  );
};



// 🟢 MAIN COMPONENT - FormBuilderContent
const FormBuilderContent = ({
  activeTab,
  formName,
  setFormName,
  formsList,
  loadingList,
  selectedFormId,
  setSelectedFormId,
  nodes,
  setNodes,
  originalFormData,
  setOriginalFormData,
  onFormLoad,
  onPreview,
  onSave,
  saving,
  language,
  setLanguage,
  permissions,
  setPermissions,
  workflow,
  setWorkflow,
  sla,
  setSla,
  formMetadata,
  selectedColumns,
  onAddField,
  existingColumns,
  setExistingColumns,
  showExistingPalette,
  setShowExistingPalette,
  // 🟢 PROPS FROM FORMBUILDERMAIN
  entryType: propEntryType = "single",
  setEntryType: propSetEntryType,
  enableFrequency: propEnableFrequency = false,
  setEnableFrequency: propSetEnableFrequency,
  frequencyType: propFrequencyType = null,
  setFrequencyType: propSetFrequencyType,
  customFrequency: propCustomFrequency = "",
  setCustomFrequency: propSetCustomFrequency,
  frequencyUnit: propFrequencyUnit = "days",
  setFrequencyUnit: propSetFrequencyUnit,
  frequencyValue: propFrequencyValue = 1,
  setFrequencyValue: propSetFrequencyValue,
  maxEntriesPerUser: propMaxEntriesPerUser = 0,
  setMaxEntriesPerUser: propSetMaxEntriesPerUser,
  showPreview: externalShowPreview,  // ✅ ADD THIS
  setShowPreview: externalSetShowPreview, 
  // 🟢 PROPS FOR APPROVAL SYSTEM
  currentUser,
  currentUserRole,
  onFormSubmitForApproval,
  onFormApprove,
  onFormReject,
}) => {
  const location = useLocation();
  const [activeDragId, setActiveDragId] = useState(null);
  
  // ✅ FIXED: Use props for showPreview state, remove duplicate declarations
  const [internalShowPreview, setInternalShowPreview] = useState(false);
  const showPreview = externalShowPreview !== undefined ? externalShowPreview : internalShowPreview;
  const setShowPreview = externalSetShowPreview || setInternalShowPreview;
  
  // Internal states for preview values
  const [previewValues, setPreviewValues] = useState({});
  const [previewFileList, setPreviewFileList] = useState({});
  
  const [roles, setRoles] = useState([]);
  const [loadingRoles, setLoadingRoles] = useState(false);
  const [workflowType, setWorkflowType] = useState(workflow?.type || "standard");
  const [customWorkflow, setCustomWorkflow] = useState(workflow?.sequence || []);
  const [isExistingMode, setIsExistingMode] = useState(false);
  // 🟢 Comparison Modal State
  const [comparisonModalVisible, setComparisonModalVisible] = useState(false);
  
  const [showExistingFormSelector, setShowExistingFormSelector] = useState(false);
  const [availableForms, setAvailableForms] = useState([]);
  const [loadingForms, setLoadingForms] = useState(false);
  const [selectedSourceForm, setSelectedSourceForm] = useState(null);
  const [sourceFormSchema, setSourceFormSchema] = useState([]);
  const [selectedFields, setSelectedFields] = useState([]);
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [autoCheck, setAutoCheck] = useState(true);
  const [creatingFromExisting, setCreatingFromExisting] = useState(false);

  const [showNameModal, setShowNameModal] = useState(false);
  const [tempFormName, setTempFormName] = useState("");
  const [existingFormNames, setExistingFormNames] = useState([]);

  // 🟢 FORM LANGUAGE MODE STATE
  const [formLanguageMode, setFormLanguageMode] = useState('bilingual');

  // 🟢 ULB CLASS SELECTION STATE
  const [selectedULBClasses, setSelectedULBClasses] = useState([]);
  const [ulbList, setUlbList] = useState([]);
  const [filteredUlbs, setFilteredUlbs] = useState([]);
  const [selectedUlbs, setSelectedUlbs] = useState([]);
  const [loadingUlbs, setLoadingUlbs] = useState(false);
  const [targetKeys, setTargetKeys] = useState([]);
  const [selectedClassForPreview, setSelectedClassForPreview] = useState(null);

  // 🟢 APPROVAL SYSTEM STATES
  const [approvalStatus, setApprovalStatus] = useState('pending');
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectionReason, setRejectionReason] = useState('');
  const [reviewerNotes, setReviewerNotes] = useState('');
  const [formCreator, setFormCreator] = useState(null);
  const [formCreatedAt, setFormCreatedAt] = useState(null);
  const [reviewedBy, setReviewedBy] = useState(null);
  const [reviewedAt, setReviewedAt] = useState(null);
  // 🟢 FORM ICON UPLOAD STATES - हे state variables जोडा
const [formIcon, setFormIcon] = useState(null);
const [formIconUrl, setFormIconUrl] = useState('');
const [uploadingIcon, setUploadingIcon] = useState(false);
  // 🟢 ACCESS REPORT STATE
  const [reportConfig, setReportConfig] = useState({
    reportName: '',
    reportDescription: '',
    selectedFields: [],
    operations: {}
  });
// 🟢 SCHEDULE CONFIGURATION STATE - Updated with separate Quarterly and Half-Yearly values
const [scheduleConfig, setScheduleConfig] = useState({
  time: "09:00",
  weekday: "monday",
  date: 1,
  month: 1,
  everyNMonths: 3,
  quarterlyEveryNMonths: 3,
  halfYearlyEveryNMonths: 6,
  period: "this",
  dateFormat: "YYYY-MM-DD",
  monthlyDateFormat: "YYYY-MM",
  yearlyFormat: "YYYY",
  monthlySelectionType: "date",
  selectionType: "date",
  dayOfWeek: "monday",
  weekNumber: 1,
});
const handleScheduleChange = (newSchedule) => {
  console.log("🔄 Schedule changed in FormBuilderContent - INPUT:", JSON.stringify(newSchedule, null, 2));
  console.log("🔄 Current scheduleConfig before update:", JSON.stringify(scheduleConfig, null, 2));
  
  // ✅ Step 1: Merge नीट करा
  const mergedSchedule = {
    ...scheduleConfig,
    ...newSchedule
  };
  
  console.log("📦 Merged scheduleConfig:", JSON.stringify(mergedSchedule, null, 2));
  
  // ✅ Step 2: Local state update
  setScheduleConfig(mergedSchedule);
  
  // ✅ Step 3: Parent ला merged object पाठवा (फक्त newSchedule नाही)
  if (setScheduleConfig && typeof setScheduleConfig === 'function') {
    console.log("📤 Sending FULL merged schedule to parent:", JSON.stringify(mergedSchedule, null, 2));
    setScheduleConfig(mergedSchedule);
  }
};
  // 🟢 TABLE SEARCH MODAL STATE
  const [tableSearchVisible, setTableSearchVisible] = useState(false);
  const [dataSourceModalVisible, setDataSourceModalVisible] = useState(false);
  // 🟢 Popover visibility state
  const [dataSourcePopoverVisible, setDataSourcePopoverVisible] = useState(false);

  // 🟢 Use props for state
  const [entryType, setEntryType] = useState(propEntryType);
  const [enableFrequency, setEnableFrequency] = useState(propEnableFrequency);
  const [frequencyType, setFrequencyType] = useState(propFrequencyType);
  const [customFrequency, setCustomFrequency] = useState(propCustomFrequency);
  const [frequencyUnit, setFrequencyUnit] = useState(propFrequencyUnit);
  const [frequencyValue, setFrequencyValue] = useState(propFrequencyValue);
  const [maxEntriesPerUser, setMaxEntriesPerUser] = useState(propMaxEntriesPerUser);

  // 🟢 Sync with props when they change
  useEffect(() => {
    console.log('🔄 Syncing props to state:', {
      entryType: propEntryType,
      enableFrequency: propEnableFrequency,
      frequencyType: propFrequencyType
    });
    setEntryType(propEntryType);
    setEnableFrequency( propEnableFrequency);
    setFrequencyType(propFrequencyType);
    setCustomFrequency(propCustomFrequency);
    setFrequencyUnit(propFrequencyUnit);
    setFrequencyValue(propFrequencyValue);
    setMaxEntriesPerUser(propMaxEntriesPerUser);
  }, [
    propEntryType, 
    propEnableFrequency, 
    propFrequencyType,
    propCustomFrequency,
    propFrequencyUnit,
    propFrequencyValue,
    propMaxEntriesPerUser
  ]);

  // 🟢 Override local setter to also call parent setter if available
  const handleEntryTypeChange = (value) => {
    console.log('🟢 Changing entryType to:', value);
    setEntryType(value);
    if (propSetEntryType) {
      propSetEntryType(value);
    }
  };

  const handleEnableFrequencyChange = (value) => {
    setEnableFrequency(value);
    if (propSetEnableFrequency) {
      propSetEnableFrequency(value);
    }
  };

  const handleFrequencyTypeChange = (value) => {
    setFrequencyType(value);
    if (propSetFrequencyType) {
      propSetFrequencyType(value);
    }
  };

  const handleCustomFrequencyChange = (value) => {
    setCustomFrequency(value);
    if (propSetCustomFrequency) {
      propSetCustomFrequency(value);
    }
  };

  const handleFrequencyUnitChange = (value) => {
    setFrequencyUnit(value);
    if (propSetFrequencyUnit) {
      propSetFrequencyUnit(value);
    }
  };

  const handleFrequencyValueChange = (value) => {
    setFrequencyValue(value);
    if (propSetFrequencyValue) {
      propSetFrequencyValue(value);
    }
  };

  const handleMaxEntriesPerUserChange = (value) => {
    setMaxEntriesPerUser(value);
    if (propSetMaxEntriesPerUser) {
      propSetMaxEntriesPerUser(value);
    }
  };

  // 🟢 Track if this form is from existing data
  const isFromExistingRef = useRef(false);

  const {
    translateField,
    translateForm,
    translateTyping,
    translating,
    autoTranslate,
    setAutoTranslate
  } = useTranslation();

  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 5 } })
  );

  const STANDARD_WORKFLOWS = {
    DEFAULT: ["ULB", "DISTRICT_ADMIN", "DIVISIONAL_OFFICER", "DMA_DESK_OFFICER"],
  };

  // 🟢 Fetch ULB list from database
  useEffect(() => {
    const fetchUlbs = async () => {
      try {
        setLoadingUlbs(true);
        const response = await axios.get(`${API_BASE}/ulbs`);
        if (response.data?.data && response.data.data.length > 0) {
          console.log("Fetched ULBs:", response.data.data);
          setUlbList(response.data.data);
        } else {
          console.log("No ULBs found in database");
        }
      } catch (error) {
        console.error("Failed to fetch ULBs:", error);
      } finally {
        setLoadingUlbs(false);
      }
    };

    fetchUlbs();
  }, []);

  // 🟢 Filter ULBs based on selected classes
  useEffect(() => {
    if (selectedULBClasses.length === 0 || selectedULBClasses.includes('all')) {
      setFilteredUlbs(ulbList);
    } else {
      const filtered = ulbList.filter(ulb => selectedULBClasses.includes(ulb.class));
      setFilteredUlbs(filtered);
    }
  }, [selectedULBClasses, ulbList]);

  // 🟢 transferData useMemo - Dashboard style with full ULB info
  const transferData = useMemo(() => {
    console.log("📊 Creating transfer data from filtered ULBs:", filteredUlbs.length);
    
    return filteredUlbs.map(ulb => ({
      key: ulb.id.toString(),
      title: ulb.ulb_name,
      description: ulb.district_id ? `District ID: ${ulb.district_id}` : '',
      class: ulb.class,
      district_id: ulb.district_id || '',
      fullDescription: ulb.class ? `${ulb.class} - ${ulb.district_id || ''}` : `${ulb.district_id || ''}`,
      // Extra fields for future use
      ulb_type: ulb.ulb_type,
      year_of_establishment: ulb.year_of_establishment,
      census_code: ulb.census_code
    }));
  }, [filteredUlbs]);

  // 🟢 Handle class selection
  const handleClassSelection = (classValue) => {
    if (classValue === 'all') {
      setSelectedULBClasses(['all']);
    } else {
      const newSelection = selectedULBClasses.filter(c => c !== 'all');
      if (newSelection.includes(classValue)) {
        setSelectedULBClasses(newSelection.filter(c => c !== classValue));
      } else {
        setSelectedULBClasses([...newSelection, classValue]);
      }
    }
  };

  // 🟢 Fetch existing columns from database on component mount
  useEffect(() => {
    const fetchUlbs = async () => {
      try {
        setLoadingUlbs(true);
        const response = await axios.get(`${API_BASE}/ulbs`);
        if (response.data?.data && response.data.data.length > 0) {
          console.log("Fetched ULBs with classes:", response.data.data);
          // प्रत्येक ULB मध्ये 'class' property आहे का ते पाहा
          response.data.data.forEach(ulb => {
            console.log(`${ulb.ulb_name} - Class: ${ulb.class}`);
          });
          setUlbList(response.data.data);
        } else {
          console.log("No ULBs found in database");
        }
      } catch (error) {
        console.error("Failed to fetch ULBs:", error);
      } finally {
        setLoadingUlbs(false);
      }
    };
    fetchUlbs();
  }, []);

  useEffect(() => {
    const fetchFormNames = async () => {
      try {
        const res = await axios.get(`${API_BASE}/forms`);
        const forms = res.data?.data || [];
        setExistingFormNames(forms.map(f => f.form_name?.toLowerCase().trim()));
      } catch (error) {
        console.error("Failed to fetch form names:", error);
      }
    };

    fetchFormNames();
  }, []);

 
useEffect(() => {
  console.log("📍 FormBuilderContent location.state:", location.state);


  if (location.state?.mode === "edit" && location.state?.formData) {
    console.log("✅ EDIT MODE - Loading form data from state");
    const { formData, formId } = location.state;
    
    console.log("📦 Edit formData:", formData);
    
    // Form name set करा
    if (formData.form_name) {
      setFormName(formData.form_name);
    }
    
    if (formData.schema) {
      console.log("📋 Raw schema:", formData.schema);
      
      let schema = formData.schema;
      
      // जर schema string असेल तर parse करा
      if (typeof schema === 'string') {
        try {
          schema = JSON.parse(schema);
          console.log("📋 Parsed schema from string:", schema);
        } catch (e) {
          console.error("Schema parse error:", e);
          schema = [];
        }
      }
      
      if (Array.isArray(schema)) {
        console.log(`✅ Setting ${schema.length} fields in form builder`);
        setNodes(schema);
        
        if (schema.length > 0) {
          console.log("📋 First field:", schema[0]);
        }
      } else {
        console.warn("⚠️ Schema is not an array:", schema);
        setNodes([]);
      }
    } else {
      console.warn("⚠️ No schema in formData");
      setNodes([]);
    }
    
    // Form ID set करा
    if (formId) {
      setSelectedFormId(formId);
    } else if (formData.id) {
      setSelectedFormId(formData.id);
    }
    
    // ✅ IMPORTANT: हे flag set करा जेणेकरून name modal दिसणार नाही
    isFromExistingRef.current = true;
    
    // ==================== 🔥 CRITICAL FIX: Load permissions from access_control ====================
    console.log("🔐 Edit mode - Checking permissions:");
    console.log("   - formData.access_control:", formData.access_control);
    console.log("   - formData.permissions:", formData.permissions);
    
    // Load permissions from access_control column first (this is where FormAccessControl stores data)
    if (formData.access_control && typeof formData.access_control === 'object' && Object.keys(formData.access_control).length > 0) {
      console.log("✅ Edit mode - Loading permissions from access_control column:", formData.access_control);
      // 👇 CRITICAL: Force a new object reference to trigger re-render in FormAccessControl
      setPermissions({ ...formData.access_control });
    } 
    // Fallback to permissions column if access_control is empty
    else if (formData.permissions && typeof formData.permissions === 'object' && Object.keys(formData.permissions).length > 0) {
      console.log("✅ Edit mode - Loading permissions from permissions column:", formData.permissions);
      // 👇 CRITICAL: Force a new object reference to trigger re-render in FormAccessControl
      setPermissions({ ...formData.permissions });
    } 
    // Initialize empty permissions if none exist
    else {
      console.log("⚠️ Edit mode - No permissions found, initializing empty");
      setPermissions({});
    }
    // ===============================================================================================
    
    // Workflow set करा
    if (formData.workflow) {
      setWorkflow(formData.workflow);
      setWorkflowType(formData.workflow.type || "standard");
      setCustomWorkflow(formData.workflow.sequence || []);
    }
    
    // SLA set करा
    if (formData.sla) {
      setSla(formData.sla);
    }
    
    // Language set करा
    if (formData.language) {
      setLanguage(formData.language);
    }
    
    // Entry type set करा
    if (formData.entry_type) {
      setEntryType(formData.entry_type);
    }
    
    // Form language mode set करा
    if (formData.form_language_mode) {
      setFormLanguageMode(formData.form_language_mode);
    }
    
    // Approval status set करा
    if (formData.approval_status) {
      setApprovalStatus(formData.approval_status);
    }
    
    // Report config set करा
    if (formData.report_config) {
      setReportConfig(formData.report_config);
    }
    
    // ULB classes set करा
    if (formData.selected_ulb_classes) {
      setSelectedULBClasses(formData.selected_ulb_classes);
    }
    if (formData.selected_ulbs) {
      setSelectedUlbs(formData.selected_ulbs);
      setTargetKeys(formData.selected_ulbs.map(id => id.toString()));
    }
    
    // message.success(`Editing form: ${formData.form_name}`);
  }
  
  // Existing form from copy mode
  else if (location.state?.mode === "existing" && location.state?.formData) {
    isFromExistingRef.current = true;
    console.log("✅ Form is from existing data - will NOT show name modal");

    if (location.state.formData) {
      setFormName(location.state.formData.form_name || formName);
      if (location.state.formData.schema && location.state.formData.schema.length > 0) {
        console.log("Setting nodes from existing form data");
        setNodes(location.state.formData.schema);
      }
      if (location.state.formId) {
        setSelectedFormId(location.state.formId);
      }
      if (location.state.formData.approval_status) {
        setApprovalStatus(location.state.formData.approval_status);
      }
      if (location.state.formData.created_by) {
        setFormCreator(location.state.formData.created_by);
      }
      if (location.state.formData.created_at) {
        setFormCreatedAt(location.state.formData.created_at);
      }
      if (location.state.formData.form_language_mode) {
        setFormLanguageMode(location.state.formData.form_language_mode);
      }
      if (location.state.formData.selected_ulb_classes) {
        setSelectedULBClasses(location.state.formData.selected_ulb_classes);
      }
      if (location.state.formData.selected_ulbs) {
        setSelectedUlbs(location.state.formData.selected_ulbs);
        setTargetKeys(location.state.formData.selected_ulbs.map(id => id.toString()));
      }
      
      // Load permissions for existing/copy mode as well
      if (location.state.formData.access_control && typeof location.state.formData.access_control === 'object' && Object.keys(location.state.formData.access_control).length > 0) {
        console.log("✅ Existing mode - Loading permissions from access_control:", location.state.formData.access_control);
        // 👇 CRITICAL: Force a new object reference to trigger re-render
        setPermissions({ ...location.state.formData.access_control });
      } else if (location.state.formData.permissions && typeof location.state.formData.permissions === 'object' && Object.keys(location.state.formData.permissions).length > 0) {
        console.log("✅ Existing mode - Loading permissions from permissions column:", location.state.formData.permissions);
        // 👇 CRITICAL: Force a new object reference to trigger re-render
        setPermissions({ ...location.state.formData.permissions });
      }
    }
  } 
  
  // New blank form
  else if (location.state?.mode === "new") {
    isFromExistingRef.current = false;
    console.log("❌ Form is blank - will show name modal");
    
    // Reset all states for new form
    setFormName("Untitled Form");
    setNodes([]);
    setSelectedFormId(null);
    setPermissions({});
    setWorkflow({ type: "none", sequence: [] });
    setSla({});
    setEntryType("single");
    setEnableFrequency(false);
    setFrequencyType(null);
    setFormLanguageMode('bilingual');
    setSelectedULBClasses([]);
    setSelectedUlbs([]);
    setTargetKeys([]);
    setApprovalStatus('pending');
    setReportConfig({
      reportName: '',
      reportDescription: '',
      selectedFields: [],
      operations: {}
    });
  }
}, [location.state]);

  // 🟢 Only show name modal for BLANK forms (not from existing)
  useEffect(() => {
    if (nodes.length === 0 && !selectedFormId && !isFromExistingRef.current) {
      console.log("🟢 SHOWING name modal for blank form");
      setShowNameModal(true);
    } else if (nodes.length === 0 && !selectedFormId && isFromExistingRef.current) {
      console.log("🔵 SKIPPING name modal - form from existing data");
    } else if (nodes.length > 0) {
      console.log("🟠 Form already has fields - not showing name modal");
    }
  }, [nodes.length, selectedFormId]);

  useEffect(() => {
    if (location.state?.mode === "existing" && location.state?.selectedColumnObjects) {
      setExistingColumns(location.state.selectedColumnObjects);
      setShowExistingPalette(true);
      setIsExistingMode(true);

      const newFields = location.state.selectedColumnObjects.map(column =>
        createField(column.type, column)
      );
      setNodes(newFields);
      // message.success(`Created ${newFields.length} fields from existing form columns`);
    }
  }, [location.state, setNodes, setExistingColumns, setShowExistingPalette]);

  const isFormNameExists = (name) => {
    if (!name) return false;
    const normalizedName = name.toLowerCase().trim();
    return existingFormNames.includes(normalizedName);
  };
// ✅ CORRECT VERSION - Store as base64 string
const handleIconUpload = (file) => {
  const isPNG = file.type === 'image/png';
  const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg';
  
  if (!isPNG && !isJPG) {
    message.error('Only PNG, JPG or JPEG files allowed');
    return false;
  }
  
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error('Image must be smaller than 2MB');
    return false;
  }
  
  const reader = new FileReader();
  reader.onload = (e) => {
    const base64String = e.target.result; // This is a string
    setFormIconUrl(base64String);
    setFormIcon(base64String); // ✅ Store as string, not File object
  };
  reader.readAsDataURL(file);
  
  // message.success('Icon selected successfully!');
  return false;
};

// ✅ Remove icon function
const handleRemoveIcon = () => {
  setFormIcon(null);
  setFormIconUrl('');
  message.info(language === 'english'
    ? 'Icon removed'
    : 'आयकॉन काढला');
};

// ✅ Handle name submit with icon
const handleNameSubmitWithIcon = async () => {
  if (!tempFormName.trim()) {
    // message.warning("Please enter a form name");
    return;
  }

  if (isFormNameExists(tempFormName)) {
    message.error("Form name already exists");
    return;
  }

  setFormName(tempFormName);
  
  // ✅ Check if formIcon is a string (base64)
  if (formIcon && typeof formIcon === 'string' && formIcon.startsWith('data:image')) {
    setUploadingIcon(true);
    try {
      const response = await axios.post(`${API_BASE}/forms/upload-icon`, {
        icon_base64: formIcon,
        form_name: tempFormName
      });
      
      if (response.data?.success) {
        // message.success(`Form "${tempFormName}" created with icon!`);
        if (response.data.data?.icon_url) {
          setFormIconUrl(response.data.data.icon_url);
        }
      }
    } catch (error) {
      console.error('Icon upload failed:', error);
      // message.warning('Form created but icon upload failed');
    } finally {
      setUploadingIcon(false);
    }
  } else {
    // message.success(`Form name set to: ${tempFormName}`);
  }
  
  setShowNameModal(false);
  setTempFormName('');
};
  const handleNameSubmit = () => {
    if (!tempFormName.trim()) {
      message.warning(language === 'english' ? "Please enter a form name" : "कृपया फॉर्मचे नाव प्रविष्ट करा");
      return;
    }

    if (isFormNameExists(tempFormName)) {
      message.error(language === 'english'
        ? "A form with this name already exists. Please choose a different name."
        : "या नावाचा फॉर्म आधीपासून अस्तित्वात आहे. कृपया वेगळे नाव निवडा.");
      return;
    }

    setFormName(tempFormName);
    setShowNameModal(false);
    message.success(language === 'english'
      ? `Form name set to: ${tempFormName}`
      : `फॉर्मचे नाव सेट केले: ${tempFormName}`);
  };

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        setLoadingRoles(true);
        const res = await axios.get(`${API_BASE}/roles`);
        console.log("Fetched roles:", res.data?.data);
        const rolesData = (res.data?.data || []).map(role => ({
          ...role,
          name: role.name || role.roles || ''
        }));
        setRoles(rolesData);
      } catch (e) {
        // message.error("Failed to load roles");
      } finally {
        setLoadingRoles(false);
      }
    };

    fetchRoles();
  }, []);

  const fetchAvailableForms = async () => {
    try {
      setLoadingForms(true);
      const res = await axios.get(`${API_BASE}/forms`);
      setAvailableForms(res.data?.data || []);
    } catch (error) {
      // message.error("Failed to load forms");
    } finally {
      setLoadingForms(false);
    }
  };

  const loadSourceFormSchema = async (formId) => {
    try {
      setLoadingForms(true);
      const res = await axios.get(`${API_BASE}/forms/${formId}`);
      const formData = res.data?.data;

      if (formData) {
        setSelectedSourceForm({
          id: formData.id,
          name: formData.form_name
        });
        setSourceFormSchema(formData.schema || []);

        const allIds = [];
        const collectIds = (nodes) => {
          nodes.forEach(node => {
            allIds.push(node.id);
            if (node.children) {
              if (Array.isArray(node.children)) {
                collectIds(node.children);
              } else {
                if (node.children.left) collectIds(node.children.left);
                if (node.children.right) collectIds(node.children.right);
              }
            }
            if (node.subFields) {
              collectIds(node.subFields);
            }
          });
        };
        collectIds(formData.schema || []);
        setExpandedKeys(allIds);
      }
    } catch (error) {
      // message.error("Failed to load form schema");
    } finally {
      setLoadingForms(false);
    }
  };

  const handleTranslateField = async (field) => {
    const updatedField = await translateField(field);
    if (updatedField) {
      updateField(updatedField);
    }
  };

  const handleTranslateForm = async () => {
    const rootFields = nodes.filter(f => !f.parentId);
    const updatedFields = await translateForm(rootFields);

    if (updatedFields && updatedFields.length > 0) {
      const allTranslatedFields = [];
      updatedFields.forEach(field => {
        allTranslatedFields.push(field);
        const subFields = nodes.filter(f => f.parentId === field.id);
        allTranslatedFields.push(...subFields);
      });

      setNodes(allTranslatedFields);
    }
  };

  const addField = (type) => {
    console.log("FormBuilderContent addField called with type:", type);

    if (onAddField) {
      console.log("Using onAddField prop from FormBuilderMain");
      onAddField(type);
    } else {
      console.log("Using local addField implementation");
      const newField = createField(type);
      setNodes([...nodes, newField]);
      // message.success(`Added ${type} field`);
    }
  };

  const addExistingColumn = (column) => {
    const newField = createField(column.type, column);
    setNodes([...nodes, newField]);
    // message.success(`Added "${column.label}" to form`);
  };

  const updateField = (updatedField) => {
    setNodes(updateNodeInList(nodes, updatedField.id, () => updatedField));
  };

  const addSubField = (newField) => {
  console.log(`  Adding sub-field to state:`, {
    id: newField.id,
    type: newField.type,
    parentId: newField.parentId
  });
  
  // ✅ Make sure parentId is preserved
  setNodes([...nodes, newField]);
};

  const updateSubField = (subFieldId, updatedData) => {
    setNodes(updateNodeInList(nodes, subFieldId, () => updatedData));
  };

  const deleteSubField = (subFieldId) => {
    setNodes(deleteNodeFromList(nodes, subFieldId));
  };

  const deleteField = (fieldId) => {
    const subFieldIds = nodes.filter(f => f.parentId === fieldId).map(f => f.id);
    setNodes(nodes.filter(item => !subFieldIds.includes(item.id) && item.id !== fieldId));
  };

  const copyField = (field) => {
    const newField = {
      ...JSON.parse(JSON.stringify(field)),
      id: uid(),
      enLabel: `${field.enLabel || field.label} (Copy)`,
      mrLabel: `${field.mrLabel || field.label} (Copy)`,
      label: `${field.label || field.enLabel} (Copy)`,
    };

    if (field.type === "radio") {
      const subFields = nodes.filter(f => f.parentId === field.id);
      const newSubFields = subFields.map(subField => ({
        ...subField,
        id: uid(),
        enLabel: `${subField.enLabel || subField.label} (Copy)`,
        mrLabel: `${subField.mrLabel || subField.label} (Copy)`,
        label: `${subField.label || subField.enLabel} (Copy)`,
        parentId: newField.id,
        colName: subField.colName
      }));

      setNodes([...nodes, newField, ...newSubFields]);
    } else if (field.type === "comparison") {
      const newComparisonField = {
        ...newField,
        mainField: {
          ...field.mainField,
          id: uid()
        },
        subFields: field.subFields.map(sf => ({
          ...sf,
          id: uid()
        }))
      };
      setNodes([...nodes, newComparisonField]);
    } 
    else if (field.type === "arithmetic") {
      const newArithmeticField = {
        ...newField,
        arithmeticFields: field.arithmeticFields.map(af => ({
          ...af,
          id: uid()
        })),
        resultField: field.resultField ? {
          ...field.resultField,
          id: uid()
        } : null
      };
      setNodes([...nodes, newArithmeticField]);
    } else if (field.type === "file") {
      const newFileField = {
        ...newField,
        acceptedFileTypes: field.acceptedFileTypes,
        maxFileSize: field.maxFileSize,
        maxFileCount: field.maxFileCount,
        fileList: []
      };
      setNodes([...nodes, newFileField]);
    } else if (field.type === "heading") {
      // Copy heading with its children
      const childFields = nodes.filter(f => f.parentId === field.id);
      const newChildFields = childFields.map(child => ({
        ...child,
        id: uid(),
        parentId: newField.id,
        enLabel: `${child.enLabel || child.label} (Copy)`,
        mrLabel: `${child.mrLabel || child.label} (Copy)`,
        label: `${child.label || child.enLabel} (Copy)`,
      }));
      setNodes([...nodes, newField, ...newChildFields]);
    } else {
      setNodes([...nodes, newField]);
    }
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;
    setActiveDragId(null);

    if (over && active.id !== over.id) {
      const oldIndex = nodes.findIndex(n => n.id === active.id);
      const newIndex = nodes.findIndex(n => n.id === over.id);
      const reorderedNodes = arrayMove(nodes, oldIndex, newIndex);

      const updatedNodes = reorderedNodes.map((node, index) => ({
        ...node,
        position: index
      }));

      setNodes(updatedNodes);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const columnData = e.dataTransfer.getData("text/plain");
    if (columnData) {
      try {
        const column = JSON.parse(columnData);
        addExistingColumn(column);
      } catch (error) {
        console.error("Failed to parse dropped column:", error);
      }
    }
  };

  const activeNode = useMemo(
    () => nodes.find(n => n.id === activeDragId),
    [activeDragId, nodes]
  );

  const handlePermissionChange = (roleId, value) => {
    setPermissions({
      ...permissions,
      [roleId]: {
        can_access: value,
        can_view: value,
        can_edit: value,
        can_submit: value,
      }
    });
  };

  const getRoleColor = (roleId) => {
    const colors = ["#52c41a", "#1890ff", "#fa8c16", "#eb2f96", "#722ed1"];
    const index = typeof roleId === 'number' ? roleId : parseInt(roleId) || 0;
    return colors[index % colors.length];
  };

  const getWorkflowRoles = () => {
    if (!roles || roles.length === 0) return [];

    if (workflowType === "standard") {
      return roles.filter(role =>
        STANDARD_WORKFLOWS.DEFAULT.includes(role.name)
      );
    } else {
      return roles.filter(role => {
        if (customWorkflow.includes(role.id)) return true;
        if (customWorkflow.includes(role.name)) return true;
        if (customWorkflow.includes(role.id.toString())) return true;
        return false;
      });
    }
  };

  const handleSlaChange = (roleId, field, value) => {
  console.log(`Updating SLA for role ${roleId}: ${field} = ${value}`);
  
  const updatedSla = {
    ...sla,
    [roleId]: {
      ...(sla[roleId] || {}),
      [field]: value
    }
  };
  setSla(updatedSla);
};

  const handleWorkflowChange = (type, sequence) => {
    setWorkflowType(type);
    setCustomWorkflow(sequence);
    setWorkflow({
      type,
      sequence: type === "standard" ? STANDARD_WORKFLOWS.DEFAULT : sequence
    });
  };

  const loadFormById = async (id) => {
  try {
    const res = await axios.get(`${API_BASE}/forms/${id}`);
    const data = res.data?.data;

    if (data) {
      console.log("Loaded form data:", data);
      
      setFormName(data.form_name || "");
      let schema = data.schema || [];
      let overallReportConfig = {
        reportName: '',
        reportDescription: '',
        selectedFields: [],
        operations: {}
      };
      const reportFieldIndex = schema.findIndex(f => f.id === 'form_report_config' || f.type === 'system_report');
      if (reportFieldIndex !== -1) {
        overallReportConfig = schema[reportFieldIndex].reportConfig || overallReportConfig;
        schema = schema.filter((_, index) => index !== reportFieldIndex);
      }
      
      setNodes(schema);
      setReportConfig(overallReportConfig); 
      
      setSelectedFormId(data.id);
      setOriginalFormData({
        schema: data.schema || [],
        workflow: data.workflow || {},
        sla: data.sla || {},
      });

      // ==================== 🔥 CRITICAL: LOAD PERMISSIONS FROM ACCESS_CONTROL ====================
      console.log("🔐 Raw permissions from API:", {
        access_control: data.access_control,
        permissions: data.permissions
      });
      
      // Load permissions from access_control column (this is where FormAccessControl stores data)
      if (data.access_control && typeof data.access_control === 'object' && Object.keys(data.access_control).length > 0) {
        console.log("✅ Loading permissions from access_control column:", data.access_control);
        setPermissions(data.access_control);
      } 
      // Fallback to permissions column if access_control is empty
      else if (data.permissions && typeof data.permissions === 'object' && Object.keys(data.permissions).length > 0) {
        console.log("✅ Loading permissions from permissions column:", data.permissions);
        setPermissions(data.permissions);
      } 
      // Initialize empty permissions if none exist
      else {
        console.log("⚠️ No permissions found in form data, initializing empty permissions");
        setPermissions({});
      }
      
      // Also load access_control separately for debugging
      if (data.access_control) {
        console.log("📋 Access Control data available:", Object.keys(data.access_control));
      }
      // ========================================================================================

      // 🟢 Load form language mode
      if (data.form_language_mode) {
        setFormLanguageMode(data.form_language_mode);
      }

      // 🟢 Load ULB class selection
      if (data.selected_ulb_classes) {
        setSelectedULBClasses(data.selected_ulb_classes);
      }
      if (data.selected_ulbs) {
        setSelectedUlbs(data.selected_ulbs);
        setTargetKeys(data.selected_ulbs.map(id => id.toString()));
      }

      // 🟢 Load approval status
      if (data.approval_status) {
        setApprovalStatus(data.approval_status);
      }
      if (data.created_by) {
        setFormCreator(data.created_by);
      }
      if (data.created_at) {
        setFormCreatedAt(data.created_at);
      }
      if (data.reviewed_by) {
        setReviewedBy(data.reviewed_by);
      }
      if (data.reviewed_at) {
        setReviewedAt(data.reviewed_at);
      }

      // 🟢 Load entry type
      const loadedEntryType = data.entry_type || "single";
      handleEntryTypeChange(loadedEntryType);

      // 🟢 Load frequency settings
      if (data.frequency) {
        console.log("Loading frequency data:", data.frequency);
        handleEnableFrequencyChange(data.frequency.enabled || false);
        
        if (data.frequency.enabled) {
          handleFrequencyTypeChange(data.frequency.type || null);
          handleCustomFrequencyChange(data.frequency.custom || "");
          handleFrequencyUnitChange(data.frequency.unit || "days");
          handleFrequencyValueChange(data.frequency.value || 1);
        } else {
          handleFrequencyTypeChange(null);
          handleCustomFrequencyChange("");
          handleFrequencyUnitChange("days");
          handleFrequencyValueChange(1);
        }
      } else {
        console.log("No frequency data found, using defaults");
        handleEnableFrequencyChange(false);
        handleFrequencyTypeChange(null);
        handleCustomFrequencyChange("");
        handleFrequencyUnitChange("days");
        handleFrequencyValueChange(1);
      }

      // 🟢 Load max entries per user
      if (data.max_entries_per_user !== undefined) {
        handleMaxEntriesPerUserChange(data.max_entries_per_user);
      }

      // Log final permissions state for debugging
      console.log("🔐 Final permissions state after load:", Object.keys(permissions));
      
      // message.success(`Loaded: ${data.form_name || 'Form ' + data.id}`);
    }
  } catch (error) {
    console.error("Error loading form:", error);
    // message.error("Failed to load form");
  }
};

  const createFormFromExisting = async () => {
  if (!selectedSourceForm) {
    message.warning("Please select a source form");
    return;
  }

  if (selectedFields.length === 0) {
    message.warning("Please select at least one field to include");
    return;
  }

  try {
    setCreatingFromExisting(true);

    const selectedFieldObjects = [];

    const collectSelectedFields = (nodes) => {
      nodes.forEach(node => {
        if (selectedFields.includes(node.id)) {
          selectedFieldObjects.push(node);
          console.log(`Selected field: ${node.id} (${node.type}) - ${node.enLabel}`);
        }
        if (node.children) {
          if (Array.isArray(node.children)) {
            collectSelectedFields(node.children);
          } else {
            if (node.children.left) collectSelectedFields(node.children.left);
            if (node.children.right) collectSelectedFields(node.children.right);
          }
        }
        if (node.subFields) {
          collectSelectedFields(node.subFields);
        }
      });
    };

    collectSelectedFields(sourceFormSchema);

    console.log("Selected field objects:", selectedFieldObjects.map(f => ({ id: f.id, label: f.enLabel })));
    console.log("Selected field IDs:", selectedFields);

    const newFormName = prompt(
      language === 'english'
        ? `Enter name for new form (based on "${selectedSourceForm.name}"):`
        : `नवीन फॉर्मसाठी नाव प्रविष्ट करा ("${selectedSourceForm.name}" वर आधारित):`,
      `${selectedSourceForm.name} (Copy)`
    );

    if (!newFormName) {
      setCreatingFromExisting(false);
      return;
    }

    if (existingFormNames.includes(newFormName.toLowerCase().trim())) {
      message.error(language === 'english'
        ? "A form with this name already exists. Please choose a different name."
        : "या नावाचा फॉर्म आधीपासून अस्तित्वात आहे. कृपया वेगळे नाव निवडा.");
      setCreatingFromExisting(false);
      return;
    }

    const response = await axios.post(`${API_BASE}/forms/from-existing`, {
      form_name: newFormName,
      linked_form_id: selectedSourceForm.id,
      selected_fields: selectedFields,
      schema: selectedFieldObjects,  
      language: language,
      form_language_mode: formLanguageMode,
      selected_ulb_classes: selectedULBClasses,
      selected_ulbs: targetKeys.map(key => parseInt(key)),
      entry_type: entryType,
      frequency: enableFrequency ? {
        enabled: true,
        type: frequencyType,
        custom: customFrequency,
        unit: frequencyUnit,
        value: frequencyValue
      } : { enabled: false },
      max_entries_per_user: maxEntriesPerUser,
      created_by: currentUser?.id,
      created_by_name: currentUser?.name
    });

    console.log("Create form response:", response.data);

    if (response.data?.data) {
      // message.success(`Form "${newFormName}" created successfully and submitted for approval!`);

      const formsRes = await axios.get(`${API_BASE}/forms`);
      setAvailableForms(formsRes.data?.data || []);

      setExistingFormNames(prev => [...prev, newFormName.toLowerCase().trim()]);

      setShowExistingFormSelector(false);
      setSelectedSourceForm(null);
      setSourceFormSchema([]);
      setSelectedFields([]);

      if (response.data.data.id) {
        loadFormById(response.data.data.id);
      }
    }
  } catch (error) {
    console.error("Error creating form from existing:", error);
    message.error("Failed to create form: " + (error.response?.data?.error || error.message));
  } finally {
    setCreatingFromExisting(false);
  }
};

  // ✅ NEW: Handle field level report config changes
  const handleFieldReportConfigChange = (fieldId, reportConfig) => {
    const updatedNodes = nodes.map(node => {
      if (node.id === fieldId) {
        return {
          ...node,
          reportConfig: {
            ...(node.reportConfig || {}),
            ...reportConfig
          }
        };
      }
      return node;
    });
    setNodes(updatedNodes);
  };

  // 🟢 Handle importing columns from table search
  // 🟢 Handle importing columns from table search with existing submission data
// 🟢 Handle importing columns from table search - WITH CORRECT FORM NAME
// 🟢 Handle importing columns from table search - WITH CORRECT SOURCE TABLE INFO
// 🟢 Handle importing columns from table search - SUPPORTS MULTIPLE TABLES
const handleImportColumns = async (columns) => {
  console.log("📥 Importing columns from table:", columns);
  
  if (!columns || columns.length === 0) return;
  
  const userId = currentUser?.id;
  
  // Group columns by their source table
  const columnsByTable = {};
  columns.forEach(column => {
    const tableName = column.table_name;
    if (!columnsByTable[tableName]) {
      columnsByTable[tableName] = [];
    }
    columnsByTable[tableName].push(column);
  });
  
  console.log(`📊 Columns grouped by ${Object.keys(columnsByTable).length} tables:`, Object.keys(columnsByTable));
  
  let allNewFields = [];
  
  // Process each table's columns separately
  for (const [sourceTableName, tableColumns] of Object.entries(columnsByTable)) {
    let sourceFormId = null;
    let sourceFormName = null;
    let existingSubmissionData = {};
    let existingDataByColumn = {};
    
    // Extract source form ID from table name
    const formIdMatch = sourceTableName.match(/form_submissions_(\d+)/);
    if (formIdMatch) {
      sourceFormId = formIdMatch[1];
      console.log(`🔍 Extracted sourceFormId: ${sourceFormId} from table: ${sourceTableName}`);
      
      // Fetch the actual form name from forms table
      try {
        const token = sessionStorage.getItem('token');
        const response = await axios.get(`${API_BASE}/forms/${sourceFormId}`, {
          headers: token ? { 'Authorization': `Bearer ${token}` } : {}
        });
        
        if (response.data?.data && response.data.data.form_name) {
          sourceFormName = response.data.data.form_name;
          console.log(`✅✅✅ Found source form name: "${sourceFormName}" (ID: ${sourceFormId})`);
        } else {
          sourceFormName = sourceTableName.replace('form_submissions_', 'Form ');
        }
      } catch (error) {
        console.error('❌ Failed to fetch source form name:', error);
        sourceFormName = sourceTableName.replace('form_submissions_', 'Form ');
      }
    } else {
      sourceFormName = sourceTableName.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
    }
    
    // Fetch existing submission data for this specific table
    if (sourceTableName && userId && sourceFormId) {
      try {
        const token = sessionStorage.getItem('token');
        const response = await fetch(`${API_BASE}/form-submissions/${sourceFormId}/${userId}`, {
          headers: token ? { 'Authorization': `Bearer ${token}` } : {}
        });
        const result = await response.json();
        
        if (result?.data) {
          existingSubmissionData = result.data;
          
          if (result.column_mapping) {
            for (const [fieldId, colName] of Object.entries(result.column_mapping)) {
              if (existingSubmissionData[fieldId] !== undefined) {
                existingDataByColumn[colName] = existingSubmissionData[fieldId];
              }
            }
          }
          
          Object.keys(existingSubmissionData).forEach(key => {
            existingDataByColumn[key] = existingSubmissionData[key];
          });
        }
      } catch (error) {
        console.log(`⚠️ Could not fetch existing submission data for ${sourceTableName}:`, error);
      }
    }
    
    // Create fields for this table's columns
    const newFields = tableColumns.map(column => {
      const actualColumnName = column.column_name || column.name;
      const newField = createField(column.field_type, null, null, actualColumnName);
      
      // Set source information
      newField.sourceTable = sourceTableName;
      newField.sourceColumn = actualColumnName;
      newField.sourceFormId = sourceFormId;
      newField.sourceFormName = sourceFormName;
      newField.sourceColumnLabel = column.en_label || column.column_name;
      newField.fromExisting = true;
      
      // Set labels with table name prefix to avoid confusion
      if (Object.keys(columnsByTable).length > 1) {
        // If multiple tables, add table name prefix to label
        newField.enLabel = `[${sourceFormName}] ${column.en_label || column.column_name}`;
        newField.mrLabel = `[${sourceFormName}] ${column.mr_label || column.column_name}`;
      } else {
        newField.enLabel = column.en_label || column.column_name;
        newField.mrLabel = column.mr_label || column.column_name;
      }
      newField.label = newField.enLabel;
      
      // Store existing value if available
      let existingValue = null;
      
      if (existingDataByColumn[actualColumnName] !== undefined && 
          existingDataByColumn[actualColumnName] !== null && 
          existingDataByColumn[actualColumnName] !== '') {
        existingValue = existingDataByColumn[actualColumnName];
      } else if (existingDataByColumn[column.en_label] !== undefined) {
        existingValue = existingDataByColumn[column.en_label];
      }
      
      if (existingValue !== null && existingValue !== undefined && existingValue !== '') {
        newField.importedExistingValue = existingValue;
        newField.defaultValue = existingValue;
        console.log(`💾 Stored existing value for field ${newField.id}: ${existingValue}`);
      }
      
      console.log(`✅ Created field from "${sourceFormName}": ${newField.enLabel}`);
      return newField;
    });
    
    allNewFields = [...allNewFields, ...newFields];
  }
  
  setNodes([...nodes, ...allNewFields]);
  
  const importedWithValues = allNewFields.filter(f => f.importedExistingValue).length;
  const tableCount = Object.keys(columnsByTable).length;
  
  if (tableCount > 1) {
    // message.success(`Imported ${allNewFields.length} columns from ${tableCount} different tables (${importedWithValues} with existing values)`);
  } else {
    const formNameDisplay = Object.keys(columnsByTable)[0]?.replace('form_submissions_', 'Form ') || 'database';
    // message.success(`Imported ${allNewFields.length} columns from "${formNameDisplay}" (${importedWithValues} with existing values)`);
  }
};
const handleSaveWithFrequency = async () => {
  // Validate form name
  if (!formName || formName.trim() === '') {
    message.error(language === 'english' 
      ? "Please enter a form name" 
      : "कृपया फॉर्मचे नाव प्रविष्ट करा");
    return;
  }

  // ✅ DYNAMIC schedule object - ONLY relevant fields based on frequency type
  const scheduleObject = {};
  
  // ==================== DAILY SCHEDULE ====================
  if (frequencyType === 'daily') {
    if (scheduleConfig.time) scheduleObject.time = scheduleConfig.time;
    if (scheduleConfig.period) scheduleObject.period = scheduleConfig.period;
    if (scheduleConfig.dateFormat) scheduleObject.dateFormat = scheduleConfig.dateFormat;
  }
  
  // ==================== WEEKLY SCHEDULE ====================
  else if (frequencyType === 'weekly') {
    if (scheduleConfig.weekday) scheduleObject.weekday = scheduleConfig.weekday;
    if (scheduleConfig.time) scheduleObject.time = scheduleConfig.time;
    if (scheduleConfig.period) scheduleObject.period = scheduleConfig.period;
    if (scheduleConfig.dateFormat) scheduleObject.dateFormat = scheduleConfig.dateFormat;
  }
  
  // ==================== MONTHLY SCHEDULE ====================
  else if (frequencyType === 'monthly') {
    if (scheduleConfig.monthlySelectionType) scheduleObject.monthlySelectionType = scheduleConfig.monthlySelectionType;
    
    if (scheduleConfig.monthlySelectionType === 'date' && scheduleConfig.date) {
      scheduleObject.date = scheduleConfig.date;
    }
    if (scheduleConfig.monthlySelectionType === 'day') {
      if (scheduleConfig.dayOfWeek) scheduleObject.dayOfWeek = scheduleConfig.dayOfWeek;
      if (scheduleConfig.weekNumber) scheduleObject.weekNumber = scheduleConfig.weekNumber;
    }
    
    if (scheduleConfig.time) scheduleObject.time = scheduleConfig.time;
    if (scheduleConfig.period) scheduleObject.period = scheduleConfig.period;
    if (scheduleConfig.monthlyDateFormat) scheduleObject.monthlyDateFormat = scheduleConfig.monthlyDateFormat;
  }
  
  // ==================== QUARTERLY SCHEDULE ====================
  else if (frequencyType === 'quarterly') {
    if (scheduleConfig.selectionType) scheduleObject.selectionType = scheduleConfig.selectionType;
    
    if (scheduleConfig.selectionType === 'date' && scheduleConfig.date) {
      scheduleObject.date = scheduleConfig.date;
    }
    if (scheduleConfig.selectionType === 'day') {
      if (scheduleConfig.dayOfWeek) scheduleObject.dayOfWeek = scheduleConfig.dayOfWeek;
      if (scheduleConfig.weekNumber) scheduleObject.weekNumber = scheduleConfig.weekNumber;
    }
    
    if (scheduleConfig.quarterlyEveryNMonths) scheduleObject.quarterlyEveryNMonths = scheduleConfig.quarterlyEveryNMonths;
    if (scheduleConfig.time) scheduleObject.time = scheduleConfig.time;
    if (scheduleConfig.period) scheduleObject.period = scheduleConfig.period;
    if (scheduleConfig.monthlyDateFormat) scheduleObject.monthlyDateFormat = scheduleConfig.monthlyDateFormat;
  }
  
  // ==================== HALF-YEARLY SCHEDULE ====================
  else if (frequencyType === 'half_yearly') {
    if (scheduleConfig.selectionType) scheduleObject.selectionType = scheduleConfig.selectionType;
    
    if (scheduleConfig.selectionType === 'date' && scheduleConfig.date) {
      scheduleObject.date = scheduleConfig.date;
    }
    if (scheduleConfig.selectionType === 'day') {
      if (scheduleConfig.dayOfWeek) scheduleObject.dayOfWeek = scheduleConfig.dayOfWeek;
      if (scheduleConfig.weekNumber) scheduleObject.weekNumber = scheduleConfig.weekNumber;
    }
    
    if (scheduleConfig.halfYearlyEveryNMonths) scheduleObject.halfYearlyEveryNMonths = scheduleConfig.halfYearlyEveryNMonths;
    if (scheduleConfig.time) scheduleObject.time = scheduleConfig.time;
    if (scheduleConfig.period) scheduleObject.period = scheduleConfig.period;
    if (scheduleConfig.monthlyDateFormat) scheduleObject.monthlyDateFormat = scheduleConfig.monthlyDateFormat;
  }
  
  // ==================== YEARLY SCHEDULE ====================
  else if (frequencyType === 'yearly') {
    if (scheduleConfig.selectionType) scheduleObject.selectionType = scheduleConfig.selectionType;
    
    if (scheduleConfig.selectionType === 'date') {
      if (scheduleConfig.date) scheduleObject.date = scheduleConfig.date;
      if (scheduleConfig.month) scheduleObject.month = scheduleConfig.month;
    }
    if (scheduleConfig.selectionType === 'day') {
      if (scheduleConfig.dayOfWeek) scheduleObject.dayOfWeek = scheduleConfig.dayOfWeek;
      if (scheduleConfig.weekNumber) scheduleObject.weekNumber = scheduleConfig.weekNumber;
      if (scheduleConfig.month) scheduleObject.month = scheduleConfig.month;
    }
    
    if (scheduleConfig.time) scheduleObject.time = scheduleConfig.time;
    if (scheduleConfig.period) scheduleObject.period = scheduleConfig.period;
    if (scheduleConfig.yearlyFormat) scheduleObject.yearlyFormat = scheduleConfig.yearlyFormat;
  }

  console.log("🟢 Complete Schedule Object for:", frequencyType);
  console.log("📦 scheduleObject being sent:", JSON.stringify(scheduleObject, null, 2));
  
  // ✅ Prepare frequency object with schedule only if schedule object has properties
  const frequencyObject = enableFrequency ? {
    enabled: true,
    type: frequencyType,
    ...(frequencyType === 'custom' 
      ? { custom: customFrequency }
      : { 
          value: frequencyValue, 
          unit: frequencyUnit 
        }
    ),
    schedule: Object.keys(scheduleObject).length > 0 ? scheduleObject : null
  } : { enabled: false };

  console.log("📦 Final frequencyObject:", JSON.stringify(frequencyObject, null, 2));

  // ✅ DEFINE formattedPermissions HERE
  const formattedPermissions = {};
  
  // Format permissions from the current state
  Object.entries(permissions).forEach(([roleId, perm]) => {
    formattedPermissions[roleId] = {
      can_access: perm.can_access || false,
      can_view: perm.can_view || false,
      can_edit: perm.can_edit || false,
      can_submit: perm.can_submit || false
    };
  });

  // ✅ DEFINE schemaWithReportConfig HERE
  const schemaWithReportConfig = [...nodes];
  const existingReportIndex = schemaWithReportConfig.findIndex(f => f.id === 'form_report_config');
  if (existingReportIndex !== -1) {
    schemaWithReportConfig.splice(existingReportIndex, 1);
  }
  schemaWithReportConfig.push({
    id: 'form_report_config',
    type: 'system_report',
    reportConfig: reportConfig,
    enLabel: 'Form Report Configuration',
    mrLabel: 'फॉर्म रिपोर्ट कॉन्फिगरेशन'
  });

  // ✅ Form data to save
  const formDataToSave = {
    form_name: formName,
    schema: schemaWithReportConfig,
    workflow: workflow,
    sla: sla,
    permissions: formattedPermissions,
    entry_type: entryType,                           
    frequency: frequencyObject,                      
    max_entries_per_user: maxEntriesPerUser,
    form_language_mode: formLanguageMode,
    selected_ulb_classes: selectedULBClasses,
    selected_ulbs: targetKeys.map(key => parseInt(key)),
    created_by: currentUser?.id,
    created_by_name: currentUser?.name
  };

  console.log("=========================================");
  console.log("  Saving Form with COMPLETE Configuration:");
  console.log("🟢 Form Name:", formName);
  console.log("🟢 Entry Type:", entryType);
  console.log("🟢 Frequency Enabled:", enableFrequency);
  console.log("🟢 Frequency Type:", frequencyType);
  console.log("🟢 Frequency Value/Unit:", frequencyType !== 'custom' ? `${frequencyValue} ${frequencyUnit}` : 'custom');
  console.log("🟢 Schedule Object:", JSON.stringify(scheduleObject, null, 2));
  console.log("🟢 Frequency Object:", JSON.stringify(frequencyObject, null, 2));
  console.log("=========================================");

  if (onSave) {
    await onSave(formDataToSave);
    setApprovalStatus('pending');
  }
};

  // 🟢 Handle approve form
 const handleApprove = async () => {
  try {
    // Make sure you're sending all required fields
    const approvalData = {
      reviewed_by: currentUser?.id,
      reviewer_notes: reviewerNotes || '',
      status: 'approved',
      reviewed_at: new Date().toISOString()
    };
    
    // If you have rejection reason, don't send it for approval
    // Only send relevant fields
    await onFormApprove(selectedFormId, approvalData);
    setApprovalStatus('approved');
    setReviewedBy(currentUser?.id);
    setReviewedAt(new Date().toISOString());
    message.success(language === 'english'
      ? "Form approved successfully"
      : "फॉर्म मंजूर केला");
  } catch (error) {
    console.error("Approve error:", error);
    // Show more detailed error message
    const errorMessage = error.response?.data?.message || error.response?.data?.error || "Failed to approve form";
    message.error(language === 'english'
      ? errorMessage
      : "फॉर्म मंजूर करण्यात अयशस्वी: " + errorMessage);
  }
};

  // 🟢 Handle reject form
  const handleReject = async () => {
    if (!rejectionReason.trim()) {
      message.warning(language === 'english'
        ? "Please provide rejection reason"
        : "कृपया नकाराचे कारण द्या");
      return;
    }

    try {
      await onFormReject(selectedFormId, {
        reviewed_by: currentUser?.id,
        rejection_reason: rejectionReason,
        reviewer_notes: reviewerNotes
      });
      setApprovalStatus('rejected');
      setReviewedBy(currentUser?.id);
      setReviewedAt(new Date().toISOString());
      setShowRejectModal(false);
      message.success(language === 'english'
        ? "Form rejected"
        : "फॉर्म नाकारला");
    } catch (error) {
      console.error("Reject error:", error);
      message.error(language === 'english'
        ? "Failed to reject form"
        : "फॉर्म नाकारण्यात अयशस्वी");
    }
  };

  const renderFieldTree = (fields, parentId = null) => {
    const filteredFields = fields.filter(f => f.parentId === parentId);

    return filteredFields.map(field => {
      const hasChildren = fields.some(f => f.parentId === field.id);
      const isSelected = selectedFields.includes(field.id);

      const getFieldIcon = (type) => {
        switch (type) {
          case 'text': return <FontSizeOutlined style={{ color: '#1890ff' }} />;
          case 'number': return <NumberOutlined style={{ color: '#52c41a' }} />;
          case 'date': return <CalendarOutlined style={{ color: '#fa8c16' }} />;
          case 'checkbox': return <CheckSquareOutlined style={{ color: '#722ed1' }} />;
          case 'radio': return <BorderOutlined style={{ color: '#eb2f96' }} />;
          case 'heading': return <FontSizeOutlined style={{ color: '#fa8c16' }} />;
          case 'paragraph': return <AlignLeftOutlined style={{ color: '#13c2c2' }} />;
          case 'file': return <UploadOutlined style={{ color: '#1890ff' }} />;
          case 'comparison': return <SwapOutlined style={{ color: '#fa8c16' }} />;
          case 'arithmetic': return <CalculatorOutlined style={{ color: '#52c41a' }} />;
          default: return <FormOutlined />;
        }
      };

      return (
        <TreeNode
          key={field.id}
          title={
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '4px 0'
            }}>
              <Checkbox
                checked={isSelected}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedFields([...selectedFields, field.id]);
                  } else {
                    setSelectedFields(selectedFields.filter(id => id !== field.id));
                  }
                }}
              />
              <span style={{ fontSize: '16px' }}>
                {getFieldIcon(field.type)}
              </span>
              <div style={{ flex: 1 }}>
                <Text strong>{field.enLabel || field.label || field.type}</Text>
                {field.required && (
                  <Tag color="red" style={{ marginLeft: 8 }}>Required</Tag>
                )}
                <br />
                <Text type="secondary" style={{ fontSize: '12px' }}>
                  Type: {field.type} | ID: {field.id.substring(0, 8)}...
                </Text>
              </div>
            </div>
          }
        >
          {hasChildren && renderFieldTree(fields, field.id)}
        </TreeNode>
      );
    });
  };

  // Helper function to calculate arithmetic result - UPDATED WITH PERCENTAGE
  const calculateArithmeticResult = (values, fields, operator = "add") => {
    if (!fields || fields.length === 0) return 0;

    const numbers = fields.map(f => parseFloat(values[f.id]) || 0);

    switch (operator) {
      case "add":
        return numbers.reduce((a, b) => a + b, 0);
      case "subtract":
        return numbers.reduce((a, b) => a - b);
      case "multiply":
        return numbers.reduce((a, b) => a * b, 1);
      case "divide":
        return numbers.reduce((a, b) => a / b);
      case "average":
        return numbers.reduce((a, b) => a + b, 0) / numbers.length;
     case 'percentage': 
  // Calculate what percentage first value is of second value
  // Example: (20 / 50) * 100 = 40 (20 is 40% of 50)
  if (numbers.length >= 2 && numbers[1] !== 0) {
    return (numbers[0] / numbers[1]) * 100;
  }
  return 0;
      default:
        return numbers.reduce((a, b) => a + b, 0);
    }
  };

  // Helper function to check comparison
  const checkComparison = (mainValue, calculatedValue, operator) => {
    const main = parseFloat(mainValue) || 0;
    const calculated = parseFloat(calculatedValue) || 0;

    switch (operator) {
      case "equals":
        return main === calculated;
      case "not_equals":
        return main !== calculated;
      case "greater_than":
        return main > calculated;
      case "less_than":
        return main < calculated;
      case "greater_than_equal":
        return main >= calculated;
      case "less_than_equal":
        return main <= calculated;
      default:
        return main === calculated;
    }
  };

  // Get file type icon for preview
  const getFileIcon = (fileName) => {
    const ext = '.' + fileName.split('.').pop().toLowerCase();
    return FILE_TYPE_ICONS[ext] || FILE_TYPE_ICONS['default'];
  };

  // ✅ EXTENDED: Validate field value based on all validation rules - UPDATED: Removed min/max validation
  const validateFieldValue = (field, value) => {
    if (!value && !field.enRequired) return { valid: true };
    if (!value && field.enRequired) return { valid: false, message: "This field is required" };

    const validation = field.validation || {};
    const stringValue = String(value);

    // Character length validation - Only exact length now
    // Length validation - Different for text and number fields
if (validation.exactLength) {
  // For number fields, check number of digits (not including decimal)
  if (field.type === 'number') {
    const numStr = stringValue.replace(/[^0-9]/g, ''); // Remove decimal and negative sign
    if (numStr.length !== validation.exactLength) {
      return { 
        valid: false, 
        message: validation.customErrorMessage || `Exactly ${validation.exactLength} digits required` 
      };
    }
  } 
  // For text fields, check character count
  else {
    if (stringValue.length !== validation.exactLength) {
      return { 
        valid: false, 
        message: validation.customErrorMessage || `Exactly ${validation.exactLength} characters required` 
      };
    }
  }
}

    // Pattern validation
    if (validation.patternType && validation.patternType !== 'none') {
      let pattern;
      switch (validation.patternType) {
        case 'letters_only':
          pattern = /^[A-Za-z]+$/;
          if (!pattern.test(stringValue)) {
            return { valid: false, message: validation.customErrorMessage || "Only letters are allowed" };
          }
          break;
        case 'letters_spaces':
          pattern = /^[A-Za-z\s]+$/;
          if (!pattern.test(stringValue)) {
            return { valid: false, message: validation.customErrorMessage || "Only letters and spaces are allowed" };
          }
          break;
        case 'alphanumeric':
          pattern = /^[A-Za-z0-9]+$/;
          if (!pattern.test(stringValue)) {
            return { valid: false, message: validation.customErrorMessage || "Only letters and numbers are allowed" };
          }
          break;
        case 'alphanumeric_spaces':
          pattern = /^[A-Za-z0-9\s]+$/;
          if (!pattern.test(stringValue)) {
            return { valid: false, message: validation.customErrorMessage || "Only letters, numbers and spaces are allowed" };
          }
          break;
        case 'numbers_only':
          pattern = /^[0-9]+$/;
          if (!pattern.test(stringValue)) {
            return { valid: false, message: validation.customErrorMessage || "Only numbers are allowed" };
          }
          break;
        case 'email':
          pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!pattern.test(stringValue)) {
            return { valid: false, message: validation.customErrorMessage || "Invalid email format" };
          }
          break;
        case 'phone':
          pattern = /^[0-9+\-\s()]+$/;
          if (!pattern.test(stringValue)) {
            return { valid: false, message: validation.customErrorMessage || "Invalid phone number format" };
          }
          break;
        case 'url':
          try {
            new URL(stringValue);
          } catch (e) {
            return { valid: false, message: validation.customErrorMessage || "Invalid URL format" };
          }
          break;
        case 'ip_address':
          const ipPattern = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
          if (!ipPattern.test(stringValue)) {
            return { valid: false, message: validation.customErrorMessage || "Invalid IP address" };
          }
          break;
        case 'credit_card':
          const ccPattern = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|6(?:011|5[0-9]{2})[0-9]{12}|(?:2131|1800|35\d{3})\d{11})$/;
          if (!ccPattern.test(stringValue.replace(/\s/g, ''))) {
            return { valid: false, message: validation.customErrorMessage || "Invalid credit card number" };
          }
          break;
        case 'custom':
          if (validation.customPattern) {
            try {
              const flags = validation.regexFlags || 'g';
              const regex = new RegExp(validation.customPattern, flags);
              if (!regex.test(stringValue)) {
                return { 
                  valid: false, 
                  message: validation.patternErrorMessage || validation.customErrorMessage || "Invalid format" 
                };
              }
            } catch (e) {
              console.error("Invalid regex pattern");
            }
          }
          break;
      }
    }

    // Space validation
    if (!validation.allowSpaces && stringValue.includes(' ')) {
      return { valid: false, message: validation.customErrorMessage || "Spaces are not allowed" };
    }
    if (!validation.allowLeadingSpaces && stringValue.startsWith(' ')) {
      return { valid: false, message: validation.customErrorMessage || "Leading spaces are not allowed" };
    }
    if (!validation.allowTrailingSpaces && stringValue.endsWith(' ')) {
      return { valid: false, message: validation.customErrorMessage || "Trailing spaces are not allowed" };
    }
    if (!validation.allowMultipleSpaces && /\s{2,}/.test(stringValue)) {
      return { valid: false, message: validation.customErrorMessage || "Multiple consecutive spaces are not allowed" };
    }

    // Allowed characters validation
    if (validation.allowedCharacters && validation.allowedCharacters !== 'any') {
      let allowedPattern;
      switch (validation.allowedCharacters) {
        case 'letters_only':
          allowedPattern = /^[A-Za-z]+$/;
          if (!allowedPattern.test(stringValue)) {
            return { valid: false, message: validation.customErrorMessage || "Only letters are allowed" };
          }
          break;
        case 'numbers_only':
          allowedPattern = /^[0-9]+$/;
          if (!allowedPattern.test(stringValue)) {
            return { valid: false, message: validation.customErrorMessage || "Only numbers are allowed" };
          }
          break;
        case 'alphanumeric':
          allowedPattern = /^[A-Za-z0-9]+$/;
          if (!allowedPattern.test(stringValue)) {
            return { valid: false, message: validation.customErrorMessage || "Only letters and numbers are allowed" };
          }
          break;
        case 'custom':
          if (validation.customAllowedChars) {
            const allowedSet = new Set(validation.customAllowedChars.split(''));
            for (let char of stringValue) {
              if (!allowedSet.has(char)) {
                return { 
                  valid: false, 
                  message: validation.customErrorMessage || `Character '${char}' is not allowed` 
                };
              }
            }
          }
          break;
      }
    }

    // Disallowed characters
    // if (validation.disallowedCharacters) {
    //   const disallowedSet = new Set(validation.disallowedCharacters.split(''));
    //   for (let char of stringValue) {
    //     if (disallowedSet.has(char)) {
    //       return { 
    //         valid: false, 
    //         message: validation.customErrorMessage || `Character '${char}' is not allowed` 
    //       };
    //     }
    //   }
    // }

    // Case validation
    if (validation.uppercase && stringValue !== stringValue.toUpperCase()) {
      return { valid: false, message: validation.customErrorMessage || "Only uppercase letters are allowed" };
    }
    if (validation.lowercase && stringValue !== stringValue.toLowerCase()) {
      return { valid: false, message: validation.customErrorMessage || "Only lowercase letters are allowed" };
    }
    if (validation.capitalize) {
      const words = stringValue.split(' ');
      const capitalized = words.map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(' ');
      if (stringValue !== capitalized) {
        return { valid: false, message: validation.customErrorMessage || "First letter of each word must be capitalized" };
      }
    }
    if (validation.titleCase) {
      const words = stringValue.split(' ');
      const titleCased = words.map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(' ');
      if (stringValue !== titleCased) {
        return { valid: false, message: validation.customErrorMessage || "Title case required (each word capitalized)" };
      }
    }

    // Language script validation
    if (validation.languageScript && validation.languageScript !== 'any') {
      const devanagariRegex = /[\u0900-\u097F]/;
      const latinRegex = /[A-Za-z]/;
      const gujaratiRegex = /[\u0A80-\u0AFF]/;
      const tamilRegex = /[\u0B80-\u0BFF]/;
      const teluguRegex = /[\u0C00-\u0C7F]/;
      const kannadaRegex = /[\u0C80-\u0CFF]/;
      const malayalamRegex = /[\u0D00-\u0D7F]/;
      const bengaliRegex = /[\u0980-\u09FF]/;
      const gurmukhiRegex = /[\u0A00-\u0A7F]/;
      const oriyaRegex = /[\u0B00-\u0B7F]/;
      const arabicRegex = /[\u0600-\u06FF]/;

      switch (validation.languageScript) {
        case 'latin_only':
          if (devanagariRegex.test(stringValue) || gujaratiRegex.test(stringValue) || 
              tamilRegex.test(stringValue) || teluguRegex.test(stringValue) ||
              kannadaRegex.test(stringValue) || malayalamRegex.test(stringValue) ||
              bengaliRegex.test(stringValue) || gurmukhiRegex.test(stringValue) ||
              oriyaRegex.test(stringValue) || arabicRegex.test(stringValue)) {
            return { valid: false, message: validation.customErrorMessage || "Only Latin characters are allowed" };
          }
          break;
        case 'devanagari_only':
          if (!devanagariRegex.test(stringValue) || latinRegex.test(stringValue)) {
            return { valid: false, message: validation.customErrorMessage || "Only Devanagari characters are allowed" };
          }
          break;
        case 'gujarati_only':
          if (!gujaratiRegex.test(stringValue) || latinRegex.test(stringValue)) {
            return { valid: false, message: validation.customErrorMessage || "Only Gujarati characters are allowed" };
          }
          break;
        case 'tamil_only':
          if (!tamilRegex.test(stringValue) || latinRegex.test(stringValue)) {
            return { valid: false, message: validation.customErrorMessage || "Only Tamil characters are allowed" };
          }
          break;
        case 'latin_devanagari':
          // Allow both
          break;
      }
    }

    // Date validation for date fields
   // Date validation for date fields - Add current date comparison
if (field.type === 'date' && value) {
  const dateValue = new Date(value);
  if (isNaN(dateValue.getTime())) {
    return { valid: false, message: "Invalid date" };
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  if (validation.futureDates && dateValue < today) {
    return { valid: false, message: "Future dates only" };
  }
  if (validation.pastDates && dateValue > today) {
    return { valid: false, message: "Past dates only" };
  }
  if (validation.todayOnly && dateValue.toDateString() !== today.toDateString()) {
    return { valid: false, message: "Today's date only" };
  }
  if (validation.minDate && new Date(value) < new Date(validation.minDate)) {
    return { valid: false, message: `Date must be after ${validation.minDate}` };
  }
  if (validation.maxDate && new Date(value) > new Date(validation.maxDate)) {
    return { valid: false, message: `Date must be before ${validation.maxDate}` };
  }
  
  // ✅ ADD CURRENT DATE COMPARISON
  if (field.enableDateComparison && field.comparisonOperator === 'current_date') {
    const todayStr = today.toISOString().split('T')[0];
    if (value !== todayStr) {
      return { 
        valid: false, 
        message: field.customValidationMessage || `Date must be today's date (${todayStr})` 
      };
    }
  }
}

    // Number validation - UPDATED: With defaults allowZero=true, allowDecimals=false, allowNegative=false
    if (field.type === 'number' && value) {
      const numValue = parseFloat(value);
      
      if (isNaN(numValue)) {
        return { valid: false, message: "Invalid number" };
      }

      if (validation.integerOnly && !Number.isInteger(numValue)) {
        return { valid: false, message: validation.customErrorMessage || "Integer only" };
      }
      if (!validation.allowZero && numValue === 0) {
        return { valid: false, message: validation.customErrorMessage || "Zero is not allowed" };
      }
      if (!validation.allowNegative && numValue < 0) {
        return { valid: false, message: validation.customErrorMessage || "Negative numbers are not allowed" };
      }
      if (!validation.allowDecimals && !Number.isInteger(numValue)) {
        return { valid: false, message: validation.customErrorMessage || "Decimals are not allowed" };
      }
      if (validation.decimalPlaces !== null) {
        const decimalStr = numValue.toString().split('.')[1];
        if (decimalStr && decimalStr.length > validation.decimalPlaces) {
          return { valid: false, message: validation.customErrorMessage || `Maximum ${validation.decimalPlaces} decimal places allowed` };
        }
      }
    }

    // Custom validation function
    if (validation.validationFunction) {
      try {
        const customValidation = new Function('value', validation.validationFunction);
        const result = customValidation(value);
        if (result !== true) {
          return { valid: false, message: result || validation.customErrorMessage || "Custom validation failed" };
        }
      } catch (e) {
        console.error("Custom validation error:", e);
      }
    }

    return { valid: true };
  };

// Helper function to get unit display info
const getUnitDisplayInfo = (field) => {
  if (!field) return null;
  if (field.selectedUnitObject) {
    return { 
      symbol: field.selectedUnitObject.unit_symbol, 
      name: field.selectedUnitObject.unit_name, 
      value: field.selectedUnitObject.unit_value 
    };
  }
  if (field.units?.enabled && field.units.selectedUnitSymbol) {
    return { 
      symbol: field.units.selectedUnitSymbol, 
      name: field.units.selectedUnitLabel, 
      value: field.units.selectedUnitValue 
    };
  }
  if (field.hasUnit && field.selectedUnit) {
    if (typeof field.selectedUnit === 'object') {
      return { 
        symbol: field.selectedUnit.unit_symbol, 
        name: field.selectedUnit.unit_name, 
        value: field.selectedUnit.unit_value 
      };
    }
  }
  return null;
};


const renderPreview = () => {
  const previewLanguage = language || 'english';

  // ==================== NUMBER TO WORDS CONVERSION ====================
  const numberToWords = (num) => {
    if (num === '' || num === null || num === undefined) return '';
    
    const numStr = String(num).replace(/,/g, '');
    if (isNaN(numStr) || numStr === '') return '';
    
    const number = parseFloat(numStr);
    if (isNaN(number)) return '';
    
    const parts = numStr.split('.');
    const integerPart = parseInt(parts[0], 10);
    const decimalPartStr = parts[1] || null;
    
    const ones = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine',
      'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
    const tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

    const convertLessThanThousand = (n) => {
      if (n === 0) return '';
      if (n < 20) return ones[n] + ' ';
      if (n < 100) return tens[Math.floor(n / 10)] + ' ' + (n % 10 !== 0 ? ones[n % 10] + ' ' : '');
      return ones[Math.floor(n / 100)] + ' hundred ' + convertLessThanThousand(n % 100);
    };

    const convertToWords = (n) => {
      if (n === 0) return 'zero';
      
      const units = ['', 'thousand', 'million', 'billion', 'trillion', 'quadrillion'];
      let result = '';
      let unitIndex = 0;
      let tempNum = n;
      
      while (tempNum > 0) {
        const chunk = tempNum % 1000;
        if (chunk !== 0) {
          result = convertLessThanThousand(chunk) + units[unitIndex] + ' ' + result;
        }
        tempNum = Math.floor(tempNum / 1000);
        unitIndex++;
      }
      
      return result.trim();
    };
    
    let words = convertToWords(integerPart);
    
    if (decimalPartStr !== null && decimalPartStr !== '') {
      const decimalValue = parseInt(decimalPartStr, 10);
      
      if (decimalValue !== 0 || decimalPartStr.length > 1) {
        const decimalDigits = decimalPartStr.split('');
        const decimalWordsArray = decimalDigits.map(digit => {
          const digitNum = parseInt(digit, 10);
          if (digitNum === 0) return 'zero';
          if (digitNum < 20) return ones[digitNum];
          return '';
        });
        words += ` point ${decimalWordsArray.join(' ')}`;
      }
    }
    
    return words.charAt(0).toUpperCase() + words.slice(1);
  };

  const getWordsRepresentation = (value) => {
    if (value === undefined || value === null || value === '') return '';
    const numValue = parseFloat(value);
    if (isNaN(numValue)) return '';
    if (numValue === 0) return '';
    const words = numberToWords(numValue);
    if (words && words !== 'zero') {
      return words.charAt(0).toUpperCase() + words.slice(1);
    }
    return '';
  };

  // Helper function to check if operator is logical
  const isLogicalOperator = (operator) => {
    const logicalOps = ['equals', 'not_equals', 'greater_than', 'less_than', 'greater_than_equal', 'less_than_equal'];
    return logicalOps.includes(operator);
  };

  // Helper function to calculate arithmetic result
  const calculateArithmeticResultLocal = (values, fields, operator = "add") => {
    if (!fields || fields.length === 0) return 0;
    const numbers = fields.map(f => parseFloat(values[f.id]) || 0);
    switch (operator) {
      case "add": return numbers.reduce((a, b) => a + b, 0);
      case "subtract": return numbers.reduce((a, b) => a - b);
      case "multiply": return numbers.reduce((a, b) => a * b, 1);
      case "divide": return numbers.reduce((a, b) => a / b);
      case "average": return numbers.reduce((a, b) => a + b, 0) / numbers.length;
      case "percentage": return numbers.length >= 2 ? (numbers[0] / 100) * numbers[1] : 0;
      default: return numbers.reduce((a, b) => a + b, 0);
    }
  };

  // Helper function to check comparison
  const checkComparisonLocal = (mainValue, calculatedValue, operator) => {
    const main = parseFloat(mainValue) || 0;
    const calculated = parseFloat(calculatedValue) || 0;
    switch (operator) {
      case "equals": return main === calculated;
      case "not_equals": return main !== calculated;
      case "greater_than": return main > calculated;
      case "less_than": return main < calculated;
      case "greater_than_equal": return main >= calculated;
      case "less_than_equal": return main <= calculated;
      default: return main === calculated;
    }
  };

  // Helper function to get unit display info
  const getUnitDisplayInfo = (field) => {
    if (!field) return null;
    if (field.selectedUnitObject) {
      return { symbol: field.selectedUnitObject.unit_symbol, name: field.selectedUnitObject.unit_name, value: field.selectedUnitObject.unit_value };
    }
    if (field.units?.enabled && field.units.selectedUnitSymbol) {
      return { symbol: field.units.selectedUnitSymbol, name: field.units.selectedUnitLabel, value: field.units.selectedUnitValue };
    }
    if (field.selectedUnit && typeof field.selectedUnit === 'object') {
      return { symbol: field.selectedUnit.unit_symbol, name: field.selectedUnit.unit_name, value: field.selectedUnit.unit_value };
    }
    return null;
  };

  // ==================== TEXT VALIDATION ====================
  const applyTextValidation = (field, value) => {
    const validation = field.validation || {};
    let transformed = value || '';
    let error = null;
    const exactLength = validation.exactLength;

    if (!value) return { transformed: value, error: null };

    if (exactLength && transformed.length > exactLength) {
      transformed = transformed.slice(0, exactLength);
    }

    if (validation.trimInput) transformed = transformed.trim();
    if (validation.collapseSpaces) transformed = transformed.replace(/\s+/g, ' ');
    if (validation.allowLeadingSpaces === false && transformed.startsWith(' ')) {
      transformed = transformed.replace(/^\s+/, '');
      error = "Leading spaces are not allowed";
    }
    if (validation.allowTrailingSpaces === false && transformed.endsWith(' ')) {
      transformed = transformed.replace(/\s+$/, '');
      error = "Trailing spaces are not allowed";
    }
    if (validation.allowSpaces === false && transformed.includes(' ')) {
      transformed = transformed.replace(/\s/g, '');
      error = "Spaces are not allowed";
    }

    if (validation.uppercase) transformed = transformed.toUpperCase();
    if (validation.lowercase) transformed = transformed.toLowerCase();
    if (validation.capitalize && transformed.length > 0) {
      transformed = transformed.charAt(0).toUpperCase() + transformed.slice(1).toLowerCase();
    }
    if (validation.titleCase) {
      transformed = transformed.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
    }

    const languageScript = validation.languageScript || "any";
    const marathiRegex = /[\u0900-\u097F]/;
    const englishRegex = /[A-Za-z]/;

    if (languageScript === "marathi_only") {
      if (englishRegex.test(transformed)) {
        error = "✗ Only Marathi (देवनागरी) characters allowed";
        transformed = transformed.replace(/[A-Za-z]/g, '');
      }
      transformed = transformed.replace(/[^\u0900-\u097F\s]/g, '');
    }
    else if (languageScript === "english_only") {
      if (marathiRegex.test(transformed)) {
        error = "✗ Only English characters allowed";
        transformed = transformed.replace(/[\u0900-\u097F]/g, '');
      }
    }

    if (validation.patternType && validation.patternType !== 'none' && transformed) {
      let pattern;
      switch (validation.patternType) {
        case 'letters_only': pattern = /^[A-Za-z\u0900-\u097F]+$/; break;
        case 'letters_spaces': pattern = /^[A-Za-z\u0900-\u097F\s]+$/; break;
        case 'alphanumeric': pattern = /^[A-Za-z0-9\u0900-\u097F]+$/; break;
        case 'alphanumeric_spaces': pattern = /^[A-Za-z0-9\u0900-\u097F\s]+$/; break;
        case 'numbers_only': pattern = /^[0-9]+$/; break;
        case 'email': pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; break;
        case 'phone': pattern = /^[0-9+\-\s()]+$/; break;
        case 'url':
          try { new URL(transformed); } catch(e) { error = "✗ Invalid URL format"; }
          break;
      }
      if (pattern && !pattern.test(transformed)) {
        error = `✗ Invalid ${validation.patternType.replace('_', ' ')} format`;
      }
    }

    return { transformed, error };
  };

  // ==================== NUMBER VALIDATION ====================
  const applyNumberValidation = (field, value) => {
    const validation = field.validation || {};
    let transformed = value || '';
    let error = null;
    const exactLength = validation.exactLength;

    if (!value) return { transformed: value, error: null };

    const originalValue = value;
    let hasLeadingZeros = false;
    
    if (typeof originalValue === 'string' && originalValue.length > 1) {
      hasLeadingZeros = originalValue[0] === '0' && originalValue[1] !== '.' && originalValue[1] !== '-';
    }
    const isAllZeros = /^0+$/.test(originalValue);

    if (validation.allowSpaces === false) transformed = transformed.replace(/\s/g, '');
    if (validation.allowLeadingSpaces === false && transformed.startsWith(' ')) transformed = transformed.trimStart();
    if (validation.allowTrailingSpaces === false && transformed.endsWith(' ')) transformed = transformed.trimEnd();

    if (validation.allowNegative && validation.allowDecimals) {
      transformed = transformed.replace(/[^-0-9.]/g, '');
    } else if (validation.allowNegative && !validation.allowDecimals) {
      transformed = transformed.replace(/[^-0-9]/g, '');
    } else if (!validation.allowNegative && validation.allowDecimals) {
      transformed = transformed.replace(/[^0-9.]/g, '');
    } else {
      transformed = transformed.replace(/[^0-9]/g, '');
    }

    if (!validation.allowDecimals) transformed = transformed.replace(/\./g, '');
    
    const decimalCount = (transformed.match(/\./g) || []).length;
    if (decimalCount > 1) {
      const lastIndex = transformed.lastIndexOf('.');
      transformed = transformed.substring(0, lastIndex) + transformed.substring(lastIndex + 1).replace(/\./g, '');
    }

    if (!validation.allowNegative && transformed.includes('-')) {
      error = "✗ Negative numbers are not allowed";
      transformed = transformed.replace(/-/g, '');
    } else if (validation.allowNegative && transformed.includes('-')) {
      if (transformed.indexOf('-') !== 0) transformed = '-' + transformed.replace(/-/g, '');
      const negativeCount = (transformed.match(/-/g) || []).length;
      if (negativeCount > 1) transformed = '-' + transformed.replace(/-/g, '');
    }

    if (exactLength && transformed && !error) {
      const cleanedForLength = transformed.replace(/[^0-9]/g, '');
      if (cleanedForLength.length > exactLength) {
        const allowedDigits = cleanedForLength.slice(0, exactLength);
        const hasNegative = transformed.startsWith('-');
        const decimalIndex = transformed.indexOf('.');
        if (decimalIndex !== -1) {
          const decimalPart = transformed.slice(decimalIndex + 1);
          const limitedDecimal = decimalPart.slice(0, validation.decimalPlaces || decimalPart.length);
          transformed = (hasNegative ? '-' : '') + allowedDigits + '.' + limitedDecimal;
        } else {
          transformed = (hasNegative ? '-' : '') + allowedDigits;
        }
      }
    }

    const numValue = parseFloat(transformed);
    
    if (!isNaN(numValue) && transformed !== '') {
      if (validation.allowZero === false && numValue === 0) {
        error = "✗ Zero is not allowed";
        transformed = '';
      }
      if (validation.integerOnly && transformed.includes('.')) {
        error = "✗ Integer only - decimals not allowed";
        transformed = transformed.split('.')[0];
      }
      if (validation.allowDecimals === false && transformed.includes('.')) {
        error = "✗ Decimals are not allowed";
        transformed = transformed.split('.')[0];
      }
      if (validation.decimalPlaces && transformed.includes('.')) {
        const parts = transformed.split('.');
        if (parts[1] && parts[1].length > validation.decimalPlaces) {
          const rounded = numValue.toFixed(validation.decimalPlaces);
          transformed = rounded;
        }
      }
    }

    if ((hasLeadingZeros || isAllZeros) && !error && transformed && !transformed.includes('.')) {
      const originalNumericPart = originalValue.replace(/[^0-9]/g, '');
      const currentNumericPart = transformed.replace(/[^0-9]/g, '');
      
      if (originalNumericPart.length === currentNumericPart.length) {
        const preservedZeros = originalNumericPart;
        const hasNegative = transformed.startsWith('-');
        transformed = (hasNegative ? '-' : '') + preservedZeros;
      }
    }

    return { transformed, error };
  };

  // ==================== DATE VALIDATION ====================
  const applyDateValidation = (field, value) => {
    const validation = field.validation || {};
    let error = null;

    if (!value) return { valid: true, error: null };

    const dateValue = new Date(value);
    if (isNaN(dateValue.getTime())) return { valid: false, error: "Invalid date" };

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (validation.futureDates && dateValue < today) error = "Future dates only";
    if (validation.pastDates && dateValue > today) error = "Past dates only";
    if (validation.todayOnly && dateValue.toDateString() !== today.toDateString()) error = "Today's date only";
    if (validation.minDate && dateValue < new Date(validation.minDate)) error = `Date must be after ${validation.minDate}`;
    if (validation.maxDate && dateValue > new Date(validation.maxDate)) error = `Date must be before ${validation.maxDate}`;

    return { valid: !error, error };
  };

  const buildTextActiveRules = (field) => {
    const rules = [];
    const v = field.validation || {};

    if (v.exactLength) rules.push({ color: "orange", text: `📏 Exact: ${v.exactLength} chars` });
    if (v.patternType && v.patternType !== 'none') {
      const patternMap = {
        letters_only: "🔤 Letters Only",
        letters_spaces: "🔤 Letters + Spaces",
        alphanumeric: "🔢 Alphanumeric",
        alphanumeric_spaces: "🔢 Alphanumeric + Spaces",
        numbers_only: "🔢 Numbers Only",
        email: "📧 Email",
        phone: "📞 Phone",
        url: "🔗 URL",
      };
      rules.push({ color: "geekblue", text: patternMap[v.patternType] || v.patternType });
    }
    if (v.uppercase) rules.push({ color: "purple", text: "🔠 UPPERCASE" });
    if (v.lowercase) rules.push({ color: "purple", text: "🔡 lowercase" });
    if (v.capitalize) rules.push({ color: "cyan", text: "  Capitalize" });
    if (v.titleCase) rules.push({ color: "cyan", text: "📚 Title Case" });
    if (v.allowSpaces === false) rules.push({ color: "red", text: "🚫 No spaces" });
    if (v.allowLeadingSpaces === false) rules.push({ color: "red", text: "🚫 No leading spaces" });
    if (v.allowTrailingSpaces === false) rules.push({ color: "red", text: "🚫 No trailing spaces" });
    if (v.allowMultipleSpaces === false) rules.push({ color: "red", text: "🚫 No multiple spaces" });
    if (v.trimInput) rules.push({ color: "green", text: "✂️ Auto trim" });
    if (v.collapseSpaces) rules.push({ color: "green", text: "🔨 Collapse spaces" });
    if (v.languageScript === "marathi_only") rules.push({ color: "green", text: "🇮🇳 मराठी Only" });
    if (v.languageScript === "english_only") rules.push({ color: "blue", text: "🇬🇧 English Only" });

    return rules;
  };

  const buildNumberActiveRules = (field, unitInfo) => {
    const rules = [];
    const v = field.validation || {};

    if (unitInfo) rules.push({ color: "blue", text: `📊 Unit: ${unitInfo.symbol}` });
    if (v.exactLength) rules.push({ color: "orange", text: `📏 Exact: ${v.exactLength} digits` });
    if (v.decimalPlaces && v.decimalPlaces > 0) {
      rules.push({ color: "cyan", text: `🔢 ${v.decimalPlaces} decimal place(s)` });
    }
    if (v.allowDecimals === false) {
      rules.push({ color: "orange", text: "🚫 No decimals" });
    } else if (v.allowDecimals === true && v.decimalPlaces === null) {
      rules.push({ color: "green", text: "✓ Decimals allowed" });
    }
    if (v.allowNegative === false) {
      rules.push({ color: "orange", text: "➕ Positive only" });
    } else if (v.allowNegative === true) {
      rules.push({ color: "green", text: "✓ Negative allowed" });
    }
    if (v.integerOnly) {
      rules.push({ color: "purple", text: "🔢 Integer only" });
    }
    if (v.allowZero === false) {
      rules.push({ color: "red", text: "🚫 Zero not allowed" });
    }
    if (v.allowSpaces === false) rules.push({ color: "red", text: "🚫 No spaces" });
    if (v.allowLeadingSpaces === false) rules.push({ color: "red", text: "🚫 No leading spaces" });
    if (v.allowTrailingSpaces === false) rules.push({ color: "red", text: "🚫 No trailing spaces" });
    if (v.trimInput) rules.push({ color: "green", text: "✂️ Auto trim" });

    return rules;
  };

  const buildDateRules = (field) => {
    const rules = [];
    const v = field.validation || {};

    if (v.minDate) rules.push({ color: "purple", text: `📅 Min: ${v.minDate}` });
    if (v.maxDate) rules.push({ color: "purple", text: `📅 Max: ${v.maxDate}` });
    if (v.futureDates) rules.push({ color: "cyan", text: "🚀 Future dates only" });
    if (v.pastDates) rules.push({ color: "cyan", text: "📜 Past dates only" });
    if (v.todayOnly) rules.push({ color: "green", text: "📆 Today only" });

    return rules;
  };

  // फील्ड मॅप तयार करा
  const fieldMap = {};
  nodes.forEach(node => {
    fieldMap[node.id] = node;
  });

  // children by parent map तयार करा
  const childrenByParent = {};
  nodes.forEach(field => {
    if (field.parentId) {
      if (!childrenByParent[field.parentId]) {
        childrenByParent[field.parentId] = [];
      }
      childrenByParent[field.parentId].push(field);
    }
  });

  // ==================== FORMULA STEP RESULT CALCULATION ====================
const calculateFormulaStepResult = (step, values, allFieldMap, visitedFields = new Set()) => {
  const fields = step.arithmeticFields || [];
  if (fields.length === 0) return 0;

  let result = 0;
  let isFirst = true;
  const operator = step.combineOperator || 'add';

  for (const fieldData of fields) {
    let value = 0;

    // ===== FIX: Handle Step Result Reference FIRST =====
    if (fieldData.isStepResultReference === true) {
      // Step result reference handle करा
      if (fieldData.sourceStepId) {
        // stepResultsMap मधून value घ्या
        // हे values मध्ये नाही, पण stepResultsMap मध्ये आहे
        // त्यासाठी आपण stepResultsMap पास करायला हवे
        // किंवा values मध्येच step result store करा
        value = values[fieldData.sourceStepId] !== undefined ? values[fieldData.sourceStepId] : 0;
      } else {
        value = 0;
      }
    }
    else if (fieldData.isSharedReference === true || fieldData.isExternalReference === true) {
      const sourceId = fieldData.sourceFieldId || fieldData.id;
      
      if (visitedFields.has(sourceId)) {
        console.warn(`Circular reference detected for field ${sourceId}`);
        value = 0;
      } else {
        visitedFields.add(sourceId);
        
        if (fieldData.sourceFieldType === 'formula') {
          const originalFormulaField = allFieldMap[sourceId];
          if (originalFormulaField && originalFormulaField.type === 'formula') {
            value = calculateFormulaFinalResult(originalFormulaField, values, allFieldMap, visitedFields);
          } else {
            value = (values && values[sourceId] !== undefined) ? parseFloat(values[sourceId]) || 0 : 0;
          }
        } 
        else if (fieldData.sourceFieldType === 'arithmetic') {
          const originalArithmeticField = allFieldMap[sourceId];
          if (originalArithmeticField && originalArithmeticField.type === 'arithmetic') {
            value = calculateArithmeticResultLocal(values, originalArithmeticField.arithmeticFields, originalArithmeticField.arithmeticOperator);
          } else {
            value = (values && values[sourceId] !== undefined) ? parseFloat(values[sourceId]) || 0 : 0;
          }
        }
        else {
          value = (values && values[sourceId] !== undefined) ? parseFloat(values[sourceId]) || 0 : 0;
        }
        
        visitedFields.delete(sourceId);
      }
    }
    else if (fieldData.fieldType === 'constant') {
      value = fieldData.constantValue !== undefined && fieldData.constantValue !== null ? parseFloat(fieldData.constantValue) : 0;
    }
    else {
      value = (values && values[fieldData.id] !== undefined) ? parseFloat(values[fieldData.id]) || 0 : 0;
    }

    const validation = fieldData.validation || {};
    if (validation.allowNegative === false && value < 0) value = 0;
    if (validation.allowZero === false && value === 0) value = 0.01;
    if (validation.integerOnly) value = Math.floor(value);
    if (validation.decimalPlaces !== null && validation.decimalPlaces !== undefined && validation.allowDecimals !== false) {
      value = parseFloat(value.toFixed(validation.decimalPlaces));
    }

    if (isFirst) {
      result = value;
      isFirst = false;
    } else {
      switch (operator) {
        case 'add': result += value; break;
        case 'subtract': result -= value; break;
        case 'multiply': result *= value; break;
        case 'divide': result = value !== 0 ? result / value : 0; break;
        case 'percentage': result = value !== 0 ? (result / value) * 100 : 0; break;
        case 'equals': result = (result === value) ? 1 : 0; break;
        case 'not_equals': result = (result !== value) ? 1 : 0; break;
        case 'greater_than': result = (result > value) ? 1 : 0; break;
        case 'less_than': result = (result < value) ? 1 : 0; break;
        case 'greater_than_equal': result = (result >= value) ? 1 : 0; break;
        case 'less_than_equal': result = (result <= value) ? 1 : 0; break;
        default: result += value;
      }
    }
  }
  return result;
};

  const calculateFormulaFinalResult = (formulaField, values, allFieldMap, visitedFields = new Set()) => {
    if (visitedFields.has(formulaField.id)) {
      console.warn(`Circular reference detected for formula field ${formulaField.id}`);
      return 0;
    }
    
    visitedFields.add(formulaField.id);
    
    const formulaSteps = formulaField.formulaSteps || [];
    const stepCombineOp = formulaField.stepCombineOperator || 'add';
    const isNoneCombine = stepCombineOp === 'none';
    
    if (formulaSteps.length === 0) {
      visitedFields.delete(formulaField.id);
      return 0;
    }

    const stepResultsArray = [];

    for (const step of formulaSteps) {
      const result = calculateFormulaStepResult(step, values, allFieldMap, visitedFields);
      stepResultsArray.push(result);
    }

    let finalResult;
    
    if (formulaSteps.length === 1 || isNoneCombine) {
      finalResult = stepResultsArray[0] || 0;
    } else {
      finalResult = stepResultsArray[0] || 0;
      
      for (let i = 1; i < stepResultsArray.length; i++) {
        switch (stepCombineOp) {
          case 'add': finalResult += stepResultsArray[i]; break;
          case 'subtract': finalResult -= stepResultsArray[i]; break;
          case 'multiply': finalResult *= stepResultsArray[i]; break;
          case 'divide': finalResult = stepResultsArray[i] !== 0 ? finalResult / stepResultsArray[i] : 0; break;
          case 'percentage': finalResult = stepResultsArray[i] !== 0 ? (finalResult / stepResultsArray[i]) * 100 : 0; break;
          case 'equals': finalResult = finalResult === stepResultsArray[i] ? 1 : 0; break;
          case 'not_equals': finalResult = finalResult !== stepResultsArray[i] ? 1 : 0; break;
          case 'greater_than': finalResult = finalResult > stepResultsArray[i] ? 1 : 0; break;
          case 'less_than': finalResult = finalResult < stepResultsArray[i] ? 1 : 0; break;
          case 'greater_than_equal': finalResult = finalResult >= stepResultsArray[i] ? 1 : 0; break;
          case 'less_than_equal': finalResult = finalResult <= stepResultsArray[i] ? 1 : 0; break;
          default: finalResult += stepResultsArray[i];
        }
      }
    }
    
    visitedFields.delete(formulaField.id);
    return finalResult;
  };

  const renderFieldWithChildren = (field) => {
    const children = childrenByParent[field.id] || [];

    // ==================== HEADING FIELD ====================
    if (field.type === "heading") {
      const headingLevel = field.headingLevel || 1;
      const marginLeft = headingLevel === 1 ? 0 : headingLevel === 2 ? 24 : headingLevel === 3 ? 48 : 64;

      return (
        <div key={field.id} style={{ marginBottom: 16, marginLeft }}>
          {headingLevel === 1 && (
            <div style={{ marginBottom: 16 }}>
              <div style={{ fontSize: '24px', fontWeight: 600, color: '#1f1f1f', borderBottom: '3px solid #fa8c16', paddingBottom: '8px', marginBottom: '8px' }}>
                {previewLanguage === 'english' ? (field.enLabel || field.label) : (field.mrLabel || field.label)}
              </div>
            </div>
          )}
          {headingLevel === 2 && (
            <div style={{ marginBottom: 12 }}>
              <div style={{ fontSize: '20px', fontWeight: 500, color: '#2c3e50', borderBottom: '2px solid #ffd591', paddingBottom: '4px' }}>
                {previewLanguage === 'english' ? (field.enLabel || field.label) : (field.mrLabel || field.label)}
              </div>
            </div>
          )}
          {headingLevel >= 3 && (
            <div style={{ marginBottom: 10 }}>
              <div style={{ fontSize: '18px', fontWeight: 500, color: '#34495e', borderBottom: '1px dashed #ffe7ba', paddingBottom: '3px' }}>
                {previewLanguage === 'english' ? (field.enLabel || field.label) : (field.mrLabel || field.label)}
              </div>
            </div>
          )}
          {(field.enHelpText || field.mrHelpText) && (
            <div style={{ marginTop: '2px', marginBottom: '8px', fontSize: '12px', color: '#666', fontStyle: 'italic', marginLeft: headingLevel === 1 ? 24 : 32 }}>
              {previewLanguage === 'english' ? field.enHelpText : field.mrHelpText}
            </div>
          )}
          {children.length > 0 && (
            <div style={{ marginLeft: headingLevel === 1 ? 24 : 16, borderLeft: headingLevel >= 2 ? '2px solid #f0f0f0' : 'none', paddingLeft: 16 }}>
              {children.map(child => renderFieldWithChildren(child))}
            </div>
          )}
        </div>
      );
    }

    // ==================== PARAGRAPH FIELD ====================
    if (field.type === "paragraph") {
      return (
        <div key={field.id} style={{ marginBottom: 16, marginLeft: field.parentId ? 64 : 0 }}>
          <Text style={{ fontSize: "14px", lineHeight: "1.6", color: "#495057", display: "block" }}>
            {previewLanguage === 'english' ? (field.enLabel || field.label) : (field.mrLabel || field.label)}
          </Text>
          {(previewLanguage === 'english' ? field.enHelpText : field.mrHelpText) && (
            <Text type="secondary" style={{ fontSize: "12px", display: "block", marginTop: 4 }}>
              {previewLanguage === 'english' ? field.enHelpText : field.mrHelpText}
            </Text>
          )}
        </div>
      );
    }

    // ==================== TEXT FIELD ====================
    if (field.type === "text") {
      const currentValue = previewValues[field.id] || '';
      const validation = applyTextValidation(field, currentValue);
      const activeRules = buildTextActiveRules(field);
      const exactLength = field.validation?.exactLength;

      if (validation.transformed !== currentValue && validation.transformed !== undefined) {
        if (previewValues[field.id] !== validation.transformed) {
          setTimeout(() => setPreviewValues(prev => ({ ...prev, [field.id]: validation.transformed })), 0);
        }
      }

      return (
        <div key={field.id} style={{ marginBottom: 12, marginLeft: field.parentId ? 64 : 0 }}>
          <div style={{ marginBottom: 4, fontWeight: 600, fontSize: '13px', color: validation.error ? '#ff4444' : '#333' }}>
            {previewLanguage === 'english' ? (field.enLabel || field.label) : (field.mrLabel || field.label)}
            {field.enRequired && <span style={{ color: "#ff4d4f", marginLeft: 4 }}>*</span>}
            {activeRules.length > 0 && (
              <div style={{ marginTop: 4, display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                {activeRules.map((rule, idx) => (
                  <Tag key={idx} color={rule.color} style={{ fontSize: '10px', margin: 0 }}>{rule.text}</Tag>
                ))}
              </div>
            )}
          </div>
          <Input
            placeholder={previewLanguage === 'english' ? (field.enPlaceholder || field.placeholder) : (field.mrPlaceholder || field.placeholder)}
            onChange={(e) => {
              let newValue = e.target.value;
              if (exactLength && newValue.length > exactLength) {
                newValue = newValue.slice(0, exactLength);
              }
              const { transformed, error } = applyTextValidation(field, newValue);
              setPreviewValues({ ...previewValues, [field.id]: transformed });
              if (error && transformed) message.error(error);
            }}
            maxLength={exactLength || undefined}
            value={validation.transformed}
            style={{
              borderRadius: "6px", width: "100%",
              textTransform: field.validation?.uppercase ? "uppercase" : field.validation?.lowercase ? "lowercase" : "none",
              borderColor: validation.error ? "#ff4d4f" : undefined
            }}
            status={validation.error ? "error" : undefined}
          />
          {validation.error && validation.transformed && (
            <Text type="danger" style={{ fontSize: "12px", display: "block", marginTop: 4 }}>{validation.error}</Text>
          )}
          {(previewLanguage === 'english' ? field.enHelpText : field.mrHelpText) && (
            <Text type="secondary" style={{ fontSize: "12px", display: "block", marginTop: 4 }}>
              {previewLanguage === 'english' ? field.enHelpText : field.mrHelpText}
            </Text>
          )}
        </div>
      );
    }

    // ==================== NUMBER FIELD WITH WORD DISPLAY ====================
    if (field.type === "number") {
      const unitInfo = getUnitDisplayInfo(field);
      const currentValue = previewValues[field.id] || '';
      const validation = applyNumberValidation(field, currentValue);
      const activeRules = buildNumberActiveRules(field, unitInfo);
      const exactLength = field.validation?.exactLength;

      const numericValue = parseFloat(validation.transformed);
      const hasValue = validation.transformed !== '' && !isNaN(numericValue);
      const textRepresentation = hasValue ? numberToWords(validation.transformed) : '';

      if (validation.transformed !== currentValue && validation.transformed !== undefined) {
        if (previewValues[field.id] !== validation.transformed) {
          setTimeout(() => setPreviewValues(prev => ({ ...prev, [field.id]: validation.transformed })), 0);
        }
      }

      return (
        <div key={field.id} style={{ marginBottom: 12, marginLeft: field.parentId ? 64 : 0 }}>
          <div style={{ marginBottom: 4, fontWeight: 600, fontSize: '13px', color: validation.error ? '#ff4444' : '#333' }}>
            {previewLanguage === 'english' ? (field.enLabel || field.label) : (field.mrLabel || field.label)}
            {field.enRequired && <span style={{ color: "#ff4d4f", marginLeft: 4 }}>*</span>}
            {activeRules.length > 0 && (
              <div style={{ marginTop: 4, display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                {activeRules.map((rule, idx) => (
                  <Tag key={idx} color={rule.color} style={{ fontSize: '10px', margin: 0 }}>{rule.text}</Tag>
                ))}
              </div>
            )}
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%' }}>
            <Input
              type="text"
              inputMode="numeric"
              placeholder={previewLanguage === 'english' ? (field.enPlaceholder || field.placeholder) : (field.mrPlaceholder || field.placeholder)}
              onChange={(e) => {
                let newValue = e.target.value;
                if (exactLength) {
                  const digitsOnly = newValue.replace(/[^0-9]/g, '');
                  if (digitsOnly.length > exactLength) {
                    const allowedDigits = digitsOnly.slice(0, exactLength);
                    const hasNegative = newValue.startsWith('-');
                    const decimalIndex = newValue.indexOf('.');
                    if (decimalIndex !== -1) {
                      newValue = (hasNegative ? '-' : '') + allowedDigits + '.' + newValue.slice(decimalIndex + 1);
                    } else {
                      newValue = (hasNegative ? '-' : '') + allowedDigits;
                    }
                  }
                }
                const { transformed, error } = applyNumberValidation(field, newValue);
                setPreviewValues({ ...previewValues, [field.id]: transformed });
                if (error && transformed) message.error(error);
              }}
              value={validation.transformed}
              style={{ borderRadius: "6px", flex: 1, borderColor: validation.error ? "#ff4d4f" : undefined }}
              status={validation.error ? "error" : undefined}
            />
            {unitInfo?.symbol && (
              <div style={{ padding: '0 12px', background: '#f5f5f5', borderRadius: '4px', fontSize: '14px', color: '#666', height: '32px', display: 'flex', alignItems: 'center', border: '1px solid #d9d9d9' }}>
                {unitInfo.symbol}
              </div>
            )}
          </div>

          {hasValue && !validation.error && textRepresentation && (
            <div style={{ marginTop: 8, padding: '8px 12px', background: '#f6ffed', borderRadius: '6px', border: '1px solid #b7eb8f' }}>
              <Text style={{ fontSize: '12px', color: '#333' }}>
                {textRepresentation.charAt(0).toUpperCase() + textRepresentation.slice(1)}
                {unitInfo?.name && <span style={{ marginLeft: 4, color: '#666' }}>({unitInfo.name})</span>}
              </Text>
            </div>
          )}

          {validation.error && validation.transformed && (
            <Text type="danger" style={{ fontSize: "12px", display: "block", marginTop: 4 }}>{validation.error}</Text>
          )}

          {(previewLanguage === 'english' ? field.enHelpText : field.mrHelpText) && (
            <Text type="secondary" style={{ fontSize: "12px", display: "block", marginTop: 4 }}>
              {previewLanguage === 'english' ? field.enHelpText : field.mrHelpText}
            </Text>
          )}
        </div>
      );
    }

    // ==================== DATE FIELD ====================
    if (field.type === "date") {
      const dateValidation = applyDateValidation(field, previewValues[field.id]);
      const dateRules = buildDateRules(field);

      let comparisonValidation = { valid: true, message: '' };

      if (field.enableDateComparison && previewValues[field.id]) {
        const selectedDate = previewValues[field.id];
        if (field.comparisonOperator === 'current_date') {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          if (selectedDate !== today.toISOString().split('T')[0]) {
            comparisonValidation = { valid: false, message: field.customValidationMessage || `Date must be today's date` };
          }
        } else if (field.comparisonType === 'single' && field.compareWithDate) {
          const compareDate = new Date(field.compareWithDate);
          const selDate = new Date(selectedDate);
          if (selDate.toDateString() !== compareDate.toDateString()) {
            comparisonValidation = { valid: false, message: field.customValidationMessage || `Date must be ${field.comparisonOperator} ${field.compareWithDate}` };
          }
        } else if (field.comparisonType === 'range' && field.startDate && field.endDate) {
          const selDate = new Date(selectedDate);
          const start = new Date(field.startDate);
          const end = new Date(field.endDate);
          if (selDate < start || selDate > end) {
            comparisonValidation = { valid: false, message: field.customValidationMessage || `Date must be between ${field.startDate} and ${field.endDate}` };
          }
        }
      }

      const finalValid = dateValidation.valid && comparisonValidation.valid;
      const finalError = dateValidation.error || comparisonValidation.message;

      return (
        <div key={field.id} style={{ marginBottom: 12, marginLeft: field.parentId ? 64 : 0 }}>
          <div style={{ marginBottom: 4, fontWeight: 600, fontSize: '13px', color: finalValid ? '#333' : '#ff4444' }}>
            {previewLanguage === 'english' ? (field.enLabel || field.label) : (field.mrLabel || field.label)}
            {field.enRequired && <span style={{ color: "#ff4d4f" }}>*</span>}
            {field.enableDateComparison && (
              <Tag color="orange" style={{ marginLeft: 8, fontSize: "10px" }}>
                <SwapOutlined /> {field.comparisonOperator === 'current_date' ? 'Current Date ON' : 'Comparison ON'}
              </Tag>
            )}
            {dateRules.length > 0 && (
              <div style={{ marginTop: 4, display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                {dateRules.map((rule, idx) => (
                  <Tag key={idx} color={rule.color} style={{ fontSize: '10px', margin: 0 }}>{rule.text}</Tag>
                ))}
              </div>
            )}
          </div>
          <Input
            type="date"
            style={{ width: "100%", borderRadius: "6px", borderColor: finalValid ? undefined : "#ff4d4f" }}
            onChange={(e) => setPreviewValues({ ...previewValues, [field.id]: e.target.value })}
            value={previewValues[field.id]}
            status={finalValid ? undefined : "error"}
          />
          {!finalValid && (
            <Text type="danger" style={{ fontSize: "12px", display: "block", marginTop: 4 }}>{finalError}</Text>
          )}
          {(previewLanguage === 'english' ? field.enHelpText : field.mrHelpText) && finalValid && (
            <Text type="secondary" style={{ fontSize: "12px", display: "block", marginTop: 4 }}>
              {previewLanguage === 'english' ? field.enHelpText : field.mrHelpText}
            </Text>
          )}
        </div>
      );
    }

    // ==================== DROPDOWN FIELD ====================
    if (field.type === "dropdown") {
      const options = field.enOptions || field.options || [];
      const mrOptions = field.mrOptions || [];
      const selectOptions = options.map((opt, idx) => ({ label: previewLanguage === 'english' ? opt : (mrOptions[idx] || opt), value: opt }));

      return (
        <div key={field.id} style={{ marginBottom: 12, marginLeft: field.parentId ? 64 : 0 }}>
          <div style={{ marginBottom: 4, fontWeight: 600, fontSize: '13px', color: '#333' }}>
            {previewLanguage === 'english' ? (field.enLabel || field.label) : (field.mrLabel || field.label)}
            {field.enRequired && <span style={{ color: "#ff4d4f" }}>*</span>}
            {field.allowSearch && <Tag color="cyan" style={{ marginLeft: 8, fontSize: '10px' }}><SearchOutlined /> Searchable</Tag>}
            {field.allowMultiSelect && <Tag color="green" style={{ marginLeft: 4, fontSize: '10px' }}><CheckSquareOutlined /> Multi-select</Tag>}
          </div>
          <Select
            placeholder={previewLanguage === 'english' ? (field.enPlaceholder || "Select option...") : (field.mrPlaceholder || "पर्याय निवडा...")}
            style={{ width: "100%" }}
            onChange={(value) => setPreviewValues({ ...previewValues, [field.id]: value })}
            value={previewValues[field.id]}
            allowClear={!field.enRequired}
            showSearch={field.allowSearch === true}
            mode={field.allowMultiSelect === true ? "multiple" : undefined}
            options={selectOptions}
            getPopupContainer={(trigger) => trigger.parentNode}
          />
          {(previewLanguage === 'english' ? field.enHelpText : field.mrHelpText) && (
            <Text type="secondary" style={{ fontSize: "12px", display: "block", marginTop: 4 }}>
              {previewLanguage === 'english' ? field.enHelpText : field.mrHelpText}
            </Text>
          )}
        </div>
      );
    }

    // ==================== RADIO FIELD ====================
    if (field.type === "radio") {
      const options = previewLanguage === 'english' ? (field.enOptions || field.options || []) : (field.mrOptions || field.options || []);

      return (
        <div key={field.id}>
          <div style={{ marginBottom: 4, fontWeight: 600, fontSize: '13px', color: '#333' }}>
            {previewLanguage === 'english' ? (field.enLabel || field.label) : (field.mrLabel || field.label)}
            {field.enRequired && <span style={{ color: "#ff4d4f", marginLeft: 4 }}>*</span>}
          </div>
          <Radio.Group onChange={(e) => setPreviewValues({ ...previewValues, [field.id]: e.target.value })} value={previewValues[field.id]}>
            {options.map((opt, idx) => <Radio key={idx} value={opt}>{opt}</Radio>)}
          </Radio.Group>
          {(previewLanguage === 'english' ? field.enHelpText : field.mrHelpText) && (
            <Text type="secondary" style={{ fontSize: "12px", display: "block", marginTop: 4 }}>
              {previewLanguage === 'english' ? field.enHelpText : field.mrHelpText}
            </Text>
          )}
          {previewValues[field.id] && (
            <div style={{ marginLeft: 24, padding: "16px", background: "#f8f9fa", borderRadius: "8px", border: "1px solid #e9ecef", marginBottom: 16, marginTop: 8 }}>
              <Text type="secondary" style={{ marginBottom: 12, display: "block" }}>
                {previewLanguage === 'english' ? 'Fields for' : 'साठी फील्ड'} "{previewValues[field.id]}":
              </Text>
              {children.filter(f => f.colName === previewValues[field.id]).map(subField => renderFieldWithChildren(subField))}
            </div>
          )}
        </div>
      );
    }

    // ==================== CHECKBOX FIELD ====================
    if (field.type === "checkbox") {
      const options = previewLanguage === 'english' ? (field.enOptions || field.options || []) : (field.mrOptions || field.options || []);
      const selectedValues = Array.isArray(previewValues[field.id]) ? previewValues[field.id] : (previewValues[field.id] ? [previewValues[field.id]] : []);

      return (
        <div key={field.id}>
          <div style={{ marginBottom: 4, fontWeight: 600, fontSize: '13px', color: '#333' }}>
            {previewLanguage === 'english' ? (field.enLabel || field.label) : (field.mrLabel || field.label)}
            {field.enRequired && <span style={{ color: "#ff4d4f", marginLeft: 4 }}>*</span>}
          </div>
          <Checkbox.Group onChange={(values) => setPreviewValues({ ...previewValues, [field.id]: values })} value={selectedValues}>
            {options.map((opt, idx) => <Checkbox key={idx} value={opt}>{opt}</Checkbox>)}
          </Checkbox.Group>
          {(previewLanguage === 'english' ? field.enHelpText : field.mrHelpText) && (
            <Text type="secondary" style={{ fontSize: "12px", display: "block", marginTop: 4 }}>
              {previewLanguage === 'english' ? field.enHelpText : field.mrHelpText}
            </Text>
          )}
          {selectedValues.length > 0 && (
            <div style={{ marginLeft: 24, padding: "16px", background: "#f6ffed", borderRadius: "8px", border: "1px solid #b7eb8f", marginBottom: 16, marginTop: 8 }}>
              <Text type="secondary" style={{ marginBottom: 12, display: "block" }}>
                {previewLanguage === 'english' ? 'Fields for selected options' : 'निवडलेल्या पर्यायांसाठी फील्ड'}:
              </Text>
              {selectedValues.map(selectedOption => {
                const optionSubFields = children.filter(f => f.colName === selectedOption);
                if (optionSubFields.length === 0) return null;
                return (
                  <div key={selectedOption} style={{ marginBottom: 12 }}>
                    <div style={{ padding: "8px 12px", background: "#e6f7ff", borderLeft: "3px solid #1890ff", marginBottom: 8 }}>
                      <Checkbox checked disabled style={{ marginRight: 8 }} /><Text strong>{selectedOption}</Text>
                    </div>
                    {optionSubFields.map(subField => renderFieldWithChildren(subField))}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      );
    }

    // ==================== FILE UPLOAD FIELD ====================
    if (field.type === "file") {
      return (
        <div key={field.id} style={{ marginBottom: 12, marginLeft: field.parentId ? 64 : 0 }}>
          <div style={{ marginBottom: 4, fontWeight: 600, fontSize: '13px', color: '#333' }}>
            {previewLanguage === 'english' ? (field.enLabel || field.label) : (field.mrLabel || field.label)}
            {field.enRequired && <span style={{ color: "#ff4d4f", marginLeft: 4 }}>*</span>}
          </div>
          <div style={{ marginTop: 4 }}>
            <Tag color="blue" style={{ fontSize: '10px' }}><UploadOutlined /> Max: {field.maxFileSize || 5}MB</Tag>
            {field.maxFileCount > 1 && <Tag color="green" style={{ fontSize: '10px', marginLeft: 4 }}>Up to {field.maxFileCount} files</Tag>}
          </div>
          <Upload
            fileList={previewFileList[field.id] || []}
            onChange={(info) => setPreviewFileList({ ...previewFileList, [field.id]: info.fileList })}
            multiple={field.maxFileCount > 1}
            accept={field.acceptedFileTypes || ".jpg,.jpeg,.png,.gif,.bmp,.pdf,.doc,.docx,.xls,.xlsx,.txt"}
          >
            <Button icon={<UploadOutlined />}>{previewLanguage === 'english' ? 'Upload File' : 'फाइल अपलोड करा'}</Button>
          </Upload>
          {(previewLanguage === 'english' ? field.enHelpText : field.mrHelpText) && (
            <Text type="secondary" style={{ fontSize: "12px", display: "block", marginTop: 4 }}>
              {previewLanguage === 'english' ? field.enHelpText : field.mrHelpText}
            </Text>
          )}
        </div>
      );
    }

    // ==================== COMPARISON FIELD ====================
    if (field.type === "comparison") {
      const calculatedValue = calculateArithmeticResultLocal(previewValues, field.subFields);
      const mainValue = previewValues[field.mainField?.id];
      const isValid = mainValue !== undefined ? checkComparisonLocal(mainValue, calculatedValue, field.comparisonOperator) : null;
      const customValidationMessage = field.customValidationMessage || (previewLanguage === 'english' ? '✗ Validation Failed' : '✗ मान्यता अयशस्वी');

      const mainUnitInfo = getUnitDisplayInfo(field.mainField);
      const currentMainValue = previewValues[field.mainField?.id] || '';
      const mainValidation = applyNumberValidation(field.mainField, currentMainValue);
      const mainActiveRules = buildNumberActiveRules(field.mainField, mainUnitInfo);

      if (mainValidation.transformed !== currentMainValue && mainValidation.transformed !== undefined) {
        if (previewValues[field.mainField?.id] !== mainValidation.transformed) {
          setTimeout(() => setPreviewValues(prev => ({ ...prev, [field.mainField.id]: mainValidation.transformed })), 0);
        }
      }

      return (
        <div key={field.id} style={{ marginBottom: 16, marginLeft: field.parentId ? 64 : 0 }}>
          <div style={{ marginBottom: 4, fontWeight: 600, fontSize: '13px', color: '#333' }}>
            {previewLanguage === 'english' ? (field.enLabel || field.label) : (field.mrLabel || field.label)}
            {field.enRequired && <span style={{ color: "#ff4d4f", marginLeft: 4 }}>*</span>}
          </div>

          {/* Main Field */}
          <div style={{ marginBottom: 12 }}>
            <div style={{ marginBottom: 4, fontSize: '12px', fontWeight: 500, color: mainValidation.error ? '#ff4444' : '#555' }}>
              {previewLanguage === 'english' ? field.mainField?.enLabel : field.mainField?.mrLabel}
              {mainActiveRules.length > 0 && (
                <div style={{ marginTop: 2, display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                  {mainActiveRules.map((rule, ridx) => (
                    <Tag key={ridx} color={rule.color} style={{ fontSize: '9px', margin: 0 }}>{rule.text}</Tag>
                  ))}
                </div>
              )}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', maxWidth: '300px' }}>
              <Input
                type="text"
                inputMode="numeric"
                placeholder={previewLanguage === 'english' ? field.mainField?.enPlaceholder : field.mainField?.mrPlaceholder}
                onChange={(e) => {
                  let newValue = e.target.value;
                  if (field.mainField?.validation?.exactLength) {
                    const exactLen = field.mainField.validation.exactLength;
                    const digitsOnly = newValue.replace(/[^0-9]/g, '');
                    if (digitsOnly.length > exactLen) {
                      const allowedDigits = digitsOnly.slice(0, exactLen);
                      const hasNegative = newValue.startsWith('-');
                      const decimalIndex = newValue.indexOf('.');
                      if (decimalIndex !== -1) {
                        newValue = (hasNegative ? '-' : '') + allowedDigits + '.' + newValue.slice(decimalIndex + 1);
                      } else {
                        newValue = (hasNegative ? '-' : '') + allowedDigits;
                      }
                    }
                  }
                  const { transformed, error } = applyNumberValidation(field.mainField, newValue);
                  setPreviewValues({ ...previewValues, [field.mainField.id]: transformed });
                  if (error && transformed) message.error(error);
                }}
                value={mainValidation.transformed}
                style={{ borderRadius: "6px", flex: 1, borderColor: mainValidation.error ? "#ff4d4f" : undefined }}
                status={mainValidation.error ? "error" : undefined}
              />
              {mainUnitInfo?.symbol && (
                <div style={{ padding: '0 12px', background: '#f5f5f5', borderRadius: '4px', fontSize: '14px', color: '#666', height: '32px', display: 'flex', alignItems: 'center', border: '1px solid #d9d9d9' }}>
                  {mainUnitInfo.symbol}
                </div>
              )}
            </div>
            {mainValidation.error && mainValidation.transformed && (
              <Text type="danger" style={{ fontSize: "11px", display: "block", marginTop: 4 }}>{mainValidation.error}</Text>
            )}
          </div>

          {/* Sub Fields */}
          {field.subFields?.map((subField, idx) => {
            const subUnitInfo = getUnitDisplayInfo(subField);
            const currentSubValue = previewValues[subField.id] || '';
            const subValidation = applyNumberValidation(subField, currentSubValue);
            const subActiveRules = buildNumberActiveRules(subField, subUnitInfo);

            if (subValidation.transformed !== currentSubValue && subValidation.transformed !== undefined) {
              if (previewValues[subField.id] !== subValidation.transformed) {
                setTimeout(() => setPreviewValues(prev => ({ ...prev, [subField.id]: subValidation.transformed })), 0);
              }
            }

            return (
              <div key={subField.id} style={{ marginBottom: 12 }}>
                <div style={{ marginBottom: 4, fontSize: '12px', fontWeight: 500, color: subValidation.error ? '#ff4444' : '#555' }}>
                  {previewLanguage === 'english' ? (subField.enLabel || subField.label) : (subField.mrLabel || subField.label)}
                  {subActiveRules.length > 0 && (
                    <div style={{ marginTop: 2, display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                      {subActiveRules.map((rule, ridx) => (
                        <Tag key={ridx} color={rule.color} style={{ fontSize: '9px', margin: 0 }}>{rule.text}</Tag>
                      ))}
                    </div>
                  )}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%' }}>
                  <Input
                    type="text"
                    inputMode="numeric"
                    placeholder={previewLanguage === 'english' ? (subField.enPlaceholder || subField.placeholder) : (subField.mrPlaceholder || subField.placeholder)}
                    onChange={(e) => {
                      let newValue = e.target.value;
                      if (subField.validation?.exactLength) {
                        const exactLen = subField.validation.exactLength;
                        const digitsOnly = newValue.replace(/[^0-9]/g, '');
                        if (digitsOnly.length > exactLen) {
                          const allowedDigits = digitsOnly.slice(0, exactLen);
                          const hasNegative = newValue.startsWith('-');
                          const decimalIndex = newValue.indexOf('.');
                          if (decimalIndex !== -1) {
                            newValue = (hasNegative ? '-' : '') + allowedDigits + '.' + newValue.slice(decimalIndex + 1);
                          } else {
                            newValue = (hasNegative ? '-' : '') + allowedDigits;
                          }
                        }
                      }
                      const { transformed, error } = applyNumberValidation(subField, newValue);
                      setPreviewValues({ ...previewValues, [subField.id]: transformed });
                      if (error && transformed) message.error(error);
                    }}
                    value={subValidation.transformed}
                    style={{ borderRadius: "6px", flex: 1, borderColor: subValidation.error ? "#ff4d4f" : undefined }}
                    status={subValidation.error ? "error" : undefined}
                  />
                  {subUnitInfo?.symbol && (
                    <div style={{ padding: '0 12px', background: '#f5f5f5', borderRadius: '4px', fontSize: '14px', color: '#666', height: '32px', display: 'flex', alignItems: 'center', border: '1px solid #d9d9d9' }}>
                      {subUnitInfo.symbol}
                    </div>
                  )}
                </div>
                {subValidation.error && subValidation.transformed && (
                  <Text type="danger" style={{ fontSize: "11px", display: "block", marginTop: 4 }}>{subValidation.error}</Text>
                )}
              </div>
            );
          })}

          {/* ONLY show error message when condition fails */}
          {mainValue !== undefined && isValid === false && (
            <div style={{ marginTop: 12, padding: "10px 12px", background: "#ffebee", border: "1px solid #ffcdd2", borderRadius: "8px" }}>
              <Text strong style={{ color: "#c62828" }}>{customValidationMessage}</Text>
            </div>
          )}
        </div>
      );
    }

    // ==================== ARITHMETIC FIELD ====================
    if (field.type === "arithmetic") {
      let calculatedResult = 0;
      let validationErrors = [];
      let allFieldsValid = true;
      const validatedInputs = [];
      
      if (field.arithmeticFields && field.arithmeticFields.length > 0) {
        for (let idx = 0; idx < field.arithmeticFields.length; idx++) {
          const afield = field.arithmeticFields[idx];
          const currentValue = previewValues[afield.id] || '';
          const unitInfo = getUnitDisplayInfo(afield);
          const validation = applyNumberValidation(afield, currentValue);
          
          if (validation.error) {
            validationErrors.push({
              field: afield,
              index: idx,
              error: validation.error,
              value: currentValue
            });
            allFieldsValid = false;
            validatedInputs.push({ field: afield, value: 0, valid: false, error: validation.error });
          } else {
            let numericValue = parseFloat(validation.transformed) || 0;
            if (unitInfo && unitInfo.value && unitInfo.value !== 1) {
              numericValue = numericValue * parseFloat(unitInfo.value);
            }
            validatedInputs.push({ 
              field: afield, 
              value: numericValue, 
              valid: true, 
              error: null,
              originalValue: validation.transformed,
              unitInfo: unitInfo
            });
          }
        }
      }
      
      if (allFieldsValid && validatedInputs.length > 0) {
        const numbers = validatedInputs.map(v => v.value);
        switch (field.arithmeticOperator) {
          case "add": calculatedResult = numbers.reduce((a, b) => a + b, 0); break;
          case "subtract": calculatedResult = numbers.reduce((a, b) => a - b); break;
          case "multiply": calculatedResult = numbers.reduce((a, b) => a * b, 1); break;
          case "divide": 
            if (numbers.slice(1).some(n => n === 0)) {
              validationErrors.push({ error: "Division by zero is not allowed" });
              allFieldsValid = false;
            } else {
              calculatedResult = numbers.reduce((a, b) => a / b);
            }
            break;
          case "average": calculatedResult = numbers.reduce((a, b) => a + b, 0) / numbers.length; break;
          case "percentage":
            if (numbers.length >= 2) {
              if (numbers[1] === 0) {
                validationErrors.push({ error: "Base value cannot be zero for percentage calculation" });
                allFieldsValid = false;
              } else {
                calculatedResult = (numbers[0] / numbers[1]) * 100;
              }
            }
            break;
          default: calculatedResult = numbers.reduce((a, b) => a + b, 0);
        }
      }
      
      const editedResult = previewValues[`${field.id}_result`];
      const displayResult = editedResult !== undefined ? editedResult : calculatedResult;
      const resultValidation = field.resultField ? applyNumberValidation(field.resultField, displayResult.toString()) : { transformed: displayResult, error: null };
      const hasResultError = resultValidation.error && !allFieldsValid;
      
      const getDefaultOperationLabel = () => {
        switch (field.arithmeticOperator) {
          case "add": return previewLanguage === 'english' ? 'Addition (+)' : 'बेरीज (+)';
          case "subtract": return previewLanguage === 'english' ? 'Subtraction (-)' : 'वजाबाकी (-)';
          case "multiply": return previewLanguage === 'english' ? 'Multiplication (×)' : 'गुणाकार (×)';
          case "divide": return previewLanguage === 'english' ? 'Division (÷)' : 'भागाकार (÷)';
          case "average": return previewLanguage === 'english' ? 'Average (avg)' : 'सरासरी (avg)';
          case "percentage": return previewLanguage === 'english' ? 'Percentage (%)' : 'टक्केवारी (%)';
          default: return previewLanguage === 'english' ? 'Calculation' : 'गणना';
        }
      };
      
      const displayOperationLabel = getDefaultOperationLabel();
      
      return (
        <div key={field.id} style={{ marginBottom: 16, marginLeft: field.parentId ? 64 : 0 }}>
          <div style={{ marginBottom: 4, fontWeight: 600, fontSize: '13px', color: '#333' }}>
            {previewLanguage === 'english' ? (field.enLabel || field.label) : (field.mrLabel || field.label)}
            {field.enRequired && <span style={{ color: "#ff4d4f", marginLeft: 4 }}>*</span>}
            <Tag color="green" style={{ marginLeft: 8, fontSize: '10px' }}>
              <CalculatorOutlined /> {displayOperationLabel}
            </Tag>
            {!allFieldsValid && (
              <Tag color="red" style={{ marginLeft: 8, fontSize: '10px' }}>
                <CloseCircleOutlined /> Validation Failed
              </Tag>
            )}
          </div>

          {field.arithmeticFields?.map((afield, idx) => {
            const currentValue = previewValues[afield.id] || '';
            const unitInfo = getUnitDisplayInfo(afield);
            const validation = applyNumberValidation(afield, currentValue);
            const activeRules = buildNumberActiveRules(afield, unitInfo);
            const exactLength = afield.validation?.exactLength;
            const hasError = !!validation.error;
            
            if (validation.transformed !== currentValue && validation.transformed !== undefined) {
              if (previewValues[afield.id] !== validation.transformed) {
                setTimeout(() => setPreviewValues(prev => ({ ...prev, [afield.id]: validation.transformed })), 0);
              }
            }
            
            return (
              <div key={afield.id} style={{ marginBottom: 12 }}>
                <div style={{ marginBottom: 4, fontSize: '12px', fontWeight: 500, color: hasError ? '#ff4444' : '#555' }}>
                  {previewLanguage === 'english' ? (afield.enLabel || afield.label) : (afield.mrLabel || afield.label)}
                  {field.arithmeticOperator === "percentage" && idx === 0 && " (%)"}
                  {field.arithmeticOperator === "percentage" && idx === 1 && " (Base)"}
                  {afield.enRequired && <span style={{ color: "#ff4d4f", marginLeft: 4 }}>*</span>}
                  {hasError && (
                    <Tooltip title={validation.error}>
                      <CloseCircleOutlined style={{ color: '#ff4d4f', fontSize: '12px', marginLeft: 8 }} />
                    </Tooltip>
                  )}
                  {activeRules.length > 0 && (
                    <div style={{ marginTop: 2, display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                      {activeRules.map((rule, ridx) => (
                        <Tag key={ridx} color={rule.color} style={{ fontSize: '9px', margin: 0 }}>
                          {rule.text}
                        </Tag>
                      ))}
                    </div>
                  )}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%' }}>
                  <Input
                    type="text"
                    inputMode="numeric"
                    placeholder={previewLanguage === 'english' ? (afield.enPlaceholder || afield.placeholder) : (afield.mrPlaceholder || afield.placeholder)}
                    onChange={(e) => {
                      let newValue = e.target.value;
                      if (exactLength) {
                        const digitsOnly = newValue.replace(/[^0-9]/g, '');
                        if (digitsOnly.length > exactLength) {
                          const allowedDigits = digitsOnly.slice(0, exactLength);
                          const hasNegative = newValue.startsWith('-');
                          const decimalIndex = newValue.indexOf('.');
                          if (decimalIndex !== -1) {
                            newValue = (hasNegative ? '-' : '') + allowedDigits + '.' + newValue.slice(decimalIndex + 1);
                          } else {
                            newValue = (hasNegative ? '-' : '') + allowedDigits;
                          }
                        }
                      }
                      const { transformed, error } = applyNumberValidation(afield, newValue);
                      setPreviewValues(prev => ({ ...prev, [afield.id]: transformed }));
                      if (error && transformed) message.error(error);
                      const newValues = { ...previewValues, [afield.id]: transformed };
                      delete newValues[`${field.id}_result`];
                      setPreviewValues(newValues);
                    }}
                    value={validation.transformed}
                    style={{ 
                      borderRadius: "6px", 
                      flex: 1, 
                      borderColor: hasError ? "#ff4d4f" : undefined,
                      backgroundColor: hasError ? '#fff2f0' : 'white'
                    }}
                    status={hasError ? "error" : undefined}
                  />
                  {unitInfo?.symbol && (
                    <div style={{ 
                      padding: '0 12px', 
                      background: '#f5f5f5', 
                      borderRadius: '4px', 
                      fontSize: '14px', 
                      color: '#666', 
                      height: '32px', 
                      display: 'flex', 
                      alignItems: 'center', 
                      border: '1px solid #d9d9d9' 
                    }}>
                      {unitInfo.symbol}
                    </div>
                  )}
                </div>
                {hasError && validation.transformed && (
                  <Text type="danger" style={{ fontSize: "11px", display: "block", marginTop: 4 }}>
                    {validation.error}
                  </Text>
                )}
                {!hasError && validation.transformed && validation.transformed !== '' && (
                  <Text type="secondary" style={{ fontSize: "10px", display: "block", marginTop: 2 }}>
                    ✓ Valid
                  </Text>
                )}
              </div>
            );
          })}

          {validationErrors.length > 0 && (
            <Alert
              message={previewLanguage === 'english' ? 'Validation Errors' : 'वैधता त्रुटी'}
              description={
                <ul style={{ margin: 0, paddingLeft: 20 }}>
                  {validationErrors.map((err, idx) => (
                    <li key={idx}>
                      {err.field?.enLabel || err.field?.label || `Field ${err.index + 1}`}: {err.error}
                    </li>
                  ))}
                </ul>
              }
              type="error"
              showIcon
              style={{ marginBottom: 16 }}
            />
          )}

          <div style={{ marginTop: 12, padding: "12px 16px", background: allFieldsValid ? "#f6ffed" : "#fff7e6", border: allFieldsValid ? "1px solid #b7eb8f" : "1px solid #ffe58f", borderRadius: "8px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
              <Text strong style={{ fontSize: "14px" }}>
                {previewLanguage === 'english' ? (field.resultField?.enLabel || "Result") : (field.resultField?.mrLabel || "परिणाम")}:
              </Text>
              <Text strong style={{ fontSize: "16px", color: allFieldsValid ? "#389e0d" : "#d48806" }}>
                {allFieldsValid ? displayResult.toFixed(2) : 'Invalid'}
              </Text>
              <Button
                size="small"
                type="link"
                onClick={() => {
                  const newValues = { ...previewValues };
                  delete newValues[`${field.id}_result`];
                  setPreviewValues(newValues);
                }}
              >
                {previewLanguage === 'english' ? 'Reset to calculated' : 'गणना केलेल्यावर रीसेट करा'}
              </Button>
            </div>
            {allFieldsValid && displayResult !== 0 && (
              <div style={{ marginTop: 6, padding: '4px 8px', background: '#e6f7ff', borderRadius: '4px' }}>
                <Text style={{ fontSize: '11px', color: '#333' }}>
                  {numberToWords(displayResult.toFixed(2)).charAt(0).toUpperCase() + numberToWords(displayResult.toFixed(2)).slice(1)}
                </Text>
              </div>
            )}
            {hasResultError && (
              <Text type="danger" style={{ fontSize: "12px", display: "block", marginTop: 6 }}>
                {resultValidation.error}
              </Text>
            )}
            {!allFieldsValid && !hasResultError && (
              <Text type="warning" style={{ fontSize: "12px", display: "block", marginTop: 6 }}>
                {previewLanguage === 'english' 
                  ? 'Please fix validation errors above to see the result'
                  : 'परिणाम पाहण्यासाठी कृपया वरील वैधता त्रुटी सुधारा'}
              </Text>
            )}
          </div>

          {field.arithmeticOperator === "percentage" && (
            <Alert
              message={previewLanguage === 'english' 
                ? "Percentage calculation: (Value1% of Value2)" 
                : "टक्केवारी गणना: (मूल्य१% of मूल्य२)"}
              type="info"
              showIcon
              style={{ marginTop: 8 }}
            />
          )}
        </div>
      );
    }

// ==================== FORMULA FIELD ====================
if (field.type === "formula") {
  const formulaSteps = field.formulaSteps || [];
  const stepCombineOp = field.stepCombineOperator || 'add';
  const showResult = field.showResult !== false;
  const finalResultLabel = field.finalResultLabel || { en: 'Final Result', mr: 'अंतिम निकाल' };
  const finalFalseMessage = field.finalFalseMessage || '';
  const isLogicalCombine = ['equals', 'not_equals', 'greater_than', 'less_than', 'greater_than_equal', 'less_than_equal'].includes(stepCombineOp);
  const isSingleStep = formulaSteps.length === 1;
  const isNoneCombine = stepCombineOp === 'none';

  const getFormulaUnitDisplay = (fieldData) => {
    if (!fieldData) return null;
    if (fieldData.selectedUnitObject) return fieldData.selectedUnitObject.unit_symbol;
    if (fieldData.units?.enabled && fieldData.units.selectedUnitSymbol) return fieldData.units.selectedUnitSymbol;
    return null;
  };

  const getFormulaConstantValue = (fieldData) => {
    if (fieldData.constantValue !== undefined && fieldData.constantValue !== null) {
      return fieldData.constantValue;
    }
    return 0;
  };

  const finalResult = calculateFormulaFinalResult(field, previewValues, fieldMap);
  const finalUnitInfo = getFormulaUnitDisplay(field);
  const finalResultWords = !isLogicalCombine ? getWordsRepresentation(finalResult) : '';
  const finalDisplayValue = !isLogicalCombine ? (finalResult || 0).toFixed(2) : finalResult;

const getStepResultsMap = () => {
  const results = {};
  const allValues = { ...previewValues };
  
  formulaSteps.forEach(step => {
    const stepResult = calculateFormulaStepResult(step, allValues, fieldMap);
    results[step.id] = stepResult;
    // IMPORTANT: Store step result in values for other steps to use
    allValues[step.id] = stepResult;
    allValues[`step_${step.id}_result`] = stepResult;
  });
  
  return results;
};
  const stepResultsMap = getStepResultsMap();

  const areAllStepFieldsIntegerOnly = (step) => {
    const stepFields = step.arithmeticFields || [];
    if (stepFields.length === 0) return false;
    return stepFields.every(f => f.validation?.integerOnly === true);
  };

  const areAllFormulaFieldsIntegerOnly = () => {
    const allFields = formulaSteps.flatMap(step => step.arithmeticFields || []);
    if (allFields.length === 0) return false;
    return allFields.every(f => f.validation?.integerOnly === true);
  };

  const allFieldsIntegerOnly = areAllFormulaFieldsIntegerOnly();

  return (
    <div key={field.id} style={{ marginBottom: 24, marginLeft: field.parentId ? 32 : 0 }}>
      {formulaSteps.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 20, background: '#fafafa', borderRadius: 8 }}>
          <Text type="secondary">No formula steps configured</Text>
        </div>
      ) : (
        <>
          {formulaSteps.map((step, stepIdx) => {
            const visibleFields = (step.arithmeticFields || []).filter(f => 
              !f.isSharedReference || f.isExternalReference
            );
            const stepResult = stepResultsMap[step.id] || 0;
            const stepIsLogical = isLogicalOperator(step.combineOperator);
            const showStepResult = step.showStepResult !== false;
            const stepFalseMessage = step.falseMessage || '';
            const stepResultLabel = previewLanguage === 'english' 
              ? (step.resultLabel?.en || `${step.name} Result`)
              : (step.resultLabel?.mr || `${step.name} चे निकाल`);
            
            const stepResultWords = !stepIsLogical ? getWordsRepresentation(stepResult) : '';
            const stepFieldsIntegerOnly = areAllStepFieldsIntegerOnly(step);

            const isDefaultStepName = step.name && /^Step \d+$/.test(step.name);
            const shouldShowStepHeading = !isDefaultStepName && step.name && step.name.trim() !== '';

            return (
              <div key={step.id} style={{ marginBottom: 24 }}>
                {showStepResult && (
                  <>
                    {shouldShowStepHeading && (
                      <div style={{ marginBottom: 12, display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                        <Badge count={stepIdx + 1} style={{ backgroundColor: '#1890ff' }} />
                        <Text strong style={{ fontSize: '14px' }}>{step.name}</Text>
                        {stepIsLogical && stepFalseMessage && (
                          <Tag color="red" style={{ fontSize: '10px' }}>
                            <MessageOutlined /> Custom False Msg
                          </Tag>
                        )}
                      </div>
                    )}

                    {visibleFields.length > 0 && (
                      <div style={{ marginBottom: 16, paddingLeft: shouldShowStepHeading ? 16 : 0 }}>
                        {visibleFields.map((f, fidx) => {
                          const unitSymbol = getFormulaUnitDisplay(f);
                          const isConstant = f.fieldType === 'constant';
                          const constantValue = isConstant ? getFormulaConstantValue(f) : null;
                          let currentValue = 0;
                          let isReadOnly = false;
                          
                          // ===== FIX: Handle Step Result Reference FIRST =====
                          if (f.isStepResultReference === true) {
                            isReadOnly = true;
                            if (f.sourceStepId) {
                              const sourceStep = formulaSteps.find(s => s.id === f.sourceStepId);
                              if (sourceStep) {
                                const stepResultValue = stepResultsMap[f.sourceStepId];
                                if (stepResultValue !== undefined && stepResultValue !== null) {
                                  currentValue = stepResultValue;
                                } else {
                                  currentValue = 0;
                                }
                              } else {
                                currentValue = 0;
                              }
                            } else {
                              currentValue = 0;
                            }
                          }
                          // ===== Handle Shared/External Reference =====
                          else if (f.isSharedReference === true || f.isExternalReference === true) {
                            const sourceId = f.sourceFieldId || f.id;
                            const sourceField = fieldMap[sourceId];
                            isReadOnly = true;
                            
                            if (f.sourceFieldType === 'formula' && sourceField && sourceField.type === 'formula') {
                              currentValue = calculateFormulaFinalResult(sourceField, previewValues, fieldMap);
                            } 
                            else if (f.sourceFieldType === 'arithmetic' && sourceField && sourceField.type === 'arithmetic') {
                              currentValue = calculateArithmeticResultLocal(previewValues, sourceField.arithmeticFields, sourceField.arithmeticOperator);
                            }
                            else {
                              currentValue = previewValues[sourceId] !== undefined ? previewValues[sourceId] : 0;
                            }
                          } 
                          else if (isConstant) {
                            currentValue = constantValue;
                            isReadOnly = true;
                          } 
                          else {
                            currentValue = previewValues[f.id] !== undefined ? previewValues[f.id] : 0;
                            isReadOnly = false;
                          }
                          
                          const validation = f.validation || {};
                          const integerOnly = validation.integerOnly === true;
                          const allowDecimals = validation.allowDecimals !== false;
                          const allowNegative = validation.allowNegative === true;
                          
                          const wordsRepresentation = !isConstant && currentValue !== 0 && !isNaN(parseFloat(currentValue)) 
                            ? getWordsRepresentation(currentValue) 
                            : '';
                          
                          const displayValue = typeof currentValue === 'number' 
                            ? (integerOnly ? currentValue.toString() : currentValue.toFixed(2))
                            : currentValue;

                          return (
                            <div key={f.id} style={{ marginBottom: 12 }}>
                              <div style={{ marginBottom: 4, fontWeight: 600, fontSize: '13px', color: '#333' }}>
                                {previewLanguage === 'english' ? (f.enLabel || 'Value') : (f.mrLabel || 'मूल्य')}
                                {f.enRequired && !isConstant && !f.isSharedReference && <span style={{ color: '#ff4d4f', marginLeft: 4 }}>*</span>}
                                
                                {integerOnly && <Tag color="orange" style={{ marginLeft: 8, fontSize: '9px' }}>Integer Only</Tag>}
                                {allowDecimals && !integerOnly && <Tag color="blue" style={{ marginLeft: 8, fontSize: '9px' }}>Decimal Allowed</Tag>}
                                {!allowNegative && <Tag color="red" style={{ marginLeft: 8, fontSize: '9px' }}>Positive Only</Tag>}
                                
                                {isConstant && <Tag color="gold" style={{ marginLeft: 8, fontSize: '9px' }}>Constant</Tag>}
                                {f.isStepResultReference && (
                                  <Tag color="magenta" style={{ marginLeft: 8, fontSize: '9px' }}>
                                    <ShareAltOutlined /> Step Result
                                  </Tag>
                                )}
                                {f.isExternalReference && f.sourceFieldType === 'formula' && (
                                  <Tag color="purple" style={{ marginLeft: 8, fontSize: '9px' }}>
                                    <FunctionOutlined /> Formula Result
                                  </Tag>
                                )}
                                {f.isExternalReference && f.sourceFieldType === 'arithmetic' && (
                                  <Tag color="orange" style={{ marginLeft: 8, fontSize: '9px' }}>
                                    <CalculatorOutlined /> Arithmetic Result
                                  </Tag>
                                )}
                              </div>
                              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                {/* ===== FIX: Show Step Result value ===== */}
                                {(isConstant || f.isSharedReference || f.isExternalReference || f.isStepResultReference) ? (
                                  <div style={{ 
                                    width: 180, 
                                    padding: '6px 11px', 
                                    background: f.isStepResultReference ? '#f9f0ff' : (f.isExternalReference ? '#f0fdf4' : '#f5f5f5'), 
                                    border: f.isStepResultReference ? '1px solid #d3adf7' : (f.isExternalReference ? '1px solid #b7eb8f' : '1px solid #d9d9d9'), 
                                    borderRadius: '6px',
                                    minHeight: '32px',
                                    display: 'flex',
                                    alignItems: 'center'
                                  }}>
                                    <Text strong style={{ color: f.isStepResultReference ? '#722ed1' : (f.isExternalReference ? '#389e0d' : '#333') }}>
                                      {typeof currentValue === 'number' ? currentValue.toFixed(2) : currentValue}
                                    </Text>
                                    {f.isStepResultReference && (
                                      <Tooltip title={`From step: ${f.sourceStepName || f.sourceStepId}`}>
                                        <InfoCircleOutlined style={{ marginLeft: 8, color: '#722ed1', fontSize: 12 }} />
                                      </Tooltip>
                                    )}
                                    {f.isExternalReference && (
                                      <Tooltip title="Auto-calculated from source formula">
                                        <InfoCircleOutlined style={{ marginLeft: 8, color: '#52c41a', fontSize: 12 }} />
                                      </Tooltip>
                                    )}
                                  </div>
                                ) : (
                                  <Input
                                    type="text"
                                    placeholder={previewLanguage === 'english' ? (f.enPlaceholder || 'Enter value') : (f.mrPlaceholder || 'मूल्य प्रविष्ट करा')}
                                    value={currentValue}
                                    onChange={(e) => {
                                      let newValue = e.target.value;
                                      
                                      if (integerOnly) {
                                        const intOnlyPattern = allowNegative ? /^-?\d*$/ : /^\d*$/;
                                        if (newValue === '' || intOnlyPattern.test(newValue)) {
                                          setPreviewValues(prev => ({ ...prev, [f.id]: newValue }));
                                        }
                                      } 
                                      else if (allowDecimals) {
                                        const decimalPattern = allowNegative ? /^-?\d*\.?\d*$/ : /^\d*\.?\d*$/;
                                        if (newValue === '' || decimalPattern.test(newValue)) {
                                          if ((newValue.match(/\./g) || []).length <= 1) {
                                            setPreviewValues(prev => ({ ...prev, [f.id]: newValue }));
                                          }
                                        }
                                      }
                                      else {
                                        const numberPattern = /^\d*$/;
                                        if (newValue === '' || numberPattern.test(newValue)) {
                                          setPreviewValues(prev => ({ ...prev, [f.id]: newValue }));
                                        }
                                      }
                                    }}
                                    style={{ width: 180 }}
                                    size="small"
                                  />
                                )}
                                {unitSymbol && (
                                  <div style={{ 
                                    padding: '0 12px', 
                                    background: '#f5f5f5', 
                                    borderRadius: '4px', 
                                    fontSize: '14px', 
                                    color: '#666', 
                                    height: '32px', 
                                    display: 'flex', 
                                    alignItems: 'center', 
                                    border: '1px solid #d9d9d9' 
                                  }}>
                                    {unitSymbol}
                                  </div>
                                )}
                              </div>
                              {wordsRepresentation && !isNaN(parseFloat(currentValue)) && parseFloat(currentValue) !== 0 && (
                                <div style={{ marginTop: 6, padding: '4px 8px', background: '#f6ffed', borderRadius: '4px', display: 'inline-block' }}>
                                  <Text style={{ fontSize: '10px', color: '#333' }}>
                                    {wordsRepresentation}
                                    {unitSymbol && <span style={{ marginLeft: 4, color: '#666' }}>({unitSymbol})</span>}
                                  </Text>
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    )}

                    <div style={{ marginTop: 8, paddingLeft: shouldShowStepHeading ? 16 : 0 }}>
                      {stepIsLogical ? (
                        stepResult === 0 && stepFalseMessage ? (
                          <div style={{ padding: '8px 12px', background: '#ffebee', border: '1px solid #ffcdd2', borderRadius: '6px', color: '#c62828', display: 'inline-block' }}>
                            <CloseCircleOutlined style={{ marginRight: 8 }} />
                            <Text style={{ color: '#c62828' }}>{stepFalseMessage}</Text>
                          </div>
                        ) : null
                      ) : (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                          <Text style={{ fontSize: '13px', color: '#666' }}>{stepResultLabel}:</Text>
                          <Tag color="green" style={{ fontSize: '13px', padding: '4px 12px' }}>
                            {typeof stepResult === 'number' ? (
                              stepFieldsIntegerOnly ? Math.round(stepResult).toString() : stepResult.toFixed(2)
                            ) : stepResult}
                          </Tag>
                          {stepResultWords && stepResult !== 0 && (
                            <Text type="secondary" style={{ fontSize: '11px' }}>({stepResultWords})</Text>
                          )}
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
            );
          })}

          {!isSingleStep && !isNoneCombine && showResult && finalResult !== null && (
            <div style={{ 
              marginTop: 16, 
              paddingTop: 16, 
              borderTop: '1px solid #e8e8e8',
              padding: '12px 20px',
              background: isLogicalCombine && finalResult === 0 ? '#fff2f0' : '#f0f5ff',
              borderRadius: 8,
              border: isLogicalCombine && finalResult === 0 ? '1px solid #ffccc7' : '1px solid #adc6ff'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '16px', flexWrap: 'wrap' }}>
                <Text strong style={{ fontSize: '14px' }}>
                  {previewLanguage === 'english' ? finalResultLabel.en : finalResultLabel.mr}:
                  {finalUnitInfo?.symbol && (
                    <Tag color="blue" style={{ marginLeft: 8, fontSize: 12 }}>{finalUnitInfo.symbol}</Tag>
                  )}
                </Text>
                <div>
                  {isLogicalCombine ? (
                    finalResult === 1 ? (
                      <span style={{ color: '#999' }}>—</span>
                    ) : (
                      <Tag color="error" style={{ fontSize: '14px', padding: '4px 16px', margin: 0 }}>
                        <CloseCircleOutlined /> {finalFalseMessage || (previewLanguage === 'english' ? 'FALSE' : 'फॉल्स')}
                      </Tag>
                    )
                  ) : (
                    <Tag color="green" style={{ fontSize: '16px', padding: '6px 20px', fontWeight: 'bold' }}>
                      {allFieldsIntegerOnly ? Math.round(finalResult).toString() : finalDisplayValue}
                    </Tag>
                  )}
                </div>
                {!isLogicalCombine && finalResultWords && finalResult !== 0 && (
                  <Text type="secondary" style={{ fontSize: '12px' }}>({finalResultWords})</Text>
                )}
              </div>
            </div>
          )}

          {(previewLanguage === 'english' ? field.enHelpText : field.mrHelpText) && (
            <div style={{ marginTop: 12, textAlign: 'center' }}>
              <Text type="secondary" style={{ fontSize: 12, fontStyle: 'italic' }}>
                {previewLanguage === 'english' ? field.enHelpText : field.mrHelpText}
              </Text>
            </div>
          )}
        </>
      )}
    </div>
  );
}

    return (
      <div key={field.id} style={{ marginBottom: 12, marginLeft: field.parentId ? 64 : 0 }}>
        <div style={{ marginBottom: 4, fontWeight: 600, fontSize: '13px', color: '#333' }}>
          {previewLanguage === 'english' ? (field.enLabel || field.label) : (field.mrLabel || field.label)} ({field.type})
        </div>
      </div>
    );
  };

  return (
    <Modal
      open={showPreview}
      onCancel={() => setShowPreview(false)}
      footer={null}
      width={900}
      style={{ top: 20 }}
      bodyStyle={{ padding: 0, maxHeight: 'calc(100vh - 100px)', overflow: 'hidden' }}
      title={`${previewLanguage === 'english' ? 'Form Preview' : 'फॉर्म पूर्वावलोकन'} - ${formName || "Untitled"}`}
    >
      <div style={{ padding: "24px", maxHeight: "calc(100vh - 180px)", overflowY: "auto", overflowX: "hidden", fontFamily: "'Segoe UI', 'Arial', sans-serif", backgroundColor: '#ffffff' }}>
        <AntForm layout="vertical" style={{ maxWidth: "100%" }}>
          {nodes.filter(f => !f.parentId).map(field => renderFieldWithChildren(field))}
        </AntForm>
      </div>
    </Modal>
  );
};

  // Render content based on active tab
  const renderTabContent = () => {
  switch (activeTab) {
    case "form-builder":
      return (
        <div className="form-builder-tab">
          <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: "16px" }}>
            {/* Center Panel - Builder */}
            <div style={{
              background: "white",
              borderRadius: "8px",
              padding: "16px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              minHeight: "600px",
              overflowY: "auto",
              maxHeight: "calc(100vh - 480px)"
            }}
              onDragOver={(e) => e.preventDefault()}
              onDrop={handleDrop}
            >
              <div style={{ marginBottom: 16, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Title level={5} style={{ margin: 0 }}>
                  {language === 'english' ? 'Form Builder' : 'फॉर्म बिल्डर'}
                </Title>
                <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                  {/* 🟢 Approval Status Badge */}
                  {selectedFormId && (
                    <Badge
                      count={
                        approvalStatus === 'approved' ? '✅ Approved' :
                        approvalStatus === 'rejected' ? '❌ Rejected' :
                        '⏳ Pending'
                      }
                      style={{
                        backgroundColor: 
                          approvalStatus === 'approved' ? '#52c41a' :
                          approvalStatus === 'rejected' ? '#ff4d4f' :
                          '#faad14',
                        color: 'white',
                        fontSize: '12px',
                        marginRight: '8px'
                      }}
                    />
                  )}
                  
                  {/* 🟢 Get Data from Data Button */}
                  <Button
                    key="getDataBtn"
                    icon={<DatabaseOutlined />}
                    onClick={() => setDataSourceModalVisible(true)}
                    shape="round"
                    size="middle"
                    style={{
                      borderColor: "#13c684",
                      color: "#13c684",
                      backgroundColor: "#f0fdf4"
                    }}
                  >
                    {language === 'english' ? 'Select Column from Existing Data Base' : 'डेटामधून डेटा मिळवा'}
                  </Button>
                  
                  <Modal
                    open={dataSourceModalVisible}
                    onCancel={() => setDataSourceModalVisible(false)}
                    footer={null}
                    width={400}
                    centered
                    title={
                      <Space>
                        <DatabaseOutlined style={{ color: "#13c684" }} />
                        <span>{language === 'english' ? 'Select Data Source' : 'डेटा स्रोत निवडा'}</span>
                      </Space>
                    }
                  >
                    <div style={{ padding: '8px 0' }}>
                      <div
                        onClick={() => {
                          setDataSourceModalVisible(false);
                          setTableSearchVisible(true);
                        }}
                        style={{
                          padding: '16px',
                          marginBottom: '12px',
                          border: '1px solid #e8e8e8',
                          borderRadius: '8px',
                          cursor: 'pointer',
                          transition: 'all 0.2s',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '12px',
                          background: '#fff'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.borderColor = '#13c684';
                          e.currentTarget.style.backgroundColor = '#f0fdf4';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.borderColor = '#e8e8e8';
                          e.currentTarget.style.backgroundColor = '#fff';
                        }}
                      >
                        <DatabaseOutlined style={{ fontSize: 24, color: '#13c684' }} />
                        <div>
                          <div style={{ fontWeight: 500, marginBottom: 4 }}>
                            {language === 'english' ? 'Select Column from Existing Data Base' : 'विद्यमान डेटामधून स्तंभ निवडा'}
                          </div>
                          <div style={{ fontSize: 12, color: '#666' }}>
                            {language === 'english' ? 'Import columns from existing tables' : 'विद्यमान टेबलमधून कॉलम्स आयात करा'}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Modal>
                  
                  {/* 🟢 Approval Actions for DMA_DESK_OFFICER */}
                  {selectedFormId && approvalStatus === 'pending' && currentUserRole === 'DMA_DESK_OFFICER' && (
                    <>
                      <Button
                        type="primary"
                        icon={<CheckOutlined />}
                        onClick={handleApprove}
                        style={{ background: '#52c41a' }}
                      >
                        Approve
                      </Button>
                      <Button
                        danger
                        icon={<CloseCircleOutlined />}
                        onClick={() => setShowRejectModal(true)}
                      >
                        Reject
                      </Button>
                    </>
                  )}

                  <Select
                    style={{ width: 200 }}
                    placeholder={language === 'english' ? "Load existing form" : "विद्यमान फॉर्म लोड करा"}
                    value={selectedFormId}
                    onChange={loadFormById}
                    loading={loadingList}
                    allowClear
                    getPopupContainer={(trigger) => trigger.parentNode}
                    dropdownMatchSelectWidth={false}
                    dropdownStyle={{ zIndex: 9999 }}
                  >
                    {formsList.map(f => (
                      <Option key={f.id} value={f.id}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px',width: '100%', }}>
                          <span>{f.form_name || `Form #${f.id}`}</span>
                        </div>
                      </Option>
                    ))}
                  </Select>
                </div>
              </div>

              {/* 🟢 Show rejection reason if rejected */}
              {approvalStatus === 'rejected' && (
                <Alert
                  message={language === 'english' ? "Form Rejected" : "फॉर्म नाकारला"}
                  description={
                    <div>
                      <p><strong>Reason:</strong> {rejectionReason}</p>
                      {reviewerNotes && <p><strong>Notes:</strong> {reviewerNotes}</p>}
                      {reviewedAt && <p><strong>Reviewed at:</strong> {new Date(reviewedAt).toLocaleString()}</p>}
                    </div>
                  }
                  type="error"
                  showIcon
                  style={{ marginBottom: 16 }}
                />
              )}

              {/* 🟢 Show approval info if approved */}
              {approvalStatus === 'approved' && (
                <Alert
                  message={language === 'english' ? "Form Approved" : "फॉर्म मंजूर"}
                  description={
                    <div>
                      <p><strong>Approved by:</strong> {reviewedBy}</p>
                      {reviewedAt && <p><strong>Approved at:</strong> {new Date(reviewedAt).toLocaleString()}</p>}
                      {reviewerNotes && <p><strong>Notes:</strong> {reviewerNotes}</p>}
                    </div>
                  }
                  type="success"
                  showIcon
                  style={{ marginBottom: 16 }}
                />
              )}

              {/* 🟢 Existing Columns Palette */}
              {showExistingPalette && existingColumns && existingColumns.length > 0 && (
                <div style={{
                  marginBottom: 20,
                  padding: "12px",
                  background: "#f8f9fa",
                  border: "1px solid #e9ecef",
                  borderRadius: "8px"
                }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "12px" }}>
                    <DatabaseOutlined style={{ color: "#113F67" }} />
                    <Text strong style={{ color: "#113F67" }}>
                      {language === 'english' ? 'Existing Columns (Drag to form)' : 'विद्यमान स्तंभ (फॉर्मवर ड्रॅग करा)'}
                    </Text>
                    <Badge count={existingColumns.length} style={{ backgroundColor: "#52c41a" }} />
                  </div>

                  <div style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
                    gap: "8px",
                    maxHeight: "150px",
                    overflowY: "auto",
                    padding: "4px"
                  }}>
                    {existingColumns.map((column, index) => (
                      <ExistingColumnItem key={index} column={column} />
                    ))}
                  </div>
                </div>
              )}

              <DndContext
                sensors={sensors}
                collisionDetection={closestCenter}
                onDragStart={(e) => setActiveDragId(e.active.id)}
                onDragEnd={handleDragEnd}
              >
                <DroppableZone id="ROOT">
                  <SortableContext
                    items={nodes.filter(f => !f.parentId).map(n => n.id)}
                    strategy={verticalListSortingStrategy}
                  >
                    {nodes.filter(f => !f.parentId).length === 0 ? (
                      <div style={{
                        textAlign: "center",
                        padding: "60px 20px",
                        border: "2px dashed #ddd",
                        borderRadius: "8px",
                        color: "#999"
                      }}>
                        <ColumnWidthOutlined style={{ fontSize: 48, marginBottom: 16 }} />
                        <p>{showExistingPalette
                          ? (language === 'english' ? "Drag columns from the top panel" : "वरील पॅनेलमधून स्तंभ ड्रॅग करा")
                          : (language === 'english' ? "Drag fields from the top panel" : "वरील पॅनेलमधून फील्ड ड्रॅग करा")}</p>
                      </div>
                    ) : (
                      nodes.filter(f => !f.parentId).map(field => (
                        <SortableItemShell key={field.id} id={field.id}>
                          {field.type === "row" ? (
                            <RowNodeEditor
                              rowNode={field}
                              onUpdate={updateField}
                              onDelete={() => deleteField(field.id)}
                              onCopy={() => copyField(field)}
                              disabled={false}
                            />
                          ) : (
                            <FieldEditor
                              field={field}
                              onUpdate={updateField}
                              onDelete={() => deleteField(field.id)}
                              onCopy={() => copyField(field)}
                              allFields={nodes}
                              onAddSubField={addSubField}
                              onUpdateSubField={updateSubField}
                              onDeleteSubField={deleteSubField}
                              language={language}
                              autoTranslate={autoTranslate}
                              translateTyping={translateTyping}
                              translating={translating}
                              disabled={false}
                            />
                          )}
                        </SortableItemShell>
                      ))
                    )}
                  </SortableContext>
                </DroppableZone>

                <DragOverlay>
                  {activeNode && !activeNode.parentId && (
                    <div style={{
                      background: activeNode.type === "comparison" ? "#fa8c16" :
                        activeNode.type === "radio" ? "#722ed1" :
                          activeNode.type === "file" ? "#1890ff" :
                            activeNode.type === "arithmetic" ? "#52c41a" : 
                            activeNode.type === "heading" ? "#fa8c16" : "#1890ff",
                      color: "white",
                      padding: "8px 16px",
                      borderRadius: "4px",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
                    }}>
                      {activeNode.enLabel || activeNode.label || activeNode.type}
                    </div>
                  )}
                </DragOverlay>
              </DndContext>
            </div>
          </div>
        </div>
      );

    case "access-report":
      return (
        <SimpleAccessReport
          fields={nodes}
          reportConfig={reportConfig}
          onReportConfigChange={setReportConfig}
          onFieldReportConfigChange={handleFieldReportConfigChange}
          language={language}
        />
      );

    case "restriction":
      return (
        <div style={{ background: "white", borderRadius: "8px", padding: "24px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
          <Tabs defaultActiveKey="language" type="card" size="large">
            <TabPane
              tab={
                <span>
                  <SafetyOutlined />
                  {language === 'english' ? 'Role Permissions' : 'भूमिका परवानग्या'}
                </span>
              }
              key="roles"
            >
              <FormAccessControl
                language={language}
                permissions={permissions}
                onPermissionsChange={setPermissions}
                roles={roles}
                loading={loadingRoles}
                formId={selectedFormId}
              />
            </TabPane>
          </Tabs>
        </div>
      );

    // // ✅ NEW: FREQUENCY CONFIGURATION TAB
    // case "frequency":
    //   return (
    //     <div style={{ background: "blue", borderRadius: "8px", padding: "24px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
          
    //       {/* Entry Type Configuration */}
    //       <Card style={{ marginBottom: 24, border: "2px solid #1890ff", borderRadius: "8px" }}>
    //         <div style={{ padding: "16px" }}>
    //           <Title level={5} style={{ marginBottom: 20, color: "#1890ff" }}>
    //             <FormOutlined style={{ marginRight: 8 }} />
    //             {language === 'english' ? 'Entry Type Configuration' : 'एंट्री प्रकार कॉन्फिगरेशन'}
    //           </Title>

    //           {/* Entry Type Buttons */}
    //           <Row gutter={24} style={{ marginBottom: 24 }}>
    //             <Col span={8}>
    //               <Text strong style={{ display: 'block', marginBottom: 8 }}>
    //                 {language === 'english' ? 'Entry Type:' : 'एंट्री प्रकार:'}
    //               </Text>
    //             </Col>
    //             <Col span={16}>
    //               <Radio.Group
    //                 value={entryType}
    //                 onChange={(e) => {
    //                   console.log('🟢 Entry Type changed to:', e.target.value);
    //                   handleEntryTypeChange(e.target.value);
    //                 }}
    //                 buttonStyle="solid"
    //                 size="large"
    //               >
    //                 <Radio.Button value="single">
    //                   <Space>
    //                     <FormOutlined />
    //                     {language === 'english' ? 'Single Entry' : 'एकल एंट्री'}
    //                   </Space>
    //                 </Radio.Button>
    //                 <Radio.Button value="multi">
    //                   <Space>
    //                     <CopyFilled />
    //                     {language === 'english' ? 'Multi Entry' : 'एकाधिक एंट्री'}
    //                   </Space>
    //                 </Radio.Button>
    //               </Radio.Group>
    //             </Col>
    //           </Row>

    //           {/* Max Entries Per User - Only for Multi Entry */}
    //           {entryType === 'multi' && (
    //             <Row gutter={24} style={{ marginBottom: 20 }}>
    //               <Col span={8}>
    //                 <Text strong style={{ display: 'block', marginBottom: 8 }}>
    //                   {language === 'english' ? 'Max Entries Per User:' : 'प्रति यूजर कमाल एंट्री:'}
    //                 </Text>
    //               </Col>
    //               <Col span={16}>
    //                 <Input
    //                   type="number"
    //                   min={0}
    //                   value={maxEntriesPerUser}
    //                   onChange={(e) => handleMaxEntriesPerUserChange(parseInt(e.target.value) || 0)}
    //                   placeholder={language === 'english' ? "0 = Unlimited" : "० = अमर्यादित"}
    //                   style={{ width: 200 }}
    //                   size="large"
    //                 />
    //                 <Text type="secondary" style={{ display: 'block', marginTop: 4, fontSize: '12px' }}>
    //                   {language === 'english' 
    //                     ? 'Set 0 for unlimited entries' 
    //                     : 'अमर्यादित एंट्रीसाठी ० सेट करा'}
    //                 </Text>
    //               </Col>
    //             </Row>
    //           )}
    //         </div>
    //       </Card>

    //       {/* Frequency Configuration */}
    //       <Card style={{ marginBottom: 24, border: "2px solid #52c41a", borderRadius: "8px" }}>
    //         <div style={{ padding: "16px" }}>
    //           <Title level={5} style={{ marginBottom: 20, color: "#52c41a" }}>
    //             <FieldTimeOutlined style={{ marginRight: 8 }} />
    //             {language === 'english' ? 'Frequency Configuration' : 'वारंवारता कॉन्फिगरेशन'}
    //           </Title>

    //           {/* Enable Frequency Radio */}
    //           <Row gutter={24} style={{ marginBottom: 20 }}>
    //             <Col span={8}>
    //               <Text strong style={{ display: 'block', marginBottom: 8 }}>
    //                 {language === 'english' ? 'Enable Frequency:' : 'वारंवारता सक्षम करा:'}
    //               </Text>
    //             </Col>
    //             <Col span={16}>
    //               <Radio.Group
    //                 value={enableFrequency}
    //                 onChange={(e) => handleEnableFrequencyChange(e.target.value)}
    //               >
    //                 <Radio value={true}>
    //                   <Space>
    //                     <CheckCircleOutlined style={{ color: '#52c41a' }} />
    //                     {language === 'english' ? 'Yes' : 'होय'}
    //                   </Space>
    //                 </Radio>
    //                 <Radio value={false}>
    //                   <Space>
    //                     <CloseOutlined style={{ color: '#ff4d4f' }} />
    //                     {language === 'english' ? 'No' : 'नाही'}
    //                   </Space>
    //                 </Radio>
    //               </Radio.Group>
    //             </Col>
    //           </Row>

    //           {/* Frequency Options - Show only if enabled */}
    //           {enableFrequency && (
    //             <div style={{
    //               marginTop: 16,
    //               padding: "20px",
    //               background: "#f8f9fa",
    //               borderRadius: "8px",
    //               border: "1px solid #e9ecef"
    //             }}>
    //               <Row gutter={24} style={{ marginBottom: 20 }}>
    //                 <Col span={8}>
    //                   <Text strong>
    //                     {language === 'english' ? 'Frequency Type:' : 'वारंवारता प्रकार:'}
    //                   </Text>
    //                 </Col>
    //                 <Col span={16}>
    //                   <Radio.Group
    //                     value={frequencyType}
    //                     onChange={(e) => {
    //                       console.log("Selected frequency:", e.target.value);
    //                       handleFrequencyTypeChange(e.target.value);
    //                     }}
    //                   >
    //                     <Space direction="vertical">
    //                       {FREQUENCY_OPTIONS.map(option => (
    //                         <Radio key={option.value} value={option.value}>
    //                           <Space>
    //                             {option.icon}
    //                             <span>{option.label}</span>
    //                           </Space>
    //                         </Radio>
    //                       ))}
    //                     </Space>
    //                   </Radio.Group>
    //                 </Col>
    //               </Row>

    //               {/* Custom Frequency Input */}
    //               {frequencyType === 'custom' && (
    //                 <Row gutter={24} style={{ marginBottom: 20 }}>
    //                   <Col span={8}>
    //                     <Text strong>
    //                       {language === 'english' ? 'Custom Frequency:' : 'सानुकूल वारंवारता:'}
    //                     </Text>
    //                   </Col>
    //                   <Col span={16}>
    //                     <Input
    //                       value={customFrequency}
    //                       onChange={(e) => handleCustomFrequencyChange(e.target.value)}
    //                       placeholder={language === 'english' ? 'e.g., Every 2 weeks' : 'उदा., दर 2 आठवड्यांनी'}
    //                       size="large"
    //                     />
    //                   </Col>
    //                 </Row>
    //               )}

    //               {/* Schedule Configuration for Non-Custom Frequencies */}
    //               {frequencyType && frequencyType !== 'custom' && (
    //                 <ScheduleConfiguration
    //                   frequencyType={frequencyType}
    //                   scheduleConfig={scheduleConfig}
    //                   onScheduleChange={handleScheduleChange}   
    //                   language={language}
    //                   disabled={false}
    //                 />
    //               )}
    //             </div>
    //           )}
    //         </div>
    //       </Card>
    //     </div>
    //   );

    // ✅ UPDATED: WORKFLOW TAB (without frequency section)
    case "workflow":
      return (
        <div style={{ background: "white", borderRadius: "8px", padding: "24px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
          
          {/* Original Workflow Configuration - Frequency section removed */}
          <div style={{ marginBottom: 24, padding: 16, background: "#e6f7ff", borderRadius: "8px", border: "1px solid #91d5ff" }}>
            <Text><SwapOutlined style={{ marginRight: 8 }} />
              {language === 'english' ? 'Configure the approval workflow for this form.' : 'या फॉर्मसाठी मंजूरी कार्यप्रवाह कॉन्फिगर करा.'}
            </Text>
          </div>

          <Card>
            <Title level={5} style={{ marginBottom: 16 }}>
              {language === 'english' ? 'Workflow Configuration' : 'कार्यप्रवाह कॉन्फिगरेशन'}
            </Title>

            <Radio.Group
              value={workflowType}
              onChange={(e) => handleWorkflowChange(e.target.value, customWorkflow)}
              style={{ marginBottom: 24 }}
            >
              <Radio.Button value="standard">{language === 'english' ? 'Standard Workflow' : 'मानक कार्यप्रवाह'}</Radio.Button>
              <Radio.Button value="custom">{language === 'english' ? 'Custom Workflow' : 'सानुकूल कार्यप्रवाह'}</Radio.Button>
            </Radio.Group>

            {workflowType === "standard" ? (
              <div style={{ padding: "24px", background: "#fafafa", borderRadius: "8px" }}>
                <Text strong style={{ display: "block", marginBottom: "16px" }}>
                  {language === 'english' ? 'Default Approval Sequence:' : 'डीफॉल्ट मंजूरी क्रम:'}
                </Text>
                <Steps
                  current={-1}
                  items={STANDARD_WORKFLOWS.DEFAULT.map(role => ({
                    title: role,
                    description: language === 'english' ? "Approval step" : "मंजूरी पायरी",
                    icon: <SafetyOutlined />
                  }))}
                />
              </div>
            ) : (
              <div style={{ padding: "24px", background: "#fafafa", borderRadius: "8px" }}>
                <Text strong style={{ display: "block", marginBottom: "16px" }}>
                  {language === 'english' ? 'Custom Workflow Sequence:' : 'सानुकूल कार्यप्रवाह क्रम:'}
                </Text>
                <Select
                  mode="multiple"
                  style={{ width: "100%", marginBottom: "16px" }}
                  placeholder={language === 'english' ? "Select roles in order" : "क्रमाने भूमिका निवडा"}
                  value={customWorkflow}
                  onChange={(val) => handleWorkflowChange("custom", val)}
                  getPopupContainer={(trigger) => trigger.parentNode}
                  dropdownMatchSelectWidth={false}
                  dropdownStyle={{ zIndex: 9999 }}
                >
                  {roles.map(r => (
                    <Option key={r.id} value={r.id}>{r.name}</Option>
                  ))}
                </Select>
                {customWorkflow.length > 0 && (
                  <Steps
                    current={-1}
                    direction="vertical"
                    items={customWorkflow.map(roleId => {
                      const role = roles.find(r => r.id === roleId || r.name === roleId);
                      return {
                        title: role?.name || roleId,
                        description: language === 'english' ? "Custom approval step" : "सानुकूल मंजूरी पायरी",
                        icon: <SafetyOutlined />
                      };
                    })}
                  />
                )}
              </div>
            )}
          </Card>
        </div>
      );

    case "sla":
      const workflowRoles = getWorkflowRoles();

      return (
        <div style={{ background: "white", borderRadius: "8px", padding: "24px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
          <div style={{ marginBottom: 24, padding: 16, background: "#e6f7ff", borderRadius: "8px", border: "1px solid #91d5ff" }}>
            <Text><ClockCircleOutlined style={{ marginRight: 8 }} />
              {language === 'english' ? 'Set Service Level Agreements (SLA) for each role in the workflow.' : 'कार्यप्रवाहातील प्रत्येक भूमिकेसाठी सेवा स्तर करार (SLA) सेट करा.'}
            </Text>
          </div>

          <Card>
            <Title level={5} style={{ marginBottom: 16 }}>
              {language === 'english' ? 'SLA Configuration' : 'SLA कॉन्फिगरेशन'}
            </Title>

            {workflowRoles.length === 0 ? (
              <Alert
                message={language === 'english' ? 'No roles in workflow' : 'कार्यप्रवाहात कोणतीही भूमिका नाही'}
                description={language === 'english'
                  ? 'Please configure the workflow first to set SLA for roles.'
                  : 'कृपया भूमिकांसाठी SLA सेट करण्यासाठी प्रथम कार्यप्रवाह कॉन्फिगर करा.'}
                type="info"
                showIcon
              />
            ) : (
              <Row gutter={[16, 16]}>
                {workflowRoles.map(role => {
                  const roleId = role.id || role;
                  const roleName = role.name || role;
                  
                  const existingSla = sla[roleId] || {};
                  const currentSla = {
                    value: existingSla.value || "",
                    unit: existingSla.unit || "days"
                  };
                  
                  return (
                    <Col xs={24} sm={12} md={8} lg={6} key={roleId}>
                      <Card
                        title={
                          <Space>
                            <Avatar size={32} style={{
                              backgroundColor: getRoleColor(roleId),
                              color: "white",
                              fontWeight: "bold"
                            }}>
                              {roleName ? roleName.charAt(0).toUpperCase() : '?'}
                            </Avatar>
                            <span>{roleName || 'Unknown Role'}</span>
                          </Space>
                        }
                        size="small"
                        bodyStyle={{ overflow: 'visible' }}
                      >
                        <div style={{ marginBottom: 12 }}>
                          <Text type="secondary" style={{ fontSize: '12px' }}>
                            {language === 'english' ? 'Duration:' : 'कालावधी:'}
                          </Text>
                          <Input
                            type="number"
                            min={1}
                            placeholder={language === 'english' ? "Enter duration" : "कालावधी प्रविष्ट करा"}
                            value={currentSla.value}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (value === '' || !isNaN(parseFloat(value))) {
                                handleSlaChange(roleId, "value", value);
                              }
                            }}
                            style={{ marginTop: 4 }}
                          />
                        </div>

                        <div>
                          <Text type="secondary" style={{ fontSize: '11px', display: 'block', marginBottom: 8 }}>
                            {language === 'english' ? 'Unit:' : 'एकक:'}
                          </Text>
                          <Radio.Group
                            value={currentSla.unit}
                            onChange={(e) => handleSlaChange(roleId, "unit", e.target.value)}
                            optionType="button"
                            buttonStyle="solid"
                            size="middle"
                            style={{ width: '100%' }}
                          >
                            <Radio.Button value="hours" style={{ width: '33.33%', textAlign: 'center' }}>
                              {language === 'english' ? 'Hours' : 'तास'}
                            </Radio.Button>
                            <Radio.Button value="days" style={{ width: '33.33%', textAlign: 'center' }}>
                              {language === 'english' ? 'Days' : 'दिवस'}
                            </Radio.Button>
                            <Radio.Button value="months" style={{ width: '33.34%', textAlign: 'center' }}>
                              {language === 'english' ? 'Months' : 'महिने'}
                            </Radio.Button>
                          </Radio.Group>
                        </div>

                        {currentSla.value && (
                          <div style={{
                            marginTop: 12,
                            padding: '8px',
                            background: '#f6ffed',
                            border: '1px solid #b7eb8f',
                            borderRadius: '4px',
                            fontSize: '12px'
                          }}>
                            <Space>
                              <ClockCircleOutlined style={{ color: '#52c41a' }} />
                              <Text style={{ color: '#389e0d' }}>
                                {currentSla.value} {
                                  currentSla.unit === 'hours' 
                                    ? (language === 'english' ? (parseInt(currentSla.value) === 1 ? 'Hour' : 'Hours') : (parseInt(currentSla.value) === 1 ? 'तास' : 'तास'))
                                    : currentSla.unit === 'days'
                                    ? (language === 'english' ? (parseInt(currentSla.value) === 1 ? 'Day' : 'Days') : (parseInt(currentSla.value) === 1 ? 'दिवस' : 'दिवस'))
                                    : (language === 'english' ? (parseInt(currentSla.value) === 1 ? 'Month' : 'Months') : (parseInt(currentSla.value) === 1 ? 'महिना' : 'महिने'))
                                }
                              </Text>
                            </Space>
                          </div>
                        )}
                      </Card>
                    </Col>
                  );
                })}
              </Row>
            )}
          </Card>
        </div>
      );
      
    default:
      return null;
  }
};

  const getStepName = (tab) => {
  const stepNames = {
    "form-builder": language === 'english' ? "Form Builder" : "फॉर्म बिल्डर",
    "access-report": language === 'english' ? "Access Report" : "अॅक्सेस रिपोर्ट",
    "restriction": language === 'english' ? "Access Control" : "प्रवेश नियंत्रण",
    // "frequency": language === 'english' ? "Frequency" : "वारंवारता",  
    "workflow": language === 'english' ? "Workflow" : "कार्यप्रवाह",
    "sla": "SLA"
  };
  return stepNames[tab] || tab;
};

  // Get current step number
  const getCurrentStep = () => {
  const steps = ["form-builder", "access-report", "restriction", "workflow", "sla"];
  return steps.indexOf(activeTab) + 1;
};
  return (
    <div>
      {/* Form Name Modal - Only shows for BLANK forms */}
      <Modal
  open={showNameModal}
  closable={true}
  maskClosable={true}
  onCancel={() => {
    setShowNameModal(false);
    setTempFormName('');
    setFormIcon(null);
    setFormIconUrl('');
    
    message.info(language === 'english' 
      ? 'Form creation cancelled - Redirecting to templates' 
      : 'फॉर्म निर्मिती रद्द केली - टेम्पलेट्स वर पुनर्निर्देशित');
    
    setTimeout(() => {
      window.location.href = '/super-admin/form-templates';
    }, 500);
  }}
  footer={null}
  width={500}
  title={
    <Space>
      <FormOutlined style={{ color: '#1890ff' }} />
      {language === 'english' ? 'New Form' : 'नवीन फॉर्म'}
    </Space>
  }
  centered
>
  <div style={{ padding: '20px 0' }}>
    
    {/* ✅ ICON UPLOAD SECTION */}
    <div style={{ marginBottom: 24, textAlign: 'center' }}>
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center',
        gap: '12px'
      }}>
      
      </div>
    </div>

    {/* ✅ FORM NAME INPUT SECTION */}
    <Title level={5} style={{ marginBottom: 16 }}>
      {language === 'english'
        ? 'Please enter a name for your form:'
        : 'कृपया तुमच्या फॉर्मसाठी नाव प्रविष्ट करा:'}
    </Title>

    <Input
      autoFocus
      value={tempFormName}
      onChange={(e) => setTempFormName(e.target.value)}
      placeholder={language === 'english' ? "Enter form name" : "फॉर्मचे नाव प्रविष्ट करा"}
      size="large"
      onPressEnter={handleNameSubmitWithIcon}
      style={{ marginBottom: 16 }}
      status={tempFormName && isFormNameExists(tempFormName) ? "error" : ""}
      prefix={formIconUrl ? <img src={formIconUrl} style={{ width: 20, height: 20, borderRadius: 4 }} /> : <FormOutlined />}
    />

    {tempFormName && isFormNameExists(tempFormName) && (
      <Alert
        message={language === 'english'
          ? "This form name already exists. Please choose a different name."
          : "हे फॉर्मचे नाव आधीपासून अस्तित्वात आहे. कृपया वेगळे नाव निवडा."}
        type="error"
        showIcon
        style={{ marginBottom: 16 }}
      />
    )}

    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
      <Button
        type="primary"
        onClick={handleNameSubmitWithIcon}
        size="large"
        loading={uploadingIcon}
        disabled={!tempFormName.trim() || isFormNameExists(tempFormName)}
      >
        {language === 'english' ? 'Continue' : 'पुढे जा'}
      </Button>
    </div>

    <Text type="secondary" style={{ fontSize: '12px', display: 'block', marginTop: 16, textAlign: 'center' }}>
      {language === 'english'
        ? 'You can change the form name and icon later in the Form Builder'
        : 'तुम्ही फॉर्म बिल्डरमध्ये फॉर्मचे नाव आणि आयकॉन नंतरही बदलू शकता'}
    </Text>
  </div>
</Modal>

{/* हिडन file input */}
<input
  type="file"
  id="iconUploadInput"
  accept="image/png,image/jpeg,image/jpg"
  style={{ display: 'none' }}
  onChange={(e) => {
    if (e.target.files && e.target.files[0]) {
      handleIconUpload(e.target.files[0]);
    }
  }}
/>

      {/* Table Search Modal */}
      <TableSearchModal
        visible={tableSearchVisible}
        onClose={() => setTableSearchVisible(false)}
        onImportColumns={handleImportColumns}
        language={language}
        existingColumns={nodes.map(node => ({ field_id: node.id, column_name: node.enLabel }))}
      />
      <ComparisonModal
  visible={comparisonModalVisible}
  onClose={() => setComparisonModalVisible(false)}
  formFields={nodes}
  language={language}
/>

      {/* Main Content */}
      {renderTabContent()}

      {/* Preview Modal */}
      {renderPreview()}

      {/* Reject Modal */}
      <Modal
        open={showRejectModal}
        onCancel={() => {
          setShowRejectModal(false);
          setRejectionReason('');
          setReviewerNotes('');
        }}
        title={language === 'english' ? 'Reject Form' : 'फॉर्म नकारा'}
        footer={[
          <Button key="cancel" onClick={() => setShowRejectModal(false)}>
            {language === 'english' ? 'Cancel' : 'रद्द करा'}
          </Button>,
          <Button key="submit" type="primary" danger onClick={handleReject}>
            {language === 'english' ? 'Reject Form' : 'फॉर्म नकारा'}
          </Button>,
        ]}
      >
        <Alert
          message={language === 'english' 
            ? "Please provide reason for rejection" 
            : "कृपया नकाराचे कारण द्या"}
          type="info"
          showIcon
          style={{ marginBottom: 16 }}
        />
        
        <div style={{ marginBottom: 16 }}>
          <Text strong>{language === 'english' ? 'Rejection Reason *' : 'नकाराचे कारण *'}</Text>
          <TextArea
            rows={3}
            value={rejectionReason}
            onChange={(e) => setRejectionReason(e.target.value)}
            placeholder={language === 'english' 
              ? "Enter rejection reason..." 
              : "नकाराचे कारण लिहा..."}
            style={{ marginTop: 8 }}
          />
        </div>

        <div>
          <Text strong>{language === 'english' ? 'Additional Notes' : 'अतिरिक्त नोट्स'}</Text>
          <TextArea
            rows={2}
            value={reviewerNotes}
            onChange={(e) => setReviewerNotes(e.target.value)}
            placeholder={language === 'english' 
              ? "Any additional comments..." 
              : "कोणत्याही अतिरिक्त टिप्पण्या..."}
            style={{ marginTop: 8 }}
          />
        </div>
      </Modal>

      {/* Create from Existing Form Modal */}
      <Modal
        open={showExistingFormSelector}
        onCancel={() => {
          setShowExistingFormSelector(false);
          setSelectedSourceForm(null);
          setSourceFormSchema([]);
          setSelectedFields([]);
        }}
        footer={null}
        width={800}
        title={
          <Space>
            <CopyFilled style={{ color: '#1890ff' }} />
            {language === 'english' ? 'Create Form from Existing Form' : 'विद्यमान फॉर्मवरून फॉर्म तयार करा'}
          </Space>
        }
        maskClosable={false}
        centered
      >
        <div style={{ padding: "20px" }}>
          {/* Step 1: Select Source Form */}
          <div style={{ marginBottom: 24 }}>
            <Title level={5}>
              {language === 'english' ? 'Step 1: Select Source Form' : 'पायरी १: स्रोत फॉर्म निवडा'}
            </Title>
            <Select
              style={{ width: '100%' }}
              placeholder={language === 'english' ? 'Select a form to copy fields from' : 'फील्ड कॉपी करण्यासाठी फॉर्म निवडा'}
              onChange={(value) => loadSourceFormSchema(value)}
              loading={loadingForms}
              allowClear
              showSearch
              optionFilterProp="children"
              getPopupContainer={(trigger) => trigger.parentNode}
              dropdownMatchSelectWidth={false}
              dropdownStyle={{ zIndex: 9999 }}
            >
              {availableForms.map(form => (
                <Option key={form.id} value={form.id}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' ,width: '100%',}}>
                    <span>{form.form_name} (ID: {form.id})</span>
                    {form.entry_type && (
                      <Tag color={form.entry_type === 'multi' ? 'purple' : 'blue'}>
                        {form.entry_type === 'multi' ? 'Multi' : 'Single'}
                      </Tag>
                    )}
                    {form.frequency?.enabled && (
                      <Tag color="green">
                        <FieldTimeOutlined /> {form.frequency.type}
                      </Tag>
                    )}
                    {form.approval_status && (
                      <Tag color={
                        form.approval_status === 'approved' ? 'green' :
                        form.approval_status === 'rejected' ? 'red' : 'orange'
                      }>
                        {form.approval_status}
                      </Tag>
                    )}
                  </div>
                </Option>
              ))}
            </Select>
          </div>

          {/* Step 2: Select Fields */}
          {sourceFormSchema.length > 0 && (
            <div style={{ marginBottom: 24 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                <Title level={5}>
                  {language === 'english' ? 'Step 2: Select Fields to Include' : 'पायरी २: समाविष्ट करण्यासाठी फील्ड निवडा'}
                </Title>
                <Space>
                  <Button
                    size="small"
                    onClick={() => {
                      const allIds = [];
                      const collectIds = (nodes) => {
                        nodes.forEach(node => {
                          allIds.push(node.id);
                          if (node.children) {
                            if (Array.isArray(node.children)) {
                              collectIds(node.children);
                            } else {
                              if (node.children.left) collectIds(node.children.left);
                              if (node.children.right) collectIds(node.children.right);
                            }
                          }
                          if (node.subFields) {
                            collectIds(node.subFields);
                          }
                        });
                      };
                      collectIds(sourceFormSchema);
                      setSelectedFields(allIds);
                    }}
                  >
                    {language === 'english' ? 'Select All' : 'सर्व निवडा'}
                  </Button>
                  <Button
                    size="small"
                    onClick={() => setSelectedFields([])}
                  >
                    {language === 'english' ? 'Clear All' : 'सर्व रद्द करा'}
                  </Button>
                </Space>
              </div>

              <div style={{
                maxHeight: '400px',
                overflowY: 'auto',
                border: '1px solid #f0f0f0',
                borderRadius: '8px',
                padding: '16px'
              }}>
                {loadingForms ? (
                  <div style={{ textAlign: 'center', padding: '40px' }}>
                    <Spin />
                  </div>
                ) : (
                  <Tree
                    checkable
                    expandedKeys={expandedKeys}
                    onExpand={setExpandedKeys}
                    checkedKeys={selectedFields}
                    onCheck={(checked) => setSelectedFields(checked)}
                    treeData={[{
                      title: <Text strong>{selectedSourceForm?.name}</Text>,
                      key: 'root',
                      children: sourceFormSchema.map(field => ({
                        key: field.id,
                        title: (
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px',width: '100%', }}>
                            <span style={{ fontSize: '16px' }}>
                              {field.type === 'text' && <FontSizeOutlined style={{ color: '#1890ff' }} />}
                              {field.type === 'number' && <NumberOutlined style={{ color: '#52c41a' }} />}
                              {field.type === 'date' && <CalendarOutlined style={{ color: '#fa8c16' }} />}
                              {field.type === 'checkbox' && <CheckSquareOutlined style={{ color: '#722ed1' }} />}
                              {field.type === 'radio' && <BorderOutlined style={{ color: '#eb2f96' }} />}
                              {field.type === 'heading' && <FontSizeOutlined style={{ color: '#fa8c16' }} />}
                              {field.type === 'paragraph' && <AlignLeftOutlined style={{ color: '#13c2c2' }} />}
                              {field.type === 'file' && <UploadOutlined style={{ color: '#1890ff' }} />}
                              {field.type === 'comparison' && <SwapOutlined style={{ color: '#fa8c16' }} />}
                              {field.type === 'arithmetic' && <CalculatorOutlined style={{ color: '#52c41a' }} />}
                            </span>
                            <Text strong>{field.enLabel || field.label || field.type}</Text>
                            {field.required && <Tag color="red">Required</Tag>}
                            <Tag color="blue">{field.type}</Tag>
                          </div>
                        ),
                        children: field.children ? (
                          Array.isArray(field.children) ? field.children.map(child => ({
                            key: child.id,
                            title: (
                              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginLeft: 24 }}>
                                <span style={{ fontSize: '14px', color: '#999' }}>↳</span>
                                <Text>{child.enLabel || child.label || child.type}</Text>
                                <Tag color="purple">subfield</Tag>
                              </div>
                            )
                          })) : [
                            ...(field.children.left || []).map(child => ({
                              key: child.id,
                              title: (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginLeft: 24 }}>
                                  <span style={{ fontSize: '14px', color: '#52c41a' }}>←</span>
                                  <Text>{child.enLabel || child.label || child.type}</Text>
                                  <Tag color="green">left</Tag>
                                </div>
                              )
                            })),
                            ...(field.children.right || []).map(child => ({
                              key: child.id,
                              title: (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginLeft: 24 }}>
                                  <span style={{ fontSize: '14px', color: '#1890ff' }}>→</span>
                                  <Text>{child.enLabel || child.label || child.type}</Text>
                                  <Tag color="blue">right</Tag>
                                </div>
                              )
                            }))
                          ]
                        ) : undefined,
                        children: field.subFields ? field.subFields.map(sub => ({
                          key: sub.id,
                          title: (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginLeft: 24 }}>
                              <CalculatorOutlined style={{ color: '#fa8c16' }} />
                              <Text>{sub.enLabel || sub.label || 'Subfield'}</Text>
                              <Tag color="orange">calculation</Tag>
                            </div>
                          )
                        })) : undefined
                      }))
                    }]}
                  />
                )}
              </div>

              <div style={{ marginTop: 16 }}>
                <Alert
                  message={
                    <Space>
                      <CheckCircleOutlined style={{ color: '#52c41a' }} />
                      {language === 'english'
                        ? `${selectedFields.length} fields selected`
                        : `${selectedFields.length} फील्ड निवडले`}
                    </Space>
                  }
                  type="info"
                  showIcon={false}
                />
              </div>
            </div>
          )}

          {/* Action Buttons */}
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: 24 }}>
            <Button onClick={() => {
              setShowExistingFormSelector(false);
              setSelectedSourceForm(null);
              setSourceFormSchema([]);
              setSelectedFields([]);
            }}>
              {language === 'english' ? 'Cancel' : 'रद्द करा'}
            </Button>
            <Button
              type="primary"
              icon={<CopyFilled />}
              onClick={createFormFromExisting}
              loading={creatingFromExisting}
              disabled={!selectedSourceForm || selectedFields.length === 0}
            >
              {language === 'english' ? 'Create Form' : 'फॉर्म तयार करा'}
            </Button>
          </div>
        </div>
      </Modal>

      {/* Global Styles */}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        * {
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }
        
        .ant-modal-content,
        .ant-modal-body {
          transform: translateZ(0);
          backface-visibility: hidden;
        }
        
        .ant-modal-body .ant-btn {
          transform: translateZ(0);
          backface-visibility: hidden;
          box-shadow: 0 2px 4px rgba(0,0,0,0.02);
        }
        
        .ant-modal-body .ant-btn:hover {
          transform: translateY(-1px) translateZ(0);
          box-shadow: 0 4px 8px rgba(0,0,0,0.1);
        }
        
        .ant-modal-body {
          padding: 20px !important;
        }
        
        .field-type-chip:hover,
        .existing-column-chip:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 8px rgba(0,0,0,0.1);
          border-color: #1890ff;
        }
        
        .ant-tree-node-content-wrapper {
          display: flex;
          align-items: center;
        }
        
        .ant-tree-treenode {
          padding: 4px 0 !important;
        }
        
        .ant-tree-node-selected {
          background: #e6f7ff !important;
        }

        /* Ensure all dropdowns are visible and clickable */
        .ant-select-dropdown {
          position: fixed !important;
          z-index: 999999 !important;
          visibility: visible !important;
          opacity: 1 !important;
          pointer-events: auto !important;
        }
        
        .ant-select {
          width: 100% !important;
          position: relative !important;
          z-index: auto !important;
        }
        
        /* Fix for modals and cards that might trap dropdowns */
        .ant-modal-wrap,
        .ant-modal,
        .ant-modal-content,
        .ant-modal-body,
        .ant-card,
        .ant-card-body {
          overflow: visible !important;
        }
        
        /* Ensure dropdowns render above everything */
        .rc-virtual-list {
          z-index: 999999 !important;
        }
        
        /* Fix for SLA cards specifically */
        .ant-col .ant-card {
          overflow: visible !important;
        }
        
        .ant-card-body {
          overflow: visible !important;
        }
        
        /* Remove any overflow hidden that might be affecting */
        .ant-row, .ant-col {
          overflow: visible !important;
        }
        
        /* Ensure dropdown menu has proper styling */
        .ant-select-dropdown {
          max-height: 300px !important;
          overflow-y: auto !important;
          box-shadow: 0 6px 16px rgba(0,0,0,0.15) !important;
          border-radius: 8px !important;
        }
        
        /* Animation fix */
        .ant-select-dropdown {
          transform-origin: center top !important;
          animation-duration: 0.2s !important;
        }
        
        /* Ensure dropdown is clickable */
        .ant-select-dropdown .ant-select-item {
          cursor: pointer !important;
          padding: 8px 12px !important;
        }
        
        .ant-select-dropdown .ant-select-item:hover {
          background-color: #f5f5f5 !important;
        }
        
        .ant-select-dropdown .ant-select-item-option-selected {
          background-color: #e6f7ff !important;
          color: #1890ff !important;
        }
        
        /* Fix for select in SLA cards */
        .ant-card .ant-select {
          width: 100% !important;
        }
        
        /* Ensure dropdown doesn't get hidden */
        .ant-select-dropdown {
          margin-top: 4px !important;
        }
        
        /* Fix for any z-index issues */
        .ant-select-dropdown {
          z-index: 999999 !important;
        }
        
        /* Ensure select trigger is clickable */
        .ant-select-selector {
          cursor: pointer !important;
        }
        
        /* Fix for nested selects */
        .ant-select-dropdown .ant-select-dropdown {
          position: static !important;
        }

        /* Upload area styles */
        .ant-upload-drag {
          border: 2px dashed #d9d9d9 !important;
          background: #fafafa !important;
          border-radius: 8px !important;
          transition: all 0.3s !important;
        }
        
        .ant-upload-drag:hover {
          border-color: #1890ff !important;
        }
        
        .ant-upload-drag-icon {
          marginBottom: 8px !important;
        }
        
        .ant-upload-text {
          color: #1e293b !important;
          font-size: 14px !important;
          marginBottom: 4px !important;
        }
        
        .ant-upload-hint {
          color: #6c757d !important;
          font-size: 12px !important;
        }

        /* Validation panel styles */
        .validation-panel {
          transition: all 0.3s ease;
        }
        
        .validation-panel:hover {
          border-color: #722ed1 !important;
          box-shadow: 0 2px 8px rgba(114, 46, 209, 0.1);
        }

        /* Transfer component styles */
        .ant-transfer-list {
          width: 100% !important;
          height: 400px !important;
        }
        
        .ant-transfer-operation {
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        
        .ant-transfer-operation .ant-btn {
          margin: 4px 0 !important;
        }
      `}</style>
    </div>
  );
};

export default FormBuilderContent;
